// Catalan
export const locale = {
  lang: 'ca',
  data: {
    // Dashboard d'exemple sense registre, /demo (#20261023-090014).
    DEMO: {
      TAG: 'Exemple',
      BAR: 'Estàs veient {{company}}, una empresa fictícia de {{employees}} empleats. Així quedaria la teva.',
      BAR_ARIA: "Dashboard d'exemple",
      NAV_ARIA: "Pàgines del dashboard d'exemple",
      CREATE_SPACE: 'Crear el meu espai →',
      KEEP_EXPLORING: 'Continuar explorant',
      SAVE_BLOCKED: {
        TITLE: 'Per desar, crea el teu espai',
        TEXT: 'Un minut. Sense dades bancàries ni contractes. Tot el que configuris serà teu.',
      },
    },
    // Interruptor «Veure amb dades d'exemple» de la capçalera (#20261023-090014).
    SAMPLE_DATA: {
      TOGGLE: "Veure amb dades d'exemple",
      TAG: "Dades d'exemple",
      HOME_NOTE: 'Així es veurà la teva empresa amb la plantilla en marxa.',
      TURN_OFF: 'Treure',
    },
    // Prova gratuïta: bàners, capa de bloqueig, etiqueta de la capçalera i confirmació en convidar (#20261023-090010).
    TRIAL: {
      BANNER: {
        WARNING: "<strong>La teva prova acaba el {{date}}</strong> · queden {{days}} dies. Per continuar amb WAIIS, completa el teu compte.",
        WARNING_ONE: "<strong>La teva prova acaba el {{date}}</strong> · queda 1 dia. Per continuar amb WAIIS, completa el teu compte.",
        PARTNER: "<strong>La teva prova acaba el {{date}}</strong> · queden {{days}} dies. {{partner}} es posarà en contacte amb tu per continuar.",
        PARTNER_ONE: "<strong>La teva prova acaba el {{date}}</strong> · queda 1 dia. {{partner}} es posarà en contacte amb tu per continuar.",
        COMPLETE: "<strong>Compte complet.</strong> El Pla Incentius comença el {{date}}, quan acabi la teva prova.",
        ENDED: "<strong>La teva prova va acabar el {{date}}.</strong> Completa el teu compte per tornar a veure el teu dashboard.",
        CTA: 'Completar el compte',
      },
      LOCK: {
        TITLE: 'La teva prova va acabar el {{date}}',
        TEXT: "Posa't en contacte amb nosaltres per continuar amb <strong>{{company}}</strong>. Mentrestant, la teva plantilla pot continuar fent servir l'app.",
        PARTNER_TEXT: "{{partner}} es posarà en contacte amb tu per activar el pla anual de <strong>{{company}}</strong>. Mentrestant, la teva plantilla pot continuar fent servir l'app.",
        CONTACT_TITLE: 'El teu contacte a WAIIS',
        TEAM: 'Equip',
        TEAM_NAME: 'Atenció a empreses',
        EMAIL: 'Correu',
        PHONE: 'Telèfon',
        BOOK_CALL: 'Reservar una trucada',
        COMPLETE_ACCOUNT: 'Completar el meu compte',
        YOUR_COMPANY: 'la teva empresa',
        MANAGER_TITLE: 'El teu gestor a {{partner}}',
        MANAGER_NAME: 'Nom',
      },
      CALENDLY: {
        TITLE: 'Reservar una trucada',
        FRAME_TITLE: 'Calendari per reservar una trucada amb WAIIS',
        CLOSE: 'Tancar',
      },
      TAG: {
        PRE_LAUNCH: 'Prova · comença quan afegeixis empleats',
        DAYS_LEFT: 'Prova · queden {{days}} dies',
        DAYS_LEFT_ONE: 'Prova · queda 1 dia',
        PLAN_FROM: 'Pla Incentius · des del {{date}}',
        ENDED: 'Prova acabada',
        ACTIVE: 'Pla Incentius · actiu',
        PARTNER_DAYS_LEFT: 'Prova · queden {{days}} dies · {{partner}}',
        PARTNER_DAYS_LEFT_ONE: 'Prova · queda 1 dia · {{partner}}',
        PARTNER_ENDED: 'Prova acabada · {{partner}} et contactarà',
        PARTNER_ACTIVE: 'Pla anual · gestionat per {{partner}}',
      },
      // Textos provisionals fins als de l'Adri (títol de la confirmació i caixa verda).
      INVITE: {
        TITLE: 'Enviar la invitació a {{count}} persones',
        TITLE_ONE: 'Enviar la invitació a 1 persona',
        TEXT: "Reben el correu amb l'enllaç a l'app.",
        TEXT_ONE: "Rep el correu amb l'enllaç a l'app.",
        TRIAL_STARTS: 'Aquí comencen els teus 3 mesos de prova gratuïta, no abans. Sense compromís ni permanència.',
        CONFIRM: 'Enviar invitacions',
        CANCEL: 'Encara no',
        TRIAL_BOX: '<strong>3 mesos</strong> de prova il·limitada, sense compromís.',
      },
    },
    // Tutorial de benvinguda (#20261023-090014). Textos dels passos propis provisionals fins als de l'Adri (E2).
    WELCOME_TOUR: {
      NEXT: 'Següent',
      PREV: 'Anterior',
      FINISH: 'Acabar',
      NOT_NOW: 'Ara no',
      SKIP: 'Saltar',
      CLOSE: 'Tancar el tutorial',
      STEP_OF: 'Pas {{n}} de {{total}}',
      CREATE_SPACE: 'Crear el meu espai',
      KEEP_EXPLORING: 'Continuar explorant',
      OVERVIEW_ALT: "Les sis píndoles d'Inici sobre el mapa",
      OWN: {
        INTRO: {
          TITLE: 'Et donem la benvinguda, {{company}}',
          META: 'Uns 5 minuts · Sense dades de facturació',
          TEXT: 'Et mostrem on és cada cosa i els passos per posar en marxa WAIIS a la teva empresa.',
          START: 'Començar la configuració',
        },
      },
      JOINUP: {
        INTRO: {
          TITLE: 'Et donem la benvinguda, {{company}}',
          META: 'Uns 2 minuts',
          TEXT: "{{partner}} ha preparat el teu espai i gestiona el teu compte. Aquí segueixes la participació de la teva plantilla i els seus resultats.",
          START: 'Veure el meu espai',
        },
      },
      STEPS: {
        PILLS: {
          TITLE: 'Els teus indicadors, sobre el mapa',
          TEXT: "D'un cop d'ull: CO₂ evitat, empleats vinculats, passatgers per viatge, viatges de l'últim mes i rutines de les últimes 24 h, de tota l'empresa o d'una seu.",
        },
        HEADQUARTERS: {
          TITLE: 'Indica la teva seu central',
          TEXT: "Escriu-ne l'adreça i desa-la: així situem la teva empresa al mapa.",
        },
        GUIDE: {
          TITLE: 'La teva posada en marxa',
          TEXT: 'Tres passos: la teva seu central, la teva plantilla i la participació. Es marquen sols quan els fas i aquí veus quants en portes.',
        },
        EMPLOYEES: {
          TITLE: "Dona d'alta la teva plantilla",
          TEXT: "A Empleats puges un CSV amb la teva plantilla o afegeixes cada persona a mà. Reben l'enllaç a l'app.",
        },
        USAGE: {
          TITLE: 'La participació, a Ús',
          TEXT: 'Quants empleats fan servir WAIIS, quants viatges comparteixen i com evoluciona.',
        },
        TRAVEL: {
          TITLE: 'Els viatges de la plantilla',
          TEXT: "Cada trajecte compartit, amb l'origen, la destinació i qui hi viatja.",
        },
        OFFICES: {
          TITLE: 'Crea les teves seus',
          TEXT: 'A Configuració dones d\'alta els teus centres de treball per seguir la participació de cadascun.',
        },
        OVERVIEW: {
          TITLE: 'Visió general',
          TEXT: "A Inici, sis indicadors sobre el mapa resumeixen com va WAIIS a l'empresa.",
        },
        DEMO_EMPLOYEES: {
          TITLE: 'Empleats',
          TEXT: "La plantilla de l'empresa: qui s'ha vinculat a l'app i des de quina seu.",
        },
        FUNNEL: {
          TITLE: 'Funnel',
          TEXT: 'De la invitació al primer viatge compartit: on es queden els empleats pel camí.',
        },
        PMST: {
          TITLE: 'PMST',
          TEXT: "El pla de mobilitat sostenible a la feina, fet amb les dades de l'empresa. El vols amb les teves?",
        },
      },
    },
    // Guia «Posada en marxa» de l'empresa (#20261023-090014).
    LAUNCH_GUIDE: {
      PANEL_TITLE: 'Els teus primers passos',
      PROGRESS: '{{done}} de {{total}} passos fets. Continua amb el següent.',
      ALL_DONE: 'Els tres passos estan fets: la teva empresa ja està en marxa.',
      STEP_DONE: 'Fet',
      VIEW_TOUR: 'Veure el tutorial',
      LOADING: 'Carregant la posada en marxa',
      STEPS: {
        HEADQUARTERS: {
          TITLE: 'On és la teva seu central?',
          TEXT: "Així situem la teva empresa al mapa d'Inici i veuràs els trajectes de la teva plantilla.",
          ACTION: 'Indicar la seu',
        },
        EMPLOYEES: {
          TITLE: 'Dona d\'alta la teva plantilla',
          TEXT: "Puja un CSV amb els teus empleats o afegeix-los a mà. Reben l'enllaç a l'app.",
          ACTION: 'Pujar CSV',
        },
        PARTICIPATION: {
          TITLE: 'Mesura la participació',
          TEXT: "Quan els teus empleats es vinculin a l'app, veuràs a Ús quants hi participen i com viatgen.",
          ACTION: 'Veure Ús',
        },
      },
    },
    // Modalidad de transporte de fraude_pooling_route_labels (equipo de datos).
    FRAUD_DATA: {
      CURRENT_DECISION_HINT: "Vigent",
      ORIGIN: {
        MANUAL: "Manual",
        AUTO_SCORE: "Score automàtica",
        AUTO_SCORE_VALUE: "Score {{score}}",
        PVP_BONUS: "Bonificació PVP",
        UNKNOWN: "—",
      },
      INTRO_TITLE: 'Scores, senyals i decisió sobre cada compte',
      INTRO_TEXT: "Els scores i els senyals els envia l'equip de dades. A la columna <strong>Decisió</strong> tries què fer amb el compte. Prem un usuari per obrir-ne la fitxa, o un viatge per veure'n el recorregut.",
      ADD_USER: 'Afegir usuari',
      ADD_SUBTITLE: 'Cerca-ho i tria la decisió. Apareixerà a Bloquejos.',
      CLOSE: 'Tancar',
      ADD_SEARCH_PLACEHOLDER: 'Nom, email o ID...',
      ADD_SEARCH_ARIA: 'Cercar usuari',
      SEARCHING_USERS: 'Cercant usuaris',
      NO_USER_MATCH: 'No hi ha cap usuari amb «{{term}}».',
      TABLE_ARIA: 'Taula',
      TABS: {
        USERS: 'Usuaris',
        TRIPS: 'Viatges',
        PAIRS: 'Col·lusió',
        WHITELIST: "Llista blanca",
        REINFORCED: "Reforçada",
        REINFORCED_NO_COST: "Reforçada + sense cost 0",
        HISTORY: "Historial",
      },
      SEARCH_PLACEHOLDER: 'Usuari, email o ID...',
      SEARCH_ARIA: 'Cercar',
      FROM_TRIP: 'Viatge des de',
      FROM: 'Des de',
      TO: 'Fins a',
      MIN_SCORE: 'Score mín.',
      MAX_SCORE: 'Score màx.',
      SEGMENT: 'Segment',
      DECISION: 'Decisió',
      SORT: 'Ordenar',
      HIGH_SIGNAL: "Només risc alt",
      UNPAID_ONLY: 'Només diners sense pagar',
      GROUP_BY_USER: 'Agrupar per usuari',
      NO_SCORE: 'Sense score',
      ONLY_CURRENT_DECISION: 'Només la decisió actual',
      ONLY_CURRENT_SCORE: 'Només el score actual',
      MIN_COLLUSION: 'Col·lusió mín.',
      ONLY_CURRENT_PAIR: 'Només el valor actual',
      CLEAR_FILTERS: 'Netejar filtres',
      DATE_RANGE_INVALID: 'La data «Fins a» no pot ser anterior a «Des de».',
      SCORE_RANGE_INVALID: 'El score màxim no pot ser menor que el mínim.',
      LOADING: 'Carregant…',
      COLS: {
        WITH: 'Amb',
        COLLUSION: 'Col·lusió',
        TRIPS_TOGETHER: 'Viatges junts',
        RECEIVED_AT: 'Data',
        USER: 'Usuari',
        SCORE_FROM: 'Score des de',
        SCORE: 'Score',
        SIGNALS: "Senyals",
        SEGMENT: 'Segment',
        DECISION: 'Decisió',
        DATE: 'Data',
        ROUTE: 'Trajecte',
        ROLE: 'Rol',
        PASSENGERS: 'Passatgers',
        MONEY: 'Diners',
        MODE: 'Modalitat',
        FINAL_DECISION: 'Decisió final',
        PERIOD: 'Període',
        DECIDED_BY: 'Decidit per',
        NOTE: 'Nota',
        SINCE: "Des de",
        ADDED_BY: "Afegit per",
        ORIGIN: "Origen",
      },
      HISTORY_UNTIL: 'Historial · fins al {{date}}',
      GROUP: 'Grup {{group}}',
      TRIPS_COUNT_ONE: '{{count}} viatge',
      TRIPS_COUNT_OTHER: '{{count}} viatges',
      DRIVER: 'Conductor',
      PASSENGER: 'Passatger',
      DRIVER_LABEL: 'Conductor:',
      NO_MATCH: 'Sense match',
      NO_PRICE: 'Sense preu',
      UNTIL: 'fins al {{date}}',
      FREE_TRIP: 'Viatge gratuït',
      PAST_DECISION_HINT: 'Historial: la decisió actual és en una altra fila',
      NO_END: 'sense fi',
      AUTOMATIC: 'Automàtic',
      PREV: 'Anterior',
      NEXT: 'Següent',
      RETRY: 'Tornar-ho a provar',
      NO_RESULTS_FILTERS: 'No hi ha resultats amb aquests filtres.',
      NO_DATA: 'Encara no hi ha dades.',
      NOT_CALCULATED: 'sense calcular',
      LOAD_ERROR: "No s'han pogut carregar les dades.",
      ALL_M: 'Tots',
      ALL_F: 'Totes',
      SORT_RECENT: 'Més recents',
      SORT_SIGNAL: "Més risc primer",
      SEGMENTS: {
        TRIP_IP_COLLUSION: 'Viatge + IP + col·lusió',
        TRIP_IP: 'Viatge + IP',
        TRIP_COLLUSION: 'Viatge + col·lusió',
        TRIP: 'Viatge',
        VALID: 'Vàlid',
      },
      DECISIONS: {
        ALLOW: 'No frau',
        REINFORCED_VERIFICATION: 'Verificació reforçada',
        BLACKLIST: 'Llista negra',
        WHITELIST: "Llista blanca",
      },
      SIGNALS: {
        MOBILITY_GPS: {
          SHORT: "GPS",
          TITLE: "Cobertura GPS",
          LEGEND_TITLE: "Cobertura GPS",
          TEXT: "% de viatges conduïts amb bona cobertura GPS (més del 70 % dels minuts amb algun punt vàlid).",
        },
        COLLISION: {
          SHORT: "Col·lusió",
          TITLE: "Col·lusió",
          LEGEND_TITLE: "Col·lusió amb els passatgers",
          TEXT: "% de passatgers d'aquest conductor amb qui no sembla que siguin persones independents (col·lusió per sobre de 90, amb com a mínim 3 dies de dades). En un viatge, és la mitjana de les seves parelles conductor-passatger.",
        },
        COPRESENCE: {
          SHORT: "Copresència",
          TITLE: "Copresència",
          LEGEND_TITLE: "Copresència conductor-passatger",
          TEXT: "% de viatges en què tots els passatgers acrediten que eren amb el conductor.",
        },
        NETWORK_IP: {
          SHORT: "Xarxa/IP",
          TITLE: "Xarxa / IP",
          LEGEND_TITLE: "IP compartida",
          TEXT: "% de viatges en què el conductor comparteix alguna IP amb algun passatger.",
        },
        ELIGIBLE_TRANSPORT: {
          SHORT: "Transport",
          TITLE: "Transport elegible",
          LEGEND_TITLE: "Transport elegible",
          TEXT: "% de viatges fets en un mitjà que dona CAE, sobre els que tenen cobertura de mapa.",
        },
      },
      PANEL: {
        PAIRS_TITLE: 'Col·lusió per parella',
        PAIRS_SUBTITLE: "Parelles que, segons l'equip de dades, no semblen persones independents. Més alt = pitjor.",
        PAIRS_ITEMS: 'parelles',
        SCORES_TITLE: 'Usuaris amb score de frau',
        SCORES_SUBTITLE: "Score i senyals que envia l'equip de dades. Prem un usuari per obrir-ne la fitxa.",
        SCORES_ITEMS: 'usuaris',
        ROUTES_TITLE: 'Viatges amb senyals de frau',
        ROUTES_SUBTITLE: "Senyals de cada viatge i estat dels diners. Prem un viatge per veure'n el recorregut.",
        ROUTES_ITEMS: 'viatges',
        BLOCKS_TITLE: "Historial de decisions",
        BLOCKS_SUBTITLE: "Totes les decisions sobre cada compte, també les antigues i els «No frau»: què, qui i quan.",
        BLOCKS_ITEMS: "decisions",
        WHITELIST_TITLE: "Llista blanca",
        WHITELIST_SUBTITLE: "Comptes protegits: sabem que fan frau però els deixem fer servir l'app. Mai no passen a verificació reforçada, ni a mà ni per la score.",
        WHITELIST_ITEMS: "usuaris",
        REINFORCED_TITLE: "Verificació reforçada",
        REINFORCED_SUBTITLE: "Qui és avui en verificació reforçada i per què.",
        REINFORCED_ITEMS: "usuaris",
        REINFORCED_NO_COST_TITLE: "Reforçada + sense cost 0",
        REINFORCED_NO_COST_SUBTITLE: "Qui és avui en reforçada i a més sense cost 0, i per què: a mà o per cobrar la Bonificació PVP.",
        REINFORCED_NO_COST_ITEMS: "usuaris",
      },
      PAGINATION: 'Mostrant {{shown}} de {{total}} {{items}}',
      PAGINATION_NO_TOTAL: 'Mostrant {{shown}} {{items}}',
      PAYOUT: {
        PAID: 'Pagat',
        HELD: 'Retingut',
        UNPAID: 'Sense cobrar',
      },
      DECISION_LEGEND: {
        TITLE: "Què vol dir cada decisió?",
        SUBTITLE: "Què li passa a l'usuari amb cada opció del desplegable «Decisió».",
        NO_FRAUD: {
          TITLE: "No frau",
          TEXT: "Sense restriccions: cobra els viatges i retira com sempre, i pot convidar a cost 0. Si arriba una score nova igual o més gran que {{score}}, passa a verificació reforçada.",
        },
        WHITELIST: {
          TITLE: "Llista blanca",
          TEXT: "Sabem que fa frau, però se li deixa. Fa servir l'app com «No frau» i mai no se li posa la verificació reforçada, ni a mà ni per la score.",
        },
        REINFORCED: {
          TITLE: "Verificació reforçada",
          TEXT: "Els viatges s'abonen al conductor {{tripDays}} dies després de verificar-se, les retirades esperen {{withdrawalDays}} dies i el mínim per retirar és {{minPayout}}. Es posa a mà o sola amb score ≥ {{score}}.",
        },
        REINFORCED_NO_COST: {
          TITLE: "Reforçada + sense cost 0",
          TEXT: "El mateix que la verificació reforçada i, a més, no pot donar ni bescanviar viatges a cost 0.",
        },
      },
      ACTIVE_RULES: {
        TITLE: "Regles actives",
        AUTO_ON: "Els usuaris amb <strong>score ≥ {{score}}</strong> passen sols a verificació reforçada (excepte la llista blanca).",
        AUTO_OFF: "La verificació reforçada automàtica per score està desactivada.",
        REINFORCED: "En reforçada, el viatge s'abona al conductor als {{tripDays}} dies, les retirades esperen {{withdrawalDays}} dies i el mínim per retirar és {{amount}}.",
        FREE_INVITE_ON: "Poden continuar convidant a cost 0.",
        FREE_INVITE_OFF: "No poden convidar a cost 0.",
        EDIT: "Canviar a Configuració",
        REVIEW_DUE: "Fa {{days}} dies que no es revisa la score mínima ({{score}}). Comprova si cal canviar-la.",
        REVIEW_NEVER: "La score mínima ({{score}}) no s'ha revisat mai. Comprova si és la correcta.",
        REVIEWED_ON: "Score mínima revisada el {{date}}.",
        SUBTITLE: "El que mana avui en la verificació reforçada. Es canvia a Configuració.",
        TILE_SCORE: "Reforçada automàtica",
        TILE_SCORE_HINT: "Amb aquesta score o més, el compte passa sol a reforçada (excepte la llista blanca).",
        TILE_SCORE_OFF_HINT: "Les scores noves no posen ningú en reforçada.",
        TILE_OFF: "Desactivada",
        TILE_TRIP: "Abonament al conductor",
        TILE_TRIP_HINT: "Des que es verifica el viatge.",
        TILE_WITHDRAWAL: "Retirades",
        TILE_WITHDRAWAL_HINT: "El que espera una retirada abans de pagar-se.",
        TILE_MIN: "Mínim per retirar",
        TILE_MIN_HINT: "Mentre és en reforçada.",
        TILE_FREE: "Cost 0",
        TILE_FREE_ON: "Permès",
        TILE_FREE_OFF: "Bloquejat",
        TILE_FREE_HINT: "«Reforçada + sense cost 0» el bloqueja sempre.",
        DAYS: "{{days}} dies",
      },
      WHITELIST_ADD: {
        OPEN: "Afegir a la llista blanca",
        TITLE: "Afegir usuaris a la llista blanca",
        HELP: "Cerca per nom, email o ID i prem «Afegir»; cadascun passa a «Llista blanca» des d'ara.",
        IDS_PLACEHOLDER: "0990e311-1ca9-4117-9a89-88bcf1f1019b\n85ab1ced-4260-486f-a0f9-93dff87617ec",
        IDS_ARIA: "IDs d'usuari",
        NOTE_PLACEHOLDER: "Nota (opcional): per què són a la llista blanca",
        COUNT: "{{count}} usuaris",
        SUBMIT: "Afegir a la llista blanca",
        ADDING: "Afegint…",
        ADDED: "Afegits: {{count}}",
        ALREADY: "Ja hi eren: {{count}}",
        NOT_FOUND: "No trobats: {{count}}",
        NOT_FOUND_HINT: "Els IDs no trobats s'han quedat a la caixa per revisar-los.",
        TOO_MANY: "Com a màxim 1000 usuaris alhora.",
        ERROR: "No s'han pogut afegir. Torna-ho a provar.",
        PICK: "Afegir",
        PICKED: "Triat",
        ALREADY_IN: "Ja és a la llista blanca",
        REMOVE_ARIA: "Treure {{name}}",
        PASTE_TOGGLE: "O enganxa IDs",
        PASTE_HELP: "IDs d'usuari, un per línia (també valen comes o espais).",
      },
      SIGNAL_RISK_TITLE: "{{signal}}: {{value}} ({{direction}})",
      SIGNAL_DIRECTION: {
        BETTER: "com més alt, millor",
        WORSE: "com més alt, pitjor",
      },
      LEGEND: {
        BETTER_TAG: "↑ millor",
        WORSE_TAG: "↑ pitjor",
        SCORE_NOTE: "La score és una prioritat de revisió, no una probabilitat: 90 o 100 = IP compartida (trip_ip); 70 o 80 = col·lusió (trip_collusion). El valor alt de cada parell és quan el CAE generat supera els 100 €.",
        TITLE: 'Què vol dir cada senyal?',
        SUBTITLE: "Què mesura cada senyal i com llegir-ne el %: en uns com més alt és millor i en d'altres, pitjor.",
        HIDE: 'Amagar',
        SHOW: 'Veure detall',
        SCALE_TITLE: "El color és el risc de cada senyal, ja llegit en el seu sentit:",
        LOW: "Bé",
        MEDIUM: "A revisar",
        HIGH: "Risc",
        NOT_CALCULATED: 'Sense calcular',
      },
      DECISION_SELECT: {
        ARIA: 'Decisió sobre {{name}}',
        NO_DECISION: 'Sense decisió',
        STATES: {
          NO_FRAUD: 'No frau',
          REINFORCED: 'Verificació reforçada',
          REINFORCED_NO_COST: 'Reforçada + sense cost 0',
          BLACKLIST: 'Llista negra',
          WHITELIST: "Llista blanca",
          NO_COST_ONLY: 'Sense cost 0',
        },
        CONFIRM_TITLE: 'Passar a «{{label}}»?',
        NOTE_PLACEHOLDER: 'Nota (opcional): per què prens aquesta decisió',
        NOTE_ARIA: 'Nota opcional',
        CONFIRM: 'Sí, canviar',
        CANCEL: 'Cancel·lar',
        SAVING: 'Desant…',
        SAVED: 'Desat',
        SAVE_ERROR: "No s'ha pogut desar la decisió. Torna-ho a provar.",
        WHITELIST_LOCKED: "És a la llista blanca: no se li pot posar la verificació reforçada. Passa-li abans a una altra decisió.",
        CONFIRM_RELIEF: "Sí, continuar",
        WARN_LEAVES_FRAUD: "Deixa d'estar en verificació reforçada: els pagaments i les retirades tornen a anar com sempre.",
        WARN_LEAVES_FRAUD_AND_COST: "Deixa d'estar en verificació reforçada i podrà tornar a fer servir el cost 0, encara que se li hagués bloquejat per la Bonificació PVP.",
        WARN_REGAINS_COST: "Podrà tornar a fer servir el cost 0, encara que se li hagués bloquejat per la Bonificació PVP.",
      },
      TRANSPORT_MODE: {
        car: 'Cotxe',
        motorbike: 'Moto',
        bus: 'Autobús',
        train: 'Tren',
        metro: 'Metro',
        tram: 'Tramvia',
        bike: 'Bicicleta',
        scooter: 'Patinet',
        walk: 'A peu',
        taxi: 'Taxi',
        plane: 'Avió',
        unknown: 'Desconeguda',
      },
    },
    // Mismas claves (en minúsculas) que `ca.json` de la app móvil, bajo
    // `routines.route.tracking`: la tarjeta de trayecto del chat de soporte
    // trae esas rutas completas en `alertTitleKey`/`alertMessageKey`/
    // `alertSuggestionKey`. Sin ellas, el dashboard en este idioma enseña la
    // clave tal cual (QA WS-2169). Mismo bloque que en `es.ts`.
    routines: {
      route: {
        tracking: {
          rejection_reason: {
            location_data_missing: 'El teu mòbil no va compartir la ubicació durant el viatge.',
            origin_not_confirmed: 'No vam detectar el teu mòbil al punt de sortida a l\'hora del viatge.',
            destination_not_confirmed: 'No vam detectar la teva arribada a la destinació.',
            location_trace_incomplete: 'Vam perdre el senyal del teu mòbil a mig viatge.',
            route_not_compatible: 'El recorregut no sembla fet amb cotxe.',
            copresence_not_confirmed: 'No vam poder confirmar que viatgéssiu al mateix cotxe.',
            multiple_devices: 'Aquest viatge es va registrar des de diversos mòbils alhora.',
            mock_location: 'La ubicació que vam rebre del teu mòbil no era la real.',
            network_failed: 'La connexió del teu mòbil no ens va deixar comprovar on eres.',
            trip_limit: 'Ja has arribat al màxim de viatges amb bonificació d\'aquest període.',
            pattern_review: 'Estem revisant aquest viatge perquè no s\'assembla als que sols fer.',
            competitor_app: 'Tens una altra app de cotxe compartit instal·lada i un mateix viatge només es pot bonificar en una.',
            shared_with_riders: 'No vam poder confirmar que tu i els teus passatgers féssiu el viatge junts.',
            shared_with_driver: 'No vam poder confirmar que fessis el viatge amb el teu conductor.',
            location_permission_missing: 'El teu mòbil no tenia permís per compartir la ubicació durant el viatge.',
          },
          rejection_suggestion: {
            location_data_missing: 'Per al proper viatge, comprova que WAIIS tingui el permís d\'ubicació a «Sempre» i que el mòbil tingui connexió a internet.',
            origin_not_confirmed: 'Per al proper viatge, comprova que la ubicació estigui activa a «Sempre» i que tinguis connexió a internet abans de sortir.',
            destination_not_confirmed: 'Per al proper viatge, mantén la ubicació activa i la connexió a internet fins a arribar a la destinació.',
            location_trace_incomplete: 'Per al proper viatge, evita tancar l\'app o activar l\'estalvi de bateria.',
            route_not_compatible: 'Recorda que només es bonifiquen els viatges fets amb cotxe.',
            copresence_not_confirmed: 'Recorda que el conductor i els passatgers han de tenir la ubicació activa i connexió a internet durant tot el trajecte.',
            multiple_devices: 'Per al proper viatge, fes servir un sol mòbil per persona.',
            mock_location: 'Per al proper viatge, desactiva les apps que simulen la ubicació.',
            network_failed: 'Per al proper viatge, desactiva la VPN o el proxy al teu mòbil.',
            trip_limit: 'Podràs tornar a bonificar viatges quan comenci el proper període.',
            pattern_review: 'No has de fer res: t\'avisarem quan acabem.',
            competitor_app: 'Desinstal·la l\'altra app perquè puguem bonificar els teus propers viatges.',
            shared_with_riders: 'Recorda que el conductor i els passatgers han de tenir la ubicació activa i connexió a internet durant tot el trajecte.',
            shared_with_driver: 'Recorda que el conductor i els passatgers han de tenir la ubicació activa i connexió a internet durant tot el trajecte.',
            location_permission_missing: 'Per al proper viatge, activa el permís d\'ubicació de WAIIS a «Sempre» als ajustos del mòbil.',
            unknown: 'Si creus que és un error, escriu-nos i ho revisem.',
          },
          no_match: {
            unrealized: {
              title: 'Trajecte no verificat',
              description: 'No hem pogut confirmar que aquest trajecte es realitzés.',
            },
          },
          assigned: {
            unrealized: {
              title: 'Trajecte no verificat',
              description: 'No hem pogut confirmar que aquest trajecte es realitzés.',
            },
          },
        },
      },
    },
    PARTNER_SECTION: {
      READ_ONLY_USER_TITLE: 'Tens accés de només lectura',
      READ_ONLY_USER_TEXT: 'Pots veure tot el de les empreses de {{partner}}, però no canviar res.',
      MANAGED_BY_TITLE: 'Aquesta secció la gestiona {{partner}}',
      MANAGED_BY_TEXT: 'La pots veure, però els canvis els fa {{partner}}.',
    },
    // Aviso de tickets de soporte creados por agentes (WS-2415).
    AGENT_TICKET_NOTICES: {
      TITLE_ONE: 'Nou tiquet de suport creat per un agent',
      TITLE_MANY: '<b>{{count}}</b> tiquets de suport d\'agents sense veure',
      OPEN: 'Fes clic per obrir-lo',
      BADGE: '{{count}} tiquets de suport d\'agents sense veure',
    },
    SIDEBAR: {
      SESSION: 'Sessió',
      COLLAPSE_MENU: 'Plegar menú',
      EXPAND_MENU: 'Desplegar menú',
      CHANGE_COMPANY: 'Canviar empresa',
      PARTNER_ADMIN: 'Partner admin',
      ALL_CENTERS: 'Tots els centres',
      MATCH_SECTION: 'Match',
      DASHBOARD: 'Tauler',
      ECONOMIC_DASHBOARD: 'Tauler Econòmic',
      ECONOMIC_REPORTS: 'Informes',
      ECONOMIC_MOVEMENTS: 'Moviments',
      ECONOMIC_USERS: 'Usuaris Generals',
      ECONOMIC_COMPANIES: 'Empreses',
      CORPORATIONS: 'Empreses',
      PARTNERS: 'Partners',
      PARTNER_REQUESTS: 'Sol·licituds',
      PARTNER_REQUESTS_NEW: '{{count}} sol·licituds noves',
      MY_PARTNER: 'El meu partner',
      PARTNER_USERS: 'Usuaris',
      PARTNER_PAYMENTS: 'Condicions de pagament',
      ECONOMIC_COMPANY_USERS: 'Usuaris Empresa',
      CORPORATION_USERS: 'Usuaris Empresa',
      CORPORATION_OFFICES: 'Seus',
      LAYOUT_BUILDER: 'Layout Builder',
      USERS: 'Usuaris',
      USERS_GENERIC: 'Usuaris',
      REPORTS_SECTION: 'Informes Waiis',
      FUNNEL: 'Funnel',
      FUNNEL_WAIIS: 'Funnel Waiis',
      TRAVEL: 'Viatges',
      TRAVELS: 'Viatges',
      PARKING: 'Parking',
      SUSTAINABILITY: 'Sostenibilitat',
      CONVERSION: 'Conversió',
      USAGE: 'Ús',
      CREDITS: 'Crèdits',
      PROVIDERS: 'Proveïdors',
      COUPONS: 'Targetes Regal',
      GIFT_CARDS: 'Targetes Regal',
      CODES: 'Codis',
      PROMOTIONAL_CODES: 'Codis Promocionals',
      PARKING_SECTION: 'Parking',
      PARKING_SPACES: 'Places Parking',
      PARKING_RESERVATIONS: 'Reserves Parking',
      PARKING_CREDITS: 'Crèdits Parking',
      COMMUNICATION: 'Comunicació',
      PUSH: 'Push',
      NOTIFICATIONS: 'Notificacions',
      TRAINING: 'Formació',
      TRAINING_RESOURCES: 'Recursos',
      TRAINING_LAUNCH: 'Llançament Intern',
      INTERNAL_LAUNCH: 'Llançament Intern',
      RESOURCES: 'Recursos',
      RESOURCES_POSTER: 'Cartells',
      POSTERS: 'Cartells',
      RESOURCES_VIDEO: 'Vídeos',
      VIDEOS: 'Vídeos',
      RESOURCES_GUIDE: 'Guies',
      GUIDES: 'Guies',
      RESOURCES_LAUNCH: 'Pack Promo Launch',
      PROMO_LAUNCH: 'Pack Promo Launch',
      RESOURCES_CAR: 'Pack Promo Car',
      PROMO_CAR: 'Pack Promo Car',
      RESOURCES_CHALLENGE: 'Pack Reptes',
      PROMO_CHALLENGES: 'Pack Reptes',
      ACTIVITY_MANAGEMENT: "Gestió d'activitat",
      ADMINISTRATION: 'Administració',
      MONEY: 'Diners',
      INTERNAL_ADMIN: 'Admin intern',
      COMPANIES: 'Empreses',
      OFFICES: 'Seus',
      SHIFTS: 'Torns',
      INCENTIVES: 'Incentius',
      INCIDENTS: 'Incidències',
      COMPLAINTS: 'Incidències',
      WAIIS_USERS: 'Usuaris WAIIS',
      FRAUD: 'Frau',
      ADMIN_HOME: 'Inici',
      TRAVEL_LIST: 'Viatges',
      RIDES: 'Rides VTC',
      RIDE_BOOKING_DESK: 'Reserves de grup',
      PAYOUT_REVIEWS: 'Retirades',
      SUPPORT: 'Suport',
      AGENT_CONVERSATIONS: "Historial d'agents",
      MARKETING: 'Marketing',
      MARKETING_USERS: 'Usuaris de Marketing',
      EMAILS: 'Correus',
      PUSH_NOTIFICATIONS: 'Notificacions push',
      REFERRALS: 'Referits',
      PVP_PROMOS: 'Promo PVP',
      PROMOS: 'Promocions',
      PROMOS_PVP: 'PVP (Frau)',
      PROMOS_TRIPS: 'Per viatges',
      ZONE_ADS: 'Anuncis per zona',
      ZONE_ADS_SETTINGS: 'Ajustos',
      ZONE_ADS_IMBALANCE: 'Informe de desequilibri',
      ZONE_ADS_DRAFTS: 'Esborranys',
      ZONE_ADS_TEMPLATES: 'Plantilles',
      FOOTPRINT_SECTION: 'Petjada',
      FOOTPRINT: 'Petjada',
      FOOTPRINT_RAW: 'Petjada en Brut',
      TRAVEL_REVIEW: 'Revisió de viatges',
      CORRIDORS_REVIEW: 'Revisió de corredors',
      MATCH_REVIEW: 'Revisió de rutes',
      MATCHES_LISTING: 'Llistat de matchs',
      MATCH_LIST: 'Variables de match',
      POIS: 'POIs',
      TAGS: 'Etiquetes',
      CONFIGURATIONS: 'Configuracions',
      CREDIT_TYPES: 'Tipus de crèdit',
      COMMISSIONS: 'Comissions',
      SUBSIDIES: 'Subvencions',
      PRICING_CONFIGS: 'Preus',
      SUBSIDY_CONSUMPTIONS: 'Subvencions',
      POOLING_RUNNERS: 'Corredors',
      POOLING_RUNNERS_CONFIG: 'Corredors',
      CORP_SECTION_PRINCIPAL: 'PRINCIPAL',
      CORP_SECTION_CARPOOLING: 'CARPOOLING',
      CORP_SECTION_TAXI_VTC: 'TAXI / VTC',
      CORP_SECTION_PARKING: 'PARKING',
      CORP_SECTION_ACCOUNT: 'COMPTE',
      CORP_LAUNCH_GUIDE: 'Posada en marxa · {{done}}/{{total}}',
      CORP_LAUNCH_GUIDE_TITLE: 'Posada en marxa',
      CORP_SUSTAINABILITY: 'Sostenibilitat',
      CORP_HOME: 'Inici',
      CORP_USAGE: 'Ús',
      CORP_EMPLOYEES: 'Treballadors',
      CORP_TRAVEL: 'Viatges',
      CORP_FUNNEL: 'Funnel',
      CORP_INCENTIVES: 'Incentius',
      CORP_PMST: 'PMST',
      CORP_SUBSIDY: 'Bonificació',
      CORP_FLEET: 'Flota',
      CORP_TAXI_RIDES: 'Viatges i despesa',
      CORP_TAXI_POLICY: 'Política',
      CORP_TAXI_BOOKINGS: 'Reserves',
      CORP_TAXI_REVIEW: 'Revisió',
      CORP_SETTINGS: 'Configuració',
      CORP_WALLET: 'Cartera',
      CORP_PLAN: 'Pla',
      ONBOARDING_LOCKED_HINT: 'Completa la posada en marxa per desbloquejar-ho',
      PLAN_READ_ONLY_HINT: 'El teu accés és de només lectura',
      PLAN_LOCKED_HINT: 'Aquesta funció no està inclosa en el teu pla actual. Canvia de pla per desbloquejar-la.',
      PMST_DISABLED_HINT: "Aquesta empresa no implanta el PMST amb WAIIS. Pots canviar aquesta resposta als ajustos de l'empresa.",
      PLAN_UPGRADE_MODAL: {
        TITLE: 'Funció no disponible en el teu pla',
        TEXT: 'Aquesta secció forma part del <strong>Pla d\'Incentius</strong>. Actualitza el teu pla per desbloquejar-la i accedir a tots els avantatges del tauler.',
        CONFIRM: 'Veure plans',
        CANCEL: 'Ara no',
      },
      CORP_COMING_SOON: 'PRÒXIMAMENT',
      CONFIG_VARIABLES: 'Variables de Configuració',
      APP_ANNOUNCEMENT: "Comunicat a l'app",
      FRAUD_RULES: 'Regles de frau',
      TERMS_CONDITIONS: "Termes i Condicions d'Ús",
      CONTRACT_TEMPLATES: 'Plantilla de contracte',
      DATA_PROCESSING_AGREEMENT: 'Contracte d\'encàrrec (DPA)',
      PMST_GOAL_CONFIG: 'Objectius PMST',
      PMST_QUESTIONNAIRE_CONFIG: 'Formulari PMST',
      PMST_QUESTIONNAIRE_RESPONSES: 'Respostes PMST',
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Ajustos',
      RIDES_CONFIG_GUEST_PHONES: 'Telèfons convidats',
      RIDES_CONFIG_PROVIDERS: 'Proveïdors',
      RIDES_CONFIG_PROVIDER_ROUTING: 'Enrutament per etiqueta',
      RIDES_CONFIG_BOOKINGS: 'Reserves de grup',
      RIDES_CONFIG_REVIEW: 'Revisió de viatges',
      FACE_VERIFICATION_CONFIG: 'Verificació facial',
      CRAFTED: 'Crafted',
      PAGES: 'Pages',
      PROFILE: 'Perfil',
      OVERVIEW: 'Resum',
      PROJECTS: 'Projectes',
      CAMPAIGNS: 'Campanyes',
      DOCUMENTS: 'Documents',
      CONNECTIONS: 'Connexions',
      WIZARDS: 'Wizards',
      HORIZONTAL: 'Horitzontal',
      VERTICAL: 'Vertical',
      ACCOUNTS: 'Comptes',
      SETTINGS: 'Configuracions',
      ERRORS: 'Errors',
      ERROR_404: 'Error 404',
      ERROR_500: 'Error 500',
      WIDGETS: 'Widgets',
      LISTS: 'Llistes',
      STATISTICS: 'Estadístiques',
      CHARTS: 'Gràfiques',
      MIXED: 'Mixt',
      TABLES: 'Taules',
      FEEDS: 'Feeds',
      APPS: 'Apps',
      CHAT: 'Xat',
      PRIVATE_CHAT: 'Xat privat',
      GROUP_CHAT: 'Xat grupal',
      DRAWER_CHAT: 'Xat lateral',
      USER_MANAGEMENT: "Gestió d'Usuaris",
      USERS_MANAGEMENT: 'Usuaris',
      ROLES: 'Rols',
      PERMISSIONS: 'Permisos',
      USER_ROLE_CORPORATIONS: 'Usuaris',
      AUTHORIZATION_DASHBOARD: "Tauler d'Autorització",
      APP_SECTION: 'APP',
      VALORATION_LABELS: 'Valoracions',
      LABELS: "Etiquetes d'usuaris i rutes",
      PERMISSIONS_ERROR: 'Error en carregar els permisos',
      RELOAD: 'Recarregar',
      NO_ACCESS: 'Sense accés a cap pàgina',
      UNSEEN_CORPORATIONS: '{{count}} empreses noves sense revisar',
    },
    PAGES: {
      COMING_SOON: {
        ALT: 'Properament',
        TITLE: 'Hi estem treballant!',
        TEXT: 'Aquesta secció estarà disponible properament.',
        THANKS: 'Gràcies per la teva paciència.',
      },
      VISIT_SURVEY: {
        DEFAULT_WHO: 'Enquesta de mobilitat al centre de treball',
        CENTER: 'Centre: {{name}}',
        TITLE: 'Enquesta de mobilitat',
        LEAD: 'Per a visitants, clients i proveïdors. Ens ajuda a elaborar el Pla de Mobilitat Sostenible a la Feina (PMST) del centre, d\'acord amb la Llei 9/2025. Et portarà menys de 2 minuts i és anònima.',
        Q1: '1. Quin és el motiu principal de la seva visita?',
        Q2: '2. Amb quina freqüència visita les nostres instal·lacions?',
        Q3: '3. Des de quin codi postal es desplaça habitualment per arribar a les nostres instal·lacions?',
        Q3_PLACEHOLDER: 'Ex.: 08025',
        Q3_HINT: 'No demanem l\'adreça exacta, per privacitat.',
        Q4: '4. Quin és el mitjà de transport principal que utilitza per accedir al centre?',
        Q5: '5. Ha trobat alguna dificultat per accedir o desenvolupar la seva activitat a les nostres instal·lacions?',
        Q6: '6. Quina mesura creu que podria millorar l\'accés o la mobilitat associada a aquest centre?',
        SUBMIT: 'Envia la resposta',
        THANKS_TITLE: 'Gràcies!',
        THANKS_TEXT: 'La teva resposta s\'ha registrat i ajudarà a millorar la mobilitat d\'aquest centre. Pots tancar aquesta finestra.',
        FOOT: 'WAIIS · Enquesta vinculada a l\'ATM per al PMST (Llei 9/2025). Dades tractades de manera agregada i anònima.',
        OPT: {
          CLIENT: 'Client',
          SUPPLIER: 'Proveïdor',
          CARRIER: 'Transportista / Logística',
          PARTNER: 'Empresa col·laboradora',
          MEETING: 'Reunió de feina',
          TECH: 'Servei tècnic / manteniment',
          OTHER_M: 'Altre',
          OTHER_F: 'Altra',
          FIRST_TIME: 'Primera vegada',
          SEVERAL_YEAR: 'Diverses vegades l\'any',
          SEVERAL_MONTH: 'Diverses vegades al mes',
          WEEKLY: 'Setmanalment',
          DAILY: 'Diàriament o gairebé cada dia',
          CAR: 'Cotxe',
          VAN: 'Furgoneta',
          TRUCK: 'Camió',
          MOTORBIKE: 'Moto',
          PUBLIC_TRANSPORT: 'Transport públic',
          CARPOOL: 'Cotxe compartit',
          BIKE: 'Bicicleta',
          SCOOTER: 'Patinet',
          WALK: 'A peu',
          NONE: 'Cap',
          TRAFFIC: 'Trànsit',
          NO_PARKING: 'Manca d\'aparcament',
          POOR_PT: 'Transport públic insuficient',
          HARD_ACCESS: 'Accessos complicats',
          NO_LOADING: 'Manca d\'espai per a càrrega i descàrrega',
          WAITING: 'Temps d\'espera',
          BETTER_ACCESS: 'Millor organització d\'accessos',
          MORE_PARKING: 'Més aparcament',
          BETTER_PT: 'Millor connexió amb transport públic',
          MORE_LOADING: 'Més espai per a càrrega i descàrrega',
          BETTER_SIGNS: 'Millor senyalització',
          LESS_WAITING: 'Reducció dels temps d\'espera',
        },
      },
      DASHBOARD: {
        TITLE: 'Tauler',
        CORPORATIONS_SECTION: 'Empreses',
        CORPORATION_OFFICES_SECTION: 'Seus Corporatives',
        CREATE_CORPORATION_TITLE: 'Alta de nova empresa',
        CREATE_CORPORATION_DESCRIPTION:
          "Crea una nova companyia introduint les dades bàsiques. A continuació podràs seguir configurant-la al tauler.",
        CREATE_CORPORATION_BUTTON: 'Crear empresa',
        NO_ACCESS: 'No tens accés a Empreses o Seus',
        NO_ACCESS_SUBTITLE:
          "Contacta amb l'administrador si creus que això és un error",
        ROLE_LABEL: 'Rol:',
        ID_LABEL: 'ID:',
        COMPANY_LABEL: 'Empresa:',
        HUB: {
          TITLE: 'On vols entrar?',
          SUBTITLE: 'Tria l\'administració de WAIIS o una de les teves empreses i seus.',
          ADMIN_SECTION: 'Administració',
          ADMIN_CARD_TITLE: 'Administració WAIIS',
          ADMIN_CARD_META: 'Gestió global de la plataforma',
          PARTNER_SECTION: 'Partner',
          PARTNER_CARD_META: 'Partner admin · {{count}} empresa/es',
          CORPORATIONS_SECTION: 'Empreses',
          OFFICES_SECTION: 'Seus',
          NEW_CORPORATION_SECTION: 'Nova empresa',
          CREATE_CARD_TITLE: 'Crear empresa',
          CREATE_CARD_META: 'Registra una nova empresa a la plataforma',
          EMPTY_TITLE: 'Sense accés assignat',
          EMPTY_SUBTITLE: 'Contacta amb el teu administrador per obtenir permisos.',
          NO_NAME: 'Sense nom',
          UNKNOWN_CORPORATION: 'Empresa desconeguda',
          ROLE_FALLBACK: 'Rol #{{id}}',
        },
      },
      CORPORATIONS_LIST: {
        TITLE: 'Empreses',
        LEGAL_NAME: 'Nom Legal',
        TRADE_NAME: 'Nom Comercial',
        TAX_ID: 'NIF/CIF',
        CONTACT_EMAIL: 'Correu de Contacte',
        STATUS: 'Estat',
        REFRESH: 'Actualitzar',
        LOADING: 'Carregant...',
        NO_CORPORATIONS: 'No hi ha empreses registrades.',
        ACTIVE: 'Activa',
        INACTIVE: 'Inactiva',
      },
      CORPORATIONS_LISTING: {
        SEARCH_PLACEHOLDER: 'Cercar empresa',
        COL_TRADE_NAME: 'Nom Comercial',
        COL_LEGAL_NAME: 'Nom Legal',
        COL_TAX_ID: 'NIF/CIF',
        COL_CONTACT_EMAIL: 'Correu de Contacte',
        COL_ACTIVE: 'Activa',
        EXPORT_EMPTY_TEXT: 'No hi ha empreses per exportar.',
        IMPORT_SUCCESS_TEXT: "S'han importat {{count}} empreses correctament.",
      },
      CORPORATION_DETAIL: {
        ERR_NO_ID: 'No s\'ha proporcionat cap ID d\'empresa',
        ERR_PARAMS: 'Error en obtenir els paràmetres de l\'URL',
        ERR_UPDATE: 'Error en actualitzar la informació de l\'empresa',
        ERR_TIMEOUT: 'La petició ha trigat massa (més de 10 segons). Comprova la connexió.',
        ERR_LOAD: 'Error en carregar l\'empresa: {{msg}}',
        ERR_UNKNOWN: 'Error desconegut',
        ERR_OFFICES_TIMEOUT: 'La càrrega de seus ha trigat massa',
        ERR_OFFICES: 'Error en carregar les seus: {{msg}}',
        ERR_ADMINS_TIMEOUT: 'La càrrega d\'administradors ha trigat massa',
        ERR_ADMINS: 'Error en carregar els administradors: {{msg}}',
        ID: 'ID',
        CLOSE: 'Tanca',
        EMAIL_PLACEHOLDER: 'usuari@exemple.com',
        TITLE: "Detall d'Empresa",
        BACK_BUTTON: 'Tornar',
        LOADING: "Carregant informació de l'empresa...",
        ERROR: 'Error',
        TAB_OVERVIEW: 'Informació',
        TAB_OFFICES: 'Oficines',
        TAB_FUNNEL: 'Funnel',
        TAB_TRAVEL: 'Viatges',
        TAB_PARKING: 'Parking',
        TAB_SUSTAINABILITY: 'Sostenibilitat',
        TAB_CONVERSION: 'Conversió',
        TAB_USAGE: 'Ús',
        TAB_ADMINS: 'Administradors',
        TAB_KPIS: 'KPIs de Mobilitat',
        GENERAL_INFORMATION: 'Informació general',
        ADDITIONAL_INFORMATION: 'Informació addicional',
        FISCAL_INFO: 'Informació Fiscal',
        LEGAL_NAME: 'Nom Legal:',
        TRADE_NAME: 'Nom Comercial:',
        TAX_ID: 'NIF/CIF:',
        CONTACT_INFO: 'Informació de Contacte',
        CONTACT_NAME: 'Nom de Contacte:',
        CONTACT_PHONE: 'Telèfon de Contacte:',
        CONTACT_EMAIL: 'Correu de Contacte:',
        FISCAL_ADDRESS_SECTION: 'Adreça fiscal',
        FISCAL_ADDRESS: 'Adreça Fiscal:',
        FISCAL_CITY: 'Ciutat Fiscal:',
        FISCAL_POSTAL_CODE: 'Codi Postal Fiscal:',
        COMMERCIAL_ADDRESS_SECTION: 'Adreça comercial',
        COMMERCIAL_ADDRESS: 'Adreça Comercial:',
        COMMERCIAL_CITY: 'Ciutat Comercial:',
        COMMERCIAL_POSTAL_CODE: 'Codi Postal Comercial:',
        STATUS_LABEL: 'Estat',
        CREATED_AT: 'Creat',
        UPDATED_AT: 'Actualitzat',
        OFFICES: 'Seus',
        NO_OFFICES: 'No hi ha seus registrades',
        OFFICES_LOADING: 'Carregant seus...',
        ADMINS_LOADING: 'Carregant administradors...',
        ADMINS_TITLE: 'Administradors',
        NO_ADMINS: 'No hi ha administradors assignats',
        ADMINS: 'Administradors',
        ADMIN_NAME: 'Nom',
        ADMIN_EMAIL: 'Correu',
        ADMIN_ROLE: 'Rol',
        ADD_ADMIN: 'Afegir administrador',
        ASSIGN_ADMIN: 'Assignar Administrador',
        ASSIGN_ADMIN_TITLE: "Assignar Administrador d'Empresa",
        ASSIGN_ROLE: 'Assignar rol',
        EMAIL_LABEL: 'Correu',
        EMAIL_REQUIRED: 'El correu és obligatori',
        EMAIL_INVALID: 'Correu no vàlid',
        SELECT_USER: 'Seleccionar Usuari',
        SELECT_ROLE: 'Seleccionar Rol',
        ASSIGN: 'Assignar',
        CANCEL: 'Cancel·lar',
        ASSIGNING: 'Assignant...',
        ADMIN_ASSIGNED_SUCCESS: 'Administrador assignat correctament',
        ADMIN_ASSIGN_ERROR: 'Error en assignar administrador',
        ASSIGN_SUCCESS: 'Administrador assignat correctament',
        ASSIGN_ERROR: 'Error en assignar administrador',
        USER_REQUIRED: 'Cal seleccionar un usuari',
        ROLE_REQUIRED: 'Cal seleccionar un rol',
        HEADING_OFFICES: 'Treballadors',
        HEADING_FUNNEL: 'Funnel',
        HEADING_TRAVEL: 'Viatges',
        HEADING_PARKING: 'Reserves',
        HEADING_SUSTAINABILITY: 'Sostenibilitat',
        HEADING_CONVERSION: 'Subvenció',
        HEADING_USAGE: 'Ús',
        HEADING_PRICING_CONFIGS: 'Polítiques',
        HEADING_SUBSIDY_CONSUMPTIONS: 'Incentius',
        HEADING_POOLING_RUNNERS: 'Flota',
        HEADING_ADMINS: 'Configuració',
        EDIT_BUTTON: 'Editar',
        EDIT_MODAL_TITLE: 'Editar informació general',
        FIELD_REQUIRED: 'Camp requerit',
        INVALID_TAX_ID: 'El CIF no és vàlid. Revisa la lletra, els dígits i el caràcter de control.',
        ACTIVE_CHECKBOX: 'Corporació activa',
        CANCEL_BUTTON: 'Cancel·lar',
        SAVE_BUTTON: 'Desar',
        SAVING: 'Desant...',
        SUCCESS_TITLE: 'Èxit!',
        UPDATE_SUCCESS_TEXT: "La informació general de la corporació s'ha actualitzat correctament.",
        ERROR_TITLE: 'Error',
      },
      CORPORATION_SETTINGS: {
        COMPANY_INFO: {
          TITLE: "Dades de l'empresa",
          SUBTITLE: 'Informació fiscal i de contacte de la corporació',
          LOGO_LABEL: "Logo de l'empresa",
          LOGO_HINT: 'PNG, JPEG o WEBP. Màx. 4 MB.',
          LOGO_UPLOAD: 'Puja el logo',
          LOGO_CHANGE: 'Canvia el logo',
          LOGO_REMOVE: 'Treu',
          LOGO_ERROR_TYPE: 'Format no admès — fes servir PNG, JPEG o WEBP.',
          LOGO_ERROR_SIZE: 'El logo no pot superar els 4 MB.',
          LEGAL_NAME: 'Raó social',
          LEGAL_NAME_PLACEHOLDER: "Nom legal de l'empresa",
          TAX_ID: 'CIF/NIF',
          INVALID_TAX_ID: 'El CIF, NIF o NIE no és vàlid. Revisa la lletra, els dígits i el caràcter de control.',
          FISCAL_ADDRESS: 'Adreça fiscal',
          FISCAL_ADDRESS_PLACEHOLDER: 'Carrer, número, pis',
          CITY: 'Ciutat',
          POSTAL_CODE: 'Codi postal',
          CONTACT_NAME: 'Persona de contacte',
          CONTACT_NAME_PLACEHOLDER: 'Nom i cognoms',
          CONTACT_EMAIL: 'Email de contacte',
          CONTACT_PHONE: 'Telèfon de contacte',
          NUM_EMPLOYEES: "Núm. de treballadors",
          NUM_OFFICES: 'Núm. de centres',
          PMST_ENABLED: 'Implantar el PMST amb WAIIS',
          PMST_ENABLED_HINT: "Si el desactives, la pantalla de PMST queda bloquejada per a aquesta empresa.",
          SAVE: 'Desar canvis',
          SAVING: 'Desant...',
          SAVE_SUCCESS_TITLE: 'Canvis desats',
          SAVE_ERROR_TITLE: "No s'han pogut desar els canvis",
          SAVE_ERROR_TEXT: 'Revisa les dades i torna-ho a provar.',
        },
        CONTRACT_PREVIEW: {
          BUTTON: 'Veure contracte',
          MODAL_TITLE: 'Contracte de prestació de serveis',
          LOADING: 'Generant contracte...',
          CLOSE: 'Tancar',
          RETRY: 'Tornar-ho a provar',
          ERROR_403: 'No tens permisos per veure el contracte d\'aquesta empresa.',
          ERROR_404: 'L\'empresa no existeix.',
          ERROR_GENERIC: 'No s\'ha pogut carregar el contracte. Torna-ho a provar.',
        },
        INVITE_CODE: {
          TITLE: 'Codi d\'invitació',
          SUBTITLE: 'Comparteix-lo perquè els empleats es donin d\'alta de forma autònoma',
          COPY: 'Copiar',
          COPIED: 'Copiat!',
          EMPTY: 'Aquesta empresa no té codi d\'invitació',
        },
        OFFICES: {
          TITLE: 'Seus',
          SUBTITLE: 'Centres de treball de la corporació',
          CREATE: 'Crear seu',
          NOTE: 'Cada seu pot tenir administradors i usuaris propis.',
          EXTRA_OFFICE_NOTE: 'Cada centre addicional suma 20 €/mes al Pla Incentius.',
          EMPTY: 'Sense seus registrades',
          ACTIVE: 'Activa',
          INACTIVE: 'Inactiva',
          TABLE_NAME: 'Nom',
          TABLE_CITY: 'Ciutat',
          TABLE_CONTACT: 'Contacte',
          TABLE_ACTIVE: 'Estat',
          MISSING_PRE: 'Falten',
          PENDING_SINGULAR: 'centre per crear',
          PENDING_PLURAL: 'centres per crear',
          MISSING_POST: 'dels',
          MISSING_SUFFIX: 'declarats. Crea-les aquí.',
          DELETE: 'Eliminar seu',
          DELETE_CONFIRM_TITLE: 'Vols eliminar aquesta seu?',
          DELETE_CONFIRM_TEXT: "S'eliminarà \"{{name}}\" de manera permanent. Aquesta acció no es pot desfer.",
          DELETE_SUCCESS_TITLE: 'Seu eliminada',
          DELETE_ERROR_TITLE: "No s'ha pogut eliminar la seu",
        },
        OFFICE_MODAL: {
          NEW_TITLE: 'Nova seu',
          NEW_SUBTITLE: 'Omple les dades de la nova seu',
          EDIT_SUBTITLE: "Edita les dades d'aquesta seu",
          NAME_LABEL: 'Nom *',
          NAME_PLACEHOLDER: 'Seu Barcelona',
          CONTACT_NAME_LABEL: 'Persona de contacte *',
          CONTACT_NAME_PLACEHOLDER: 'Nom i cognoms',
          CONTACT_PHONE_LABEL: 'Telèfon *',
          CONTACT_EMAIL_LABEL: 'Email de contacte *',
          ADDRESS_LABEL: 'Adreça *',
          ADDRESS_PLACEHOLDER: 'Carrer, número, pis',
          CITY_LABEL: 'Ciutat *',
          POSTAL_CODE_LABEL: 'Codi postal *',
          CANCEL: 'Cancel·lar',
          SAVE: 'Crear seu',
          SAVE_CHANGES: 'Desar canvis',
          SAVING: 'Desant...',
          ERROR_SAVE: 'No s\'ha pogut desar la seu. Torna-ho a provar.',
        },
        WALLET: {
          TITLE: 'La meva cartera',
          BALANCE_LABEL: 'Saldo disponible',
          RECHARGE: 'Recarregar',
          WITHDRAW: 'Retirar',
        },
        ADMINS: {
          TITLE: 'Administradors',
          SUBTITLE: "Usuaris amb permisos d'administració sobre aquesta corporació",
          ADD: 'Afegir admin',
          EMAIL_LABEL: 'Email',
          EMAIL_PLACEHOLDER: 'Cerca usuari per email...',
          EMAIL_NOTICE: 'Només els emails ja registrats a WAIIS podran ser administradors d\'una empresa o seu.',
          ROLE_LABEL: 'Rol',
          ROLE_CORPORATION_ADMIN: "Admin d'empresa",
          ROLE_OFFICE_ADMIN: 'Admin de seu',
          OFFICE_LABEL: 'Seu',
          SELECT_OFFICE_PLACEHOLDER: 'Selecciona una seu',
          ADDING: 'Afegint...',
          CONFIRM: 'Confirmar',
          CANCEL: 'Cancel·lar',
          ERROR_TITLE: "S'ha produït un error",
          ERROR_ADD: "No s'ha pogut afegir l'administrador. Torna-ho a provar.",
          ERROR_EMAIL_NOT_FOUND: "Només es poden afegir com a administradors usuaris que ja estiguin registrats a WAIIS.",
          ALL_OFFICES: 'Totes les seus',
          TABLE_USER: 'Usuari',
          TABLE_ROLE: 'Rol',
          TABLE_EMAIL: 'Email',
          REMOVE_TITLE: 'Eliminar permís',
          EMPTY: 'Sense administradors assignats',
          ROLE_ADMIN_DISPLAY: 'Admin',
          ROLE_OFFICE_ADMIN_DISPLAY: "Admin d'oficina",
        },
        DELETE: {
          ZONE_TITLE: 'Eliminar empresa',
          ZONE_DESC: "S'eliminarà l'empresa i totes les seves dades. Aquesta acció no es pot desfer.",
          CONFIRM_TITLE: 'Eliminar empresa?',
          CONFIRM_HTML:
            "Estàs a punt d'eliminar <strong>{{name}}</strong> i totes les seves dades. Aquesta acció no es pot desfer.<br><br>Escriu el nom per confirmar:",
          CONFIRM_BUTTON: 'Eliminar definitivament',
          CANCEL_BUTTON: 'Cancel·lar',
          NAME_MISMATCH: 'El nom no coincideix.',
          SUCCESS_TITLE: 'Empresa eliminada',
          ERROR_TITLE: "No s'ha pogut eliminar",
          ERROR_TEXT: 'Torna-ho a provar més tard.',
        },
      },
      PMST: {
        FORM: {
          TITLE: 'Formulari d\'empresa · PMST',
          PROGRESS: '{{answered}} / {{total}} obligatòries respostes',
          AUTOSAVE_HINT: 'Es desa automàticament en emplenar cada camp: el pots tancar i continuar més endavant.',
          INHERITED: 'Aquests són els valors desats a nivell d\'empresa. Aquesta seu encara no té resposta pròpia: tan bon punt desis, deixarà de seguir l\'empresa.',
          REQUIRED: 'Obligatòria',
          ADD_ROW: 'Afegeix una fila',
          UPLOADING: 'Pujant…',
          SELECT_FILE: 'Selecciona un fitxer',
          PREVIOUS: 'Anterior',
          SAVE_AND_EXIT: 'Desa i surt',
          NEXT: 'Següent',
          FINISH: 'Finalitza',
          QUESTIONNAIRE: 'Qüestionari',
          VIEW_DOCUMENT: 'Mostra el document',
          QR: 'QR',
          SEND_ERROR: 'No s\'ha pogut enviar la resposta',
          SELECT_OFFICE: 'Selecciona una seu',
          SELECT_OFFICE_TEXT: 'El teu compte necessita una seu concreta per emplenar el PMST.',
          MISSING_TITLE: 'Falten preguntes obligatòries',
          MISSING_TEXT_ONE: 'Et queda 1 pregunta obligatòria per respondre.',
          MISSING_TEXT_OTHER: 'Et queden {{n}} preguntes obligatòries per respondre.',
          DONE_TITLE: 'Formulari completat',
          DONE_TEXT: 'Ja pots veure el document generat.',
        },
        PMST_DISABLED: "Aquesta empresa no té activat el PMST amb WAIIS.",
        TOOLBAR: {
          MY_COMPANY: 'La meva empresa',
          ALL_CENTERS: 'Tots els centres',
        },
        HERO: {
          STATUS_BADGE: 'Pla en curs',
          TITLE: 'Pla de Mobilitat Sostenible a la Feina',
          SUBTITLE: "El PMST és una obligació legal per als centres de treball amb més de 200 treballadors o més de 100 per torn (Llei 9/2025). El termini màxim per a la seva implantació finalitza el {{deadline}} (RDL 7/2026).",
          DAYS_LABEL: 'dies per al<br />{{deadline}}',
          PROGRESS_CAPTION: 'Registre actual · {{registered}} / {{total}} de la plantilla',
          LEGEND_YOU: 'Tu · {{percent}}%',
          LEGEND_MIN: 'Mínim PMST · {{percent}}% de la plantilla',
          LEGEND_GOAL: 'Meta empresa {{percent}}%',
          ACTION_INVITE: 'Carregar i convidar treballadors',
          ACTION_COMPLETE_DATA: 'Completar dades',
          ACTION_INCENTIVES: 'Gestionar incentius',
          ACTION_ADD_DOC: 'Afegir documentació extra',
        },
        REQUIREMENTS: {
          SECTION_LABEL: 'REQUISITS DEL PMST',
          COMPANY_DATA: "Dades d'empresa registrades",
          OFFICES: 'Oficines i seus registrades ({{count}} seus)',
          MOBILITY_MEASURES: 'Mesures de mobilitat compartida actives',
          STAFF_REGISTRATION: 'Registre de plantilla',
          STAFF_REGISTRATION_SUBTITLE: 'de la plantilla declarada',
          PMST_PENDING_OFFICES: 'Pendent a: {{offices}}',
          PMST_DOCUMENT: 'Document PMST generat i validat',
        },
        STATUS: {
          COMPLETED: 'Completat',
          PROGRESS: 'En curs',
          PENDING: 'Pendent',
        },
        EXTRA_DOCS: {
          SECTION_LABEL: 'DOCUMENTACIÓ EXTRA',
          DOWNLOAD: 'Descarregar',
          DELETE: 'Eliminar',
          EMPTY: 'Encara no has afegit documentació extra.',
          UPLOAD_ERROR_TITLE: 'Error en pujar el document',
          UPLOAD_ERROR_TEXT: 'No s\'ha pogut pujar el fitxer. Comprova el format i la mida.',
        },
        EXTRA_DOCS_MODAL: {
          TITLE: 'Afegir documentació extra',
          DESC: 'Puja qualsevol document i dona-li un nom per afegir-lo al teu PMST.',
          NAME_LABEL: 'Nom del document',
          NAME_PLACEHOLDER: 'Ex.: Conveni de transport 2026',
          FILE_LABEL: 'Arxiu',
          FILE_PICKER: "Seleccionar arxiu des del teu equip",
          FILE_HINT: 'Ex: enquestes, aparcaments, convenis, etc.',
          SUBMIT: 'Afegir document',
        },
        VISITORS: {
          TITLE: 'Enquesta de visitants, clients i proveïdors',
          DESC: "Comparteix el <strong>formulari en línia</strong> amb visitants i proveïdors habituals; les seves respostes, vinculades a la teva empresa, alimenten l'informe PMST.",
          LINK_LABEL: "Enllaç del formulari de la teva empresa",
          COPY: 'Copiar',
          COPIED: 'Copiat',
          QR_ALT: 'Codi QR del formulari',
          OPEN_FORM: 'Obrir formulari',
          SEND_EMAIL: 'Enviar per correu',
          PDF_VERSION: 'Versió PDF',
        },
      },
      PMST_GOAL_CONFIG: {
        TITLE: 'Objectius de registre PMST',
        SUBTITLE: "Selecciona una empresa (i opcionalment una seu) per configurar el percentatge mínim exigit per llei i la meta pròpia de plantilla registrada per al PMST.",
        CORPORATION_LABEL: 'Empresa',
        CORPORATION_PLACEHOLDER: 'Selecciona una empresa',
        OFFICE_LABEL: 'Seu (opcional)',
        OFFICE_PLACEHOLDER: "Tota l'empresa",
        MIN_LABEL: 'Mínim PMST (%)',
        MIN_HINT: 'Percentatge mínim de plantilla registrada exigit per llei.',
        TARGET_LABEL: 'Meta de empresa (%)',
        TARGET_HINT: "Percentatge que l'empresa vol assolir com a objectiu propi.",
        CURRENT_STATUS: 'Registrats actualment',
        SAVE: 'Desar objectius',
        SAVING: 'Desant…',
        SAVED: 'Objectius desats correctament.',
        ERROR_LOAD: "No s'ha pogut carregar la configuració d'objectius.",
        ERROR_SAVE: "No s'ha pogut desar. Torna-ho a provar.",
        ERROR_TITLE: 'Error',
        ACCEPT: "D'acord",
        SECTION_SCOPE: 'Empresa i seu',
        SECTION_SCOPE_SUB: "A qui s'apliquen els objectius: a tota l'empresa o a una de les seves seus.",
        SECTION_GOALS: 'Objectius de plantilla registrada',
        SECTION_GOALS_SUB: "Percentatges de la plantilla que ha d'estar registrada al PMST.",
        LOADING: 'Carregant la configuració…',
      },
      PMST_QUESTIONNAIRE_RESPONSES: {
        TITLE: 'Respostes del qüestionari PMST',
        SUBTITLE: 'Selecciona una empresa (i opcionalment una seu) per veure les respostes que ha enviat cada persona empleada.',
        CORPORATION_LABEL: 'Empresa',
        CORPORATION_PLACEHOLDER: 'Selecciona una empresa',
        OFFICE_LABEL: 'Seu (opcional)',
        OFFICE_PLACEHOLDER: "Tota l'empresa",
        NO_RESPONSES: 'Encara no hi ha cap resposta enviada.',
        SUBMITTED_AT: 'Enviat:',
        UNANSWERED: 'Sense respondre',
        ERROR_TITLE: 'Error',
        ERROR_LOAD: 'No s\'han pogut carregar les respostes.',
        ERROR_FORBIDDEN: 'No tens accés a les respostes d\'aquesta empresa.',
        ACCEPT: "D'acord",
        SECTION_SCOPE: 'Empresa i seu',
        SECTION_SCOPE_SUB: "De quina empresa i, si vols, de quina seu veure'n les respostes.",
        LOADING: 'Carregant les respostes…',
        ERROR_LOAD_TITLE: "No s'han pogut carregar les respostes",
      },
      CORPORATION_OFFICES_LIST: {
        TITLE: 'Seus Corporatives',
        CORPORATION: 'Empresa',
        NAME: 'Nom',
        CONTACT_NAME: 'Nom de Contacte',
        CONTACT_EMAIL: 'Correu de Contacte',
        CONTACT_PHONE: 'Telèfon de Contacte',
        CITY: 'Ciutat',
        STATUS: 'Estat',
        REFRESH: 'Actualitzar',
        LOADING: 'Carregant...',
        NO_OFFICES: 'No hi ha seus registrades.',
        ACTIVE: 'Activa',
        INACTIVE: 'Inactiva',
      },
      CORPORATION_OFFICES_LISTING: {
        SEARCH_PLACEHOLDER: 'Cercar seu',
        CREATE_OFFICE: 'Crear seu',
        COL_NAME: 'Nom',
        COL_CONTACT: 'Contacte',
        COL_PHONE: 'Telèfon',
        COL_EMAIL: 'Correu',
        COL_CITY: 'Ciutat',
        COL_ACTIVE: 'Activa',
        EXPORT_EMPTY_TEXT: 'No hi ha seus per exportar.',
        IMPORT_SUCCESS_TEXT: "S'han importat {{count}} seus correctament.",
      },
      CORPORATION_OFFICE_DETAIL: {
        TEXTS: {
          ERROR: 'Error',
          SUCCESS: 'Fet',
          ACCEPT: 'D\'acord',
          ERR_UPDATE_OFFICE: 'Error en actualitzar la informació de la seu',
          ERR_CREATE_OFFICE: 'Error en crear la seu',
          USERS_LINKED: 'Usuaris vinculats correctament',
          ERR_LINK_USERS: 'Error en vincular els usuaris',
          OFFICE_NOT_FOUND: 'No s\'ha trobat la seu',
          OFFICE_TIMEOUT: 'S\'ha esgotat el temps d\'espera en carregar la seu',
          OFFICE_LOAD_ERROR: 'Error en carregar la seu',
          USERS_TIMEOUT: 'S\'ha esgotat el temps d\'espera en carregar els usuaris',
          USERS_LOAD_ERROR: 'Error en carregar els usuaris',
          INVALID_CSV: 'Selecciona un fitxer CSV vàlid',
          IMPORT_OK: 'Usuaris importats correctament',
          IMPORT_ERROR: 'Error en importar usuaris del CSV',
          USER_UPDATED: 'Usuari actualitzat correctament',
          USER_UPDATE_ERROR: 'Error en actualitzar l\'usuari',
          USER_ADDED: 'Usuari afegit correctament',
          USER_ADD_ERROR: 'Error en crear l\'usuari',
          DT_SEARCH: 'Cerca:',
          DT_LENGTH: 'Mostra _MENU_ registres',
          DT_ZERO: 'No s\'han trobat registres',
          DT_INFO: 'Es mostren del _START_ al _END_ de _TOTAL_ registres',
          DT_INFO_EMPTY: 'Es mostren 0 registres',
          DT_INFO_FILTERED: '(filtrat de _MAX_ registres totals)',
          DT_FIRST: 'Primer',
          DT_LAST: 'Últim',
          DT_NEXT: 'Següent',
          DT_PREVIOUS: 'Anterior',
          COL_SPACE: 'Plaça',
          COL_TYPE: 'Tipus',
          COL_USER: 'Usuari',
          COL_RESERVED_DAYS: 'Dies reservats',
          COL_SHIFT: 'Torn',
          COL_SHARING: 'Compartint',
          COL_ACTIVE_F: 'Activa',
          COL_ACTIVE: 'Actiu',
          COL_LOCATION: 'Ubicació',
          COL_OFFICE: 'Seu',
          COL_ROLE: 'Rol',
          COL_CREDIT: 'Crèdit',
          COL_EXPIRY: 'Caducitat',
          COL_CODE: 'Codi',
          COL_ENTRY: 'Entrada',
          COL_EXIT: 'Sortida',
          NOT_ASSIGNED: 'No assignat',
          YES: 'Sí',
          NO: 'No',
          BUSY: 'Ocupat',
          FREE: 'Lliure',
          CLOSE: 'Tanca',
          EMAIL_PLACEHOLDER: 'usuari@exemple.com',
        },
        TITLE: 'Detall de Seu',
        BACK_BUTTON: 'Tornar',
        TAB_OVERVIEW: 'Informació general',
        TAB_USERS: 'Usuaris adscrits',
        TAB_MANAGERS: 'Gestors',
        TAB_KPIS: 'KPIs de Mobilitat',
        GENERAL_INFORMATION: 'Informació general',
        ADDITIONAL_INFORMATION: 'Informació addicional',
        CONTACT_PERSON: 'Persona de Contacte',
        CONTACT_PHONE: 'Telèfon de Contacte',
        CONTACT_EMAIL: 'Correu de Contacte',
        STATUS: 'Estat',
        COMMERCIAL_ADDRESS: 'Adreça Comercial',
        CITY: 'Ciutat',
        POSTAL_CODE: 'Codi Postal',
        LOADING: 'Carregant informació de la seu...',
        LOADING_USERS: 'Carregant usuaris...',
        ERROR: 'Error',
        USERS: 'Usuaris',
        USER_NAME: 'Nom',
        USER_EMAIL: 'Correu',
        USER_PHONE: 'Telèfon',
        USER_CORPORATE_EMAIL: 'Correu Corporatiu',
        USER_PERSONAL_EMAIL: 'Correu Personal',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: 'Departament',
        USER_CORPORATE_PHONE: 'Telèfon Corporatiu',
        USER_CONFIRMED: 'Confirmat',
        USER_ROLE: 'Rol',
        OFFICE_CODE: "Codi d'Oficina",
        CORPORATION: 'Corporació',
        CREATED_AT: 'Creat:',
        UPDATED_AT: 'Actualitzat:',
        NO_USERS: 'No hi ha usuaris en aquesta seu',
        WAIIS_LINK: 'Veure a WAIIS',
        DELETE_USER: 'Eliminar',
        DELETE_CONFIRMATION:
          'Estàs segur que vols eliminar aquest usuari?',
        DELETE_CONFIRM_BUTTON: 'Sí, eliminar',
        DELETE_CANCEL_BUTTON: 'Cancel·lar',
        ACTIONS: 'Accions',
        EDIT_USER: 'Editar usuari',
        ADD_USER: 'Afegir usuari',
        REQUIRED_FIELDS: 'Camps obligatoris',
        OPTIONAL_FIELDS:
          "Camps opcionals (almenys un d'ells obligatori)",
        NAME: 'Nom',
        SURNAME: 'Cognoms',
        DEPARTMENT: 'Departament',
        CORPORATE_EMAIL: 'Correu corporatiu',
        PERSONAL_EMAIL: 'Correu personal',
        DNI: 'DNI',
        CORPORATE_PHONE: 'Telèfon corporatiu',
        PERSONAL_PHONE: 'Telèfon personal',
        CONFIRMED: 'Confirmat',
        STATUS_PENDING: 'Pendent',
        STATUS_REJECTED: 'Rebutjat',
        STATUS_ACCEPTED: 'Acceptat',
        STATUS_ACTIVE: 'Actiu',
        STATUS_INACTIVE: 'Inactiu',
        CANCEL: 'Cancel·lar',
        SAVE_USER: 'Desar usuari',
        UPDATE_USER: 'Actualitzar usuari',
        WAIT: 'Espera',
        UPLOAD_CSV: 'Pujar CSV',
        UPLOADING: 'Pujant...',
        LINK_USERS: 'Vincular usuaris',
        LINKING: 'Vinculant...',
        ERROR_REQUIRED_FIELD: 'Camp obligatori',
        ERROR_INVALID_EMAIL: 'Correu no vàlid',
        ERROR_MIN_LENGTH: 'Ha de tenir almenys 2 caràcters',
        ERROR_INVALID_FIELD: 'Camp no vàlid',
        MANAGERS_LOADING: 'Carregant gestors...',
        MANAGERS_TITLE: 'Gestors',
        NO_MANAGERS: 'No hi ha gestors assignats',
        MANAGERS: 'Gestors',
        MANAGER_NAME: 'Nom',
        MANAGER_EMAIL: 'Correu',
        MANAGER_ROLE: 'Rol',
        ADD_MANAGER: 'Afegir gestor',
        ASSIGN_MANAGER: 'Assignar Gestor',
        ASSIGN_MANAGER_TITLE: 'Assignar Administrador de Seu',
        ASSIGN_ROLE: 'Assignar rol',
        EMAIL_LABEL: 'Correu',
        EMAIL_REQUIRED: 'El correu és obligatori',
        EMAIL_INVALID: 'Correu no vàlid',
        SELECT_USER: 'Seleccionar Usuari',
        SELECT_ROLE: 'Seleccionar Rol',
        ASSIGN: 'Assignar',
        ASSIGNING: 'Assignant...',
        MANAGER_ASSIGNED_SUCCESS: 'Gestor assignat correctament',
        MANAGER_ASSIGN_ERROR: 'Error en assignar gestor',
        ASSIGN_SUCCESS: 'Gestor assignat correctament',
        ASSIGN_ERROR: 'Error en assignar gestor',
        USER_REQUIRED: 'Cal seleccionar un usuari',
        ROLE_REQUIRED: 'Cal seleccionar un rol',
        CREATE_OFFICE_TITLE: 'Crear Nova Seu',
        CORPORATION_LABEL: 'Corporació *',
        SELECT_CORPORATION: 'Seleccionar Corporació',
        CREATE_OFFICE_NAME_LABEL: 'Nom de la Seu *',
        CREATE_CONTACT_NAME_LABEL: 'Nom de Contacte *',
        CREATE_CONTACT_PHONE_LABEL: 'Telèfon de Contacte *',
        CREATE_CONTACT_EMAIL_LABEL: 'Correu de Contacte *',
        CREATE_COMMERCIAL_ADDRESS_LABEL: 'Adreça Comercial *',
        CREATE_CITY_LABEL: 'Ciutat *',
        CREATE_POSTAL_CODE_LABEL: 'Codi Postal *',
        CREATE_ACTIVE_LABEL: 'Activa',
        YES: 'Sí',
        NO: 'No',
        CREATE_OFFICE_BUTTON: 'Crear Seu',
        CREATING: 'Creant...',
        VALIDATION_CORPORATION: 'Cal seleccionar una corporació.',
        VALIDATION_NAME: 'El nom és obligatori.',
        VALIDATION_CONTACT_NAME: 'El nom de contacte és obligatori.',
        VALIDATION_CONTACT_PHONE: 'El telèfon de contacte és obligatori.',
        VALIDATION_CONTACT_EMAIL: 'El correu de contacte és obligatori i ha de ser vàlid.',
        VALIDATION_COMMERCIAL_ADDRESS: "L'adreça comercial és obligatòria.",
        VALIDATION_CITY: 'La ciutat és obligatòria.',
        VALIDATION_POSTAL_CODE: 'El codi postal és obligatori.',
        CHECKLIST_TITLE: 'Ordre de comprovació de criteris',
        CHECKLIST_DNI_LABEL: 'DNI',
        CHECKLIST_DNI_TEXT: ": el match s'intenta si el document de l'usuari coincideix amb el DNI de l'empleat corporatiu.",
        CHECKLIST_PERSONAL_EMAIL_LABEL: 'Correu personal',
        CHECKLIST_PERSONAL_EMAIL_TEXT: ": es comprova si el correu de l'usuari coincideix amb el correu personal de l'empleat corporatiu.",
        CHECKLIST_CORPORATE_EMAIL_LABEL: 'Correu corporatiu',
        CHECKLIST_CORPORATE_EMAIL_TEXT: ": es comprova si el correu de l'usuari coincideix amb el correu corporatiu de l'empleat.",
        CHECKLIST_PERSONAL_PHONE_LABEL: 'Telèfon personal',
        CHECKLIST_PERSONAL_PHONE_TEXT: ": es comprova si el telèfon de l'usuari coincideix amb el telèfon personal de l'empleat corporatiu.",
        CHECKLIST_CORPORATE_PHONE_LABEL: 'Telèfon corporatiu',
        CHECKLIST_CORPORATE_PHONE_TEXT: ": es comprova si el telèfon de l'usuari coincideix amb el telèfon corporatiu de l'empleat.",
        SEARCH_PARKING_SPACE: 'Buscar Plaça Pàrquing',
        SEARCH_PARKING_RESERVATION: 'Buscar Reserva Pàrquing',
        SEARCH_USER: 'Buscar usuari',
        SEARCH_SHIFT: 'Buscar Torn',
        FILTERS: 'Filtres',
        APPLY_FILTERS: 'Aplicar filtres',
        CLEAR: 'Netejar',
        CLOSE: 'Tancar',
        CREATE_PARKING_SPACE: 'Crear Plaça Pàrquing',
        RESERVE_PARKING_SPACE: 'Reservar Plaça Pàrquing',
        ASSIGN_PARKING_CREDIT: 'Assignar cupó crèdit pàrquing',
        CREATE_SHIFT: 'Crear Torn',
        EDIT_BUTTON: 'Editar',
        EDIT_OFFICE_TITLE: "Editar informació general de l'oficina",
        OFFICE_INFO_SECTION: "Informació de l'oficina",
        CONTACT_INFO_SECTION: 'Informació de contacte',
        COMMERCIAL_ADDRESS_SECTION: 'Adreça comercial',
        EDIT_OFFICE_NAME_LABEL: "Nom de l'oficina",
        EDIT_CONTACT_NAME_LABEL: 'Nom de contacte',
        EDIT_CONTACT_PHONE_LABEL: 'Telèfon de contacte',
        EDIT_CONTACT_EMAIL_LABEL: 'Correu de contacte',
        EDIT_COMMERCIAL_ADDRESS_LABEL: 'Adreça comercial',
        EDIT_CITY_LABEL: 'Ciutat',
        EDIT_POSTAL_CODE_LABEL: 'Codi postal',
        FIELD_REQUIRED: 'Camp requerit',
        EMAIL_INVALID_MODAL: 'Correu no vàlid',
        OFFICE_ACTIVE: 'Oficina activa',
        CANCEL_BUTTON: 'Cancel·lar',
        SAVE_BUTTON: 'Desar',
        SAVING: 'Desant...',
        SUCCESS_TITLE: 'Èxit!',
        ERROR_TITLE: 'Error',
        UPDATE_OFFICE_SUCCESS: "La informació de l'oficina s'ha actualitzat correctament.",
        CREATE_OFFICE_SUCCESS: "La seu s'ha creat correctament.",
        DELETE_TITLE: 'Confirmar eliminació',
        DELETE_USER_SUCCESS: 'Usuari eliminat correctament',
        DELETE_USER_ERROR: "Error en eliminar l'usuari",
      },
      CORPORATION_KPIS: {
        ERROR_TIMEOUT: 'La càrrega dels KPI ha trigat massa',
        ERROR_LOAD: 'Error en carregar els KPI de mobilitat',
        PERIOD_CURRENT_MONTH: 'Mes actual',
        PERIOD_LAST_30_DAYS: 'Últims 30 dies',
        AS_OF: 'Actualitzat a',
        LOADING: 'Carregant KPIs...',
        COMING_SOON: 'Pròximament',
        NO_PREVIOUS_DATA: 'Sense dada del mes anterior',
        REPARTO_MODAL_SOSTENIBLE: 'Repartiment modal sostenible',
        CO2E_EVITADO: 'CO2e evitat',
        EMPLEADOS_COMPARTIENDO: 'Treballadors compartint',
        CUESTIONARIO_MOVILIDAD: 'Qüestionari de mobilitat',
        VIAJES_COMPARTIDOS: 'Viatges compartits',
        KM_COMPARTIDOS: 'Km compartits',
        USUARIOS_ACTIVOS: 'Usuaris actius',
        CONVERSION_CARPOOLING: 'Conversió a carpooling',
        OCUPACION_MEDIA_VEHICULO: 'Ocupació mitjana del vehicle',
        AHORRO_ESTIMADO_EUR: 'Estalvi estimat',
        OCUPACION_PARKING: 'Ocupació de pàrquing',
      },
      ROUTES_TOGGLE: {
        COUNT_LABEL: 'Rutines en les últimes 24 h',
        SHOW: 'Mostrar rutines',
        VISIBLE: 'Visibles al mapa',
        HIDDEN: 'Amagades al mapa',
      },
      // Página Cartera: bolsa del mes, movimientos y cómo se paga la recarga mensual.
      CORPORATION_WALLET_PAGE: {
        RETRY: 'Torna-ho a provar',
        BAG: {
          LOADING: 'Carregant la bossa…',
          LOAD_ERROR: 'No s\'ha pogut carregar la bossa.',
          MONTH_TITLE: 'Bossa {{month}}',
          REMAINING: 'En queden {{remaining}} € de {{total}} €',
          SPENT: 'Gastats {{amount}} €',
          RENEWS: 'Es renova el {{date}}',
          MONTHLY_TITLE: 'Bossa mensual de {{amount}} €',
          NEXT_CHARGE: 'Es recarrega el {{date}}.',
          PENDING_PAYMENT: 'La recàrrega d\'aquest mes està pendent: la bossa es recarrega quan arriba el pagament.',
          NOT_TOPPED_UP: 'La bossa d\'aquest mes no s\'ha recarregat perquè el pagament no ha arribat.',
          NONE_TITLE: 'Encara no tens bossa',
          NONE_TEXT: 'Tria l\'import i el mètode de pagament',
          PARTNER_TITLE: 'La teva bossa anual de mobilitat',
          PARTNER_TEXT:
            'La teva bossa surt del pla anual de {{partner}}: cada mes es recarrega amb la seva part i el que no es gasta s\'acumula.',
          PARTNER_PENDING_TEXT: 'La bossa s\'activa quan {{partner}} activi el teu pla anual.',
        },
        MOVEMENTS: {
          TITLE: 'Moviments',
          SUBTITLE: 'Cada pagament (−) i cada recàrrega (+) de la cartera.',
          EMPTY: 'Aquí veuràs cada pagament i cada recàrrega.',
          LOAD_ERROR: 'No s\'han pogut carregar els moviments.',
          AMOUNT: '{{sign}}{{amount}} €',
          SHOW_ALL: 'Veure\'ls tots ({{count}})',
        },
        PAYMENT: {
          TITLE: 'Com es paga la bossa',
          SUBTITLE: 'Es cobra el dia 1 de cada mes per l\'import de la bossa.',
          AMOUNT_LABEL: 'Import mensual',
          AMOUNT_HINT: 'En euros. El que no es gasta s\'acumula per al mes següent.',
          AMOUNT_ERROR: 'Escriu un import més gran que 0.',
          AMOUNT_MAX_HINT: 'Fins a {{max}} € al mes.',
          AMOUNT_MAX_ERROR: 'El màxim és de {{max}} € al mes. Per a un import més gran, parla amb WAIIS.',
          CONFIRM_TITLE: 'Segur que vols una bossa de {{amount}} € al mes?',
          CONFIRM_TEXT: 'Es cobrarà el dia 1 de cada mes.',
          CONFIRM_SAVE: 'Sí, desa',
          METHOD_LABEL: 'Forma de pagament',
          METHOD_HINT: 'La mateixa que la del pla.',
          CHANGE: 'Canviar',
          CHOOSE_IN_PLAN: 'Tria la forma de pagament a Pla',
          CARD: 'Targeta',
          CARD_LAST4: 'Targeta •••• {{last4}}',
          SEPA_DEBIT: 'Domiciliació bancària (SEPA)',
          SEPA_DEBIT_LAST4: 'Domiciliació bancària (SEPA) · •••• {{last4}}',
          BANK_TRANSFER: 'Transferència amb factura',
          DAY_ONE_NOTICE:
            'Si el pagament no arriba abans del dia 1, la bossa no es recarrega fins que entri. T\'avisem per correu 5 dies abans.',
          ACTIVE: 'Recàrrega mensual activa',
          SAVE: 'Desar',
          SAVING: 'Desant…',
          SAVED: 'Bossa mensual desada',
          SAVE_ERROR: 'No s\'ha pogut desar. Torna-ho a provar.',
          DEACTIVATE: 'Desactivar la recàrrega mensual',
          DEACTIVATE_TITLE: 'Vols desactivar la recàrrega mensual?',
          DEACTIVATE_TEXT: 'No es cobrarà el pròxim dia 1. El saldo que tinguis continua a la cartera.',
          DEACTIVATE_CONFIRM: 'Desactivar',
          DEACTIVATING: 'Desactivant…',
          DEACTIVATED: 'Recàrrega mensual desactivada',
          PARTNER_MANAGED: 'L\'import i el mètode els gestiona {{partner}}.',
        },
      },
      CORPORATION_WALLET: {
        BACK: 'Enrere',
        TITLE: 'La meva cartera',
        UPGRADE_TO_INCENTIVES_BANNER: 'Passa’t al pla d’incentius per treureʼn el màxim rendiment',
        AVAILABLE_BALANCE: 'SALDO DISPONIBLE',
        RETAINED_BALANCE: 'Saldo retingut',
        PAYMENT_SETTINGS: 'Mètodes de pagament i cobrament',
        PAYMENT_METHODS_SECTION: 'Mètode de pagament',
        PAYOUT_METHODS_SECTION: 'Mètode de cobrament',
        TRANSACTIONS_HISTORY: 'Historial de transaccions',
        CHANGE_PAYMENT_METHOD: 'Canviar mètode de pagament',
        RECHARGE: 'Recarregar',
        WITHDRAW: 'Retirar',
        RECHARGE_MODAL_TITLE: 'Recarregar cartera',
        RECHARGE_AMOUNT: 'Import a recarregar',
        PAY_WITH: 'Pagar amb',
        ADD_CARD: 'Afegir targeta',
        CANCEL: 'Cancel·lar',
        PROCESSING: 'Processant...',
        CONTINUE: 'Continuar',
        WITHDRAW_MODAL_TITLE: 'Retirar saldo',
        AVAILABLE_BALANCE_LABEL: 'Saldo disponible',
        WITHDRAW_AMOUNT: 'Import a retirar',
        DESTINATION_ACCOUNT: 'Compte de destinació',
        ADD_BANK_ACCOUNT: 'Afegir compte bancari',
        WITHDRAW_NOTE: "L'ingrés sol trigar 1-2 dies hàbils.",
        REQUEST_WITHDRAWAL: 'Sol·licitar retirada',
        PAYMENT_METHOD: 'Mètode de pagament',
        CHOOSE_CARD_HINT: 'Tria la targeta amb la qual recarregar la teva cartera.',
        EXPIRES: 'Caduca',
        REMOVE_CARD: 'Eliminar targeta',
        NO_SAVED_CARDS: 'Sense targetes desades',
        CLOSE: 'Tancar',
        NEW_CARD_HINT: 'Introdueix les dades de la nova targeta.',
        STRIPE_SECURE_NOTE: 'Pagament segur gestionat per Stripe',
        SAVING: 'Desant...',
        SAVE_CARD: 'Desar targeta',
        BANK_ACCOUNT: 'Compte bancari',
        CHOOSE_ACCOUNT_HINT: 'Tria el compte al qual retirar el saldo.',
        REMOVE_ACCOUNT: 'Eliminar compte',
        NO_SAVED_ACCOUNTS: 'Sense comptes bancaris desats',
        ADD_BANK_ACCOUNT_SHORT: 'Afegir compte',
        NEW_ACCOUNT_HINT: 'Introdueix les dades del nou compte bancari.',
        IBAN: 'IBAN',
        ADDRESS: 'Adreça',
        ADDRESS_PLACEHOLDER: 'Carrer, número, pis',
        CITY: 'Ciutat',
        POSTAL_CODE: 'Codi postal',
        SAVE_ACCOUNT: 'Desar compte',
        ACCOUNT_HOLDER: 'Titular (opcional)',
        ACCOUNT_HOLDER_PLACEHOLDER: "Raó social de l'empresa",
        ACCOUNT_HOLDER_HINT: "Si ho deixes buit, el titular és la raó social de l'empresa.",
        KYB: {
          SECTION: 'Verificació',
          TITLE: "Verificació de l'empresa",
          STATUS_VERIFIED: 'Verificada',
          STATUS_PENDING: 'Pendent',
          STATUS_VERIFIED_TEXT: 'Empresa verificada: ja pots retirar saldo.',
          STATUS_PENDING_TEXT: "Stripe encara no ha verificat l'empresa: fins aleshores no es pot retirar saldo.",
          WITHDRAW_BLOCKED_TITLE: "Falta verificar l'empresa",
          WITHDRAW_BLOCKED_TEXT: "Per poder transferir al teu compte, Stripe necessita saber qui representa l'empresa i en té la titularitat.",
          COMPLETE: 'Completar la verificació',
          PERSONS_HINT: "Declara les persones que representen l'empresa, l'administren o en tenen més d'un 25 %. Quan hi siguin totes, confirma la llista.",
          NO_PERSONS: 'Encara no has declarat ningú.',
          ADD_PERSON: 'Afegir persona',
          REMOVE_PERSON: 'Treure persona',
          UNKNOWN_PERSON: 'Persona sense dades',
          ATTEST: 'Confirmar la llista',
          ATTEST_HINT: 'Declara a Stripe que ja hi són totes les persones.',
          ATTESTED: 'Llista confirmada. Stripe pot trigar uns minuts a revisar les dades.',
          NEW_PERSON_HINT: "Dades de la persona tal com apareixen al seu document d'identitat.",
          EDIT_PERSON_HINT: 'Revisa les dades de la persona.',
          FIRST_NAME: 'Nom',
          LAST_NAME: 'Cognoms',
          DOB: 'Data de naixement',
          HOME_ADDRESS: 'Domicili',
          ROLES: "Càrrec a l'empresa",
          ROLES_REQUIRED: 'Marca almenys un càrrec.',
          ROLE_REPRESENTATIVE: 'Representant legal',
          ROLE_REPRESENTATIVE_HINT: "Pot actuar en nom de l'empresa.",
          ROLE_DIRECTOR: 'Administrador',
          ROLE_DIRECTOR_HINT: "Forma part de l'òrgan d'administració.",
          ROLE_EXECUTIVE: 'Directiu',
          ROLE_EXECUTIVE_HINT: 'Té un càrrec de direcció (CEO, director general…).',
          ROLE_OWNER: 'Titular',
          ROLE_OWNER_HINT: "Té participació a l'empresa.",
          OWNERSHIP: 'Participació',
          OWNERSHIP_REQUIRED: 'Indica el percentatge de participació del titular.',
          FORM_INCOMPLETE: 'Completa tots els camps.',
          SAVE_PERSON: 'Desar persona',
          PERSON_UNVERIFIED: 'Sense verificar',
          PERSON_PENDING: 'En revisió',
          PERSON_VERIFIED: 'Verificada',
          ERROR_LOAD: "No s'han pogut carregar les persones.",
          ERROR_SAVE: "No s'ha pogut desar la persona.",
          ERROR_DELETE: "No s'ha pogut treure la persona.",
          ERROR_ATTEST: "No s'ha pogut confirmar la llista.",
          ERROR_NO_STRIPE_ACCOUNT: "Primer afegeix un compte bancari: és el que crea el compte de Stripe de l'empresa.",
          ERROR_RECORDING_FAILED: "La persona s'ha enviat a Stripe, però no s'ha pogut desar. No ho tornis a provar i contacta amb suport.",
          ERROR_NO_PERSONS: 'Declara almenys una persona abans de confirmar la llista.',
          ERROR_PERSON_NOT_FOUND: 'Aquesta persona ja no existeix.',
          ERROR_STRIPE_REJECTED: 'Stripe no ha acceptat les dades. Revisa-les i torna-ho a provar.',
          DOCUMENT_MISSING: 'Falta document',
          UPLOAD_DOCUMENT: "Pujar document d'identitat",
          DOCUMENT_HINT: "Document d'identitat de {{name}}: DNI, NIE o passaport, per les dues cares si en té.",
          DOCUMENT_FRONT: 'Anvers',
          DOCUMENT_BACK: 'Revers (opcional)',
          DOCUMENT_BACK_HINT: 'Obligatori per a DNI i NIE. El passaport no el necessita.',
          DOCUMENT_PICK: 'Triar fitxer',
          DOCUMENT_FORMATS: 'JPG, PNG o PDF · màx. 10 MB',
          DOCUMENT_REMOVE: 'Treure fitxer',
          DOCUMENT_PRIVACY: "S'envia directament a Stripe: WAIIS no guarda el document.",
          DOCUMENT_SEND: 'Enviar document',
          DOCUMENT_SENDING: 'Enviant…',
          DOCUMENT_SENT: 'Document enviat. Stripe pot trigar uns minuts a verificar-lo.',
          DOCUMENT_INVALID_TYPE: 'Format no admès: fes servir JPG, PNG o PDF.',
          DOCUMENT_TOO_BIG: 'El fitxer pesa més de 10 MB.',
          ERROR_DOCUMENT: "No s'ha pogut enviar el document.",
          ERROR_DOCUMENT_REJECTED: 'Stripe ha rebutjat el document. Comprova que es llegeix bé i que és un DNI, NIE o passaport vàlid.',
        },
        TRANSACTIONS_SUBTITLE: "Moviments de la cartera WAIIS de la teva empresa.",
        NO_TRANSACTIONS: 'Sense transaccions registrades',
        RECHARGE_ERROR: 'Error en recarregar la cartera',
        RECHARGE_PENDING: "La recàrrega s'ha cobrat. El saldo s'actualitzarà en uns minuts.",
        WITHDRAW_ERROR: 'Error en sol·licitar la retirada',
        WITHDRAW_INSUFFICIENT_BALANCE: 'Saldo insuficient',
        WITHDRAW_SUBSCRIPTION_BALANCE: 'No pots retirar el saldo adquirit per la subscripció',
        SELECT_CARD_ERROR: 'Error en seleccionar la targeta',
        REMOVE_CARD_ERROR: 'Error en eliminar la targeta',
        STRIPE_KEY_MISSING: 'Falta configurar la clau pública de Stripe.',
        START_CARD_ERROR: "Error en iniciar l'alta de la targeta",
        CONFIRM_CARD_ERROR: 'Error en confirmar la targeta',
        SAVE_CARD_ERROR: 'Error en desar la targeta',
        REMOVE_ACCOUNT_ERROR: 'Error en eliminar el compte',
        SAVE_ACCOUNT_ERROR: 'Error en desar el compte bancari',
        TODAY: 'Avui',
        YESTERDAY: 'Ahir',
      },
      ROUTES_MAP: {
        OFFICE: 'Seu',
        OFFICE_LABEL: 'Seu',
        ALL_OFFICES: 'Tots els centres',
        NO_OFFICE_ACCESS: 'Sense accés a cap seu',
        CO2_AVOIDED: 'CO₂ evitat',
        CO2_VALUE: '{{value}} kg CO₂e',
        PERIOD_30_DAYS: '30 dies',
        LINKED_EMPLOYEES: 'Empleats vinculats',
        PASSENGERS_PER_TRIP: 'Passatgers per viatge',
        TRIPS_LAST_MONTH: 'Viatges · últim mes',
        HEADQUARTERS: {
          TITLE: 'On és la teva seu central?',
          TEXT: 'Així situem la teva empresa al mapa i veuràs els trajectes de la teva plantilla.',
          PLACEHOLDER: 'Carrer, número, ciutat',
          ADDRESS_LABEL: 'Adreça de la seu central',
          SAVE: 'Desa',
          SAVING: 'Desant…',
          ERROR: 'No s’ha pogut desar la seu central.',
        },
        NO_ROUTINES: {
          TITLE: 'Encara no hi ha rutines',
          TEXT: 'Apareixeran aquí quan la teva plantilla creï els seus trajectes a l’app.',
        },
      },
      COMPANY_OFFICE_DETAILS: {
        BACK: 'Tornar',
        TITLE: 'Detalls Seu empresa',
        BASIC_INFO: 'Informació bàsica',
        OFFICE_NAME: 'Nom de la seu',
        CONTACT_PERSON: 'Persona de contacte',
        CONTACT_PHONE: 'Telèfon de contacte',
        CONTACT_EMAIL: 'Email de contacte',
        ADDRESS: 'Adreça',
        CITY: 'Ciutat',
        POSTAL_CODE: 'Codi postal',
        LOADING: 'Carregant...',
      },
      OFFICES_LISTING: {
        SEARCH_PLACEHOLDER: 'Cercar Seu',
        CREATE: 'Crear seu',
        EDIT_TITLE: 'Editar Seu',
        CREATE_TITLE: 'Crear Seu',
        COL_OFFICE: 'Seu',
        COL_LOCATION: 'Ubicació',
        COL_EMPLOYEES: 'Treballadors',
        COL_LINKED: 'Vinculats',
        COL_ACTIVE: 'Activa',
        IMPORT_UNAVAILABLE_TITLE: 'Importació no disponible',
        IMPORT_UNAVAILABLE_TEXT: 'La importació massiva per CSV encara no està disponible. No s\'ha desat cap dada.',
        UPDATE_SUCCESS_TEXT: "S'ha modificat correctament la seu",
        CREATE_SUCCESS_TEXT: "S'ha creat correctament la seu",
      },
      PRICING_CONFIG_FORM: {
        CREATE_TITLE: 'Crear configuració de preus',
        EDIT_TITLE: 'Editar configuració de preus',
        INTRO_TITLE: 'Configuració de preus tipus A',
        INTRO_TEXT:
          'Aquesta configuració defineix quant subvenciona l\'empresa, si WAIIS cofinança, a qui aplica i quins límits té. Els imports fixos i límits per import s\'envien en cèntims.',
        GUIDE_SUMMARY: 'Guia de camps i exemples',
        SUBSIDY_SECTION: 'Configuració de subvenció',
        SUBSIDY_TYPE: 'Tipus de subvenció',
        SUBSIDY_TYPE_HINT:
          '<strong>fixed</strong>: import fix en cèntims. <strong>percentage</strong>: percentatge enter sobre el preu.',
        SUBSIDY_VALUE: 'Valor de subvenció',
        SUBSIDY_VALUE_HINT:
          'Valor que aporta la corporació. Si el tipus és <strong>fixed</strong>, s\'informa en cèntims. Si és <strong>percentage</strong>, s\'informa com a percentatge enter.',
        WAIIS_SECTION: 'Cofinançament de WAIIS',
        WAIIS_CONTRIBUTES: 'WAIIS contribueix',
        WAIIS_CONTRIBUTES_HINT:
          'Indica si WAIIS participa en la subvenció juntament amb l\'empresa.',
        CONTRIBUTION_TYPE: 'Tipus de contribució',
        CONTRIBUTION_TYPE_HINT:
          'Defineix si l\'aportació de WAIIS és fixa en cèntims o un percentatge enter.',
        SELECT_TYPE: 'Seleccionar tipus',
        CONTRIBUTION_VALUE: 'Valor de contribució',
        CONTRIBUTION_VALUE_HINT:
          'Valor del cofinançament de WAIIS segons el tipus seleccionat.',
        PRICE_SECTION: 'Configuració de preu',
        FINAL_PRICE_ZERO: 'Preu final zero',
        FINAL_PRICE_ZERO_HINT:
          'Si s\'activa, el preu final per a la persona usuària serà 0.',
        RESTRICTIONS_SECTION: 'Restriccions',
        EMPLOYEES_ONLY: 'Només treballadors',
        EMPLOYEES_ONLY_HINT:
          'Restringeix aquesta configuració als treballadors de la corporació.',
        LIMIT_TYPE: 'Tipus de límit',
        LIMIT_TYPE_HINT:
          '<strong>none</strong>: sense límit. <strong>date</strong>: fins a una data concreta. <strong>amount</strong>: fins a consumir un import màxim en cèntims.',
        LIMIT_DATE: 'Data límit',
        LIMIT_DATE_HINT:
          'Data màxima en què aquesta configuració continuarà aplicant-se.',
        LIMIT_AMOUNT: 'Import límit',
        LIMIT_AMOUNT_HINT:
          'Import total màxim subvencionable per a aquesta configuració, expressat en cèntims.',
        OTHER_SECTION: 'Altres opcions',
        BASE_PRICE_RECIPIENT: 'Receptor del preu base',
        BASE_PRICE_RECIPIENT_HINT:
          'Indica sobre quin preu base es calcula la subvenció. En aquest model el valor esperat és <strong>route_driver</strong>.',
        ACTIVE: 'Actiu',
        ACTIVE_HINT:
          'Permet activar o desactivar la configuració sense eliminar-la.',
        REFUND_CREDITS: 'Retornar crèdits',
        REFUND_CREDITS_HINT:
          'Defineix si els crèdits s\'han de retornar quan correspongui segons la lògica del model econòmic.',
        CANCEL: 'Cancel·lar',
        CREATE: 'Crear',
        UPDATE: 'Actualitzar',
        FIELD_GUIDE:
          '# Guia de Camps - Configuració de Preus Corporatius\n\n**Programa de subsidis d\'empresa per reduir el preu dels viatges dels seus usuaris.**\n\n---\n\n## Camps\n\n| Camp | Descripció |\n|-------|-------------|\n| **Corporation** | L\'empresa que assumeix el subsidi. Identifica a qui pertany aquesta configuració. |\n| **Active** | ✅ Activada / ❌ Inactiva. Les inactives no apliquen a cap viatge. |\n| **Subsidy Type** | Tipus de descompte: `fixed` (quantitat fixa: 250 = 2,50€) o `percentage` (percentatge: 50 = 50%). |\n| **Subsidy Value** | Import del descompte. Si `fixed`: cèntims. Si `percentage`: 0-100. Ex: 300 cèntims = 3€. |\n| **Waiis Contributes** | ✅ WAIIS afegeix diners addicionals / ❌ No. Fes-lo servir per forçar preu 0€ si cal. |\n| **Waiis Contribution Type** | Només si contribueix WAIIS i el preu final no és 0: `fixed` o `percentage`. Ex: 400 cèntims = 4€ addicionals. |\n| **Waiis Contribution Value** | Quantitat que aporta WAIIS. Mateix format que Subsidy Value. |\n| **Final Price Zero** | ✅ Força preu = 0€ / ❌ No. Si activat i el subsidi no cobreix el 100%, WAIIS ho completa automàticament. |\n| **Applies to Employees Only** | ✅ Només treballadors verificats / ❌ Qualsevol usuari. |\n| **Limit Type** | Tipus de límit: `none` (sense límit), `date` (fins a data), `amount` (màxima despesa en €). |\n| **Limit Date** | Vàlid si `Limit Type = date`. Data fins a la qual aplica el subsidi (ex: 2026-12-31). |\n| **Limit Amount** | Vàlid si `Limit Type = amount`. Despesa màxima en cèntims (ex: 500000 = 5.000€). |\n| **Consumed Amount** | Només lectura. Despesa actual acumulada. Quan arriba a `Limit Amount`, es desactiva. |\n| **Base Price Recipient** | Qui rep el preu base: normalment `route_driver` (el conductor del viatge). |\n| **Refund Credits** | ✅ Acumular crèdits post-viatge / ❌ Descompte directe. Ex: viatge 10€, descompte 3€ -> paga 7€ + 3€ crèdits vs només 7€. |\n| **Runners** | Corredors (rutes) on aplica. Ex: Barcelona-Sabadell, Barcelona-Terrassa. Si buit, no aplica. |\n\n---\n\n## Exemples ràpids\n\n### ✅ Subsidi simple (25% per a treballadors Telefónica)\n- **Subsidy Type:** `percentage` | **Value:** `25`\n- **Applies to Employees Only:** ✅ Sí\n- **Limit Type:** `none`\n- **Runners:** Barcelona-Sabadell, Barcelona-Terrassa\n- **Resultat:** Els treballadors paguen un 25% menys, sense límit de despesa.\n\n### ✅ Viatges gratis (empresa 6€ + WAIIS 4€)\n- **Subsidy Type:** `fixed` | **Value:** `600`\n- **Waiis Contributes:** ✅ Sí | **Type:** `fixed` | **Value:** `400`\n- **Final Price Zero:** ✅ Sí\n- **Applies to Employees Only:** ✅ Sí\n- **Limit Type:** `date` | **Date:** `2026-12-31`\n- **Resultat:** Els treballadors de Google paguen 0€ fins a final d\'any.\n\n### ✅ Centre logístic (30% per a qualsevol, màx 5.000€)\n- **Subsidy Type:** `percentage` | **Value:** `30`\n- **Applies to Employees Only:** ❌ No\n- **Limit Type:** `amount` | **Amount:** `500000` (cèntims)\n- **Runners:** Barcelona-CentroATM, CentroATM-Barcelona\n- **Resultat:** Qualsevol rep un 30% de descompte, fins a esgotar 5.000€.\n\n### ✅ Fidelització amb crèdits (10% per a treballadors)\n- **Subsidy Type:** `percentage` | **Value:** `10`\n- **Refund Credits:** ✅ Sí\n- **Applies to Employees Only:** ✅ Sí\n- **Limit Type:** `none`\n- **Resultat:** Els treballadors paguen un 10% menys i reben aquest descompte com a crèdits regalats.',
      },
      PRICING_CONFIGS_LIST: {
        HOW_TO_READ_TITLE: 'Com llegir aquest llistat',
        HOW_TO_READ_TEXT:
          'Els valors fixos i límits per import es mostren en cèntims. Els percentatges es mostren com a enters. Cada fila representa una regla de subvenció aplicable a una corporació i, opcionalment, a corredors concrets.',
        GUIDE_SUMMARY: 'Guia de camps i exemples',
        CREATE_CONFIG: 'Crear configuració',
        LOADING: 'Carregant...',
        EMPTY:
          'No s\'han trobat configuracions de preus. Creeu-ne una per començar.',
        COL_SUBSIDY_TYPE: 'subsidy_type',
        COL_SUBSIDY_VALUE: 'subsidy_value',
        COL_WAIIS_CONTRIBUTES: 'waiis_contributes',
        COL_WAIIS_CONTRIBUTION_TYPE: 'waiis_contribution_type',
        COL_WAIIS_CONTRIBUTION_VALUE: 'waiis_contribution_value',
        COL_FINAL_PRICE_ZERO: 'final_price_zero',
        COL_APPLIES_TO_EMPLOYEES_ONLY: 'applies_to_employees_only',
        COL_LIMIT_TYPE: 'limit_type',
        COL_LIMIT_DATE: 'limit_date',
        COL_LIMIT_AMOUNT: 'limit_amount',
        COL_BASE_PRICE_RECIPIENT: 'base_price_recipient',
        COL_CONSUMED_AMOUNT: 'consumed_amount',
        COL_REFUND_CREDITS: 'refund_credits',
        COL_ACTIVE: 'active',
        COL_ACTIONS: 'Accions',
        YES: 'Sí',
        NO: 'No',
        EDIT_RUNNERS: 'Editar corredors',
        EDIT_CONFIG: 'Editar configuració',
        DELETE_CONFIG: 'Eliminar configuració',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'No s\'han pogut carregar les configuracions de preus',
        CREATE_SUCCESS_TITLE: 'Èxit',
        CREATE_SUCCESS_TEXT: 'Configuració de preus creada correctament',
        CREATE_ERROR_TEXT: 'No s\'ha pogut crear la configuració de preus',
        UPDATE_SUCCESS_TITLE: 'Èxit',
        UPDATE_SUCCESS_TEXT: 'Configuració de preus actualitzada correctament',
        UPDATE_ERROR_TEXT: 'No s\'ha pogut actualitzar la configuració de preus',
        DELETE_CONFIRM_TITLE: 'Eliminar configuració?',
        DELETE_CONFIRM_TEXT:
          'Esteu segur que voleu eliminar aquesta configuració de preus?',
        DELETE_CONFIRM_BUTTON: 'Eliminar',
        DELETE_CANCEL_BUTTON: 'Cancel·lar',
        DELETE_SUCCESS_TITLE: 'Eliminada',
        DELETE_SUCCESS_TEXT: 'Configuració de preus eliminada correctament',
        DELETE_ERROR_TEXT: 'No s\'ha pogut eliminar la configuració de preus',
      },
      PRICING_RUNNERS_MODAL: {
        TITLE: 'Gestionar corredors de la configuració de preus',
        LOADING: 'Carregant...',
        SEARCH_PLACEHOLDER: 'Cercar corredors...',
        NO_RUNNERS: 'No s\'han trobat corredors.',
        RUNNER_ID: 'ID: {{id}}',
        SELECTED_COUNT: 'Seleccionats: {{selected}} de {{total}}',
        CLEAR_ALL: 'Netejar tot',
        CANCEL: 'Cancel·lar',
        SAVE_RUNNERS: 'Desar corredors',
        MISSING_ID_TITLE: 'Error',
        MISSING_ID_TEXT: 'Falta l\'id de la configuració de preus',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT:
          'No s\'han pogut carregar els corredors. La sol·licitud pot haver caducat o retornat una resposta inesperada.',
        SAVE_SUCCESS_TITLE: 'Èxit',
        SAVE_SUCCESS_TEXT: 'Corredors sincronitzats correctament',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'No s\'han pogut sincronitzar els corredors',
      },
      SUBSIDY_FORM: {
        CREATE_TITLE: 'Crear subvenció',
        EDIT_TITLE: 'Editar subvenció',
        MODE: 'Mode',
        SELECT_MODE: 'Seleccionar mode',
        MODE_REQUIRED: 'El mode és obligatori',
        AMOUNT: 'Import',
        AMOUNT_REQUIRED: 'L\'import és obligatori',
        MAX_SUBSIDY: 'Subvenció màxima',
        MAX_SUBSIDY_REQUIRED: 'La subvenció màxima és obligatòria',
        MAX_SUBSIDY_PER_USER: 'Subvenció màxima per usuari',
        MAX_SUBSIDY_PER_USER_REQUIRED: 'El màxim per usuari és obligatori',
        CANCEL: 'Cancel·lar',
        CREATE: 'Crear',
        UPDATE: 'Actualitzar',
      },
      SUBSIDIES_LIST: {
        TITLE: 'Subvencions',
        CREATE_SUBSIDY: 'Crear subvenció',
        LOADING: 'Carregant...',
        EMPTY: 'No s\'han trobat subvencions. Creeu-ne una per començar.',
        COL_MODE: 'Mode',
        COL_AMOUNT: 'Import',
        COL_MAX_SUBSIDY: 'Subvenció màxima',
        COL_MAX_PER_USER: 'Màxim per usuari',
        COL_ACTIONS: 'Accions',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'No s\'han pogut carregar les subvencions',
        LIMIT_TITLE: 'Límit assolit',
        LIMIT_TEXT: 'Només es permet una subvenció per corporació',
        CREATE_SUCCESS_TITLE: 'Èxit',
        CREATE_SUCCESS_TEXT: 'Subvenció creada correctament',
        CREATE_ERROR_TEXT: 'No s\'ha pogut crear la subvenció',
        UPDATE_SUCCESS_TITLE: 'Èxit',
        UPDATE_SUCCESS_TEXT: 'Subvenció actualitzada correctament',
        UPDATE_ERROR_TEXT: 'No s\'ha pogut actualitzar la subvenció',
        DELETE_CONFIRM_TITLE: 'Eliminar subvenció?',
        DELETE_CONFIRM_TEXT:
          'Esteu segur que voleu eliminar aquesta subvenció?',
        DELETE_CONFIRM_BUTTON: 'Eliminar',
        DELETE_CANCEL_BUTTON: 'Cancel·lar',
        DELETE_SUCCESS_TITLE: 'Eliminada',
        DELETE_SUCCESS_TEXT: 'Subvenció eliminada correctament',
        DELETE_ERROR_TEXT: 'No s\'ha pogut eliminar la subvenció',
      },
      SUBSIDY_CONSUMPTION_FORM: {
        CREATE_TITLE: 'Crear consum',
        EDIT_TITLE: 'Editar consum',
        USER_ID: 'ID d\'usuari',
        USER_ID_PLACEHOLDER: 'Introduïu l\'ID d\'usuari (UUID)',
        USER_ID_REQUIRED: 'L\'ID d\'usuari és obligatori',
        ROUTE_ID: 'ID de ruta de pooling',
        ROUTE_ID_PLACEHOLDER: 'Introduïu l\'ID de ruta (UUID)',
        ROUTE_ID_REQUIRED: 'L\'ID de ruta és obligatori',
        AMOUNT: 'Import',
        AMOUNT_REQUIRED: 'L\'import és obligatori',
        WAIIS_AMOUNT: 'Import WAIIS',
        WAIIS_AMOUNT_REQUIRED: 'L\'import WAIIS és obligatori',
        CANCEL: 'Cancel·lar',
        CREATE: 'Crear',
        UPDATE: 'Actualitzar',
      },
      SUBSIDY_CONSUMPTIONS_LIST: {
        TITLE: 'Consums de subvenció',
        CREATE_CONSUMPTION: 'Crear consum',
        SELECT_CONFIG_LABEL: 'Seleccionar configuració de preus',
        SELECT_CONFIG_PLACEHOLDER: '-- Seleccioneu una configuració --',
        LOADING: 'Carregant...',
        EMPTY:
          'No s\'han trobat consums per a aquesta configuració. Creeu-ne un per començar.',
        COL_USER_ID: 'ID d\'usuari',
        COL_ROUTE_ID: 'ID de ruta',
        COL_AMOUNT: 'Import',
        COL_WAIIS_AMOUNT: 'Import WAIIS',
        COL_ACTIONS: 'Accions',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'No s\'han pogut carregar els consums',
        CREATE_SUCCESS_TITLE: 'Èxit',
        CREATE_SUCCESS_TEXT: 'Consum creat correctament',
        CREATE_ERROR_TEXT: 'No s\'ha pogut crear el consum',
        UPDATE_SUCCESS_TITLE: 'Èxit',
        UPDATE_SUCCESS_TEXT: 'Consum actualitzat correctament',
        UPDATE_ERROR_TEXT: 'No s\'ha pogut actualitzar el consum',
        DELETE_CONFIRM_TITLE: 'Eliminar consum?',
        DELETE_CONFIRM_TEXT:
          'Esteu segur que voleu eliminar aquest registre de consum?',
        DELETE_CONFIRM_BUTTON: 'Eliminar',
        DELETE_CANCEL_BUTTON: 'Cancel·lar',
        DELETE_SUCCESS_TITLE: 'Eliminat',
        DELETE_SUCCESS_TEXT: 'Consum eliminat correctament',
        DELETE_ERROR_TEXT: 'No s\'ha pogut eliminar el consum',
        PAGE_NAME: 'Bonificació',
        SUBTITLE:
          'Configura l\'aportació econòmica per trajecte compartit per als teus treballadors.',
        BOX_LABEL: 'Bonificació que l\'empresa aporta per trajecte',
        PER_TRIP: '€/trajecte',
        EDIT_PRICE: 'Editar preu',
        STATUS_ACTIVE: 'Bonificació activa',
        EXPLANATION:
          'Aquest preu és el que s\'aplica com a bonificació als trajectes que facin els treballadors de {{scope}}.',
        ALL_OFFICES: 'Tots els centres',
        WHOLE_COMPANY: 'tota l\'empresa',
        CANCEL: 'Cancel·lar',
        SAVE_CONFIG: 'Desar configuració',
        SAVE_SUCCESS_TITLE: 'Desat',
        SAVE_SUCCESS_TEXT: 'Bonificació desada amb èxit',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'No s\'ha pogut desar la bonificació',
        OFFICES_HEADER: 'Bonificació per seu',
        NO_OFFICE_CONFIG: 'Sense configurar (s\'aplica la de l\'empresa)',
        BLOCKED_WARNING: 'Bonificació bloquejada per impagament. Es desbloqueja automàticament quan es salda el deute.',
      },
      POOLING_RUNNERS: {
        PER_MONTH: '{{amount}} €/mes',
        TITLE: 'Configuració de corredors',
        LOADING: 'Carregant...',
        EMPTY: 'No hi ha corredors associats a aquesta corporació.',
        LOAD_ERROR_TEXT: 'No s\'han pogut carregar els corredors',
        COL_NAME: 'name',
        COL_DESCRIPTION: 'description',
        COL_COLOR: 'color',
        COL_CREATED_AT: 'created_at',
        COL_UPDATED_AT: 'updated_at',
        MODAL_TITLE: 'Editar corredor',
        NAME_LABEL: 'name',
        NAME_REQUIRED: 'El nom és obligatori.',
        DESCRIPTION_LABEL: 'description',
        COLOR_LABEL: 'color',
        COLOR_INVALID:
          'El color ha de tenir format hexadecimal, per exemple #009640.',
        CANCEL: 'Cancel·lar',
        SAVE: 'Desar canvis',
        SAVE_SUCCESS_TITLE: 'Èxit',
        SAVE_SUCCESS_TEXT: 'Corredor actualitzat correctament',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'No s\'ha pogut actualitzar el corredor',
        FLEET_PAGE_NAME: 'Flota',
        FLEET_MOCK_MODE: 'Dades d\'exemple',
        FLEET_REAL_MODE: 'Dades reals',
        FLEET_ALL_OFFICES: 'Tots els centres',
        FLEET_HEADER_TITLE: 'Flota',
        FLEET_HEADER_DESC:
          'Control econòmic dels vehicles i model de retorn de la teva corporació.',
        FLEET_KPI_REVENUE_GENERATED: 'Ingressos generats (mes passat)',
        FLEET_KPI_TOTAL_REVENUE: 'Ingressos totals acumulats',
        FLEET_RETURN_MODEL_TITLE: 'Model de retorn de la flota',
        FLEET_RETURN_MODEL_TOOLTIP: 'Configuració de CAEs i retorn',
        FLEET_RETURN_MODEL_DESC:
          'Tria el percentatge del retorn econòmic que rebrà l\'empresa per cada viatge. Un retorn del 50% equival a assignar a l\'empresa el 100% del valor generat pels Certificats d\'Estalvi Energètic (CAEs).',
        FLEET_SLIDER_LABEL:
          'Percentatge que es queda l\'empresa de cada passatger',
        FLEET_INCOME_LABEL: 'Ingrés estimat amb aquest percentatge',
        FLEET_SAVE_MODEL_BUTTON: 'Desar model',
        FLEET_VEHICLES_TITLE: 'Vehicles de la flota',
        FLEET_UPLOAD_CSV_BUTTON: 'Pujar CSV',
        FLEET_ADD_VEHICLE_BUTTON: 'Afegir vehicle',
        FLEET_COL_VEHICLE: 'VEHICLE',
        FLEET_COL_OFFICE: 'SEU ASSIGNADA',
        FLEET_COL_DRIVER: 'CONDUCTOR',
        FLEET_COL_CAES: 'CAES GENERATS',
        FLEET_ASSIGN_DRIVER_LINK: 'Assignar conductor',
        FLEET_EDIT_TOOLTIP: 'Editar',
        FLEET_DELETE_TOOLTIP: 'Eliminar',
        FLEET_EMPTY_VEHICLES: 'No hi ha vehicles en aquesta flota.',
        FLEET_LOADING_VEHICLES: 'Carregant vehicles...',
        FLEET_VEHICLE_MODAL_EDIT_TITLE: 'Editar vehicle',
        FLEET_VEHICLE_MODAL_ADD_TITLE: 'Afegir vehicle',
        FLEET_LICENSE_PLATE_LABEL: 'Matrícula',
        FLEET_LICENSE_PLATE_PLACEHOLDER: '0000 XYZ',
        FLEET_BRAND_LABEL: 'Marca',
        FLEET_BRAND_PLACEHOLDER: 'Toyota',
        FLEET_MODEL_LABEL: 'Model',
        FLEET_MODEL_PLACEHOLDER: 'Corolla',
        FLEET_COLOR_LABEL: 'Color',
        FLEET_SEATS_LABEL: 'Places disponibles',
        FLEET_FUEL_TYPE_LABEL: 'Combustible',
        FLEET_FUEL_TYPE_GASOLINE: 'Gasolina',
        FLEET_FUEL_TYPE_DIESEL: 'Dièsel',
        FLEET_FUEL_TYPE_ELECTRIC: 'Elèctric',
        FLEET_FUEL_TYPE_HYBRID: 'Híbrid',
        FLEET_OFFICE_LABEL: 'Seu assignada',
        FLEET_SELECT_OFFICE_PLACEHOLDER: 'Selecciona una seu',
        FLEET_DRIVER_LABEL: 'Conductor',
        FLEET_DRIVER_SEARCH_MIN_CHARS: 'Escriu almenys 2 lletres...',
        FLEET_DRIVER_SEARCH_PLACEHOLDER: 'Cercar empleat...',
        FLEET_IMPORT_MODAL_TITLE: 'Importar vehicles per CSV',
        FLEET_OFFICE_ONLY_LABEL: 'Seu',
        FLEET_CSV_FILE_LABEL: 'Arxiu CSV',
        FLEET_DOWNLOAD_TEMPLATE: 'Descarregar plantilla d\'exemple',
        FLEET_DOWNLOADING_TEMPLATE: 'Descarregant plantilla...',
        FLEET_IMPORT_BUTTON: 'Importar',
        FLEET_MISSING_DATA_TITLE: 'Falten dades',
        FLEET_MISSING_DATA_TEXT: 'Completa matrícula, seu i les característiques del vehicle (marca, model, color, places i combustible)',
        FLEET_MISSING_OFFICE_TITLE: 'Falta la seu',
        FLEET_MISSING_OFFICE_TEXT: 'Has de seleccionar una seu',
        FLEET_MISSING_FILE_TITLE: 'Falta l\'arxiu',
        FLEET_MISSING_FILE_TEXT: 'Has de seleccionar un arxiu CSV',
        FLEET_MOCK_IMPORT_TITLE: 'Simulació',
        FLEET_MOCK_IMPORT_TEXT:
          'En mode dades d\'exemple la importació no s\'envia al backend.',
        FLEET_SAVED_TITLE: 'Desat',
        MODEL_SAVED_TEXT: 'Model de retorn desat correctament',
        MODEL_SAVE_ERROR_TEXT: 'No s\'ha pogut desar el model de retorn',
        FLEET_VEHICLE_SAVED_TEXT: 'Vehicle desat amb èxit',
        FLEET_VEHICLE_SAVE_ERROR_TEXT: 'No s\'ha pogut desar el vehicle',
        FLEET_DELETE_CONFIRM_TITLE: 'Eliminar vehicle?',
        FLEET_DELETE_CONFIRM_TEXT: 'S\'eliminarà el vehicle {{plate}}.',
        FLEET_DELETE_CONFIRM_BUTTON: 'Eliminar',
        FLEET_DELETED_TITLE: 'Eliminat',
        FLEET_VEHICLE_DELETED_TEXT: 'Vehicle eliminat',
        FLEET_VEHICLE_DELETE_ERROR_TEXT: 'No s\'ha pogut eliminar el vehicle',
        FLEET_IMPORTED_TITLE: 'Importat',
        FLEET_IMPORTED_TEXT: 'Vehicles importats amb èxit',
        FLEET_IMPORT_ERROR_TEXT: 'No s\'ha pogut importar l\'arxiu CSV',
      },
      SHIFTS_LIST: {
        SELECT_OFFICE: 'Selecciona una seu:',
        SEARCH_PLACEHOLDER: 'Cercar Torn',
        FILTERS: 'Filtres',
        FILTERS_TITLE: 'Filtres',
        CLOSE: 'Tancar',
        DATE_PLACEHOLDER: 'Seleccioni data',
        APPLY_FILTERS: 'Aplicar filtres',
        CLEAR: 'Netejar',
        EXPORT_CSV: 'Exportar CSV',
        CREATE_SHIFT: 'Crear Torn',
        COL_CODE: 'Codi',
        COL_SHIFT: 'Torn',
        COL_START: 'Entrada',
        COL_END: 'Sortida',
        COL_ACTIVE: 'Actiu',
        EDIT_TITLE: 'Editar Torn',
        CREATE_TITLE: 'Crear Torn',
      },
      SHIFT_DETAILS: {
        BACK: 'Tornar',
        TITLE: 'Detalls Torn',
        ID: 'Id',
        CODE: 'Codi',
        NAME: 'Nom del torn',
        START_TIME: 'Hora d\'entrada',
        END_TIME: 'Hora de sortida',
        OFFICE: 'Seu',
        LOADING: 'Carregant...',
      },
      SHIFT_FORM: {
        CLOSE: 'Tancar',
        CANCEL: 'Cancel·lar',
        ACCEPT: 'Acceptar',
        ACTIVE: 'Actiu',
        NAME_LABEL: 'Nom del torn',
        NAME_REQUIRED: 'El nom és obligatori',
        START_TIME_LABEL: "Hora d'entrada",
        TIME_PLACEHOLDER: 'HH:MM',
        START_TIME_REQUIRED: "L'hora d'entrada és obligatòria",
        END_TIME_LABEL: 'Hora de sortida',
        END_TIME_REQUIRED: 'La hora de sortida és obligatòria',
        WAIT: 'Espera si us plau...',
        LOADING: 'Carregant...',
        SUCCESS_TITLE: 'Èxit!',
        UPDATE_SUCCESS_TEXT: 'Torn actualitzat correctament',
        CREATE_SUCCESS_TEXT: 'Torn creat correctament',
        ERROR_TITLE: 'Error',
      },
      GETTING_STARTED: {
        STEP_EMPLOYEES: {
          METHOD_AUTONOMOUS_NAME: 'Registre autònom',
          METHOD_AUTONOMOUS_DESC: 'No necessites pujar cap arxiu. Comparteix l\'enllaç i el codi; el teu equip es vincula sol a aquest tauler en registrar-se.',
          METHOD_TEMPLATE_NAME: 'Carregar plantilla',
          METHOD_TEMPLATE_DESC: 'Si prefereixes precarregar la teva llista de treballadors abans que es registrin, per controlar qui hi té accés.',
          SHARE_CODE_LABEL: 'Codi d\'empresa',
          COPY_CODE_BUTTON: 'Copiar codi',
          SHARE_CODE_HELP: 'Cada treballador l\'introdueix en registrar-se des del seu perfil per vincular-se a aquest tauler.',
          SHARE_LINK_LABEL: 'Enllaç d\'invitació',
          COPY_LINK_BUTTON: 'Copiar enllaç',
          SHARE_LINK_HELP: 'Enllaç directe que obre l\'app de WAIIS amb el codi d\'empresa ja precarregat.',
          INVITE_MESSAGE_LABEL_ALT: 'Missatge d\'invitació',
          COPY_MESSAGE_BUTTON: 'Copiar missatge d\'invitació',
          COPY_MESSAGE_HELP: 'Pots editar el text abans de copiar-lo. Es enganxarà a Slack, WhatsApp, Teams o correu amb l\'enllaç i el codi ja inclosos.',
          INVITE_UNAVAILABLE: 'El codi d\'empresa i l\'enllaç d\'invitació no estan disponibles ara mateix. Torna-ho a provar d\'aquí uns minuts o contacta amb suport.',
          COPIED_SUFFIX: 'copiat',
          INVITE_MESSAGE_BODY: 'Hola!\n\nDes de **{{company}}** hem activat **WAIIS**, l\'app per compartir cotxe amb companys en el trajecte a la feina: estalvies diners, vas més còmode i redueixes emissions.\n\n**Unir-t\'hi triga menys de 2 minuts:**\n\n**1.** Descarrega l\'app WAIIS al teu mòbil (disponible a l\'App Store i Google Play).\n\n**2.** Des del mòbil, prem aquest enllaç per vincular-te a l\'empresa automàticament i rebre avantatges a WAIIS:\n\n{{link}}\n\nL\'enllaç no s\'obre o ja tenies l\'app? Obre WAIIS, registra\'t i a **Perfil → La meva organització** introdueix aquest codi d\'empresa:\n\n{{code}}\n\nI llest! Ja pots començar a compartir trajecte amb qui visqui o treballi a prop teu.\n\nTens algun dubte? Escriu-nos mitjançant el xat de suport de l\'app.\n\nEns veiem a **WAIIS**!',
          INVITE_MESSAGE_COMPANY_FALLBACK: 'la teva empresa',
        },
        STEP_PAYMENT: {
          ADD_CARD_BUTTON: 'Afegir targeta de pagament',
          CARD_DATA_LABEL: 'Dades de la targeta',
          SAVE_CARD: 'Desar targeta',
          SAVING_CARD: 'Desant...',
          CANCEL_CARD: 'Cancel·lar',
          LOADING_CARDS: 'Carregant targetes...',
          DEFAULT_BADGE: 'Predeterminada',
          SET_DEFAULT: 'Fer predeterminada',
          REMOVE: 'Eliminar',
          STRIPE_MISCONFIGURED: 'La passarel·la de pagament no està configurada (falta la clau pública de Stripe). Contacta amb suport.',
          SETUP_INTENT_ERROR: 'No s\'ha pogut iniciar l\'alta de la targeta. Torna-ho a provar.',
          CARD_INIT_ERROR: 'No s\'ha pogut carregar el formulari de targeta.',
          CARD_DECLINED: 'No s\'ha pogut validar la targeta. Revisa les dades i torna-ho a provar.',
          ATTACH_ERROR: 'La targeta es va validar però no s\'ha pogut associar a l\'empresa. Torna-ho a provar.',
        },
      },
      SUBSCRIPTION_FEATURES: {
        OVERVIEW: 'Resum general',
        OFFICE_BREAKDOWN: 'Desglossament per seu',
        CAE_CARPOOLING: 'CAE de mobilitat',
        CAE_FLEET: 'CAE de Flota',
        INCENTIVES: 'Gestió d\'incentius',
        WALLET: 'Wallet / fons d\'incentius',
        TRIP_BONIFICATION: 'Bonificació per trajecte',
        PSMT_DRAFT: 'Esborrany PMST / PDE',
        ADVANCED_REPORTS: 'Informes avançats',
        USER_MANAGEMENT: 'Gestió d\'usuaris',
        ADD_OFFICES: 'Alta de seus addicionals',
        BILLING: 'Facturació i historial de pagaments',
        NEW_DASHBOARD_FEATURES: 'Noves funcions del dashboard',
      },
      CORPORATION_PLAN: {
        TITLE: 'Pla',
        SUBTITLE: 'Pla contractat per la teva empresa i les seves condicions.',
        LOADING: 'Carregant pla...',
        DEADLINE_LABEL: 'Data límit:',
        ACCESS_BLOCKED: 'L\'accés al dashboard està bloquejat: no hi ha cap subscripció activa. Tria un pla per reactivar-lo.',
        STATUS_LABEL: 'Estat:',
        DAYS_REMAINING_LABEL: 'Dies restants:',
        ENDS_AT_LABEL: 'Venç:',
        CURRENT_PLAN_BADGE: 'PLA ACTUAL',
        PREVIEW_CALCULATING: 'Calculant canvis...',
        PREVIEW_DOWNGRADE: 'Aquest canvi és un downgrade',
        PREVIEW_UPGRADE: 'Aquest canvi és una millora de pla',
        PREVIEW_GAIN: 'Guanyes',
        PREVIEW_LOSS: 'Perds',
        CARD_SECTION_TITLE: 'Afegeix una targeta de crèdit',
        CARD_SECTION_TEXT: 'El Pla d\'Incentius requereix una targeta de crèdit registrada.',
        CONFIRM_BUTTON: 'Confirmar canvi de pla',
        CANCEL_BUTTON: 'Donar de baixa la subscripció',
        PLAN_NOT_AVAILABLE_TITLE: 'Pla no disponible',
        CARD_REQUIRED_TITLE: 'Falta la targeta de crèdit',
        CARD_REQUIRED_TEXT: 'Afegeix una targeta de crèdit per poder continuar amb el Pla d\'Incentius.',
        UPDATE_SUCCESS_TITLE: 'Pla actualitzat',
        UPDATE_SUCCESS_TEXT: 'El canvi de pla s\'ha aplicat correctament.',
        UPDATE_ERROR_TITLE: 'No s\'ha pogut canviar el pla',
        UPDATE_ERROR_GENERIC: 'No s\'ha pogut canviar el pla. Torna-ho a intentar.',
        CANCEL_CONFIRM_TITLE: 'Vols donar de baixa la subscripció?',
        CANCEL_CONFIRM_TEXT: 'L\'empresa deixarà de tenir un pla actiu. Podràs triar-ne un de nou quan vulguis.',
        CANCEL_CONFIRM_BUTTON: 'Donar de baixa',
        CANCEL_CANCEL_BUTTON: 'Cancel·lar',
        CANCEL_SUCCESS_TITLE: 'Subscripció donada de baixa',
        CANCEL_ERROR_TITLE: 'Error',
        CANCEL_ERROR_GENERIC: 'No s\'ha pogut donar de baixa la subscripció.',
        LOAD_ERROR: 'No s\'ha pogut carregar el pla.',
        RETRY: 'Torna-ho a provar',
        TRIAL_CARD: {
          PRE_LAUNCH_TITLE: 'Prova gratuïta de 3 mesos',
          PRE_LAUNCH_TAG: 'Comença en afegir empleats',
          NO_COMMITMENT: 'Sense compromís · sense permanència',
          TRIAL_TITLE: 'Prova gratuïta · queden {{days}} dies',
          TRIAL_TITLE_ONE: 'Prova gratuïta · queda 1 dia',
          TRIAL_TEXT: 'Acaba el {{date}}. No es cobra res fins aleshores.',
          TRIAL_TEXT_COMPLETE: 'Acaba el {{date}}. Després comença el Pla Incentius.',
          TRIAL_DAY_TAG: 'Dia {{day}} de {{total}}',
          LOCKED_TITLE: 'La teva prova va acabar el {{date}}',
          LOCKED_TEXT: 'El dashboard està bloquejat fins que completis el teu compte. L\'app de la teva plantilla continua funcionant.',
          LOCKED_TAG: 'Bloquejat',
          ACTIVE_TITLE: 'Pla Incentius · actiu',
          ACTIVE_TAG: 'Actiu',
          PARTNER_PRE_LAUNCH_TITLE: 'Prova gratuïta',
          PARTNER_TRIAL_TEXT: 'Acaba el {{date}}. {{partner}} es posarà en contacte amb tu per activar el teu pla anual.',
          PARTNER_LOCKED_TEXT: '{{partner}} està preparant el teu contracte i es posarà en contacte amb tu.',
          PARTNER_ACTIVE_TITLE: 'Pla anual',
          PARTNER_ACTIVE_TEXT: 'La teva bossa de mobilitat surt d\'aquest pla: cada dia 1 entra a la teva cartera 1/12 i el que no es gasta s\'acumula.',
          PARTNER_TAG: 'Gestionat per {{partner}}',
          PARTNER_MANAGED: 'El teu pla, la facturació i el contracte els gestiona {{partner}}.',
          ANNUAL_ACTIVE_SINCE: 'Actiu des del {{date}}.',
          ANNUAL_RENEWS_ON: 'Es renova el {{date}}.',
          ANNUAL_PENDING_PAYMENT: 'Pendent de pagament: {{partner}} t\'enviarà com pagar-lo.',
          ANNUAL_DRAFT: '{{partner}} està preparant el teu pla anual.',
        },
        MANAGER: {
          TITLE: 'El teu gestor a {{partner}}',
          NAME: 'Nom',
          EMAIL: 'Correu',
          PHONE: 'Telèfon',
        },
        ACCOUNT: {
          TITLE: 'Completa el teu compte',
          SUB_TRIAL: 'Quan vulguis durant la prova. No es cobra res fins que acabi.',
          SUB_LOCKED: 'És l\'únic que falta per tornar a editar.',
          COUNT: '{{done}} de {{total}}',
          BILLING_TITLE: 'Dades de facturació',
          BILLING_TEXT: 'Raó social, CIF, adreça i correu de facturació.',
          BILLING_ACTION: 'Completar',
          BILLING_DONE: '{{name}} · {{taxId}}',
          PAYMENT_TITLE: 'Mètode de pagament',
          PAYMENT_TEXT: 'Domiciliació SEPA, targeta o transferència amb factura.',
          PAYMENT_ACTION: 'Triar',
          CONTRACT_TITLE: 'Contracte',
          CONTRACT_TEXT: 'Llegeix-lo i accepta\'l aquí mateix, amb el teu nom i càrrec.',
          CONTRACT_ACTION: 'Llegir i acceptar',
          CONTRACT_DISABLED: 'Primer completa la facturació i el pagament.',
          EDIT: 'Editar',
          COMPLETE_TITLE: 'El teu compte està complet',
          COMPLETE_SIGNED: 'Contracte acceptat per {{name}}, {{position}} · {{date}}',
          VIEW_CONTRACT: 'Veure el contracte',
          SUMMARY_PLAN: 'Pla',
          SUMMARY_TIER: 'Tarifa',
          SUMMARY_AMOUNT: 'Import',
          SUMMARY_STARTS: 'Comença',
          SUMMARY_PAYMENT: 'Pagament',
        },
        PAYMENT_LABEL: {
          CARD: 'Targeta',
          CARD_LAST4: 'Targeta •••• {{last4}}',
          SEPA_DEBIT: 'Domiciliació SEPA',
          BANK_TRANSFER: 'Transferència amb factura',
        },
        COACHING: {
          TITLE: 'Acompanyament setmanal',
          TEXT: 'Una sessió de 45 minuts a la setmana amb el nostre equip durant la prova. Inclosa i opcional.',
          ACTION: 'Reservar sessió',
        },
        PRICE: {
          EUR: '{{amount}} €',
          PER_MONTH: '{{amount}} €/mes',
          MONTH_AMOUNT: '{{amount}} € al mes',
          ADVISOR: 'A consultar amb un assessor',
        },
        TIER: {
          BELOW: 'Menys de {{max}}',
          RANGE: '{{min}} – {{max}}',
          ABOVE: 'Més de {{min}}',
        },
        TARIFFS: {
          TITLE: 'Tarifes del Pla Incentius',
          SUB: 'Mensual per empresa, segons la mida del centre principal.',
          YOUR_TIER: 'El teu tram',
          EXTRA_OFFICE: '+{{amount}} €/mes per cada centre addicional',
          EXTRA_OFFICE_OFFICES: '+{{amount}} €/mes per cada centre addicional · tens {{offices}} seus',
          REFERENCE: 'Es pren com a referència el centre amb més treballadors.',
        },
        BILLING_MODAL: {
          TITLE: 'Dades de facturació',
          SUB: 'Les que aniran al contracte i a les factures.',
          LEGAL_NAME: 'Raó social',
          TAX_ID: 'CIF',
          ADDRESS: 'Adreça fiscal',
          ADDRESS_PLACEHOLDER: 'Carrer, número, pis',
          POSTAL_CODE: 'Codi postal',
          CITY: 'Ciutat',
          EMAIL: 'Correu de facturació',
          REQUIRED: 'Aquest camp és obligatori.',
          POSTAL_CODE_INVALID: 'Escriu un codi postal de 5 dígits.',
          EMAIL_INVALID: 'Escriu un correu vàlid.',
          TAX_ID_INVALID: 'CIF no vàlid',
          ERROR: 'No s\'han pogut desar les dades de facturació.',
        },
        PAYMENT_MODAL: {
          TITLE: 'Mètode de pagament',
          SUB: 'S\'utilitza a partir del {{date}}. Fins aleshores no es cobra res.',
          SEPA: 'Domiciliació bancària',
          CARD: 'Targeta',
          TRANSFER: 'Transferència amb factura',
          IBAN: 'IBAN',
          SEPA_HINT: 'Signes el mandat SEPA en desar.',
          CARD_HINT: 'Es desa de manera segura a Stripe.',
          STRIPE_ERROR: 'No s\'ha pogut carregar el formulari de Stripe. Torna-ho a provar.',
          ERROR: 'No s\'ha pogut desar el mètode de pagament.',
        },
        CONTRACT_MODAL: {
          TITLE: 'Contracte de prestació de serveis',
          SUB: 'Acceptació electrònica des del dashboard. Queda desada amb data, nom i càrrec.',
          CLIENT: 'Client',
          PLAN: 'Pla',
          TIER: 'Tarifa',
          AMOUNT: 'Import',
          START: 'Inici',
          DURATION: 'Durada',
          PAYMENT: 'Pagament',
          TODAY: 'Avui',
          AT_TRIAL_END: 'En acabar la prova',
          TIER_TEXT: 'Tram {{tier}} empleats · {{price}} €/mes',
          TIER_TEXT_EXTRA_ONE: 'Tram {{tier}} empleats · {{price}} €/mes + 1 centre addicional ({{extra}} €)',
          TIER_TEXT_EXTRA: 'Tram {{tier}} empleats · {{price}} €/mes + {{count}} centres addicionals ({{extra}} €)',
          TIER_TEXT_ADVISOR: 'Tram {{tier}} empleats · a consultar amb un assessor',
          READ_PDF: 'Llegir el contracte complet (PDF)',
          NAME: 'El teu nom',
          POSITION: 'Càrrec',
          CONFIRM: 'He llegit el contracte i tinc poders per acceptar-lo en nom de {{company}}.',
          ACCEPT: 'Accepto i signo',
          ACCEPTING: 'Signant…',
          ERROR: 'No s\'ha pogut acceptar el contracte.',
        },
        CONTRACT_PDF: {
          TITLE: 'Contracte de prestació de serveis',
          LOADING: 'Carregant el contracte…',
          ERROR: 'No s\'ha pogut carregar el contracte.',
          FRAME_TITLE: 'Contracte en PDF',
        },
        MODAL: {
          SAVE: 'Desar',
          SAVING: 'Desant…',
          CANCEL: 'Cancel·lar',
          CLOSE: 'Tancar',
        },
        COMPARISON: {
          CATEGORY_DASHBOARD: 'L\'app i el dashboard',
          CATEGORY_CAE: 'Ingressos per CAE',
          CATEGORY_INCENTIVES: 'Incentius a la plantilla',
          CATEGORY_COMPLIANCE: 'Compliment',
          CATEGORY_ACCOUNT: 'Gestió del compte',
          CATEGORY_LIMITS: 'Límits',
          LIMIT_DURATION: 'Durada',
          LIMIT_DURATION_TRIAL: '3 mesos',
          LIMIT_DURATION_UNLIMITED: 'Indefinida',
          LIMIT_TEAM_SIZE: 'Mida de la plantilla',
          LIMIT_UNLIMITED: 'Sense límit',
          LIMIT_ACTIVE_USERS: 'Usuaris actius',
          LIMIT_REQUIRES_CARD: 'Requereix targeta',
          YES: 'Sí',
          NO: 'No',
          SELECT_PLAN: 'Seleccionar',
          NOT_ELIGIBLE_BADGE: 'No elegible',
          TRIAL_COLUMN: 'Prova 3 mesos',
          TRIAL_PRICE_NOTE: 'durant 3 mesos',
          INCENTIVES_COLUMN: 'Pla Incentius',
          INCENTIVES_PRICE_NOTE: 'al mes · tram {{tier}}',
          INCENTIVES_PRICE_NOTE_NO_TIER: 'al mes',
          RECOMMENDED: 'Recomanat',
          YOUR_PLAN: 'El teu pla',
          INCLUDED: 'Inclòs',
          NOT_INCLUDED: 'No inclòs',
        },
      },
      CORPORATION_RIDE_POLICY: {
        NOTE_COMMISSION: 'La comissió de la plataforma s\'aplica igual que en un viatge normal.',
        NOTE_REASON: 'L\'empleat indica sempre el motiu del viatge.',
        LOADING: 'Carregant la política…',
        LOAD_ERROR: 'No s\'ha pogut carregar la política.',
        RETRY: 'Torna-ho a provar',
        CREATE_GROUP: 'Crea un grup',
        CREATE_GROUP_LONG: 'Crea un grup amb les seves pròpies regles',
        OFF_TITLE: 'Pagament d\'empresa desactivat',
        OFF_TEXT: 'Cap grup no pot pagar viatges amb l\'empresa des de l\'app. Activa\'l a «Pagament d\'empresa».',
        GROUPS_TITLE: 'Grups',
        GROUPS_SUB: 'Cada grup té les seves pròpies regles. Qui no és en cap altre grup fa servir les de «Tots els empleats».',
        GROUPS_ERROR: 'No s\'han pogut carregar els grups.',
        DEFAULT_GROUP_NAME: 'Tots els empleats',
        DEFAULT_BADGE: 'Predeterminat',
        DEFAULT_WHO: 'qui no és en cap altre grup',
        MEMBERS_ONE: '{{count}} persona',
        MEMBERS_MANY: '{{count}} persones',
        EDIT_GROUP: 'Edita',
        SPEND_ONE: '{{amount}} en {{count}} viatge · últims 30 dies',
        SPEND_MANY: '{{amount}} en {{count}} viatges · últims 30 dies',
        SPEND_NONE: 'Sense viatges els últims 30 dies',
        SPEND_UNAVAILABLE: 'No s\'ha pogut llegir la despesa dels últims 30 dies',
        RULES: {
          NO_COMPANY_PAY: 'Sense pagament amb l\'empresa',
          LIMIT: 'Fins a {{amount}} / viatge',
          ANY_TIME: 'Qualsevol dia i hora',
          CATEGORY: {
            economy: 'Econòmic',
            executive: 'Fins a executiu',
            any: 'Qualsevol categoria',
          },
          SERVICE: {
            any: 'Taxi o VTC',
            taxi: 'Només taxi',
            vtc: 'Només VTC',
          },
        },
        CATEGORY: {
          economy: 'Econòmic',
          executive: 'Executiu',
          any: 'Qualsevol',
        },
        SERVICE: {
          any: 'Taxi o VTC',
          taxi: 'Taxi',
          vtc: 'VTC',
        },
        DAYS: {
          MON: 'Dl',
          TUE: 'Dt',
          WED: 'Dc',
          THU: 'Dj',
          FRI: 'Dv',
          SAT: 'Ds',
          SUN: 'Dg',
          EVERY_DAY: 'Cada dia',
          WEEKDAYS: 'Dl–Dv',
        },
        GROUP_CREATED: 'Grup «{{name}}» creat amb {{count}} persones',
        GROUP_CREATED_ONE: 'Grup «{{name}}» creat amb 1 persona',
        GROUP_SAVED: 'Grup «{{name}}» desat',
        GROUP_APPLIES_SOON: 'Les regles s\'apliquen a l\'app en uns minuts.',
        GROUP_MOVED: '{{moved}} persones canvien de grup.',
        GROUP_MOVED_ONE: '1 persona canvia de grup.',
        PAYMENT_TITLE: 'Pagament d\'empresa',
        PAYMENT_SUB: 'Comú a tots els grups: si es pot pagar amb l\'empresa, el pressupost del mes i la recàrrega del wallet.',
        NEVER_SUBSCRIBED_TITLE: 'La teva empresa encara no té pla',
        NEVER_SUBSCRIBED_TEXT: 'Pots desar la política, però l\'app no oferirà el pagament d\'empresa fins que contracteu un pla que l\'inclogui.',
        ACTIVE_LABEL: 'Pagament d\'empresa actiu',
        ACTIVE_HINT: 'Desactivat, cap grup no pot pagar viatges amb l\'empresa.',
        BUDGET_TITLE: 'Pressupost mensual',
        BUDGET_LABEL: 'Limita la despesa d\'empresa al mes',
        BUDGET_HINT: 'Comú a tots els grups. Avís al 80 % i bloqueig al 100 %: quan s\'esgota, ningú no pot pagar amb l\'empresa fins al mes següent.',
        BUDGET_AMOUNT_LABEL: 'Pressupost al mes (€)',
        BUDGET_AMOUNT_HINT: 'Mínim 100 €.',
        USAGE_LABEL: 'Consumit aquest mes',
        USAGE_TEXT: '{{consumed}} de {{budget}} · mes en curs',
        USAGE_WARNING: 'S\'ha consumit el 80 % del pressupost d\'aquest mes.',
        USAGE_EXHAUSTED: 'Pressupost esgotat: el pagament d\'empresa queda bloquejat fins al mes vinent.',
        TOPUP_TITLE: 'Recàrrega automàtica',
        TOPUP_LABEL: 'Import de la recàrrega (€)',
        TOPUP_HINT: 'Si no hi ha saldo, el wallet es recarrega com a mínim amb aquest import des de la targeta de l\'empresa. Mínim 10 €.',
        SAVE: 'Desa els canvis',
        SAVING: 'Desant…',
        SAVE_DISABLED_HINT: 'Revisa els camps marcats per poder desar',
        SAVED: 'Política desada',
        SAVE_ERROR: 'No s\'ha pogut desar la política',
        ACCEPT: 'D\'acord',
        CANCEL: 'Cancel·la',
        DEACTIVATE_TITLE: 'Desactiva el pagament d\'empresa',
        DEACTIVATE_TEXT: 'Cap grup no veurà «Pagament d\'empresa» a l\'app. Els viatges ja fets no canvien.',
        DEACTIVATE_CONFIRM: 'Desactiva',
        DEACTIVATING: 'Desactivant…',
        DEACTIVATED: 'Desactivat',
        HOW_TITLE: 'Com s\'apliquen les regles',
        HOW_GROUPS_TITLE: 'Cada persona, en un sol grup',
        HOW_GROUPS_TEXT: 'Si l\'afegeixes a un altre grup, passa a aquest grup. Si la treus, torna a «Tots els empleats».',
        HOW_LIMIT_TITLE: 'Si un viatge supera el límit',
        HOW_LIMIT_TEXT: 'L\'empresa paga fins al límit del seu grup i la resta es cobra a la targeta de l\'empleat. Ho veu abans de confirmar.',
        HOW_TRIP_TITLE: 'A cada viatge',
        HOW_WAIIS_TITLE: 'Què no decideix l\'empresa',
        HOW_WAIIS_TEXT: 'Els proveïdors (Uber, Cabify, Bolt) i els preus els gestiona WAIIS.',
        BILLING_TITLE: 'Com es cobra',
        BILLING_SUB: 'Els viatges es paguen amb el wallet de l\'empresa. Si hi falta saldo, es recarrega amb la targeta per defecte.',
        WALLET_BALANCE: 'Saldo del wallet',
        COMPANY_CARD: 'Targeta de l\'empresa',
        CARD_VALUE: '{{brand}} •••• {{last4}}',
        NO_CARD: 'Sense targeta',
        NO_CARD_WARNING: 'Sense targeta, quan no hi hagi saldo el pagament d\'empresa fallarà.',
        GO_TO_SETTINGS: 'Recarrega o afegeix una targeta a Configuració',
        PREVIEW: {
          TITLE: 'Així ho veu l\'empleat',
          SUB: 'El full «Tria com et mous» de l\'app amb les regles del grup i el que hi ha desat a «Pagament d\'empresa».',
          VIEW_AS: 'Veure com',
          EDITOR_TITLE: 'Així ho veuran a l\'app',
          PHONE_ARIA: 'Vista prèvia de l\'app',
          SHEET_TITLE: 'Tria com et mous',
          PERSONAL_CARD: 'Targeta de l\'empleat',
          COMPANY_NAME: 'La teva empresa',
          COMPANY_ROW_SUBTITLE: 'Pagament d\'empresa · fins a {{limit}}',
          SELECT: 'Seleccionar',
          CLOCK: 'Amb l\'hora actual de Madrid ({{time}})',
          PRODUCT: {
            go: 'VTC econòmic',
            premium: 'VTC executiu',
            xl: 'VTC XL',
            taxi: 'Taxi',
          },
        },
        EDITOR: {
          NEW_TITLE: 'Grup nou',
          NEW_SUB: 'Comença amb les regles de «Tots els empleats». Ajusta-les i afegeix-hi les persones.',
          DEFAULT_SUB: 'Regles comunes per a qui no és en cap altre grup',
          GROUP_SUB: '{{count}} persones amb aquestes regles',
          GROUP_SUB_ONE: '1 persona amb aquestes regles',
          CLOSE: 'Tanca',
          NAME_LABEL: 'Nom del grup',
          NAME_PLACEHOLDER: 'Ex.: Directius, Comercial, Torn de nit',
          TAB_RULES: 'Regles',
          TAB_MEMBERS: 'Membres',
          COMPANY_PAYS: 'Poden pagar amb l\'empresa',
          COMPANY_PAYS_HINT: 'Si ho desactives, aquest grup no veurà «Pagament d\'empresa» a l\'app.',
          LIMIT_LABEL: 'Límit per viatge (€)',
          LIMIT_HINT: 'La resta la paga l\'empleat. Mínim 5 €.',
          CATEGORY_LABEL: 'Categoria màxima',
          SERVICE_LABEL: 'Servei',
          SCHEDULE: 'Només en horari',
          SCHEDULE_HINT: 'Fora de l\'horari, l\'app no ofereix el pagament d\'empresa.',
          FROM: 'Des de',
          TO: 'Fins a',
          CROSSES_MIDNIGHT: 'Passa la mitjanit: acaba l\'endemà.',
          DAYS_LABEL: 'Dies',
          DEFAULT_MEMBERS_NOTE: 'Aquest grup no s\'edita a mà: inclou tothom qui no és en cap altre grup. Per donar altres regles a algú, afegeix-lo a un grup.',
          SEARCH: 'Cerca un empleat…',
          MEMBERS_HINT: 'Cada persona és en un sol grup: si tries algú d\'un altre grup, en surt.',
          IN_GROUP: 'a «{{name}}»',
          LEAVES_GROUP: 'surt de «{{name}}»',
          NO_RESULTS: 'Sense resultats.',
          NO_EMPLOYEES: 'L\'empresa encara no té empleats vinculats.',
          EMPLOYEES_ERROR: 'No s\'han pogut carregar els empleats.',
          DELETE: 'Elimina el grup',
          DELETE_TITLE: 'Eliminar el grup «{{name}}»',
          DELETE_TEXT: 'Les seves {{count}} persones tornen a «Tots els empleats».',
          DELETE_TEXT_ONE: 'La persona del grup torna a «Tots els empleats».',
          DELETE_TEXT_NONE: 'El grup no té persones.',
          DELETE_CONFIRM: 'Elimina el grup',
          DELETING: 'Eliminant…',
          DELETED: 'Eliminat',
          DELETE_ERROR: 'No s\'ha pogut eliminar el grup',
          CREATE: 'Crea el grup',
          SAVE: 'Desa',
          SAVE_ERROR: 'No s\'ha pogut desar el grup',
          SAVE_DISABLED_HINT: 'Omple els camps obligatoris (*) per poder desar',
        },
        VALIDATION: {
          REQUIRED: 'Aquest camp és obligatori.',
          MIN: 'L\'import mínim és {{min}} €.',
          MAX_LENGTH: 'Com a màxim {{max}} caràcters.',
          SAME_TIMES: 'L\'hora de fi ha de ser diferent de la d\'inici.',
          DAYS_REQUIRED: 'Tria almenys un dia.',
        },
      },
      CORPORATION_RIDES: {
        TITLE: 'Viatges i despesa en taxi',
        ALL_OFFICES: 'Tots els centres',
        OFFICE_ARIA: 'Centre',
        PERIOD: {
          ARIA: 'Període',
          LAST_30_DAYS: 'Últims 30 dies',
          LAST_90_DAYS: 'Últims 90 dies',
          THIS_YEAR: 'Aquest any',
        },
        EXPORT_CSV: 'Exportar CSV',
        EXPORTING: 'Exportant…',
        EXPORT_ERROR: 'No s\'ha pogut exportar el CSV.',
        EXPORT_EMPTY: 'No hi ha viatges en el període.',
        EXPORT_DONE: 'CSV exportat · {{count}} viatges',
        LOAD_ERROR: 'No s\'han pogut carregar els viatges.',
        FORBIDDEN: 'No tens permís per veure els viatges d\'aquesta empresa.',
        RETRY: 'Tornar-ho a provar',
        ACCEPT: 'Acceptar',
        TODAY: 'Avui',
        YESTERDAY: 'Ahir',
        NO_COST: 'Sense cost',
        PAGINATION: 'Mostrant {{shown}} de {{total}} viatges',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        KPI: {
          SPEND: 'Despesa empresa',
          VS_PREVIOUS: 'davant de {{value}} el període anterior',
          NO_PREVIOUS: 'Sense període anterior comparable',
          RIDES: 'Viatges d\'empleats',
          RIDES_HINT: 'Completats en el període',
          AWAITING_RECEIPT: '{{count}} pendents de rebut',
          AVERAGE: 'Import mitjà per viatge',
          AVERAGE_HINT: 'El que paga l\'empresa',
          EMPLOYEES: 'Empleats que l\'han fet servir',
          EMPLOYEES_HINT: 'Amb algun viatge completat',
          ELIGIBLE: 'de {{count}} amb pagament d\'empresa',
        },
        WEEKS: {
          TITLE: 'Despesa per setmana',
          Q: 'El que ha pagat l\'empresa les últimes 8 setmanes',
          TOTAL: '{{value}} en 8 setmanes',
          CURRENT: 'Setmana en curs',
          TIP: 'Despesa empresa',
          EMPTY: 'Sense despesa les últimes 8 setmanes.',
          TABLE: 'Veure les dades',
          WEEK: 'Setmana',
          TOTAL_ROW: 'Total',
        },
        RECLAIM: {
          LINE: 'Reclamat a l’empleat després del rebuig',
          STATUS: {
            WAITING: 'Esperant que es tanqui el cobrament',
            REQUESTED: 'Reclamant',
            PENDING_DEBT: 'En deute de l’empleat',
            RECLAIMED: 'Reclamat',
            NOT_NEEDED: 'Res a reclamar',
            FAILED: 'Fallit: gestió manual',
          },
        },
        TABLE: {
          TITLE: 'Detall de viatges',
          SUB: 'Els viatges del període i el centre triats, del més recent al més antic.',
          SEARCH: 'Empleat, origen o destinació…',
          STATE: 'Estat',
          REVIEW: 'Revisió',
          EMPLOYEE: 'Empleat',
          DATE: 'Data',
          ROUTE: 'Trajecte',
          COMPANY_AMOUNT: 'Import empresa',
          OPEN: 'Obrir',
          PLUS_EMPLOYEE: '+ {{value}} empleat',
        },
        REVIEW_FILTER: {
          ALL: 'Totes les revisions',
          PENDING: 'Pendents de revisar',
        },
        STATE_FILTER: {
          ALL: 'Tots els estats',
          IN_PROGRESS: 'En curs',
          COMPLETED: 'Completats',
          CANCELLED: 'Cancel·lats',
          REJECTED: 'Rebutjats',
        },
        STATE_GROUP: {
          IN_PROGRESS: 'En curs',
          COMPLETED: 'Completat',
          CANCELLED: 'Cancel·lat',
        },
        AMOUNT_STATUS: {
          AWAITING_RECEIPT: 'Pendent de rebut',
          WALLET_SYNC_PENDING: 'Cobrament al wallet pendent',
        },
        EMPTY: {
          TITLE: 'Sense viatges',
          FILTERED: 'Res no coincideix amb el filtre.',
          NONE: 'Quan un empleat autoritzat pagui un viatge amb l\'empresa, apareixerà aquí.',
        },
        REASON: {
          COMMUTE: 'Anada/tornada a la feina',
          CLIENT_VISIT: 'Visita a client',
          BETWEEN_OFFICES: 'Desplaçament entre seus',
          LATE_EXIT: 'Sortida tard',
          CORPORATE_EVENT: 'Esdeveniment corporatiu',
          OTHER: 'Altres',
        },
        DETAIL: {
          CLOSE: 'Tancar',
          LOAD_ERROR: 'No s\'ha pogut carregar el viatge',
          NOT_FOUND: 'El viatge ja no existeix o no el paga l\'empresa',
          TRIP: 'Viatge',
          REASON: 'Motiu declarat',
          JUSTIFICATION: 'Justificació',
          NO_JUSTIFICATION: 'No aportada',
          REVIEW: 'Revisió',
          STATE: 'Estat',
          DEPARTMENT: 'Departament',
          REQUESTED_AT: 'Demanat',
          SCHEDULED_AT: 'Programat per a',
          ACCEPTED_AT: 'Acceptat',
          ENDED_AT: 'Finalitzat',
          RECEIPT: 'Rebut del proveïdor',
          RECEIPT_YES: 'Rebut',
          RECEIPT_NO: 'Encara no',
          SPLIT: 'Repartiment del pagament',
          COMPANY: 'Empresa',
          COMPANY_UP_TO: 'Empresa · fins a {{limit}} per viatge',
          EMPLOYEE_OVER_LIMIT: 'Targeta de l\'empleat · excés sobre el límit',
          AWAITING_RECEIPT_NOTE: 'El proveïdor encara no ha enviat el rebut: l\'import es cobra al wallet quan arribi.',
          WALLET_SYNC_NOTE: 'No s\'ha pogut cobrar aquest import del wallet de l\'empresa. Es cobrarà quan hi hagi saldo.',
          CANCELLATION: 'Cancel·lació',
          PENALTY: 'Penalització',
          PENALTY_COMPANY: 'A càrrec de l\'empresa',
          PENALTY_EMPLOYEE: 'A càrrec de l\'empleat',
          PRICE: 'Desglossament del preu',
          CONCEPT: 'Concepte',
          ESTIMATED: 'Estimat',
          FINAL: 'Final',
          PROVIDER_PRICE: 'Preu de {{provider}}',
          COMMISSION: 'Comissió WAIIS',
          COMMISSION_PCT: 'Comissió WAIIS ({{pct}} %)',
          TOTAL: 'Total',
        },
        CSV: {
          DATE: 'Data',
          TIME: 'Hora',
          EMPLOYEE: 'Empleat',
          DEPARTMENT: 'Departament',
          OFFICE: 'Seu',
          PICKUP: 'Origen',
          DROPOFF: 'Destinació',
          PROVIDER: 'Proveïdor',
          PRODUCT: 'Categoria',
          TOTAL: 'Import total',
          COMPANY: 'Import empresa',
          EMPLOYEE_AMOUNT: 'Import empleat',
          REASON: 'Motiu',
          STATE: 'Estat',
          REVIEW: 'Revisió',
        },
      },
      EMPLOYEES_GATE: {
        TITLE: 'Activa el teu compte per gestionar empleats',
        TEXT: 'Introdueix la teva targeta de crèdit de forma segura per activar el teu compte, afegir els teus empleats i començar a veure les teves dades reals. No es realitzarà cap càrrec en aquest moment (verificació de 0€).',
        ZERO_CHARGE_BADGE: 'Pagament segur · Verificació de 0€ · Sense càrrec ara',
      },
      PMST_QUESTIONNAIRE_CONFIG: {
        PREVIEW: 'Previsualització',
        RESTORE: 'Restaurar l\'exemple',
        SUMMARY: '{{steps}} passos · {{questions}} preguntes · {{required}} obligatòries',
        LOADING_BACKEND: 'Carregant la versió vigent del backend…',
        STEP_TITLE: 'Pas {{n}}',
        STEP_TITLE_LABEL: 'Títol del pas',
        QUESTIONS_COUNT: '{{count}} preguntes',
        SAVE_TITLE: 'Desar el títol',
        CANCEL: 'Cancel·lar',
        MOVE_UP: 'Pujar',
        MOVE_DOWN: 'Baixar',
        RENAME: 'Canviar el nom',
        DELETE_STEP: 'Eliminar el pas',
        NO_STATEMENT: '(sense enunciat)',
        NO_TEXT: '(sense text)',
        REQUIRED: 'Obligatòria',
        OPTIONAL: 'Opcional',
        CONDITIONAL: 'Condicional',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        EMPTY_STEP: 'Aquest pas encara no té preguntes.',
        ADD_QUESTION: 'Afegir pregunta',
        ADD_STEP: 'Afegir pas',
        SYNCING: 'Sincronitzant amb el backend…',
        SYNCED: 'Sincronitzat amb el backend',
        SYNC_ERROR: 'No s\'ha pogut sincronitzar amb el backend — el desament local sí que s\'ha fet',
        SAVING: 'Desant…',
        SAVE_CHANGES: 'Desar els canvis',
        SAVED: 'Desat',
        NEW_QUESTION: 'Nova pregunta',
        EDIT_QUESTION: 'Editar pregunta',
        SECTION_QUESTION: 'Pregunta',
        STATEMENT: 'Enunciat',
        STATEMENT_PLACEHOLDER: 'Text de la pregunta',
        ANSWER_TYPE: 'Tipus de resposta',
        REQUIREDNESS: 'Obligatorietat',
        UNIT: 'Unitat (opcional)',
        UNIT_PLACEHOLDER: 'p. ex. €/any, places, km/any',
        SECTION_OPTIONS: 'Opcions',
        OPTION_N: 'Opció {{n}}',
        REMOVE: 'Treure',
        ADD_OPTION: 'Afegir opció',
        SECTION_COLUMNS: 'Columnes de la taula',
        COLUMN_N: 'Columna {{n}}',
        ADD_COLUMN: 'Afegir columna',
        SECTION_CONDITION: 'Condició',
        IS_CONDITIONAL: 'És una pregunta condicional («només si s\'escau»)',
        DEPENDS_ON: 'Depèn de',
        DEPENDS_ON_NOTE: '(opcional — deixa-ho en blanc si la pregunta d\'origen encara no existeix)',
        UNLINKED: '— Sense enllaçar —',
        TRIGGER_VALUE: 'Valor que activa la pregunta',
        TRIGGER_VALUE_PLACEHOLDER: 'Valor exacte de la resposta',
        NOTE: 'Nota explicativa',
        NOTE_HINT: '(es mostra sempre al costat de la pregunta)',
        NOTE_PLACEHOLDER: 'p. ex. Només si l\'empresa té flota pròpia',
        SAVE_QUESTION: 'Desar la pregunta',
        DELETE_STEP_TITLE: 'Vols eliminar aquest pas?',
        DELETE_STEP_TEXT: 'S\'eliminarà «{{title}}» i les seves {{count}} preguntes.',
        DELETE_QUESTION_TITLE: 'Vols eliminar aquesta pregunta?',
        MISSING_STATEMENT_TITLE: 'Falta l\'enunciat',
        MISSING_STATEMENT_TEXT: 'Escriu el text de la pregunta abans de desar.',
        PREVIEW_WINDOW_TITLE: 'Previsualització · Formulari PMST',
        RESTORE_TITLE: 'Vols restaurar el qüestionari d\'exemple?',
        RESTORE_TEXT: 'Els passos i les preguntes actuals se substituiran pels 81 d\'exemple (11 passos).',
        RESTORE_CONFIRM: 'Restaurar',
        TYPE: {
          short_text: 'Resposta curta',
          long_text: 'Resposta oberta (text lliure)',
          single_choice: 'Opció única',
          multiple_choice: 'Diverses opcions',
          table: 'Taula',
          integer: 'Nombre enter',
          number: 'Nombre',
          percentage: 'Percentatge (%)',
          currency: 'Import en €',
          file: 'Adjuntar fitxer',
          date: 'Data',
        },
      },
    },
    MOCK_MODE: {
      DEMO_BADGE: 'Entorn de demostració · dades simulades',
    },
    EMPLOYEES_BANNER: {
      TITLE: 'Encara no has afegit cap empleat?',
      TEXT: 'Mentrestant, pots anar explorant com funcionen les seccions d\'Ús, Funnel i Viatges: de moment mostren dades fictícies d\'exemple, a manera de demostració, perquè vegis quina informació podràs consultar. Quan afegeixis la teva plantilla, aquestes dades passaran a reflectir l\'activitat real dels teus empleats. Per veure dades reals,',
      MOCK_NOTICE: 'Les dades que veus ara són simulades fins que afegeixis empleats.',
      CTA: 'carrega els teus empleats',
    },
    TRANSLATOR: {
      SELECT: 'Tria el teu idioma',
    },
    MENU: {
      NEW: 'nou',
      ACTIONS: 'Comportament',
      CREATE_POST: 'Crear nova publicació',
      PAGES: 'Pages',
      FEATURES: 'Característiques',
      APPS: 'Aplicacions',
      DASHBOARD: 'Tauler',
    },
    AUTH: {
      PARTNER_INVITATION: {
        BRAND_EYEBROW: 'Invitació',
        BRAND_TITLE: 'Uneix-te a l\'equip de {{partner}}',
        BRAND_SUB: 'Gestiona amb el teu equip les empreses que {{partner}} porta a WAIIS.',
        EYEBROW: 'Invitació a l\'equip',
        TITLE: '{{partner}} et convida al seu equip',
        AS_ROLE: 'Hi entraràs com a {{role}}.',
        ROLE_TUTOR: 'Partner admin',
        ROLE_SUBTUTOR: 'Partner usuari (només lectura)',
        REGISTER_HINT: 'Crea el teu compte amb aquest correu per acceptar la invitació.',
        REGISTER: 'Crea el meu compte',
        LOGIN_HINT: 'Ja tens compte amb aquest correu: inicia la sessió i la invitació s\'accepta sola.',
        LOGIN: 'Inicia la sessió',
        ACCEPTING: 'Acceptant la invitació…',
        OTHER_ACCOUNT: 'Has iniciat la sessió com a {{session}}, però la invitació és per a {{email}}.',
        SWITCH_ACCOUNT: 'Tanca la sessió i continua',
        ACCEPT_ERROR: 'No s\'ha pogut acceptar la invitació.',
        RETRY: 'Torna-ho a provar',
        INVALID: 'Aquesta invitació no és vàlida o ha caducat.',
        INVALID_HINT: 'Demana a qui et va convidar que te n\'enviï una de nova.',
        REGISTER_NOTE_TITLE: 'T\'uneixes a l\'equip de {{partner}}',
        REGISTER_NOTE_TEXT: 'El compte es crea amb {{email}}, el correu de la invitació.',
      },
      PARTNER: {
        LINKED_TO: 'La teva empresa quedarà vinculada a {{partner}}.',
      },
      GENERAL: {
        OR: 'O',
        SUBMIT_BUTTON: 'Enviar',
        NO_ACCOUNT: 'No tens compte?',
        SIGNUP_BUTTON: "Registra't",
        FORGOT_BUTTON: 'Has oblidat la contrasenya?',
        BACK_BUTTON: 'Enrere',
        PRIVACY: 'Privacitat',
        LEGAL: 'Legal',
        CONTACT: 'Contacte',
      },
      LOGIN: {
        TITLE: 'Inicia sessió',
        SUBTITLE: 'T\'enviem un codi d\'un sol ús al teu correu o al teu telèfon, sense necessitat de contrasenya.',
        TOGGLE_PASSWORD: 'Mostrar o amagar la contrasenya',
        GOOGLE: 'Continuar amb Google',
        OR_FORM: 'o amb el teu correu o telèfon',
        GOOGLE_POPUP_BLOCKED: 'El teu navegador ha blocat la finestra de Google. Permet les finestres emergents per a aquest lloc i torna-ho a provar.',
        GOOGLE_ERROR: 'No s\'ha pogut iniciar sessió amb Google. Torna-ho a provar.',
        EMAIL: 'Correu electrònic',
        SUBMIT: 'Inicia sessió',
        LOADING: 'Espera, si us plau...',
        NO_ACCOUNT: 'Encara no tens compte?',
        REGISTER_LINK: "Registra't",
      },
      FORGOT: {
        TITLE: 'Has oblidat la contrasenya?',
        DESC: "Introdueix el teu correu electrònic per restablir la contrasenya",
        SUCCESS:
          "S'ha enviat el restabliment de contrasenya. Comprova el teu correu electrònic.",
        ERROR:
          "Ho sentim, s'han detectat alguns errors, si us plau torna-ho a intentar.",
        EMAIL: 'Correu electrònic',
        EMAIL_HINT:
          "S'enviarà un correu electrònic amb un botó per restablir la contrasenya. Revisa la teva safata d'entrada i, si no apareix, revisa la carpeta de correu brossa. Si tampoc el trobes, escriu a soporte@waiss.com.",
        SUBMIT: 'Enviar',
        LOADING: 'Si us plau, espera...',
        CANCEL: 'Cancel·lar',
        VALIDATION: {
          EMAIL_REQUIRED: 'El correu electrònic és obligatori',
          EMAIL_INVALID: 'El correu electrònic no és vàlid',
          EMAIL_MIN: 'El correu electrònic ha de tenir almenys 3 símbols',
          EMAIL_MAX: 'El correu electrònic ha de tenir un màxim de 30 símbols',
        },
      },
      RESET: {
        TITLE: 'Restablir contrasenya',
        DESC: 'Introdueix el token rebut per correu i la teva nova contrasenya',
        ERROR:
          "Ho sentim, s'han detectat alguns errors, si us plau torna-ho a intentar.",
        SUCCESS:
          'Contrasenya restablerta correctament. Redirigint a l\'inici de sessió…',
        TOKEN: 'Token',
        TOKEN_PLACEHOLDER: 'Token de restabliment',
        EMAIL: 'Correu electrònic',
        NEW_PASSWORD: 'Nova contrasenya',
        CONFIRM_PASSWORD: 'Confirmar contrasenya',
        SUBMIT: 'Restablir contrasenya',
        LOADING: 'Si us plau, espera...',
        CANCEL: 'Cancel·lar',
        VALIDATION: {
          TOKEN_REQUIRED: 'El token és obligatori',
          EMAIL_REQUIRED: 'El correu electrònic és obligatori',
          EMAIL_INVALID: 'El correu electrònic no és vàlid',
          PASSWORD_REQUIRED: 'La contrasenya és obligatòria',
          PASSWORD_MIN: 'La contrasenya ha de tenir almenys 8 caràcters',
          PASSWORD_CONFIRM_REQUIRED: 'La confirmació de contrasenya és obligatòria',
          PASSWORD_MISMATCH: 'Les contrasenyes no coincideixen',
        },
      },
      TWO_FACTOR: {
        TITLE: 'Autenticació en dos passos',
        DESC: 'Per continuar, tria un mètode d\'autenticació en dos passos:',
        METHOD_MOBILE: 'Enviament de codi al teu telèfon *****{{phone}}',
        METHOD_EMAIL: 'Enviament de codi al teu correu {{email}}',
        DEFAULT: 'Predeterminat',
        SUBMIT: 'Continuar',
        LOADING: 'Espera, si us plau...',
      },
      VERIFY: {
        SMS_TITLE: 'Hem enviat un codi SMS',
        SMS_DESC:
          'Al número de telèfon ******{{contact}}. Els codis són vàlids durant 10 minuts. No has rebut el codi? Sol·licita que es torni a enviar en 28 segons.',
        EMAIL_TITLE: 'Hem enviat un correu electrònic',
        EMAIL_DESC:
          'Per continuar, escriu el codi de verificació de 6 dígits enviat al teu correu electrònic: {{contact}}. Els codis són vàlids durant 10 minuts. No has rebut el codi? Sol·licita que es torni a enviar en 28 segons.',
        NO_CODE: 'No has rebut el codi?',
        RESEND: 'Reenviar',
        ERROR: 'El codi és incorrecte',
        LOADING: 'Espera, si us plau...',
        SUBMIT: 'Inicia sessió',
      },
      OTP_VERIFY: {
        TITLE: 'Verifica el teu codi',
        SUBTITLE_SMS: 'Codi enviat per SMS al {{contact}}',
        SUBTITLE_EMAIL: 'Codi enviat per correu a {{contact}}',
        CODE_ERROR: 'El codi introduït no és correcte',
        SUBMIT: 'Verificar i entrar',
        LOADING: 'Verificant...',
        RESEND: 'Reenviar codi',
        RESEND_COUNTDOWN: 'Reenviar codi en {{time}}',
        RESENDING: 'Reenviant codi...',
      },
      LOGIN_OTP: {
        TAB_PHONE: 'Telèfon',
        TAB_EMAIL: 'Correu electrònic',
        PHONE_LABEL: 'Número de telèfon',
        PHONE_PLACEHOLDER: '600 000 000',
        PHONE_INVALID: 'Introdueix un número de telèfon vàlid',
        PHONE_NOT_REGISTERED: 'Aquest número de telèfon no està registrat',
        EMAIL_PLACEHOLDER: 'elteucorreu@empresa.com',
        EMAIL_INVALID: 'Introdueix un correu electrònic vàlid',
        EMAIL_NOT_REGISTERED: 'Aquest correu electrònic no està registrat',
        SUBMIT: 'Continuar',
        LOADING: 'Enviant codi...',
      },
      WELCOME: {
        EYEBROW: 'Comença ara',
        TITLE: 'Crea el teu dashboard',
        SUBTITLE: 'Explora\'l amb dades d\'exemple o crea\'l ja per a la teva empresa.',
        REGISTER_OPTION: 'Crear el meu espai',
        EXPLORE_OPTION: 'Explorar el dashboard',
        GOOGLE_OPTION: 'Continuar amb Google',
        GOOGLE_ERROR: 'No s\'ha pogut iniciar sessió amb Google. Torna-ho a provar.',
        HAS_ACCOUNT: 'Ja tens compte?',
        LOGIN_LINK: 'Inicia sessió',
        VIDEO_TITLE: 'Coneix WAIIS',
        VIDEO_SUBTITLE: 'Mobilitat, més fàcil',
        VIDEO_DURATION: '{{duration}} min',
        VIDEO_CLOSE: 'Tancar el vídeo',
      },
      BRAND: {
        TITLE: 'Mobilitat sostenible, mesurada amb',
        TITLE_END: 'dades reals.',
        SUBTITLE: 'La teva plantilla comparteix cotxe amb l\'app. Tu ho veus tot al dashboard.',
        FEATURE_1: 'Participació de la teva plantilla, en temps real',
        FEATURE_2: 'Viatges i CO₂e evitat, mesurats i verificats',
        FEATURE_3: 'Informe PMST i seguiment del compliment',
        COPYRIGHT: '© {{year}} WAIIS Solutions Iberia, SL',
      },
      SIGNUP_BRAND: {
        TITLE: 'El teu espai,',
        TITLE_END: 'en dos passos.',
        SUB: 'Això és el que passa després:',
        STEP_1: 'Crees el teu espai',
        STEP_1_SUB: 'Ara',
        STEP_2: 'Convides la teva plantilla',
        STEP_2_SUB: 'Per correu o amb un CSV',
        STEP_3: 'Comença la teva prova',
        STEP_3_SUB: '3 mesos gratis des del teu primer empleat',
        STEP_4: 'T\'acompanyem',
        STEP_4_SUB: 'Sessions setmanals amb el nostre equip',
      },
      REGISTER: {
        EYEBROW: 'Pas 1 de 2',
        TITLE: 'Crea el teu compte',
        TOGGLE_PASSWORD: 'Mostrar o amagar la contrasenya',
        GOOGLE: 'Continuar amb Google',
        GOOGLE_POPUP_BLOCKED: 'El teu navegador ha blocat la finestra de Google. Permet les finestres emergents per a aquest lloc i torna-ho a provar.',
        GOOGLE_SKIP: '— salta aquest pas',
        OR_FORM: 'o amb el teu correu',
        FULLNAME: 'Nom i cognoms',
        FULLNAME_PLACEHOLDER: 'Marta Vidal',
        EMAIL_PLACEHOLDER: 'marta@latevaempresa.com',
        BACK: 'Enrere',
        LEGAL_PREFIX: 'En continuar acceptes els',
        LEGAL_TERMS: 'Termes',
        LEGAL_AND: 'i la',
        LEGAL_PRIVACY: 'Privacitat',
        LEGAL_SUFFIX: '.',
        EMAIL: 'Correu d\'empresa',
        DNI: 'DNI',
        DNI_PLACEHOLDER: '12345678A',
        BIRTH_DATE: 'Data de naixement',
        PHONE: 'Telèfon',
        PHONE_PLACEHOLDER: '+34 600 000 000',
        PASSWORD: 'Contrasenya',
        PASSWORD_HINT: 'Mínim 8 caràcters, una majúscula i un caràcter especial.',
        PASSWORD_CONFIRM: 'Confirmar contrasenya',
        SUBMIT: 'Continuar',
        LOADING: 'Espera, si us plau...',
        ERROR: "S'ha produït un error en el registre. Si us plau, torna-ho a intentar.",
        VALIDATION: {
          FULLNAME_REQUIRED: 'Escriu el teu nom i cognoms.',
          EMAIL_REQUIRED: 'El correu electrònic és obligatori',
          EMAIL_INVALID: 'Escriu un correu vàlid.',
          DNI_REQUIRED: 'El DNI és obligatori',
          DNI_INVALID: 'Format de DNI no vàlid (8 dígits + lletra)',
          BIRTH_DATE_REQUIRED: 'La data de naixement és obligatòria',
          PHONE_REQUIRED: 'El telèfon és obligatori',
          PHONE_INVALID: 'Introdueix un número de telèfon espanyol vàlid',
          PASSWORD_REQUIRED: 'La contrasenya és obligatòria',
          PASSWORD_MIN: 'La contrasenya ha de tenir almenys 8 caràcters',
          PASSWORD_UPPERCASE: 'La contrasenya ha de contenir almenys una majúscula',
          PASSWORD_SPECIAL: 'La contrasenya ha de contenir almenys un caràcter especial',
          PASSWORD_CONFIRM_REQUIRED: 'Confirma la teva contrasenya',
          PASSWORD_MATCH: 'Les contrasenyes no coincideixen',
        },
        PASSWORD_PLACEHOLDER: '••••••••',
        PASSWORD_CONFIRM_PLACEHOLDER: 'Repeteix la contrasenya',
        PERSONAL_EMAIL: 'Sembla un correu personal; millor fes servir el de la teva empresa',
      },
      COMPANY: {
        EYEBROW: 'Pas 2 de 2',
        STEP: 'Pas 2 de 2 · {{email}}',
        BACK: 'Enrere',
        TITLE: 'Sobre la teva empresa',
        GOOGLE: 'Google',
        PHONE: 'Telèfon',
        PHONE_PREFIX: 'Prefix del país',
        PHONE_PLACEHOLDER: '600 000 000',
        NAME: 'Empresa',
        NAME_PLACEHOLDER: 'Logística Norte',
        TAX_ID: 'CIF',
        TAX_ID_PLACEHOLDER: 'B12345674',
        EMPLOYEES: 'Nre. d\'empleats',
        EMPLOYEES_PLACEHOLDER: 'Nombre aproximat',
        SUBMIT: 'Crear el meu espai',
        SUBMIT_LARGE: 'Continuar',
        LEGAL_PREFIX: 'En continuar acceptes els',
        LEGAL_TERMS: 'Termes',
        LEGAL_SEP: ', la',
        LEGAL_PRIVACY: 'Privacitat',
        LEGAL_AND: 'i el',
        LEGAL_DPA: 'DPA',
        LEGAL_TERMS_TITLE: 'Termes i condicions',
        LEGAL_DPA_TITLE: 'Contracte d\'encàrrec de tractament (DPA)',
        LEGAL_CLOSE: 'Tancar',
        LEGAL_MISSING: 'No s\'han pogut carregar els termes i el DPA vigents. Recarrega la pàgina per continuar.',
        ERROR: 'No s\'ha pogut crear el teu espai. Torna-ho a provar.',
        VALIDATION: {
          PHONE_REQUIRED: 'Escriu el teu telèfon.',
          PHONE_INVALID: 'Escriu un telèfon vàlid.',
          NAME_REQUIRED: 'Escriu el nom de la teva empresa.',
          TAX_ID_REQUIRED: 'Escriu el CIF de la teva empresa.',
          TAX_ID_INVALID: 'CIF no vàlid',
          EMPLOYEES_REQUIRED: 'Tria la mida de la teva empresa.',
          EMPLOYEES_INVALID: 'Escriu un nombre enter més gran que 0.',
        },
      },
      LARGE_ACCOUNT: {
        EYEBROW: 'Grans comptes',
        TITLE: 'El teu compte el gestiona l\'equip de {{partner}}',
        SUBTITLE: 'Les empreses de la teva mida tenen un equip dedicat que prepara l\'espai amb tu. Ja els hem passat les teves dades.',
        SENT_TITLE: 'Dades enviades a {{partner}}',
        SENT_BADGE: '✓ Enviat',
        COMPANY: 'Empresa',
        TAX_ID: 'CIF',
        EMPLOYEES: 'Empleats',
        CONTACT: 'Contacte',
        EMAIL: 'Correu',
        PHONE: 'Telèfon',
        CONTACT_PARTNER: 'Contactar amb {{partner}} ↗',
        WAIT: 'Prefereixo que em contactin',
        DEMO_MEANWHILE: 'Mentrestant, explora el dashboard d\'exemple →',
        DONE_TITLE: 'Sol·licitud enviada',
        DONE_TEXT: '{{partner}} t\'escriurà a {{email}} en 24–48 h per preparar l\'espai de {{company}}.',
        NEXT_TITLE: 'Què passa ara',
        NEXT_1: '{{partner}} revisa la teva sol·licitud i et contacta.',
        NEXT_2: 'Acordeu pla i tarifa.',
        NEXT_3: '{{partner}} crea el teu espai i rebràs un correu per entrar.',
        DEMO: 'Explorar el dashboard d\'exemple →',
        TITLE_NO_PARTNER: 'El teu compte el gestiona un equip dedicat',
        SENT_TITLE_NO_PARTNER: 'Dades enviades',
        DONE_TEXT_NO_PARTNER: 'L\'equip de WAIIS t\'escriurà a {{email}} en 24–48 h per preparar l\'espai de {{company}}.',
        NEXT_1_NO_PARTNER: 'L\'equip de WAIIS revisa la teva sol·licitud i et contacta.',
        NEXT_3_NO_PARTNER: 'L\'equip de WAIIS crea el teu espai i rebràs un correu per entrar.',
        BRAND_TITLE: 'Grans comptes,',
        BRAND_TITLE_END: 'amb {{partner}}.',
        BRAND_TITLE_END_NO_PARTNER: 'amb un equip dedicat.',
        BRAND_SUB: 'Això és el que passa ara:',
        STEP_1: 'Rebem les teves dades',
        STEP_1_SUB: 'Ara',
        STEP_2: '{{partner}} et contacta',
        STEP_2_NO_PARTNER: 'Et contactem',
        STEP_2_SUB: 'El seu equip de grans comptes',
        STEP_2_SUB_NO_PARTNER: 'El nostre equip de grans comptes',
        STEP_3: 'Prepareu el vostre espai junts',
        STEP_3_SUB: '{{partner}} el crea per tu',
        STEP_3_SUB_NO_PARTNER: 'El creem per tu',
        STEP_4: 'Llanceu WAIIS',
        STEP_4_SUB: 'A tota la teva plantilla',
        FOOT_NOTE: 'WAIIS × {{partner}} · Mobilitat per a grans plantilles',
        EYEBROW_THRESHOLD: 'Grans comptes · Més de {{threshold}} empleats',
        BACK: 'Enrere',
      },
      SPACE_READY: {
        BRAND_TITLE: 'El teu espai',
        BRAND_TITLE_END: 'ja està llest.',
        BRAND_SUB: '{{partner}} ha creat el teu espai. Ja pots entrar.',
        LOGIN_TITLE: 'Entra al teu espai',
        LOGIN_SUBTITLE: 'Amb el compte que vas crear en registrar-te.',
        GOOGLE: 'Continuar amb Google',
        OR_EMAIL: 'o amb el teu correu',
        EMAIL: 'Correu d\'empresa',
        SUBMIT: 'Envia el codi',
        ERROR: 'No s\'ha pogut entrar. Torna-ho a provar.',
        STEP_1: 'Sol·licitud enviada',
        STEP_1_SUB: 'Des del registre',
        STEP_2: '{{partner}} ha creat el teu espai',
        STEP_2_NO_PARTNER: 'Hem creat el teu espai',
        STEP_2_SUB: 'Pla i tarifa acordats',
        STEP_3: 'Entres al teu espai',
        STEP_3_SUB: 'Ara',
        STEP_4: 'Convides la teva plantilla',
        STEP_4_SUB: 'Per correu o amb un CSV',
      },
      INPUT: {
        EMAIL: 'Correu electrònic',
        FULLNAME: 'Nom complet',
        PASSWORD: 'Contrasenya',
        CONFIRM_PASSWORD: 'Confirmar contrasenya',
        USERNAME: 'Usuari',
      },
      VALIDATION: {
        INVALID: '{{name}} no és vàlid',
        REQUIRED: '{{name}} és obligatori',
        MIN_LENGTH: 'La longitud mínima de {{name}} és {{min}}',
        AGREEMENT_REQUIRED: "Cal acceptar els termes i condicions",
        NOT_FOUND: "No s'ha trobat {{name}}",
        INVALID_LOGIN: 'Les dades d\'accés són incorrectes',
        REQUIRED_FIELD: 'Camp obligatori',
        MIN_LENGTH_FIELD: 'Longitud mínima del camp:',
        MAX_LENGTH_FIELD: 'Longitud màxima del camp:',
        INVALID_FIELD: 'El camp no és vàlid',
      },
    },
    COMMON: {
      SUCCESS: 'Fet',
      OK: 'D\'acord',
      ACCEPT: 'Acceptar',
      CANCEL: 'Cancel·lar',
      SUBMIT: 'Enviar',
      PLEASE_WAIT: 'Si us plau, espera...',
      TYPE_TO_SEARCH: 'Escriu almenys 2 caràcters',
      NO_RESULTS: 'No s\'han trobat resultats',
      SELECT: 'Seleccionar',
      REQUIRED_FIELD: 'Aquest camp és obligatori',
      CONFIRM_DELETE_TITLE: 'Confirmar eliminació',
      FILTERS: 'Filtres',
      CLOSE: 'Tancar',
      LOADING: 'Carregant...',
      ACTIVE: 'Actiu',
      SELECT_DATE_PLACEHOLDER: 'Selecciona una data',
      APPLY_FILTERS: 'Aplicar filtres',
      CLEAR_FILTERS: 'Netejar filtres',
      REFRESH: 'Actualitzar',
      EXPORT_CSV: 'Exportar CSV',
      IMPORT_CSV: 'Importar CSV',
      NO_DATA_TITLE: 'Sense dades',
      ERROR: 'Error',
      EXPORT_CSV_ERROR_PREFIX: "Error en exportar el CSV: ",
      EMPTY_FILE_TITLE: 'Fitxer buit',
      IMPORT_EMPTY_TEXT: "L'arxiu no conté cap registre vàlid per importar.",
      IMPORT_SUCCESS_TITLE: 'Importació completada',
      IMPORT_ERROR_TITLE: 'Error en la importació',
      UNKNOWN_ERROR: 'S\'ha produït un error desconegut',
      PROCESS_ERROR_TITLE: 'Error en processar l\'arxiu',
      CSV_ERRORS: {
        EXPORT_FAILED: 'No s’ha pogut exportar el CSV:',
        NO_FILE: 'No s’ha seleccionat cap fitxer',
        INVALID_FILE: 'Selecciona un fitxer CSV vàlid',
        EMPTY_FILE: 'El fitxer CSV és buit',
        READ_FAILED: 'Error en llegir el fitxer CSV:',
        MAP_FAILED: 'Error en processar les files del CSV:',
        UNKNOWN: 'Error desconegut',
      },
      BREADCRUMB_ARIA: 'Ruta de navegació',
    },
    HTTP_ERRORS: {
      FORBIDDEN: {
        TITLE: 'Accés denegat',
        MESSAGE: 'No tens accés a aquest recurs.',
        CONFIRM: 'Entès',
      },
      FEATURE_LOCKED: {
        TITLE: 'Funció no inclosa al pla',
        MESSAGE: "El pla d'aquesta empresa no inclou aquesta funció.",
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    // Cabecera común de las páginas del menú (app-bo-page-header): qué se hace
    // en cada página, en una frase.
    PAGE_HEADER: {
      PARTNER_REQUESTS: 'Sol·licituds de grans comptes de tots els partners: reassigna-les a un altre partner o crea’n l’empresa.',
      PARTNERS: 'Distribuïdors que porten les seves pròpies empreses. Per a cadascun es decideix què gestiona el partner i què veu l’empresa.',
      CORP_LAUNCH_GUIDE: 'Els tres passos per posar en marxa WAIIS a la teva empresa. Cadascun es marca sol quan el fas.',
      CORP_PLAN: 'La teva prova, el que falta per continuar amb WAIIS i el preu del Pla Incentius.',
      CORP_PLAN_PARTNER: 'La teva prova gratuïta i el teu pla anual.',
      CORP_WALLET:
        'La bossa del mes, els seus moviments i com es recarrega; el saldo, les recàrregues a mà i les retirades.',
      CORP_TAXI_RIDES:
        'Només els viatges que paga l\'empresa: quant es gasta, qui els fa i el detall de cadascun. Els viatges personals no hi apareixen mai.',
      CORP_TAXI_POLICY:
        'Pagament d\'empresa en taxi i VTC per grups: regles de cada grup, pressupost mensual i com es cobra.',
      CORP_TAXI_BOOKINGS:
        'Reserves de diversos vehicles per a un esdeveniment, una visita o un grup. Es reserven soles com a viatges d’Uber, Cabify o Bolt i l’empresa paga.',
      CORP_TAXI_REVIEW: 'WAIIS compara cada viatge que paga l’empresa amb el patró habitual de l’empleat i només et mostra els que necessiten la teva atenció.',
      RIDE_BOOKING_DESK: 'Reserves de grup de les empreses: les veus i les cancel·les; els vehicles es reserven sols.',
      RIDE_BOOKING_DESK_DETAIL: 'Una reserva de grup: l’empresa, el trajecte, l’import, els vehicles i el seu historial, amb les accions del seu estat.',
      RIDES_CONFIG_BOOKINGS: 'Regles de les reserves de grup de les empreses: antelació, cancel·lació, places per vehicle i avisos a WAIIS.',
      RIDES_CONFIG_REVIEW: 'Punts, nivells, cost, distàncies i llocs amb què es revisen els viatges que paguen les empreses.',
      RIDES: 'Viatges VTC demanats a Uber, Bolt i Cabify: estat, imports i incidències de cobrament.',
      RIDE_DETAIL: 'Un ride VTC: qui el va demanar, trajecte, imports, cobrament i les dades que envia el proveïdor.',
      ADMIN_HOME:
        'Mapa amb les rutines recorregudes en les últimes 24 hores i quantes n\'hi ha.',
      TRAVEL_LIST:
        'Viatges compartits de la plataforma i la seva verificació. Filtra per dates, estat, distància o empresa.',
      WAIIS_USERS:
        'Totes les persones registrades a l\'app. Cerca per nom, email, telèfon o ID i fes clic en una fila per veure\'n la fitxa, els viatges i els moviments de la wallet.',
      FRAUD:
        'Scores i senyals de frau que envia l\'equip de dades, i què es decideix amb cada compte.',
      PAYOUT_REVIEWS:
        'Retirades de diners pendents de revisar: risc, senyals i la decisió de pagar-les o no.',
      SUPPORT_CHAT:
        'Converses amb els usuaris en temps real. Obre\'n diverses alhora en pestanyes i respon des d\'aquí.',
      AGENT_CONVERSATIONS:
        'Historial de converses dels agents per app, WhatsApp i trucada, amb el resultat.',
      RECLAMATIONS:
        'Reclamacions dels usuaris per categoria i estat. Obre\'n una per revisar-la i marcar-la com a processada.',
      RECLAMATION_TAXONOMY:
        'Categories i subcategories amb què es classifiquen les reclamacions. Crea o edita les que necessitis.',
      CORPORATIONS:
        'Empreses clients amb les seves seus, empleats, viatges i pla. Obre\'n una per veure\'n la fitxa o entra al seu dashboard.',
      EMAILS: 'Els correus que envia WAIIS i la seva capçalera i peu, amb el seu estat en cada idioma. Tria’n un per editar-lo.',
      PUSH_NOTIFICATIONS: 'Envia una notificació push escrita a mà a un o diversos usuaris de l’app.',
      EMAIL_EDITOR: 'Edita l’assumpte i el contingut d’un correu en un idioma, mira com queda i publica’l.',
      EMAIL_LAYOUT_EDITOR: 'Edita la capçalera o el peu de tots els correus en un idioma, mira com queda i publica’l.',
      MARKETING_USERS:
        'Usuaris registrats: verificació, CAE i activitat de pooling. Filtra\'ls i tria quines columnes veure.',
      REFERRALS:
        'Qui ha creat enllaços d\'invitació, com avança el seu embut i quant paga cada enllaç.',
      PVP_PROMOS:
        'Usuaris amb la bonificació preu complet activada: el seu progrés de viatges i si ja se\'ls ha ingressat. Cerca i filtra per estat.',
      PROMOS:
        'Promocions del backoffice: la bonificació preu complet (amb conseqüència de frau) i la promo per viatges. Cada pestanya amb el seu progrés i si ja s\'ha ingressat.',
      ZONE_AD_IMBALANCE:
        'Cel·les H3 amb desequilibri entre conductors i passatgers. Filtra, mira el mapa i crea un esborrany d’anunci per a una cel·la.',
      ZONE_AD_DRAFTS:
        'Esborranys d’anuncis a Meta per zona. Filtra per estat o destinatari i obre’ls per revisar-los.',
      ZONE_AD_DRAFT:
        'Revisa un esborrany: edita’l mentre és esborrany, aprova’l, rebutja’l o publica’l a Meta.',
      ZONE_AD_TEMPLATES:
        'Imatge i textos dels anuncis per zona. Crea, edita, activa o elimina plantilles.',
      ZONE_AD_SETTINGS:
        'Com es generen els esborranys d\'anuncis a Meta per a les zones amb rutines sense match: quan, amb quins valors i amb quines dades de publicació.',
      ROLES:
        'Rols d\'accés al backoffice. Crea o edita rols i revisa\'n les accions, els permisos i les pàgines.',
      ROLE_ACTIONS:
        'Accions que pot fer aquest rol. Afegeix, edita o treu accions.',
      ROLE_PERMISSIONS:
        'Operacions de l\'API que aquest rol té permeses. Afegeix, canvia o treu permisos.',
      ROLE_PAGES:
        'Pantalles del backoffice que pot veure aquest rol. Afegeix, canvia o treu pàgines.',
      USER_ROLE_CORPORATIONS:
        'Quin rol té cada usuari i a quina empresa o seu. Afegeix o treu assignacions.',
      CORPORATION_USERS:
        'Tots els usuaris de les empreses en una sola llista. Cerca\'ls per nom o email, o crea\'n un de nou.',
      POOLING_RUNNERS:
        'Corredors de pooling amb el seu nom, descripció i color. Obre\'n un per veure i editar les seves parades.',
      CREDIT_PROVIDERS:
        'Empreses que ofereixen targetes regal, el seu contacte i quantes targetes tenen disponibles.',
      GIFT_CARDS:
        'Targetes regal per proveïdor: el seu valor en crèdits i en euros, la data de caducitat i si estan actives.',
      CODES:
        'Codis de cada targeta regal, a quin usuari s\'han assignat i quan caduquen. Pots importar-los des d\'un CSV.',
      PROMOTIONAL_CODES:
        'Codis de descompte per als viatges: tipus i valor, viatges gratuïts, dates de validesa i estat.',
      PARKING_SPACES:
        'Places d\'aparcament de l\'empresa: tipus, ubicació, seu i disponibilitat per torn.',
      PARKING_RESERVATIONS:
        'Reserves de places d\'aparcament: qui reserva, quins dies i torn, a quina seu i si la comparteix.',
      PARKING_CREDITS:
        'Crèdits d\'aparcament de cada usuari: dies i torn reservats, saldo disponible i data de caducitat.',
      FOOTPRINT_USERS:
        'Usuaris amb la seva darrera petjada i darrer segment registrats. Filtra per data i obre la revisió dels seus viatges.',
      FOOTPRINT_RAW:
        'Petjada en brut d\'un usuari sobre el mapa. Tria l\'usuari i un interval de dates per carregar-ne els punts.',
      TRAVEL_REVIEW:
        'Viatges d\'un usuari dia a dia, en calendari i mapa. Revisa\'ls i classifica\'ls un a un.',
      CORRIDORS_REVIEW:
        'Corredors de les rutes compartides sobre el mapa. Afegeix rutines o polilínies per veure on coincideixen.',
      TAGS:
        'Etiquetes per classificar els viatges en revisar-los, amb la categoria i el color. Crea-les, edita-les i activa-les.',
      VALORATION_LABELS:
        'Parelles d\'etiquetes positiva i negativa amb què conductors i passatgers valoren els seus viatges.',
      LABELS:
        'Etiquetes per marcar usuaris i rutes de pooling, com ara «VIP». Decideix a quines fitxes es poden assignar.',
      MATCH_REVIEW:
        'Compara al mapa les rutines de conductors i passatgers per veure si els seus trajectes encaixen.',
      MATCHES_LISTING:
        'Matchs generats entre conductors i passatgers. Filtra per estat, conductor o dates.',
      MATCH_CONFIG_VARIABLES:
        'Variables que ajusten com s\'aparellen conductors i passatgers. Edita cada valor a la taula.',
      POIS:
        'Punts de recollida i baixada per categoria. Revisa\'ls al mapa o puja un nou llistat.',
      CREDIT_TYPES:
        'Tipus de crèdit disponibles, amb la seva descripció i valor. Pots editar-los o crear-ne de nous.',
      COMMISSIONS:
        'Comissions que aplica Waiis, amb la seva descripció i import. Pots editar-les o crear-ne de noves.',
      FRAUD_RULES:
        'Llindars que marquen un viatge com a sospitós i avís que veu el conductor en verificació reforçada.',
      CONFIG_VARIABLES:
        'Variables que ajusten el comportament de la plataforma. Crea-les, edita-les, importa-les o exporta-les en CSV i activa els logs.',
      APP_ANNOUNCEMENT:
        "Comunicat que veu la gent en obrir l'app fins que prem el botó. Activa'l, escriu els textos en cada idioma i publica'l.",
      TERMS_CONDITIONS:
        'Text dels termes i condicions que accepta la gent al tauler i a l\'app. Edita i publica una versió nova.',
      CONTRACT_TEMPLATES:
        'Plantilla del contracte que es genera per a les empreses. Edita-la i desa-la com a versió nova.',
      DATA_PROCESSING_AGREEMENT:
        'Contracte d\'encàrrec de tractament de dades (DPA) que accepten les empreses en donar-se d\'alta. En desar es publica.',
      PMST_GOAL:
        'Percentatge mínim legal i objectiu propi de plantilla registrada per al PMST, per empresa o seu.',
      PMST_QUESTIONNAIRE:
        'Passos i preguntes del formulari PMST que omplen les empreses. Reordena\'ls, edita\'ls i revisa\'n la vista prèvia.',
      PMST_QUESTIONNAIRE_RESPONSES:
        'Respostes al qüestionari PMST que ha enviat cada empresa. Filtra per empresa i, si vols, per seu.',
      FACE_VERIFICATION:
        'Quan es demana la verificació facial als usuaris i amb quins llindars de Rekognition es dona per superada.',
      RIDES_SETTINGS:
        'Ajustos generals dels viatges: activar VTC, comissió, penalització per cancel·lació i ajustos per tarifa real o rebut.',
      RIDES_GUEST_PHONES:
        'Telèfons donats d\'alta com a convidats per als viatges. Afegeix-los, edita\'ls o desactiva\'ls.',
      RIDES_PROVIDER_ROUTING:
        'Quin proveïdor veu a estimates un usuari segons la seva etiqueta. Les etiquetes les assigna l\'equip de dades.',
      RIDES_PROVIDERS:
        'Productes de viatge que veu el rider i la seva equivalència amb els productes de cada proveïdor, per ordre d\'aparició.',
      SUPPORT_SNIPPETS:
        'Textos que l\'equip de suport insereix des del xat. Arrossega les files per canviar l\'ordre en què apareixen.',
    },
    WAIIS: {
      // Marketing › Correos: listado de plantillas, cabecera y pie.
      EMAILS: {
        LAYOUTS_TITLE: 'Capçalera i peu',
        LAYOUTS_SUB: 'Les peces comunes a tots els correus.',
        HEADER: 'Capçalera',
        FOOTER: 'Peu',
        TEMPLATES_TITLE: 'Plantilles',
        TEMPLATES_SUB: 'Cada correu amb l’estat dels seus idiomes. Prem un idioma per obrir-ne l’editor.',
        COL_PIECE: 'Peça',
        COL_EMAIL: 'Correu',
        COL_LOCALES: 'Idiomes',
        SEARCH: 'Cerca per nom o codi…',
        SEARCH_ARIA: 'Cerca correus',
        STATE_PUBLISHED: 'Publicat',
        STATE_DRAFT: 'Esborrany',
        STATE_EMPTY: 'Sense contingut',
        STATE_ARCHIVED: 'Arxivat',
        PUBLISHED_VERSION: 'Versió publicada: v{{version}}',
        OPEN_LOCALE: 'Obre {{name}} en {{locale}}',
        NO_MATCH: 'Cap correu coincideix amb la cerca',
        EMPTY: 'No hi ha correus editables.',
        LOAD_ERROR_TEMPLATES: 'No s’han pogut carregar els correus.',
        LOAD_ERROR_LAYOUTS: 'No s’han pogut carregar la capçalera i el peu.',
        RETRY: 'Torna-ho a provar',
        HEALTH_COUNT: 'Problemes: {{count}}',
        HEALTH_LOCALES: 'Problemes a la versió publicada de: {{locales}}',
        EDITOR: {
          TITLE: 'Editor de correu',
          ALIAS: 'Àlies',
          ALIAS_ADD: 'Posar àlies',
          ALIAS_EDIT: 'Canviar l’àlies',
          ALIAS_SAVE: 'Desar l’àlies',
          ALIAS_CANCEL: 'Cancel·la',
          ALIAS_HINT: 'El nom que es veu a Correus. Deixa’l buit per fer servir el nom intern.',
          ALIAS_SAVED: 'Àlies desat',
          ALIAS_ERROR: 'No s’ha pogut desar l’àlies',
          HEALTH_TITLE: 'La versió publicada v{{version}} té problemes',
          HEALTH_SUB: 'Corregeix el que s’indica a sota, desa i publica. Aquest avís no impedeix desar ni publicar.',
          LOCALE: 'Idioma',
          UNSAVED: 'Canvis sense desar',
          CONTENT_TITLE: 'Contingut',
          CONTENT_SUB: 'L’assumpte, el preheader i el cos del correu en aquest idioma.',
          SUBJECT: 'Assumpte',
          PREHEADER: 'Preheader',
          PREHEADER_HINT: 'El text que la safata d’entrada mostra al costat de l’assumpte. Opcional.',
          BODY_HTML: 'Contingut (HTML)',
          BODY_BLOCKS: 'Contingut (blocs en JSON)',
          JSON_INVALID: 'JSON no vàlid',
          SAVE: 'Desa l’esborrany',
          SAVING: 'Desant…',
          SAVED: 'Esborrany desat',
          SAVE_ERROR: 'No s’ha pogut desar l’esborrany',
          DISCARD: 'Descarta l’esborrany',
          DISCARD_TITLE: 'Descartar l’esborrany',
          DISCARD_TEXT: 'S’esborra l’esborrany i l’editor torna a la versió publicada.',
          DISCARD_CONFIRM: 'Descarta',
          DISCARD_SAVING: 'Descartant…',
          DISCARD_DONE: 'Descartat',
          DISCARD_ERROR: 'No s’ha pogut descartar l’esborrany',
          PUBLISH: 'Publica',
          PUBLISH_TITLE: 'Publicar l’esborrany',
          PUBLISH_TEXT: 'Els correus que s’enviïn a partir d’ara en aquest idioma faran servir aquesta versió.',
          PUBLISH_CONFIRM: 'Publica',
          PUBLISH_SAVING: 'Publicant…',
          PUBLISH_DONE: 'Publicat',
          PUBLISH_ERROR: 'No s’ha pogut publicar',
          PUBLISH_NEEDS_SAVE: 'Desa l’esborrany abans de publicar',
          TEST_SEND: 'Envia una prova',
          TEST_SENDING: 'Enviant…',
          TEST_SENT: 'Enviat a {{email}}',
          TEST_ERROR: 'No s’ha pogut enviar la prova',
          TEST_NEEDS_SAVE: 'Desa l’esborrany per enviar-te una prova',
          PREVIEW: 'Previsualització',
          PREVIEW_TITLE: 'Previsualització',
          PREVIEW_SUB: 'Com es veu el que hi ha a l’editor.',
          PREVIEW_VERSION: 'La versió {{version}}, tal com es va desar.',
          PREVIEW_EMPTY: 'Prem «Previsualització» per veure el correu.',
          PREVIEW_ERROR: 'No s’ha pogut generar la previsualització.',
          DEVICE: 'Dispositiu',
          DESKTOP: 'Escriptori',
          MOBILE: 'Mòbil',
          SCHEME: 'Tema',
          LIGHT: 'Clar',
          DARK: 'Fosc',
          VERSIONS_TITLE: 'Versions',
          VERSIONS_SUB: 'Tria’n una per veure com era; hi pots tornar.',
          VERSIONS_ERROR: 'No s’han pogut carregar les versions.',
          VERSIONS_EMPTY: 'Encara no hi ha versions desades.',
          EDITING: 'El que estàs editant',
          ACTIVE: 'Activa',
          ROLLBACK: 'Torna a aquesta versió',
          ROLLBACK_TITLE: 'Tornar a la versió {{version}}',
          ROLLBACK_TEXT: 'Es crea un esborrany nou amb el contingut d’aquella versió. El que no hagis desat es perd.',
          ROLLBACK_CONFIRM: 'Torna-hi',
          ROLLBACK_SAVING: 'Tornant-hi…',
          ROLLBACK_DONE: 'Esborrany creat',
          ROLLBACK_ERROR: 'No s’ha pogut tornar a aquesta versió',
          VARIABLES_TITLE: 'Variables',
          VARIABLES_SUB: 'El que pots fer servir a l’assumpte, el preheader i el contingut.',
          VARIABLES_EMPTY: 'Aquest correu no té variables.',
          MUST_APPEAR: 'Ha d’aparèixer',
          UNSAVED_TITLE: 'Tens canvis sense desar',
          UNSAVED_TEXT: 'Si continues, es perden.',
          UNSAVED_LEAVE: 'Continua sense desar',
          CANCEL: 'Cancel·la',
          ACCEPT: 'D’acord',
          LOAD_ERROR: 'No s’ha pogut carregar el correu.',
          BACK: 'Torna al llistat',
        },
        // Editor de la cabecera y el pie.
        LAYOUT_EDITOR: {
          TITLE: '{{piece}} · {{locale}}',
          NOT_FOUND_TITLE: 'Peça no trobada',
          NOT_FOUND: 'Aquesta peça o aquest idioma no existeixen.',
          LOAD_ERROR: 'No s’ha pogut carregar la peça.',
          CONTENT_SUB: 'El que porten tots els correus en aquest idioma.',
          ALLOWED_BLOCKS: 'Blocs que admet: {{types}}.',
        },
      },
      AGENT_CONVERSATIONS: {
        CHANNELS: {
          IN_APP: 'In-app',
          WHATSAPP: 'WhatsApp',
          CALL: 'Trucades',
        },
        CHANNEL_SUBTITLES: {
          IN_APP: "Xats dels usuaris amb els agents d'IA dins de l'app. Tria'n un per veure el fil complet.",
          WHATSAPP: "Converses dels agents d'IA per WhatsApp. Tria'n una per veure el fil complet.",
          CALL: "Trucades ateses pels agents d'IA, amb la transcripció. Tria'n una per veure-la completa.",
        },
        OUTCOMES: {
          RESOLVED: 'Resolta',
          ESCALATED: 'Escalada',
          UNRESOLVED: 'Sense resoldre',
          UNKNOWN: 'Sense classificar',
        },
        NOTES: {
          RESOLVED_HUMAN: 'Conversa resolta amb intervenció humana',
          RESOLVED_AUTO: 'Conversa resolta automàticament',
          ESCALATED: "Conversa escalada a l'equip de suport",
          UNRESOLVED: 'Conversa sense resoldre',
          UNKNOWN: 'Resultat sense classificar',
        },
        USER_FALLBACK: 'Usuari',
        FIRST_NAME_FALLBACK: "l'usuari",
        TODAY: 'Avui',
        YESTERDAY: 'Ahir',
        CHANNEL_ARIA: 'Canal',
        SEARCH_PLACEHOLDER: 'Cerca conversa, usuari o agent...',
        SEARCH_ARIA: 'Cercar converses',
        PERIOD_ARIA: 'Període',
        AGENT_ARIA: 'Agent',
        OUTCOME_ARIA: 'Resultat',
        CLEAR_FILTERS: 'Netejar filtres',
        LIST_ARIA: 'Converses',
        LOADING: 'Carregant converses',
        RETRY: 'Tornar-ho a provar',
        EMPTY: 'No hi ha converses de {{channel}} que coincideixin amb els filtres.',
        LOADING_MORE: 'Carregant més converses...',
        LOAD_MORE: 'Carregar-ne més',
        THREAD_ARIA: 'Conversa',
        PERIOD: {
          D7: 'Període: 7 dies',
          D30: 'Període: 30 dies',
          D90: 'Període: 90 dies',
          ALL: 'Període: tot',
        },
        OUTCOME_ALL: 'Resultat: tots',
        OUTCOME_OPTION: 'Resultat: {{label}}',
        AGENT_ALL: 'Agent: tots',
        AGENT_OPTION: 'Agent: {{name}}',
        LOAD_ERROR: "No s'ha pogut carregar l'historial de converses.",
        DETAIL_ERROR: "No s'ha pogut carregar la conversa.",
        PANEL_CALLS: 'Trucades amb agents',
        PANEL_CHANNEL: 'Converses de {{channel}}',
        COUNT_ONE: '1 conversa',
        COUNT_OTHER: '{{count}} converses',
        SHOWING: 'Mostrant {{shown}} de {{total}} converses',
        THREAD: {
          SELECT_TITLE: 'Selecciona una conversa',
          SELECT_TEXT: "Tria una conversa del llistat per veure com la va atendre l'agent.",
          REF_COPIED: 'Referència copiada',
          COPY_REF: 'Copiar referència',
          OPENS_NEW_TAB: "S'obre en una altra pestanya",
          VIEW_PROFILE_OF: 'Veure la fitxa de {{name}}',
          CHANNEL: 'Canal',
          MESSAGES: 'Missatges',
          DURATION: 'Durada',
          INTERVENTION: 'Intervenció',
          RECORDING_UNAVAILABLE: 'Gravació de la trucada no disponible al backoffice.',
          NO_TRANSCRIPT: "Encara no hi ha transcripció d'aquesta trucada.",
          NO_MESSAGES: 'Aquesta conversa no té missatges.',
          OUTCOME_PENDING_TEXT: 'El sistema encara no ha indicat si aquesta conversa es va resoldre, es va escalar o va quedar sense resoldre.',
          CALL_SUMMARY: 'Resum de la trucada',
          DETECTED_REASON: 'Motiu detectat',
          MESSAGES_ONE: '1 missatge',
          MESSAGES_OTHER: '{{count}} missatges',
          WITH_HUMAN: 'Amb intervenció humana',
          WITHOUT_HUMAN: 'Sense intervenció humana',
          TRANSCRIPT: 'Transcripció',
        },
      },
      COMPLAINTS: {
        SEARCH_CODE: 'Cercar codi',
        FILTERS: 'Filtres',
        CLOSE: 'Tancar',
        SELECT_DATE: 'Selecciona una data',
        APPLY_FILTERS: 'Aplicar filtres',
        CLEAR: 'Netejar',
        EXPORT_CSV: 'Exportar CSV',
        ADD: 'Afegir incidència',
        CREATE_TITLE: 'Crear incidència',
        EDIT_TITLE: 'Editar incidència',
        FIELDS: {
          CONTEXT: 'Context',
          TYPE: 'Tipus',
          REASON: 'Motiu',
          REPORTER: 'Informant',
          REPORTED: 'Persona reportada',
          ASSIGN_TO: 'Assignar a',
          DESCRIPTION: 'Descripció',
          DATE: 'Data',
          STATUS: 'Estat',
          ASSIGNED_TO: 'Assignat a',
          LAST_UPDATE: 'Darrera actualització',
          COMMENT: 'Comentari',
        },
        REQUIRED: {
          CONTEXT: 'El context és obligatori',
          TYPE: 'El tipus és obligatori',
          REASON: 'El motiu és obligatori',
          REPORTER: "L'informant és obligatori",
          REPORTED: 'La persona reportada és obligatòria',
          DESCRIPTION: 'La descripció és obligatòria',
          COMMENT: 'El comentari és obligatori',
        },
        CANCEL: 'Cancel·lar',
        ACCEPT: 'Acceptar',
        WAIT: 'Espera...',
        SUCCESS_TITLE: 'Correcte',
        ERROR_TITLE: 'Error',
        CREATED: "S'ha creat correctament la incidència",
        UPDATED: "S'ha modificat correctament la incidència",
        ASSIGNED: "S'ha assignat correctament la incidència",
        STATUS: {
          PENDING: 'Pendent',
          ASSIGNED: 'Assignada',
          IN_PROGRESS: 'En curs',
          RESOLVED: 'Resolta',
        },
        CONTEXT: {
          TRAVEL: 'Finalitzar viatge',
          UNMATCH: "Realització d'unmatch",
          TRAVEL_LINK: 'Enllaç al viatge',
          PROFILE_LINK: 'Enllaç al perfil',
        },
        TYPE: {
          UNMATCH: 'Unmatch',
          TRAVEL: 'Viatge',
        },
        REASON: {
          CLEANLINESS: 'Neteja',
          DELAY: 'Retard',
          SAFETY: 'Seguretat',
          BEHAVIOUR: 'Comportament',
        },
        DETAIL: {
          BACK: 'Tornar',
          PROBLEM_INFO: 'Informació del problema',
          ASSIGN: 'Assignar incidència',
          MANAGE: 'Gestionar incidència',
          TYPE: 'Tipus:',
          REASON: 'Motiu:',
          STATUS: 'Estat:',
          EXPLANATION: 'Explicació:',
          ASSIGNED_TO: 'Assignat a:',
          COMMENT: 'Comentari:',
          TRIP_INFO: 'Informació del viatge',
          TRIP_ID: 'Id del viatge:',
          DATE: 'Data:',
          ORIGIN: 'Origen:',
          DESTINATION: 'Destinació:',
          DRIVER: 'Conductor:',
          PASSENGER: 'Passatger:',
          REPORTED_INFO: "Informació de l'usuari reportat",
          REPORTER_INFO: "Informació de l'usuari informant",
          NAME: 'Nom:',
          SURNAME: 'Cognoms:',
          PHONE: 'Telèfon:',
          EMAIL: 'Correu electrònic:',
          ROLE: 'Rol:',
          USER_ID: 'Id usuari:',
        },
      },
      RIDES: {
        SEARCH_PLACEHOLDER: 'Cerca per nom, email o telèfon',
        FROM: 'Des de',
        TO: 'Fins a',
        ALL_PROVIDERS: 'Tots els proveïdors',
        ALL_STATES: 'Tots els estats',
        INCIDENT_FILTER: 'Només incidències de cobrament',
        COL_DATE: 'Data',
        COL_USER: 'Usuari',
        COL_PROVIDER: 'Proveïdor',
        COL_ROUTE: 'Trajecte',
        COL_AMOUNT: 'Import',
        COL_STATE: 'Estat',
        COL_ACTIONS: 'Accions',
        SCHEDULED_FOR: 'Programat: {{date}}',
        EMPTY: 'No hi ha rides amb aquests filtres',
        ERROR: 'No s\'han pogut carregar els rides',
        NOT_FOUND: 'El ride no existeix',
        RETRY: 'Tornar-ho a provar',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        PAGINATION: 'Mostrant {{shown}} de {{total}} rides',
        BACK: 'Tornar als rides',
        DETAIL_TITLE: 'Detall del ride',
        BACK_TO_LIST: 'Tornar al llistat',
        LOADING: 'Carregant el ride…',
        COPY_ID: 'Copiar ID',
        ID_COPIED: 'ID copiat',
        NO_FIELDS: 'Sense dades',
        RAW_TITLE: 'Dades completes',
        RAW_SUB: 'Tal com les envia el proveïdor (JSON).',
        RAW_SHOW: 'Veure dades completes',
        RAW_HIDE: 'Amagar',
        SECTION_SUB: {
          SUMMARY: 'Proveïdor, producte, dates i identificadors del viatge.',
          ROUTE: 'Origen, destinació, conductor, vehicle i valoració.',
          AMOUNTS: 'Tarifa del proveïdor, comissió, cupó i import final.',
          BILLING: 'Pagament de l\'usuari, liquidació i incidències de cobrament.',
          CANCELLATION: 'Dades de la cancel·lació que envia el proveïdor.',
          RECEIPT: 'Dades del rebut que envia el proveïdor.',
        },
        NO_PAYMENT: 'Sense pagament registrat',
        STATE: {
          SCHEDULED: 'Programat',
          REQUESTED: 'Sol·licitat',
          ACCEPTED: 'Acceptat',
          ARRIVING: 'En camí',
          ARRIVED: 'Conductor al punt',
          IN_PROGRESS: 'En curs',
          COMPLETED: 'Completat',
          NO_DRIVERS: 'Sense conductors',
          CANCELLED_BY_RIDER: 'Cancel·lat per l\'usuari',
          CANCELLED_BY_DRIVER: 'Cancel·lat pel conductor',
          FAILED: 'Fallit',
        },
        INCIDENT: {
          DEFERRED_CHARGE_DEBT: 'Deute: cobrament fallit',
          RECEIPT_MANUAL_REVIEW: 'Rebut en revisió manual',
        },
        SECTION: {
          SUMMARY: 'Resum',
          ROUTE: 'Trajecte i conductor',
          AMOUNTS: 'Imports',
          BILLING: 'Cobrament',
          CANCELLATION: 'Cancel·lació',
          RECEIPT: 'Rebut del proveïdor',
        },
        FIELD: {
          USER: 'Usuari',
          PRODUCT: 'Producte',
          CREATED_AT: 'Creat',
          SCHEDULED_AT: 'Programat per a',
          ACCEPTED_AT: 'Acceptat',
          UPDATED_AT: 'Última actualització',
          PROVIDER_TRIP_ID: 'ID del viatge al proveïdor',
          PROVIDER_PRODUCT_ID: 'ID del producte al proveïdor',
          PICKUP: 'Origen',
          DROPOFF: 'Destinació',
          DRIVER: 'Conductor',
          VEHICLE: 'Vehicle',
          RATING: 'Valoració',
          PROVIDER_FARE: 'Tarifa del proveïdor',
          COMMISSION: 'Comissió',
          FARE: 'Tarifa estimada',
          PROVIDER_FINAL: 'Import final del proveïdor',
          FINAL_COMMISSION: 'Comissió final',
          FINAL: 'Import final',
          COUPON: 'Cupó',
          PAYMENT: 'Pagament',
          REFUNDED: 'Reemborsat',
          SETTLEMENT_REFUNDED: 'Retornat a la liquidació',
          SETTLEMENT_APPLIED_AT: 'Liquidació aplicada',
          DEFERRED_CHARGE: 'Cobrament diferit fallit',
          ATTEMPTS: 'Intents',
          RECEIPT_FALLBACK: 'Rebut pendent des de',
          ALERTED_AT: 'Alerta de revisió manual',
          RIDE_ID: 'ID del ride',
        },
      },
      TRAVEL_LIST: {
        RANGE_7: 'Rang: 7 dies',
        RANGE_30: 'Rang: 30 dies',
        RANGE_90: 'Rang: 90 dies',
        RANGE_365: 'Rang: 1 any',
        RANGE_ALL: 'Rang: tot',
        KM_ANY: 'Km: qualsevol',
        KM_LT: 'Km: menys de {{km}}',
        KM_GT: 'Km: més de {{km}}',
        TYPE_RECURRING: 'Rutina',
        TYPE_PUNCTUAL: 'Puntual',
        TYPE_FLEET: 'Taxi/VTC',
        TAB_ALL: 'Tots',
        TAB_RECURRING: 'De rutina',
        TAB_PUNCTUAL: 'Puntuals',
        TAB_FLEET: 'Taxi/VTC',
        STATUS_PENDING: 'Pendent',
        STATUS_ONGOING: 'En curs',
        STATUS_IN_REVIEW: 'En revisió',
        APP_SHOWS_VERIFYING: "A l'app: «Verificando»",
        APP_VERIFYING_HINT: "Verificat, però el conductor encara no ha cobrat (retard de caixa). Fins que cobri, l'app mostra «Verificando» al conductor i als passatgers.",
        STATUS_REINFORCED_REVIEW: 'En revisió reforçada',
        STATUS_VERIFIED: 'Verificat',
        STATUS_UNREALIZED: 'No verificat',
        STATUS_CANCELLED: 'Cancel·lat',
        VERIF_SHARED: 'Compartit',
        VERIF_SHARED_H3: 'Compartit (H3)',
        VERIF_BLUETOOTH: 'Bluetooth',
        VERIF_TEMPORAL: 'Temporal',
        VERIF_NONE: 'Sense verificar',
        FILTER_TYPE_ALL: 'Tipus: tots',
        FILTER_STATUS_ALL: 'Estat: tots',
        FILTER_VERIFICATION_ALL: 'Verificació: totes',
        FILTER_COMPANY_ALL: 'Empresa: totes',
        FILTER_RUNNER_ALL: 'Corredor: tots',
        SEARCH_PLACEHOLDER: 'Cerca per ID, usuari, match...',
        SEARCH_ARIA: 'Cercar viatges',
        ARIA_DATE_RANGE: 'Rang de dates',
        ARIA_TRIP_TYPE: 'Tipus de viatge',
        ARIA_STATUS: 'Estat del viatge',
        ARIA_VERIFICATION: 'Mètode de verificació',
        ARIA_DISTANCE: 'Distància',
        ARIA_COMPANY: 'Empresa',
        ARIA_RUNNER: 'Corredor',
        ARIA_IDENTITY: 'Identitat',
        UNVERIFIED_IDENTITY_FILTER: 'Sense identitat verificada',
        LOADING_ARIA: 'Carregant viatges',
        COL_ID: 'ID',
        COL_DATE: 'Data',
        COL_ROUTE: 'Ruta',
        COL_KM: 'Km',
        COL_TYPE: 'Tipus',
        COL_DRIVER: 'Conductor',
        COL_PASSENGERS: 'Passatgers',
        COL_VERIFICATION: 'Verificació',
        COL_PRICE: 'Preu',
        COL_PRICE_RECEIVED: 'Preu rebut',
        COL_STATUS: 'Estat',
        COL_ACTIONS: 'Accions',
        LOAD_ERROR: 'No s\'ha pogut carregar el llistat de viatges.',
        EXPORT_ERROR: 'No s\'ha pogut exportar el llistat.',
        CSV_FILE_PREFIX: 'viatges',
        RETRY: 'Torna-ho a provar',
        EMPTY: 'No hi ha viatges que coincideixin amb els filtres.',
        UNVERIFIED_TOOLTIP: 'Algun participant va fer el viatge sense la identitat verificada',
        UNVERIFIED_BADGE: 'Sense identitat',
        CASH_DELAY_TITLE: 'Retard de caixa: el conductor no té aquest import al saldo fins al {{date}} a les {{time}}. L\'app no ho anuncia.',
        CASH_DELAY_LABEL: 'Abonament per caixa: {{date}} {{time}}',
        CASH_DELAY_DAYS_LABEL: 'Caixa · dia {{day}}/{{total}} · {{date}}',
        CASH_DELAY_DUE_LABEL: 'Caixa · dia {{day}}/{{total}} · s\'abona en uns minuts',
        REINFORCED_HOLD_TITLE: 'Verificació reforçada: el conductor rep aquest viatge al saldo el {{date}} a les {{time}}. Si surt de la reforçada abans, se li abona a la propera passada (cada 10 min).',
        REINFORCED_HOLD_LABEL: 'S\'abona el {{date}}',
        REINFORCED_HOLD_DAYS_LABEL: 'Dia {{day}}/{{total}} · s\'abona el {{date}}',
        REINFORCED_HOLD_DUE_LABEL: 'Dia {{day}}/{{total}} · s\'abona en uns minuts',
        PAGINATION: 'Mostrant {{shown}} de {{total}} viatges',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        PANEL_ALL_TITLE: 'Tots els viatges',
        PANEL_ALL_SUB: 'De rutina, puntuals i en taxi/VTC. Prem un viatge per veure qui anava al cotxe; amb la fletxa › n\'obres el detall.',
        PANEL_RECURRING_TITLE: 'Viatges de rutina',
        PANEL_RECURRING_SUB: 'Trajectes que formen part de la rutina dels usuaris. Prem-ne un per veure qui anava al cotxe; amb la fletxa › n\'obres el detall.',
        PANEL_PUNCTUAL_TITLE: 'Viatges puntuals',
        PANEL_PUNCTUAL_SUB: 'Trajectes d\'un sol dia, fora de la rutina. Prem-ne un per veure qui anava al cotxe; amb la fletxa › n\'obres el detall.',
        PANEL_FLEET_TITLE: 'Viatges en taxi/VTC',
        PANEL_FLEET_SUB: 'Viatges demanats en taxi o VTC des de l\'app. Prem-ne un per veure\'n el detall.',
        OPEN_TRIP: 'Obrir el viatge',
        DRAWER: {
          EYEBROW: 'Detall del viatge',
          LOADING: 'Carregant viatge…',
          NOT_FOUND: 'No s\'ha trobat el viatge sol·licitat.',
          TIMEOUT: 'El servidor no ha respost a temps. Torna-ho a provar.',
          LOAD_ERROR: 'No s\'ha pogut carregar el detall del viatge.',
          MARKER_PICKUP: 'Recollida · {{name}}',
          MARKER_DROPOFF: 'Baixada · {{name}}',
          LEGEND_REFERENCE: 'Empremta teòrica (ruta del conductor)',
          LEGEND_TRACE: 'Empremta real (conductor)',
          ORIGIN_DESTINATION: 'Origen / Destinació',
          DRIVER: 'Conductor',
          FOOTPRINT: 'Empremta',
          NO_DRIVER: 'Sense dades del conductor.',
          PASSENGERS: 'Passatgers',
          COL_PASSENGER: 'Passatger',
          COL_VERIFICATION: 'Verificació',
          COL_STATUS: 'Estat',
          COL_PICKUP_DISTANCE: 'Dist. recollida',
          COL_DESTINATION_DISTANCE: 'Dist. destinació',
          NO_PASSENGERS: 'Sense passatgers.',
          TRIP_DATA: 'Dades del trajecte',
          DATE_TIME: 'Data i hora',
          DISTANCE_LISTING: 'Distància (llistat)',
          DRIVER_DETOUR: 'Desviament del conductor',
          DURATION: 'Durada',
          PASSENGER_FOOTPRINTS: 'Empremtes de passatgers',
          N_VERIFIED: '{{count}} verificades',
          N_PENDING: '{{count}} pendents',
          N_REJECTED: '{{count}} rebutjades',
          WAYPOINTS: 'Waypoints',
          NO_WAYPOINTS: 'Sense waypoints registrats.',
          IDENTIFIER: 'Identificador',
          FOOTPRINT_PENDING: 'Pendent',
          FOOTPRINT_VERIFIED: 'Verificada',
          FOOTPRINT_REJECTED: 'Rebutjada',
          FOOTPRINT_IN_REVIEW: 'En revisió',
          APP_SHOWS_VERIFYING: "A l'app: «Verificando»",
          APP_VERIFYING_HINT: "Verificada, però el conductor encara no ha cobrat. Fins que cobri, l'app mostra «Verificando» al conductor i als passatgers.",
          FOOTPRINT_CANCELLED: 'Cancel·lada',
          STATUS: {
            PENDING: 'Pendent',
            IN_PROGRESS: 'En curs',
            ONGOING: 'En curs',
            ACCEPTED: 'Acceptat',
            CONFIRMED: 'Confirmat',
            COMPLETED: 'Completat',
            VERIFIED: 'Verificat',
            IN_REVIEW: 'En revisió',
            REJECTED: 'Rebutjat',
            CANCELLED: 'Cancel·lat',
          },
          ACTION: {
            PICKUP: 'Recollida',
            DROPOFF: 'Baixada',
          },
        },
      },
      CORRIDORS_REVIEW: {
        LOAD_CORRIDORS: 'Carregar corredors',
        LOADING: 'Carregant…',
        ADD_ROUTINE: 'Afegir rutina',
        LOAD_POLYLINE: 'Carregar polilínia',
        PROCESSING: 'Processant…',
        MAP_TITLE: 'Mapa de corredors',
        MAP_SUBTITLE: 'Corredors de pooling, rutines afegides i polilínies carregades des d\'arxiu.',
        H3_SEARCH_PLACEHOLDER: 'Cercar H3…',
        H3_SEARCH_ARIA: 'Identificador H3',
        SEARCH: 'Cercar',
        SEARCHING: 'Cercant…',
        SHOW_ALL: 'Mostrar-los tots',
        HIDE_ALL: 'Amagar-los tots',
        FIT_ALL: 'Enquadrar-ho tot',
        FIT_ALL_TOOLTIP: 'Ajustar el mapa per veure tots els corredors',
        EMPTY_HINT: 'Prem «Carregar corredors» per veure les dades al mapa',
        LEGEND_LABEL: 'Corredors',
        SHOW_ON_MAP: 'Mostrar al mapa',
        HIDE_ON_MAP: 'Amagar al mapa',
        ADD_ROUTINE_SUB: 'Coordenades «latitud, longitud» d\'origen i destinació',
        ORIGIN: 'Origen',
        DESTINATION: 'Destinació',
        CREATING: 'Creant…',
        CREATE_ROUTE: 'Crear ruta',
        ROUTE_NAME: 'Ruta {{n}}',
        POLYLINE_NAME: 'Polilínia {{id}}',
        INVALID_COORDINATES: 'Format no vàlid. Fes servir: 41.67520306862359, -0.8767050772489519',
        NOT_ENOUGH_POINTS: 'La ruta no retorna prou punts per dibuixar.',
        ROUTE_ERROR: 'No s\'ha pogut generar la ruta. Revisa les coordenades i l\'endpoint.',
        POLYLINE_NO_COORDINATES: 'No s\'han pogut extreure coordenades vàlides de l\'arxiu. Fes servir: JSON amb LineString, JSON amb polyline encoded, o només la polyline encoded.',
        POLYLINE_UNKNOWN_ERROR: 'Error desconegut en carregar l\'arxiu.',
        POLYLINE_READ_ERROR: 'Error en llegir l\'arxiu.',
        H3_REQUIRED: 'Introdueix un identificador H3',
        H3_INVALID: 'L\'identificador H3 no és vàlid',
        MAP_UNAVAILABLE: 'El mapa no està disponible. Torna-ho a provar.',
        H3_PROCESS_ERROR: 'Error en processar l\'hexàgon H3: {{detail}}',
        UNKNOWN_ERROR: 'Error desconegut',
      },
      POOLING_RUNNERS_ADMIN: {
        ITEMS: 'corredors',
        COL_NAME: 'Nom',
        COL_DESCRIPTION: 'Descripció',
        COL_COLOR: 'Color',
        COL_CREATED: 'Creat',
        COL_UPDATED: 'Actualitzat',
        DETAIL_TITLE: 'Detalls',
        DETAIL_SUBTITLE: 'Dades del corredor i les seves parades. Prem una parada per canviar-ne l\'ordre o habilitar-la.',
        BACK: 'Tornar',
        BACK_TO_LIST: 'Tornar al llistat',
        RETRY: 'Torna-ho a provar',
        EDIT: 'Editar',
        DETAILS_TITLE: 'Detalls del corredor',
        STOPS_TITLE: 'Parades',
        STOPS_COUNT: '{{count}} parada(es)',
        COL_ORDER: 'Ordre',
        COL_LOCALITY: 'Localitat',
        COL_ADDRESS: 'Adreça',
        COL_TYPE: 'Tipus',
        COL_COORDINATES: 'Coordenades',
        NO_STOPS: 'Aquest corredor no té parades associades',
        EDIT_RUNNER_TITLE: 'Editar corredor',
        EDIT_STOP_TITLE: 'Editar parada',
        NAME_PLACEHOLDER: 'Nom del corredor',
        NAME_REQUIRED: 'El nom és obligatori',
        NAME_MAXLENGTH: 'El nom no pot superar els {{max}} caràcters',
        DESCRIPTION_PLACEHOLDER: 'Descripció del corredor',
        DESCRIPTION_MAXLENGTH: 'La descripció no pot superar els {{max}} caràcters',
        PICK_COLOR: 'Triar color',
        COLOR_REQUIRED: 'El color és obligatori',
        COLOR_INVALID: 'El color ha de ser un valor hexadecimal vàlid (#RRGGBB)',
        ORDER_PLACEHOLDER: 'Ordre de la parada',
        ORDER_REQUIRED: 'L\'ordre és obligatori',
        ORDER_MIN: 'L\'ordre ha de ser més gran o igual que 0',
        ENABLED: 'Habilitada',
        SAVE: 'Desar',
        SAVING: 'Desant...',
        LOAD_ERROR: 'Error en carregar les dades del corredor',
        LOAD_ERROR_SWAL: 'No s\'han pogut carregar les dades del corredor',
        STOPS_LOAD_ERROR: 'No s\'han pogut carregar les parades.',
        SAVE_SUCCESS: 'Corredor actualitzat correctament',
        SAVE_ERROR: 'No s\'ha pogut actualitzar el corredor',
        STOP_SAVE_SUCCESS: 'Parada actualitzada correctament',
        STOP_SAVE_ERROR: 'No s\'ha pogut actualitzar la parada',
      },
      FOOTPRINT_STATISTICS: {
        TITLE: 'Captura de localització',
        SUBTITLE: 'Mitjanes mòbils de punts per dia i precisió del GPS a cada període (fins ahir).',
        HELP_LINK: 'Què són aquestes mètriques?',
        EXPAND: 'Desplegar',
        COLLAPSE: 'Plegar',
        POINTS_PER_DAY: 'Punts/dia',
        POINTS_PER_DAY_UNIT: 'punts/dia',
        ACCURACY_3_DAYS: 'Precisió (últims 3 dies)',
        AVG_ERROR_METERS: "metres d'error mitjà",
        CHANGE_VS_WEEK: "Canvi vs l'última setmana",
        POINTS_VARIATION: 'Variació de punts/dia',
        CHART_TITLE: 'Tendència de dades i precisió',
        CHART_QUESTION: 'Quants punts es capturen al dia i amb quina precisió, segons el període? Del més llarg (esquerra) al més recent (dreta).',
        SERIES_ACCURACY_POSITION: 'Precisió (posició)',
        SERIES_ACCURACY_SPEED: 'Precisió (velocitat)',
        BY_PERIOD_ARIA: '{{series}} per període',
        VIEW_DATA: 'Veure les dades',
        PERIOD: 'Període',
        NO_DATA: 'No hi ha dades de cap període.',
        SUMMARY_BY_PERIOD: 'Resum per període',
        ACCURACY_POS_SHORT: 'Precisió (pos)',
        ACCURACY_SPEED_SHORT: 'Precisió (vel)',
        VS_PREVIOUS_PERIOD: 'Respecte al període anterior de la llista',
        STATUS_GOOD: 'Bé',
        STATUS_WARNING: 'Atenció',
        STATUS_CRITICAL: 'Crític',
        INSIGHT: "{{period}}: {{points}} punts al dia, amb {{accuracy}} m d'error mitjà de posició",
        INSIGHT_SAME: "; igual que l'última setmana.",
        INSIGHT_MORE: "; un {{pct}} % més que l'última setmana.",
        INSIGHT_LESS: "; un {{pct}} % menys que l'última setmana.",
        PERIODS: {
          LAST_3_DAYS: 'Últims 3 dies',
          LAST_WEEK: 'Última setmana',
          LAST_15_DAYS: 'Últims 15 dies',
          LAST_MONTH: 'Últim mes',
          LAST_2_MONTHS: 'Últims 2 mesos',
          LAST_QUARTER: 'Últim trimestre',
          LAST_4_MONTHS: 'Últims 4 mesos',
          LAST_5_MONTHS: 'Últims 5 mesos',
          LAST_6_MONTHS: 'Últims 6 mesos',
        },
        PERIODS_SHORT: {
          LAST_3_DAYS: '3 dies',
          LAST_WEEK: 'setmana',
          LAST_15_DAYS: '15 dies',
          LAST_MONTH: 'mes',
          LAST_2_MONTHS: '2 mesos',
          LAST_QUARTER: 'trimestre',
          LAST_4_MONTHS: '4 mesos',
          LAST_5_MONTHS: '5 mesos',
          LAST_6_MONTHS: '6 mesos',
        },
      },
      FOOTPRINT: {
        ITEMS: 'usuaris',
        RAW_FOOTPRINT: 'Petjada en brut',
        RAW_FOOTPRINT_TOOLTIP: 'Veure la petjada en brut dels usuaris',
        SEARCH_PLACEHOLDER: 'Cerca nom o correu',
        REMOVE_FILTER: 'Treure {{label}}',
        OPEN_CALENDAR: 'Obrir el calendari',
        CLEAR: 'Netejar',
        COL_NAME: 'Nom',
        COL_SURNAME: 'Cognoms',
        COL_EMAIL: 'Correu electrònic',
        COL_LAST_FOOTPRINT: 'Última petjada',
        COL_LAST_SEGMENT: 'Últim segment',
        BACK: 'Tornar',
        USER: 'Usuari',
        SEARCH_USER: 'Cerca un usuari...',
        NO_RESULTS: 'Sense resultats',
        FROM_LOCAL: 'Des de (data i hora local)',
        TO_LOCAL: 'Fins a (data i hora local)',
        SHOWN: 'Es mostra: {{date}}',
        LOADING: 'Carregant…',
        LOAD_DATA: 'Carregar dades',
        EMPTY_MAP: "Carrega les dades d'un usuari per veure'n la petjada en brut al mapa",
        ERROR_LOADING_USERS: 'Error en carregar els usuaris',
        SELECT_USER: 'Selecciona un usuari',
        SELECT_BOTH_DATES: 'Selecciona les dues dates i hores',
        CHECK_RANGE: "Revisa l'interval",
        RANGE_INVALID: "La data/hora d'inici no pot ser posterior a la de fi",
        NO_DATA_TEXT: 'No hi ha dades disponibles per al període seleccionat',
        LOADED_POINTS: "S'han carregat {{count}} punts de petjada en brut",
        ERROR_LOADING_DATA: 'Error en carregar les dades',
        DETAILS_TITLE: "Petjada de l'usuari",
        DETAILS_EXPORT_CSV: "Exportar l'usuari complet en CSV",
        DETAILS_SELECT_DATE: 'Selecciona la data:',
        DETAILS_PHONE_STATUS: 'Estat del telèfon',
        DETAILS_DATA: 'Dades',
        DETAILS_CREATED: 'Creació',
        DETAILS_UPDATED: 'Modificació',
        DETAILS_PREVIOUS: '← Anterior',
        DETAILS_NEXT: 'Següent →',
        DETAILS_ITEM_OF: 'Element {{n}} de {{total}} elements totals',
        DETAILS_NO_DATA_FOR_DATE: 'No hi ha dades disponibles per a la data seleccionada.',
      },
      MATCH_CONFIG_VARIABLES: {
        TITLE: 'Configuracions de match',
        SUB: 'Cada fila és una configuració de l\'aparellament. Prem el llapis per editar un valor: Retorn desa i Esc cancel·la.',
        LOADING: 'Carregant…',
        LOAD_ERROR: 'No s\'han pogut carregar les variables de match.',
        LOAD_ERROR_TITLE: 'No s\'han pogut carregar les variables',
        RETRY: 'Tornar-ho a provar',
        EMPTY: 'No hi ha configuracions de match.',
        RELOAD: 'Recarregar',
        UPDATED: 'Actualitzat',
        EDIT_FIELD: 'Editar {{field}}',
        SAVE: 'Desar',
        SAVING: 'Desant…',
        SAVED: 'Desat',
        FOOTER_ONE: 'Mostrant {{count}} de {{total}} configuració',
        FOOTER_OTHER: 'Mostrant {{count}} de {{total}} configuracions',
        CONFIRM_TITLE: 'Canviar {{field}}',
        CONFIRM_TEXT: 'Configuració {{id}}: de {{from}} a {{to}}.',
        CONFIRM_BUTTON: 'Sí, desar',
        SAVE_ERROR_TITLE: 'No s\'ha pogut desar el canvi',
        INVALID_TITLE: 'Valor no vàlid',
        INVALID_SELECT: 'Selecciona un valor vàlid.',
        INVALID_EMPTY: 'El valor no pot estar buit.',
        INVALID_NUMBER: 'Introdueix un número vàlid abans de desar.',
        INVALID_INTEGER: 'Aquest camp només admet nombres enters.',
        GENERIC_ERROR: 'No s\'ha pogut completar l\'operació.',
        LEGEND: 'Llegenda',
        LEGEND_SUB: 'Descripció funcional de les variables que es mostren a la taula.',
        SHOW_GUIDE: 'Veure guia',
        HIDE_GUIDE: 'Amagar guia',
        LEGEND_ITEMS: {
          ALGORITHM: 'Indica quin algorisme de matching aplica aquesta fila de configuració: <code class="bo-code">\'v1\'</code> (legacy) o <code class="bo-code">\'v2\'</code> (nou).<br /><br />Detalls:<br />- L\'algorisme actiu és global: tan bon punt existeix alguna fila amb <code class="bo-code">algorithm = \'v2\'</code>, tot el sistema passa a fer servir v2<br />- v1 fa servir totes les seves files de configuració (ordenades per <code class="bo-code">order</code>); v2 només fa servir la primera fila amb <code class="bo-code">algorithm = \'v2\'</code>',
          H3_RESOLUTION_START: 'És el nivell de resolució H3 que s\'utilitza per comparar els punts d\'inici (origen) de la ruta del conductor i del passatger durant el matching.<br /><br />Detalls:<br />- <code class="bo-code">h3_resolution_start = 8</code> -> Hexàgons de ~500 metres<br />- <code class="bo-code">h3_resolution_start = 6</code> -> Hexàgons de ~10 km<br />- <code class="bo-code">h3_resolution_start = 4</code> -> Hexàgons de ~150 km',
          H3_KRING_START: 'És el nombre d\'anells (k-ring) al voltant de l\'hexàgon H3 d\'inici que també s\'accepten com a coincidents en comparar punts d\'origen. Augmentar aquest valor amplia la tolerància geogràfica més enllà de l\'hexàgon exacte.',
          H3_RESOLUTION_END: 'És el nivell de resolució H3 que s\'utilitza per comparar els punts de destinació (final) de la ruta del conductor i del passatger durant el matching.',
          H3_KRING_END: 'És el nombre d\'anells (k-ring) al voltant de l\'hexàgon H3 de destinació que també s\'accepten com a coincidents en comparar punts finals. Augmentar aquest valor amplia la tolerància geogràfica més enllà de l\'hexàgon exacte.',
          H3_RESOLUTION_POLYLINE: 'És el nivell de resolució H3 que s\'utilitza per extreure hexàgons H3 al llarg de tot el trajecte (polyline) de les dues rutes per calcular-ne la superposició (overlap).',
          H3_KRING_ROUTE: 'És el nombre d\'anells (k-ring) al voltant de cada hexàgon H3 del trajecte que s\'inclouen en calcular la superposició (overlap) entre les polylines del conductor i del passatger. Augmentar aquest valor fa més permissiu el càlcul de l\'overlap.',
          DURATION_DELTA: 'És el temps addicional màxim permès, en segons, que es pot afegir a la durada del viatge del conductor quan recull un passatger. Si el temps extra és inferior a aquest llindar, el match s\'accepta.',
          DISTANCE_DELTA: 'És un multiplicador percentual que defineix l\'augment relatiu màxim permès en la durada del viatge. Si el temps nou és inferior a <code class="bo-code">distance_delta</code> vegades el temps original, el match s\'accepta.<br /><br />Detalls (important: el nom és enganyós):<br />- Tot i dir-se "<code class="bo-code">distance_delta</code>", NO es refereix a una distància en metres, sinó a un llindar percentual<br />- Es valida amb la lògica: <code class="bo-code">newDuration / baseDuration &lt; distance_delta</code><br />- És un factor multiplicador, normalment entre 1.0 i 1.5',
          DELAY_THRESHOLD: 'És el retard màxim permès, en segons, entre l\'hora real en què el conductor recull/deixa el passatger i l\'hora que espera el passatger. Si la diferència és inferior a aquest llindar, el match s\'accepta.<br /><br />Detalls:<br />- Compara dos temps:<br />- Hora real de pickup/dropoff: calculada a partir del temps de viatge del conductor (durada OSRM) + retards<br />- Hora esperada pel passatger: el seu horari de sortida/arribada desitjat<br />- Si la diferència és &lt;= <code class="bo-code">delay_threshold</code> segons en TOTS DOS casos (pickup i dropoff), el match s\'accepta',
          EXTENDED_DELAY_THRESHOLD: 'És el marge de retard ampli (en segons) que s\'utilitza al costat flexible de la finestra horària, complementant <code class="bo-code">delay_threshold</code> (marge ajustat del costat compromès per l\'usuari).<br /><br />Detalls:<br />- Si es deixa buit (null), es fa servir <code class="bo-code">delay_threshold</code> als dos costats, i es manté el comportament simètric anterior<br />- En sortir: marge ajustat cap enrere, marge ampli cap endavant (p. ex. sortir més tard)<br />- En arribar: marge ampli cap enrere, marge ajustat cap endavant (p. ex. arribar abans)',
          DEPARTURE_MARGIN_SECONDS: 'És el marge de temps permès abans de la sortida del conductor perquè un passatger es consideri compatible. Defineix una finestra de temps primerenca en què s\'accepten passatgers.<br /><br />Detalls:<br />- Estableix quants segons ABANS que surti el conductor es poden acceptar passatgers<br />- Es valida amb la lògica: <code class="bo-code">riderDepartureTime &gt;= driverDepartureTime - departure_margin_seconds</code><br />- Crea una finestra flexible de compatibilitat temporal',
          ARRIVAL_MARGIN_SECONDS: 'És el marge de temps permès després de l\'arribada del conductor perquè un passatger es consideri compatible. Defineix una finestra de temps tardana en què s\'accepten passatgers.<br /><br />Detalls:<br />- Estableix quants segons DESPRÉS que arribi el conductor es poden acceptar passatgers<br />- Es valida amb la lògica: <code class="bo-code">riderArrivalTime &lt;= driverArrivalTime + arrival_margin_seconds</code><br />- Crea una finestra flexible de compatibilitat temporal (en sentit oposat a <code class="bo-code">departure_margin_seconds</code>)',
          RADIUS_METERS: 'Defineix el radi geogràfic de cerca (en metres) que s\'utilitza en fer el matching entre riders i conductors.<br /><br />Detalls:<br />- En cercar rutes de conductors compatibles per a un rider, només es tenen en compte les que tenen els punts d\'origen/destinació dins d\'aquest radi des de les coordenades del rider<br />- És una restricció geogràfica que limita els matches a conductors propers',
        },
      },
      PAYOUT_REVIEWS: {
        TIME: {
          NOW: 'ara',
          AGO: 'fa {{value}}',
          IN: "d'aquí a {{value}}",
        },
        LEVEL: {
          HIGH: 'Frau probable',
          MEDIUM: 'Revisar',
          LOW: 'Baix',
        },
        HOLD: {
          REINFORCED: 'Verificació reforçada',
          CASH_DELAY: 'Retard de caixa',
        },
        DELAY: {
          INSTANT: 'al moment',
          HOURS: '{{value}} h',
          DAY: '{{value}} dia',
          DAYS: '{{value}} dies',
        },
        DEADLINE: {
          PAID_AUTO: 'Aprovada automàticament',
          PAID_RECOVERY: 'Pagada (pagament recuperat)',
          VERIFIED_BY: 'Verificada per {{name}}',
          REJECTED_BY: 'Rebutjada per {{name}}',
          PREAPPROVED_PAYS: 'Aprovada per endavant per {{name}} · es paga {{when}}',
          PREAPPROVED_NEXT_CRON: 'Aprovada per endavant per {{name}} · es pagarà al pròxim cron',
          SCHEDULED: 'Programada · es pot pagar {{when}}',
          OVERDUE_OVER_LIMIT: 'Termini vençut · requereix decisió (supera el límit)',
          NEEDS_DECISION: 'Requereix decisió · termini {{when}}',
          OVERDUE_NEXT_CRON: 'Termini vençut · es pagarà al pròxim cron',
          AUTO_PAY: 'Pagament automàtic {{when}}',
        },
        STRIPE_ERRORS: {
          NO_TRANSFERS: 'El compte de Stripe del conductor no pot rebre transferències: li falta activar la capacitat de transferències (transfers) a Stripe.',
          INSUFFICIENT_FUNDS: 'No hi ha prou saldo a Stripe per fer la transferència.',
          NO_ACCOUNT: 'El compte de Stripe del conductor no existeix o ja no està connectat.',
          RESTRICTED: 'El compte de Stripe del conductor està restringit i no pot rebre pagaments.',
          BANK_INVALID: 'El compte bancari del conductor a Stripe no és vàlid o està tancat.',
          RATE_LIMIT: "Stripe ha rebut massa peticions seguides. Torna-ho a provar d'aquí a uns minuts.",
          GENERIC: "Stripe ha rebutjat l'operació.",
        },
        // Pestaña «Retiradas» de la ficha de usuario (la misma tabla, filtrada).
        USER: {
          TAB: 'Retirades',
          EMPTY_TITLE: 'Aquest usuari no té retirades en revisió',
        },
        LIST: {
          HEADER_NOTE: 'Sense decisió en {{hours}} h es paguen soles les de fins a {{amount}}; les que el superen esperen aquí.',
          KPIS_ARIA: 'Indicadors de retirades',
          KPI_PENDING: 'Pendents',
          KPI_PENDING_HINT: 'Esperen revisió o el pagament automàtic',
          KPI_IN_TABLE: 'A la taula',
          KPI_SEE_IN_TABLE: 'Veure a la taula',
          KPI_OVERDUE: 'Amb termini vençut',
          KPI_OVERDUE_HINT: 'Han passat {{hours}} h sense decisió',
          KPI_OVERDUE_HINT_NO_META: 'Han passat les hores de marge sense decisió',
          KPI_OVERDUE_ACTION: 'Revisar com més aviat millor',
          NONE: 'Cap',
          KPI_OVER_LIMIT: 'Superen el límit',
          KPI_OVER_LIMIT_HINT: 'Més de {{amount}}: no es paguen soles',
          KPI_OVER_LIMIT_HINT_NO_META: 'Més del límit: no es paguen soles',
          KPI_OVER_LIMIT_ACTION: 'Requereixen decisió',
          KPI_DECIDED: 'Decidides avui',
          KPI_DECIDED_HINT: 'Aprovades o rebutjades avui',
          STATUS_ARIA: 'Estat',
          TABS: {
            PENDING: 'Pendents',
            DECIDED: 'Resoltes',
            ALL: 'Totes',
          },
          PANEL: {
            PENDING_TITLE: 'Retirades pendents',
            PENDING_SUBTITLE: "Esperen una decisió. Prem-ne una per veure'n l'anàlisi de risc.",
            DECIDED_TITLE: 'Retirades decidides',
            DECIDED_SUBTITLE: "Ja pagades o rebutjades. Prem-ne una per veure'n el detall.",
            ALL_TITLE: 'Totes les retirades',
            ALL_SUBTITLE: "Pendents i decidides. Prem-ne una per veure'n el detall.",
          },
          SEARCH_PLACEHOLDER: 'Cerca per nom, email, DNI o telèfon',
          SEARCH_ARIA: 'Cercar retirades',
          SORT_ARIA: 'Ordre',
          SORT: {
            RELEASE: 'Ordre: termini més proper',
            RISK: 'Ordre: més risc',
            AMOUNT: 'Ordre: import més alt',
            CREATED: 'Ordre: més recents',
          },
          REFRESH: 'Actualitzar',
          LOADING: 'Carregant retirades',
          COLS: {
            USER: 'Usuari',
            AMOUNT: 'Import',
            REQUESTED: 'Sol·licitada',
            DEADLINE: 'Termini',
            STATUS: 'Estat',
            RISK: 'Risc',
            SIGNALS: 'Senyals',
            DECISION: 'Decisió',
            OPEN: 'Obrir',
          },
          ERROR: 'Error',
          RETRY: 'Tornar-ho a provar',
          EMPTY_TITLE: 'Res pendent',
          EMPTY_TEXT: 'No hi ha retirades en aquest filtre.',
          OVER_LIMIT: 'supera el límit',
          STRIPE_ORIGINAL: 'Missatge original de Stripe: {{message}}',
          ANALYZING: 'Analitzant…',
          ANALYSIS_FAILED: 'Anàlisi fallida',
          TRIPS_KM_ONE: '{{count}} viatge · {{km}} km',
          TRIPS_KM_OTHER: '{{count}} viatges · {{km}} km',
          FIXED_IP: 'IP fixa {{pct}}',
          SHARED_IP: 'Passatgers mateixa IP {{pct}}',
          APPROVE_SCHEDULED_TIP: 'La deixa aprovada: es paga sola quan arribi la data',
          PAY_NOW_TIP: 'Paga la retirada a Stripe ara',
          APPROVE: 'Aprovar',
          VERIFY: 'Verificar',
          REJECT_TIP: "Retorna l'import a la seva wallet",
          REJECT: 'Rebutjar',
          PAID: 'Pagada',
          REJECTED: 'Rebutjada',
          APPROVED: 'Aprovada',
          PAYOUT_PAID: 'Pagada al banc',
          PAYOUT_FAILED: 'Retornada pel banc',
          PAYOUT_CANCELED: 'Cancel·lada a Stripe',
          PAYOUT_SENT: 'Enviada al banc',
          PAGINATION: 'Mostrant {{shown}} de {{total}} retirades',
          PREV: 'Anterior',
          NEXT: 'Següent',
          LOAD_ERROR: "No s'han pogut carregar les retirades.",
          TOAST_PREAPPROVED: 'Retirada de {{amount}} aprovada per endavant: es paga sola el {{date}}.',
          TOAST_PAID: 'Retirada de {{amount}} pagada a {{name}}.',
          REJECT_TITLE: 'Rebutjar {{amount}} de {{name}}',
          REJECT_TEXT: "L'import torna a la seva wallet. No es paga res a Stripe. El motiu és opcional i només el veu l'equip.",
          REJECT_PLACEHOLDER: 'Motiu (opcional): p. ex. IP fixa en tots els viatges, salts GPS…',
          REJECT_ARIA: 'Motiu opcional',
          REJECT_CONFIRM: 'Rebutjar retirada',
          CANCEL: 'Cancel·lar',
          REJECTING: 'Rebutjant…',
          ALREADY_DECIDED: 'Ja decidida',
          DECIDED_BY_OTHER: 'Una altra persona ho ha decidit abans.',
          DECIDED_BY_NAME: '{{message}} Decidida per {{name}}.',
          STRIPE_REJECTED_TITLE: 'Stripe no ha acceptat el pagament',
          STILL_PENDING: 'La retirada continua pendent.',
          STRIPE_ERROR_STILL_PENDING: '{{error}} La retirada continua pendent.',
          DECISION_ERROR: "No s'ha pogut aplicar la decisió",
          NO_JUMPS: 'Sense salts',
          JUMPS_ONE: '{{count}} salt · {{detail}}',
          JUMPS_OTHER: '{{count}} salts · {{detail}}',
          JUMP_KM_KMH: '{{km}} km a {{kmh}} km/h',
        },
        DETAIL: {
          BREADCRUMB_ARIA: 'Ruta de navegació',
          DETAIL: 'Detall',
          LOADING: 'Carregant retirada',
          BACK: 'Tornar',
          VIEW_PROFILE: 'Veure fitxa',
          DNI: 'DNI {{value}}',
          SIGNUP: 'Alta {{date}}',
          APPROVE_SCHEDULED_TIP: 'Encara no es pot pagar: queda aprovada i es paga sola en la seva data',
          PREAPPROVE: 'Aprovar per endavant',
          VERIFY_AND_PAY: 'Verificar i pagar',
          DECIDED_AUTO: 'automàticament',
          DECIDED_BY: 'per {{name}}',
          REQUESTED_AT: 'sol·licitada {{when}} · {{date}}',
          SCHEDULED_FOR: 'Programada per {{reason}} · es pot pagar des del {{date}}',
          CASH_DELAY: 'Retard de caixa {{delay}}',
          CASH_DELAY_FIRST: '(de les primeres)',
          CASH_PREVIOUS_ONE: '{{count}} retirada prèvia per {{amount}}',
          CASH_PREVIOUS_OTHER: '{{count}} retirades prèvies per {{amount}}',
          CASH_LAST: "l'anterior {{delay}}",
          CASH_LAST_LATE: "l'anterior {{delay}}, va arribar tard",
          PREAPPROVED_BY: 'Aprovada per endavant per {{name}} · {{date}}',
          NO_FLAGS: 'Sense senyals de frau en el període.',
          ANALYZING: 'Analitzant viatges, IPs i empremta…',
          NOTE: 'Nota:',
          STRIPE: 'Stripe:',
          STRIPE_ERROR: 'Error de Stripe:',
          KPIS_ARIA: 'Indicadors de la retirada',
          K_TRIPS: 'Viatges com a conductor',
          K_TRIPS_HINT: 'En el període analitzat',
          K_TRIPS_DELTA: '{{km}} km · {{hours}} h · {{days}} dies',
          K_PER_DAY: 'Viatges per dia actiu',
          K_PER_DAY_HINT: 'Mitjana dels dies amb viatges',
          K_PER_DAY_DELTA: 'màx. {{count}} en un dia',
          K_MAX_DAY: 'Màxim de viatge en un dia',
          K_MAX_DAY_HINT: 'Hores conduint el dia amb més viatges',
          K_OVER_4H: 'Més de 4 h',
          K_NORMAL: 'Normal',
          K_FIXED_IP: 'Viatges amb IP fixa',
          K_FIXED_IP_HINT: "IP de casa o d'oficina, no mòbil",
          K_FIXED_IP_DELTA: "{{fixed}} de {{total}} amb dades d'IP",
          K_SHARED: 'Passatgers a la seva IP',
          K_SHARED_HINT: 'Tots els passatgers amb la IP del conductor',
          K_SHARED_DELTA: '{{shared}} de {{total}} amb dades · algun: {{any}}',
          K_JUMPS: 'Salts GPS impossibles',
          K_JUMPS_HINT: 'Més de 10 km i 130 km/h entre punts',
          K_JUMPS_DELTA: 'màx. {{km}} km · {{kmh}} km/h',
          K_NONE: 'Cap',
          MONEY_TITLE: 'Diners',
          MONEY_NOTE: 'no influeix en la puntuació',
          MONEY_REQUESTED: 'Demana retirar',
          MONEY_EARNED_PERIOD: 'Generat en el període',
          MONEY_WALLET: 'A la wallet ara',
          MONEY_WITHDRAWN: 'Retirat al banc (històric)',
          MONEY_WITHDRAWN_COUNT: '· {{count}} retirades',
          MONEY_EARNED_TOTAL: 'Generat total',
          MONEY_REVIEWS: 'Revisions prèvies',
          MONEY_REVIEWS_VALUE: '{{approved}} pagades · {{rejected}} rebutjades',
          RIDERS_TITLE: 'Passatgers que ha portat',
          RIDERS_COUNT: '{{count}} diferents',
          RIDER_TRIPS_ONE: '{{count}} viatge · {{amount}}',
          RIDER_TRIPS_OTHER: '{{count}} viatges · {{amount}}',
          RIDER_SAME_IP: 'mateixa IP {{same}}/{{total}}',
          RIDER_NEVER_DRIVES: 'mai condueix',
          RIDER_SAME_WEEK: 'alta la mateixa setmana',
          NO_RIDERS: 'Cap passatger confirmat en el període.',
          MAP_TITLE: 'Empremta GPS del període',
          MAP_POINTS: 'Punts',
          MAP_LINE: 'Recorregut',
          MAP_JUMPS: 'Salts',
          MAP_COLOR_TRIPS: 'Acolorir viatges',
          MAP_FIT: 'Veure-ho tot',
          MAP_LOADING: 'Carregant empremta…',
          MAP_FOOTER: '{{kept}} punts pintats de {{total}} llegits ({{from}} → {{to}}) · recorregut {{km}} km',
          MAP_TRUNCATED: 'empremta retallada als darrers 60 dies del període',
          JUMPS_TITLE: 'Salts GPS impossibles',
          JUMPS_NOTE: '> 10 km entre dos punts consecutius a > 130 km/h · com més km i més km/h, més clar',
          J_FROM: 'Des de',
          J_TO: 'Fins a',
          J_KM: 'Km',
          J_KMH: 'Km/h',
          J_SECONDS: 'Segons',
          J_SHOW: 'Veure al mapa',
          TRIPS_TITLE: 'Viatges com a conductor',
          TRIPS_NOTE: '{{reason}} · {{from}} → {{to}} · clic en un viatge per veure’l al mapa',
          T_START: 'Inici',
          T_ROUTINE: 'Rutina',
          T_DURATION: 'Durada',
          T_RIDERS: 'Passatgers',
          T_DRIVER_IP: 'IP del conductor',
          T_SHARED: 'Passatgers a la seva IP',
          T_EARNS: 'Cobra',
          OVERLAP: 'solapament {{pct}} %',
          RIDER_SAME: 'mateixa IP',
          RIDER_OTHER: 'una altra IP',
          RIDER_NO_IP: "sense dades d'IP",
          NO_RIDERS_TRIP: 'Sense passatgers',
          DETAIL_LINK: 'Detall',
          NO_TRIPS: 'Sense viatges acabats com a conductor en el període.',
          IPS_TITLE: 'IPs vistes durant els viatges',
          IPS_RESOLVING: 'resolent rDNS des del navegador…',
          IPS_NOTE: "fixa = rDNS d'operador de casa/oficina o mateixa IP ≥ 3 dies · mòbil (CGNAT) canvia entre dies",
          I_IP: 'IP',
          I_TYPE: 'Tipus',
          I_DETAIL: 'Detall',
          I_TRIPS: 'Viatges',
          I_DAYS: 'Dies',
          I_USERS: 'Usuaris',
          I_DRIVER: 'conductor',
          I_RDNS_PENDING: 'rDNS pendent',
          COMPUTED: 'Informe calculat {{when}} ({{date}}).',
          RECOMPUTE: 'Recalcular',
          ANALYSIS_FAILED_TEXT: "L'anàlisi ha fallat: {{error}}",
          RETRY_ANALYSIS: "Tornar a provar l'anàlisi",
          NOT_FOUND: 'Aquesta retirada no existeix.',
          LOAD_ERROR: "No s'ha pogut carregar la retirada.",
          TRACK_NOT_READY: "L'empremta encara no està llesta.",
          TRACK_ERROR: "No s'ha pogut carregar l'empremta.",
          TOAST_PREAPPROVED: 'Aprovada per endavant: es pagaran {{amount}} sols el {{date}}.',
          TOAST_PAID: '{{amount}} pagats a {{name}}.',
          REJECT_TITLE: 'Rebutjar {{amount}}',
          REJECT_TEXT: "L'import torna a la wallet de l'usuari. No es paga res a Stripe. El motiu és opcional i només el veu l'equip.",
          REJECT_PLACEHOLDER: 'Motiu (opcional)',
          RECOMPUTE_ERROR: "No s'ha pogut recalcular",
          PERIOD: {
            LAST_PAYOUT: 'des del darrer cobrament',
            FIRST_TRIP: 'des del primer viatge (mai no havia cobrat)',
            SIGNUP: "des de l'alta",
          },
          IP_KIND: {
            HOSTING: 'Hosting / VPN',
            FIXED: 'Fixa',
            FIXED_PROBABLE: 'Fixa (probable)',
            MOBILE: 'Mòbil',
            UNKNOWN: 'Desconeguda',
          },
          TRIP_IP: {
            NO_DATA: 'Sense dades',
            FIXED_ALL: 'IP fixa tota la ruta',
            FIXED_MANY: 'IPs fixes',
            MOBILE: 'Mòbil',
            ONE_UNKNOWN: 'Una IP (desconeguda)',
            MANY: '{{count}} IPs',
          },
          DURATION_RATIO: '{{pct}} % del pla',
        },
        MAP: {
          DURING_TRIP: 'Durant un viatge',
          OUT_OF_TRIP: 'Fora de viatge',
          SELECTED: 'Seleccionat',
          IMPOSSIBLE_JUMP: 'Salt impossible',
          JUMP_TOOLTIP: '{{km}} km en {{seconds}} s',
          JUMP_TOOLTIP_KMH: '{{km}} km en {{seconds}} s · {{kmh}} km/h',
        },
      },
      PARTNER_PANEL: {
        COMMON: {
          CLOSE: 'Tancar',
          CANCEL: 'Cancel·lar',
          SAVE: 'Desar',
          SAVING: 'Desant…',
          RETRY: 'Tornar-ho a provar',
          OK: 'D’acord',
          PREVIOUS: 'Anterior',
          NEXT: 'Següent',
          ACTION_ERROR: 'No s’ha pogut completar l’acció. Torna-ho a provar.',
        },
        SPLIT: {
          LABEL: 'Repartiment a la bossa de l’empresa',
          VALUE: '{{n}} % a la bossa de l’empresa',
          ALL_PARTNER: 'Tot per a {{partner}}',
          ALL_WALLET: 'Tot a la bossa',
        },
        BILLING_MODE: {
          LABEL: 'Qui factura',
          WAIIS: 'WAIIS factura a l’empresa',
          PARTNER: '{{partner}} factura a l’empresa',
          PARTNER_HINT: 'WAIIS li factura a {{partner}} la bossa',
          LOCKED: 'Qui factura només canvia en la renovació. Ho canvia WAIIS.',
          SCHEDULED: 'Des de la renovació: {{option}}',
          NO_AMOUNT_NOTE: 'Sense import no es desa el pla: qui factura es tria després a «Contracte i preu».',
          LIST_WAIIS: 'Factura WAIIS',
          LIST_PARTNER: 'Factura {{partner}}',
        },
        STATUS: {
          INVITED: 'Invitació enviada',
          NONE: '—',
        },
        COMPANIES: {
          TITLE: 'Empreses de {{name}}',
          SUBTITLE: 'Les teves empreses: l’adopció, el pla anual i el que els falta. Fes clic en una fila per veure’n la fitxa.',
          NEW_COMPANY: 'Nova empresa',
          EXPORT: 'Exportar CSV',
          EXPORT_ERROR: 'No s’ha pogut exportar.',
          KPIS_LABEL: 'Indicadors de les teves empreses',
          KPI_COMPANIES: 'Empreses',
          KPI_COMPANIES_HINT: '{{active}} actives · {{trial}} en prova',
          KPI_REGISTERED: 'Empleats registrats',
          KPI_REGISTERED_HINT: '{{percent}} % de {{declared}} en plantilla',
          KPI_REGISTERED_HINT_NONE: 'de {{declared}} en plantilla',
          KPI_TRIPS: 'Viatges compartits · {{month}}',
          KPI_CO2: 'CO₂e evitat · {{month}}',
          KPI_CO2_VALUE: '{{value}} t',
          KPI_CONTRACTED: 'Contractat a l’any',
          KPI_CONTRACTED_SUB: 'Empreses actives',
          KPI_CONTRACTED_HINT: '{{wallet}} a bosses',
          KPIS_ERROR: 'No s’han pogut carregar els indicadors.',
          ENDING_ONE: 'Una empresa acaba la prova aviat',
          ENDING_OTHER: '{{n}} empreses acaben la prova aviat',
          ENDING_ITEM: '{{name}} · acaba el {{date}} ({{days}} dies)',
          ENDING_ITEM_ONE_DAY: '{{name}} · acaba el {{date}} (1 dia)',
          PREPARE_CONTRACT: 'Preparar el contracte',
          SEARCH_PLACEHOLDER: 'Cerca per nom o CIF…',
          SEARCH_LABEL: 'Cercar empreses',
          FILTER_ALL: 'Totes',
          FILTER_ACTIVE: 'Actives',
          FILTER_TRIAL: 'En prova',
          FILTER_LOCKED: 'Bloquejades',
          FILTER_PENDING: 'Pendents',
          FILTER_NONE: 'Sense estat',
          FILTER_STATUS_LABEL: 'Estat',
          FILTER_MANAGER: 'Gestor',
          FILTER_MANAGER_ALL: 'Gestor: tots',
          CLEAR_FILTERS: 'Netejar filtres',
          TABLE_TITLE: 'Les teves empreses',
          COL_COMPANY: 'Empresa',
          COL_MANAGER: 'Gestor',
          COL_HEADCOUNT: 'Plantilla',
          COL_REGISTERED: 'Registre',
          COL_TRIPS: 'Viatges ({{month}})',
          COL_PLAN: 'Pla anual',
          COL_STATUS: 'Estat',
          COL_ACTIONS: 'Accions',
          PLAN_YEAR: '{{amount}} / any',
          PLAN_WALLET: '{{wallet}} a bossa · {{monthly}}/mes',
          PLAN_NONE: 'Sense pla anual',
          PLAN_DRAFT: 'Sense activar',
          PLAN_PENDING_PAYMENT: 'Pagament pendent',
          PLAN_PENDING_INVOICE: 'Factura pendent',
          NO_MANAGER: 'Sense gestor',
          EMPTY: 'No hi ha empreses amb aquests filtres',
          LOAD_ERROR: 'No s’han pogut carregar les empreses.',
          ACTION_DASHBOARD: 'Veure el seu dashboard',
          ACTION_CONTRACT: 'Contracte i preu',
          ACTION_DETAIL: 'Obrir la fitxa',
          FOOT: 'Mostrant {{shown}} de {{total}} empreses',
          CREATED_PRICE_ERROR: 'L’empresa s’ha creat, però no se n’ha pogut desar el preu. Posa’l a «Contracte i preu».',
        },
        CREATE: {
          TITLE: 'Nova empresa',
          SUBTITLE: 'La convidem a l’instant: l’administrador rep un correu per entrar.',
          SUBTITLE_REQUEST: 'Amb les dades de la sol·licitud de {{company}}.',
          SECTION_COMPANY: 'Empresa',
          SECTION_ADMIN: 'Administrador de l’empresa',
          SECTION_PRICE: 'Preu i prova',
          LEGAL_NAME: 'Empresa (raó social)',
          TAX_ID: 'CIF',
          CITY: 'Ciutat',
          EMPLOYEES: 'Nre. d’empleats',
          MANAGER: 'Gestor',
          MANAGER_HINT: 'Un Partner admin del teu equip.',
          ADMIN_NAME: 'Nom i cognoms',
          ADMIN_EMAIL: 'Correu',
          ADMIN_EMAIL_HINT: 'Li arribarà la invitació per entrar.',
          ADMIN_PHONE: 'Telèfon',
          PRICE_SUMMARY: 'Bossa de l’empresa {{wallet}} a l’any · {{monthly}} cada mes',
          ERROR_REQUIRED: 'Camp obligatori',
          ERROR_EMAIL: 'Escriu un correu vàlid',
          ERROR_EMPLOYEES: 'Escriu un nombre més gran que 0.',
          ERROR_AMOUNT: 'Escriu un import més gran que 0.',
          ERROR_SAVE: 'No s’ha pogut crear l’empresa. Torna-ho a provar.',
          SUBMIT: 'Crear i enviar la invitació',
          CREATING: 'Creant…',
          DONE_INVITED: 'Empresa creada. Invitació enviada a {{email}}',
          DONE_LINKED: 'Empresa creada. {{email}} ja pot entrar com a administrador',
        },
        CONTRACT: {
          CLOSE_PERIOD: {
            BUTTON: 'Tancar el període avui',
            TITLE: 'Tancar el període avui',
            TEXT: 'El període en curs del pla acaba avui en lloc del {{date}} i s’obre la renovació amb el que hi ha programat (qui factura, import i repartiment). La bossa deixa de rebre els mesos que faltaven. Retornar o compensar el que no s’ha assignat es fa a mà.',
            CONFIRM: 'Tancar el període',
            CANCEL: 'Cancel·lar',
            DONE: 'Període tancat. La renovació és oberta.',
            ERROR: 'No s’ha pogut tancar el període. Torna-ho a provar.',
          },
          AMOUNT: 'Import anual',
          AMOUNT_HINT: '€ a l’any · IVA a part',
          TRIAL_MONTHS: 'Mesos de prova',
          TRIAL_UNCHANGED: 'Sense canviar',
          TRIAL_HINT: 'Mesos de prova gratuïta des de l’alta.',
          TRIAL_ENDS: 'Ara la prova acaba el {{date}}.',
          TRIAL_LOCKED: 'Amb el pla actiu, la prova ja no es canvia.',
          SPLIT: 'Repartiment',
          PRICE_TITLE: 'Preu anual',
          PRICE_SUB: 'El que paga l’empresa a l’any i quina part va a la seva bossa.',
          ACTIVE_NOTE: 'El pla és actiu: el repartiment canvia des del mes següent i l’import, en la renovació.',
          SCHEDULED_SPLIT: 'Programat: {{n}} % a la bossa des del {{date}}.',
          SCHEDULED_AMOUNT: 'En la renovació: {{amount}}.',
          SUMMARY_TITLE: 'Resum',
          SUMMARY_EMPTY: 'Escriu l’import anual per veure el repartiment entre {{partner}} i la bossa.',
          SUMMARY_PLAN: 'Pla anual',
          SUMMARY_PARTNER: 'Per a {{partner}}',
          SUMMARY_WALLET: 'Bossa de l’empresa',
          SUMMARY_MONTHLY: 'Bossa cada mes · acumulable',
          SAVED: 'Preu desat',
          SAVED_ACTIVE: 'El repartiment canvia des del mes següent; l’import, en la renovació.',
          SAVE_ERROR: 'No s’ha pogut desar el preu.',
          ERROR_NO_AMOUNT: 'Escriu l’import anual.',
          LOAD_ERROR: 'No s’ha pogut carregar el pla anual.',
          CHECK_TITLE: 'Per activar el pla',
          CHECK_NOTE: 'Ho omples tu amb el client. Ell només en veu el resultat al seu dashboard.',
          STEP_BILLING: 'Dades de facturació',
          STEP_BILLING_TEXT: 'Les dona l’empresa en pagar a Stripe; el panell no en rep l’estat.',
          STEP_PAYMENT: 'Pagament',
          STEP_PAYMENT_TEXT: 'Amb l’enllaç de pagament d’Stripe: targeta, SEPA o transferència.',
          STEP_CONTRACT: 'Contracte',
          STEP_CONTRACT_TEXT: 'El tanca l’empresa en pagar el pla; el panell no en rep l’estat.',
          GENERATE_LINK: 'Generar l’enllaç de pagament',
          LINK_NEEDS_PRICE: 'Desa abans el preu.',
          COPY_LINK: 'Copiar l’enllaç de pagament',
          LINK_COPIED: 'Enllaç copiat',
          LINK_EXPIRES: 'Val fins al {{date}}.',
          LINK_ERROR: 'No s’ha pogut generar l’enllaç de pagament.',
          PAYMENT_IN_PROGRESS: 'El pagament està en curs.',
          STATE_DONE: 'Fet',
          STATE_PENDING: 'Pendent',
          STATE_ON_PAYMENT: 'En pagar',
          INVOICE_TITLE: 'Factura de WAIIS a {{partner}}',
          INVOICE_NOTE: 'WAIIS factura a {{partner}} la bossa de l’empresa. L’empresa no paga res ni ho veu al seu dashboard.',
          STEP_PARTNER_PAYMENT: 'Pagament de {{partner}}',
          STEP_PARTNER_PAYMENT_TEXT: '{{partner}} paga per transferència amb les dades de la factura de Stripe.',
          GENERATE_INVOICE: 'Generar factura',
          VIEW_INVOICE: 'Veure factura',
          INVOICE_DUE: 'Venç el {{date}}.',
          INVOICE_WALLET: 'La bossa de {{company}} comença quan {{partner}} pagui aquesta factura.',
          INVOICE_ERROR: 'No s’ha pogut generar la factura.',
        },
        SUMMARY: {
          FUNNEL_TITLE: 'Adopció de la plantilla',
          FUNNEL_SUB: '{{percent}} % de {{total}} en plantilla',
          FUNNEL_REGISTERED: 'Registrats',
          FUNNEL_ROUTINE: 'Amb rutina',
          FUNNEL_SHARED: 'Viatge compartit',
          FUNNEL_PERCENT_TIP: 'Sobre els registrats',
          TRIPS_TITLE: 'Viatges compartits per mes',
          NO_TRIPS: 'Encara sense viatges',
          CONTACT_TITLE: 'Contacte',
          ADMIN: 'Administrador',
          EMAIL: 'Correu',
          PHONE: 'Telèfon',
          MANAGER: 'Gestor del partner',
        },
        EMPLOYEES: {
          ADD: 'Afegir empleats',
          EXPORT: 'Exportar CSV',
          EXPORT_ERROR: 'No s’ha pogut exportar la plantilla.',
          ADD_TITLE: 'Afegir empleats',
          NOTE: 'Les altes les fas tu. L’empresa només veu la llista.',
          OFFICE: 'Seu',
          NO_OFFICES: 'Crea abans una seu a la pestanya «Seus».',
          BY_EMAIL: 'Per correu',
          EMAILS: 'Correus dels empleats',
          EMAILS_PLACEHOLDER: 'ana@empresa.cat, pere@empresa.cat',
          EMAILS_HINT: 'Separats per comes o en línies. La invitació surt a l’instant.',
          SEND: 'Enviar les invitacions',
          BY_CSV: 'O puja un CSV',
          CSV_FILE: 'Fitxer CSV',
          TEMPLATE: 'Descarregar la plantilla d’exemple',
          UPLOAD: 'Pujar CSV',
          SENT_ONE: '1 invitació enviada a la plantilla de {{company}}',
          SENT_OTHER: '{{n}} invitacions enviades a la plantilla de {{company}}',
          SKIPPED: 'Ja eren a la plantilla: {{emails}}.',
          CSV_DONE: 'CSV pujat a la plantilla de {{company}}',
          ERROR_NO_EMAILS: 'Escriu almenys un correu.',
          ERROR_EMAILS: 'Revisa aquests correus: {{emails}}',
          ERROR_SAVE: 'No s’han pogut donar d’alta. Torna-ho a provar.',
        },
        OFFICES: {
          CREATE: 'Crear seu',
          CREATE_TITLE: 'Crear seu',
          CREATE_SUB: 'Tria l’adreça de l’autocompletat: sense ella no es pot crear.',
          NAME: 'Nom de la seu',
          ADDRESS: 'Adreça',
          ADDRESS_PLACEHOLDER: 'Comença a escriure l’adreça…',
          ADDRESS_HINT: 'Tria una adreça de la llista.',
          ADDRESS_OK: 'Adreça triada · {{city}}',
          CONTACT: 'Contacte de la seu',
          CONTACT_NAME: 'Nom',
          CONTACT_EMAIL: 'Correu',
          CONTACT_PHONE: 'Telèfon',
          CREATED: '«{{name}}» creada',
          ERROR_SAVE: 'No s’ha pogut crear la seu. Torna-ho a provar.',
        },
        DATA: {
          TITLE: 'Dades de l’empresa',
          SUBTITLE: 'El que veu l’empresa al seu espai. El correu d’accés de l’administrador no es canvia aquí.',
          TRADE_NAME: 'Nom comercial',
          LEGAL_NAME: 'Raó social',
          TAX_ID: 'CIF',
          CITY: 'Ciutat',
          EMPLOYEES: 'Nre. d’empleats',
          MANAGER: 'Gestor',
          MANAGER_HINT: 'Només un Partner admin del teu equip.',
          ADMIN_TITLE: 'Administrador',
          ADMIN_NAME: 'Nom',
          ADMIN_EMAIL: 'Correu d’accés',
          ADMIN_EMAIL_HINT: 'No es canvia: per a un altre administrador, convida’l.',
          CHANGE_ADMIN: 'Canviar l’administrador',
          CHANGE_ADMIN_NOTE: 'Convidem el nou administrador. L’anterior conserva l’accés.',
          NEW_ADMIN_EMAIL: 'Correu del nou administrador',
          INVITE_ADMIN: 'Convidar el nou administrador',
          ADMIN_INVITED: 'Invitació enviada a {{email}}',
          ADMIN_LINKED: '{{email}} ja pot entrar com a administrador',
          ADMIN_ERROR: 'No s’ha pogut canviar l’administrador.',
          SAVE: 'Desar els canvis',
          SAVED: 'Dades desades',
          NO_CHANGES: 'No hi ha canvis per desar.',
          FIX_FIELDS: 'Revisa els camps obligatoris.',
          SAVE_ERROR: 'No s’han pogut desar les dades.',
        },
        FOLLOWUP: {
          CONTACT_TITLE: 'Contacte',
          COPY_EMAIL: 'Copiar el correu',
          EMAIL_COPIED: 'Correu copiat',
          NOTES_TITLE: 'Notes de seguiment',
          NOTES_SUB: 'El que parles amb l’empresa. WAIIS també les veu.',
          NEW_NOTE: 'Escriu una nota…',
          ADD: 'Afegir',
          EMPTY: 'Encara sense notes',
          LOAD_ERROR: 'No s’han pogut carregar les notes.',
          SAVE_ERROR: 'No s’ha pogut desar la nota.',
          SYSTEM: 'Sistema',
          UNKNOWN_AUTHOR: 'Usuari',
        },
        WALLET: {
          BAG_TITLE: 'Bossa de {{month}} · 1/12 del pla anual',
          BAG_SUB: 'El que no es gasta s’acumula per al mes següent.',
          MONTHLY: '{{amount}} cada mes del pla anual',
          AVAILABLE: 'Saldo disponible a la cartera: {{amount}}',
          INACTIVE_TITLE: 'S’activa amb el contracte',
          INACTIVE_TEXT: 'Durant la prova no hi ha bossa: comença amb el contracte.',
          MOVES_TITLE: 'Moviments del mes',
          MOVES_EMPTY: 'Cap moviment aquest mes.',
          MOVES_ERROR: 'No s’han pogut carregar els moviments.',
          LOAD_ERROR: 'No s’ha pogut carregar la cartera.',
        },
      },
      PARTNER_REQUESTS: {
        TABS_LABEL: 'Estat de la sol·licitud',
        TAB_NEW: 'Noves',
        TAB_CONTACTED: 'Contactades',
        TAB_CREATED: 'Alta creada',
        TAB_DISCARDED: 'Descartades',
        TITLE_TAB_NEW: 'Sol·licituds noves',
        TITLE_TAB_CONTACTED: 'Sol·licituds contactades',
        TITLE_TAB_CREATED: 'Sol·licituds amb alta creada',
        TITLE_TAB_DISCARDED: 'Sol·licituds descartades',
        INTRO: 'Empreses que han arribat al llindar d’un partner en registrar-se. Les gestiona el partner; aquí les veus totes, de tots.',
        COL_RECEIVED: 'Rebuda',
        COL_COMPANY: 'Empresa',
        COL_PARTNER: 'Partner',
        COL_EMPLOYEES: 'Empleats',
        COL_CONTACT: 'Contacte',
        COL_ORIGIN: 'Origen',
        COL_ACTIONS: 'Accions',
        ORIGIN_SIGNUP: 'Registre',
        EMPTY: 'No hi ha sol·licituds en aquest estat.',
        LOAD_ERROR: 'No s’han pogut carregar les sol·licituds.',
        RETRY: 'Tornar-ho a provar',
        FOOT: 'Es mostren {{shown}} de {{total}} sol·licituds',
        REASSIGN: 'Reassignar',
        REASSIGN_TITLE: 'Reassignar la sol·licitud',
        REASSIGN_CURRENT: 'Ara és de {{partner}}.',
        REASSIGN_TO: 'Nou partner',
        REASSIGN_HINT: 'La sol·licitud passa al panell del partner nou i deixa de sortir al de l’actual.',
        REASSIGN_CONFIRM: 'Reassignar',
        REASSIGNING: 'Reassignant…',
        REASSIGN_ERROR: 'No s’ha pogut reassignar la sol·licitud.',
        CREATE_COMPANY: 'Crear empresa',
        PARTNER_SUBTITLE: 'Empreses grans que han demanat WAIIS amb tu en registrar-se: contacta-hi i crea’n l’empresa.',
        PARTNER_INTRO: 'Tria una sol·licitud per veure’n les dades i què hi pots fer.',
        EMPTY_NEW_PARTNER: 'Estàs al dia. Les noves sol·licituds apareixeran aquí.',
        DETAIL_TITLE: 'Dades del registre de {{company}}',
        DETAIL_TAX_ID: 'CIF',
        DETAIL_EMAIL: 'Correu',
        DETAIL_PHONE: 'Telèfon',
        DETAIL_REASON: 'Motiu del descart',
        CREATE_FROM_REQUEST: 'Crear l’empresa amb aquestes dades',
        MARK_CONTACTED: 'Marcar com a contactada',
        DISCARD: 'Descartar',
        RESTORE: 'Recuperar la sol·licitud',
        DISCARD_TITLE: 'Per què la descartes?',
        DISCARD_TEXT: 'L’avisem per correu que no seguiu endavant.',
        DISCARD_CONFIRM: 'Descartar la sol·licitud',
        DISCARD_REASON_SIZE: 'No encaixa per mida',
        DISCARD_REASON_OTHER_PROVIDER: 'Ja treballa amb un altre proveïdor',
        DISCARD_REASON_NO_RESPONSE: 'No respon',
        DISCARD_REASON_DUPLICATE: 'Duplicada',
        CONTACTED: '{{company}} passa a contactades',
        DISCARDED: '{{company}} descartada',
        RESTORED: '{{company}} torna a noves',
      },
      PARTNERS: {
        USERS: {
          TITLE: 'Usuaris del partner',
          SUBTITLE: 'Qui entra al panell de {{partner}}: Partner admin (gestiona) i Partner usuari (només consulta).',
          NOTE: 'Els gestiona {{partner}} des del seu panell.',
        },
        PAYOUT: {
          TITLE: 'Termini de l’abonament de la bonificació CAE',
          NOTE: 'El fixa {{partner}} des del seu panell.',
        },
        BILLING: {
          TITLE: 'Facturació',
          SUBTITLE: 'Client de Stripe al qual WAIIS factura {{partner}} i liquidació del pla anual.',
          CUSTOMER_TITLE: 'Client de Stripe',
          CUSTOMER_TEXT: 'Client al qual WAIIS factura la bossa de les empreses en què {{partner}} factura.',
          CUSTOMER_ID: 'Id del client a Stripe',
          SAVE: 'Desar',
          NAME: 'Nom a Stripe',
          EMAIL: 'Correu a Stripe',
          NO_CUSTOMER: 'Sense client de Stripe: no se li pot facturar.',
          SAVED: 'Client de Stripe de {{partner}} desat',
          STRIPE_UNAVAILABLE: 'No s\'ha pogut contactar amb Stripe. Torna-ho a provar.',
          SAVE_ERROR: 'No s\'ha pogut desar el client de Stripe.',
          LOAD_ERROR: 'No s\'ha pogut carregar el client de Stripe.',
          SETTLEMENT_TITLE: 'Liquidació del pla anual',
          SETTLEMENT_TEXT: 'Per empresa i període: el que s\'ha cobrat, el que ha anat a la bossa i el que correspon a {{partner}}.',
          FROM: 'Des de',
          TO: 'Fins a',
          DOWNLOAD: 'Descarregar CSV',
          DATES_HINT: 'Data de cobrament, tots dos dies inclosos.',
          SETTLEMENT_HELP: 'A les files cobrades per Connect es paga la «Diferència», no la «Part del partner». La «Bossa no assignada» és a retornar o compensar.',
          DOWNLOAD_ERROR: 'No s\'ha pogut descarregar la liquidació.',
        },
        TABS: {
          DATA: 'Dades i accés',
          LARGE: 'Grans comptes',
          DEFAULTS: 'Preus i mesos de prova',
          SECTIONS: 'Què veu l’empresa',
          USERS: 'Usuaris del partner',
          PAYOUT: 'Abonament a conductors',
          BILLING: 'Facturació',
        },
        SETTINGS_ERROR: 'No s’ha pogut carregar la configuració del partner.',
        LARGE: {
          TITLE: 'Grans comptes',
          SUBTITLE: 'Si {{partner}} rep les empreses grans que es registren a WAIIS i a qui s’avisa.',
          FLAG: 'Partner de grans comptes',
          THRESHOLD: 'Llindar d’empleats',
          THRESHOLD_HINT: 'Les empreses amb més empleats que aquest nombre envien una sol·licitud al partner en lloc de crear el seu espai.',
          FROM_NOW: 'S’aplica als registres a partir d’ara.',
          THRESHOLD_INVALID: 'Escriu un nombre enter més gran que 0.',
          EMAILS: 'Correus d’avís',
          EMAILS_HINT: 'Reben cada sol·licitud nova. Sense cap, només li arriba a WAIIS.',
          ADD_EMAIL: 'Afegir',
          REMOVE_EMAIL: 'Treure {{email}}',
          EMAIL_INVALID: 'Escriu un correu vàlid.',
          SAVE: 'Desar',
          SAVED: 'Grans comptes de {{partner}} desats',
          OK: 'D’acord',
          SAVE_ERROR: 'No s’han pogut desar els grans comptes.',
        },
        DEFAULTS: {
          TITLE: 'Preus i mesos de prova',
          SUBTITLE: 'El que reben per defecte les empreses noves de {{partner}}.',
          NOTE: 'Els fixa {{partner}} des del seu panell.',
          WALLET: 'Repartiment per defecte · {{percent}} % a la bossa',
          TRIAL_MONTHS: 'Mesos de prova gratis per defecte · {{months}}',
        },
        ADMINS: {
          TITLE: 'Partner admin',
          SUBTITLE: 'Qui administra {{partner}}: veu i gestiona les seves empreses i convida el seu equip. S\'assigna per invitació: li arriba un correu, vàlid 7 dies, i passa a ser Partner admin en acceptar-lo.',
          COL_PERSON: 'Persona',
          COL_STATUS: 'Estat',
          COL_DATE: 'Data',
          COL_ACTIONS: 'Accions',
          STATUS_ACTIVE: 'Actiu',
          STATUS_PENDING: 'Invitació pendent',
          STATUS_EXPIRED: 'Invitació caducada',
          SINCE: 'Des de {{date}}',
          EXPIRES_ON: 'Caduca {{date}}',
          EXPIRED_ON: 'Va caducar {{date}}',
          EMPTY: 'Encara no té Partner admin. Convida algú a sota.',
          LOAD_ERROR: 'No s\'han pogut carregar els Partner admin.',
          EMAIL: 'Assigna Partner admin',
          EMAIL_PLACEHOLDER: 'nom@empresa.com',
          EMAIL_INVALID: 'Escriu un correu vàlid.',
          EMAIL_HINT: 'Li enviarem la invitació a aquest correu.',
          INVITE: 'Envia la invitació',
          INVITING: 'Enviant…',
          INVITED: 'Invitació enviada a {{email}}.',
          INVITE_ERROR: 'No s\'ha pogut enviar la invitació.',
          RESEND: 'Reenvia la invitació',
          RESENT: 'Invitació reenviada a {{email}}.',
          ACTION_ERROR: 'No s\'ha pogut completar l\'acció.',
          REMOVE: 'Treu el Partner admin',
          REMOVE_TITLE: 'Treu el Partner admin',
          REMOVE_TEXT: '{{name}} deixarà d\'administrar {{partner}}.',
          REMOVING: 'Traient…',
          REMOVED: 'Tret',
          CANCEL: 'Cancel·la la invitació',
          CANCEL_TITLE: 'Cancel·la la invitació',
          CANCEL_TEXT: 'L\'enllaç que li va arribar a {{email}} deixarà de valer.',
          CANCELLING: 'Cancel·lant…',
          CANCELLED: 'Cancel·lada',
          KEEP: 'Torna',
        },
        TUTORS_COUNT: 'Tutors: {{count}}',
        CREATE: {
          TUTOR_EMAIL: 'Primer tutor (Partner admin)',
          TUTOR_EMAIL_HINT: 'Li arribarà una invitació per correu, vàlida 7 dies, per unir-se al partner. No es crea cap compte fins que l\'accepti.',
          SECTIONS_NOTE: 'Les seves empreses veuen les seccions que configuris a «Què veu l’empresa»; fins aleshores, totes ocultes.',
          SUBTITLE: 'En donar-lo d’alta es convida el seu primer Partner admin. La resta es configura a les seves pestanyes.',
          SLUG: 'Identificador',
          SLUG_HINT: 'Minúscules, números i guions. S’usa a la marca dels seus correus i no es canvia després.',
        },
        DATA: {
          SAVE: 'Desa les dades',
          SAVING: 'Desant…',
          SAVED: 'Dades del partner desades.',
          TITLE: 'Dades de {{partner}}',
          SUBTITLE: 'Nom i logo per a la marca compartida, i qui l’administra.',
          NAME: 'Nom',
          LOGO: 'Logo',
          NO_LOGO: 'Sense logo',
          UPLOADING: 'Pujant…',
          CHANGE_LOGO: 'Canviar',
        },
        SECTIONS: {
          TITLE: 'Què veu cada empresa al seu dashboard',
          SUBTITLE: 'S\'aplica igual a totes les empreses de {{partner}}. Limita els seus admins i els de les seves seus; {{partner}} sempre ho veu tot.',
          COL_SECTION: 'Secció',
          COL_ACCESS: 'Què veu l\'empresa',
          MODE_NORMAL: 'Normal',
          MODE_READONLY: 'Només lectura',
          MODE_HIDDEN: 'Oculta',
          MANAGED_BY: 'la gestiona {{partner}}',
          RETRY: 'Torna-ho a provar',
          DISCARD_TITLE: 'Descarta els canvis de seccions de {{partner}}',
          DISCARD_TEXT: 'Els canvis que no has aplicat es perden.',
          DISCARD_CONFIRM: 'Descarta',
          DISCARD_CANCEL: 'Continua editant',
          ERROR_APPLY_ALL: 'No s\'han pogut aplicar les seccions. No ha canviat cap empresa.',
          ERROR_FORBIDDEN_ALL: 'Només un administrador de WAIIS pot aplicar seccions a totes les empreses d\'un partner.',
          ERROR_PARTNER_NOT_FOUND: 'Aquest partner ja no existeix.',
          WALLET: 'Cartera',
          SAVE: 'Desar',
          SAVED: 'S’aplica al moment a totes les empreses de {{partner}}.',
        },
      },
      PARTNER_PAYMENTS: {
        SUBTITLE: "Condicions d'abonament als conductors en els viatges de les empreses vinculades a {{name}}.",
        SCOPE: 'Totes les empreses de {{name}}',
        TERMS_TITLE: "Termini de l'abonament de la bonificació CAE",
        TERMS_SUB: "Dies naturals des de la data del viatge fins a l'abonament a la wallet del conductor.",
        DAYS: '{{days}} dies',
        EXAMPLE_TRIP: 'Viatge del {{date}}, abonament el',
        TERMS_ERROR: "No s'ha pogut carregar el termini.",
        LAST_CHANGE: 'Última modificació: {{date}}',
        DISCARD: 'Descartar',
        SAVE: 'Desar canvis',
        SAVING: 'Desant…',
        SAVED: 'Desat',
        SAVE_ERROR: "No s'ha pogut desar el termini.",
        CALENDAR_TITLE: "Calendari d'abonaments",
        CALENDAR_SUB: "Bonificacions CAE pendents d'abonament.",
        PENDING_AMOUNT: 'Import pendent',
        NEXT_PAYOUT: 'Proper abonament',
        COL_PAYOUT_DATE: "Data d'abonament",
        COL_AMOUNT: 'Import',
        TODAY: 'Avui',
        EMPTY: 'No hi ha abonaments pendents.',
        CALENDAR_ERROR: "No s'ha pogut carregar el calendari d'abonaments.",
        TAB_DEFAULTS: 'Preu anual i bossa',
        TAB_PAYOUT: 'Abonament a conductors',
        DEFAULTS_TITLE: 'Preu anual i bossa',
        DEFAULTS_SUB: 'El que es proposa a cada empresa nova. Cada empresa pot tenir després el seu propi preu.',
        DEFAULTS_ERROR: 'No s’han pogut carregar els valors per defecte.',
        DEFAULT_SPLIT: 'Repartiment per defecte',
        DEFAULT_TRIAL: 'Mesos de prova gratuïta per a empreses noves',
        DEFAULT_TRIAL_HINT: 'No canvia les proves que ja estan en marxa.',
        SIMULATOR: 'Import anual acordat',
        SIMULATOR_PLACEHOLDER: 'P. ex.: 12000',
        DEFAULTS_SAVED: 'Valors per defecte desats',
        DEFAULTS_SAVE_ERROR: 'No s’han pogut desar els valors per defecte.',
        PAYOUTS: 'Abonaments',
        SCHEDULED: 'El termini de {{days}} dies val des del {{date}}.',
        RETRY: 'Tornar-ho a provar',
      },
      PARTNER_USERS: {
        TITLE: 'Usuaris de {{name}}',
        TITLE_GENERIC: 'Usuaris',
        SUBTITLE: 'Les persones de {{name}} amb accés al dashboard. Només el Partner admin pot convidar o treure gent.',
        INVITE: 'Convidar usuari',
        COL_USER: 'Usuari',
        COL_ROLE: 'Rol',
        COL_STATUS: 'Estat',
        ACTIONS: 'Accions',
        YOU: '(tu)',
        ROLE_ADMIN: 'Partner admin',
        ROLE_USER: 'Partner usuari',
        STATUS_ACTIVE: 'Actiu',
        STATUS_INVITED: 'Invitació pendent',
        TODAY: 'Avui',
        YESTERDAY: 'Ahir',
        LOAD_ERROR: "No s'han pogut carregar els usuaris.",
        RETRY: 'Tornar-ho a provar',
        EMPTY: 'Encara no hi ha ningú amb accés.',
        RESEND: 'Reenviar invitació',
        REMOVE: "Treure l'accés",
        REMOVE_TEXT: '{{name}} ja no podrà entrar al dashboard de {{partner}}.',
        RESENT: 'Invitació reenviada a {{email}}.',
        INVITED: 'Invitació enviada a {{email}}.',
        ACTION_ERROR: "No s'ha pogut completar l'acció.",
        INVITE_TITLE: 'Convidar usuari',
        INVITE_SUB: 'Li arribarà un correu amb un enllaç, vàlid 7 dies, per unir-se a l\'equip de {{name}}.',
        EMAIL: 'Email',
        EMAIL_PLACEHOLDER: 'nom@empresa.com',
        EMAIL_INVALID: 'Escriu un email vàlid.',
        ROLE: 'Rol',
        INVITE_ERROR: "No s'ha pogut enviar la invitació.",
        CANCEL: 'Cancel·lar',
        SEND: 'Enviar invitació',
        SENDING: 'Enviant…',
        CANCEL_INVITE: 'Cancel·la la invitació',
        CANCEL_INVITE_TITLE: 'Cancel·la la invitació',
        CANCEL_INVITE_TEXT: 'L\'enllaç que li va arribar a {{email}} deixarà de valer.',
        CANCELLING_INVITE: 'Cancel·lant…',
        CANCELLED_INVITE: 'Invitació cancel·lada',
        COL_COMPANIES: 'Empreses a càrrec',
        COL_LAST_ACCESS: 'Darrer accés',
        NAME: 'Nom',
        NAME_REQUIRED: 'Escriu-ne el nom.',
        ROLE_ADMIN_HINT: 'Crea empreses, fixa preus i convida usuaris',
        ROLE_USER_HINT: 'Només consulta empreses i dades',
        MAKE_ADMIN: 'Canviar el rol a Partner admin',
        MAKE_USER: 'Canviar el rol a Partner usuari',
        REMOVE_ASK: 'Treure l’accés a {{name}}?',
        REMOVE_CONFIRM: 'Sí, treure l’accés',
        REMOVED_NAME: '{{name}} ja no té accés.',
        ROLE_ASK: 'Passar {{name}} a {{role}}?',
        ROLE_TEXT: '{{name}} passarà a ser {{role}} de {{partner}}.',
        ROLE_CONFIRM: 'Canviar el rol',
        ROLE_CHANGED: '{{name}} ara és {{role}}.',
        REASSIGN_TO: 'A quin Partner admin passen les seves {{n}} empreses?',
        REASSIGN_LABEL: 'Nou gestor',
        REASSIGN_NONE: 'No hi ha cap altre Partner admin: convida’n un abans.',
      },
      COMPANIES: {
        CREATE: {
          TITLE: 'Nova empresa',
          SUBTITLE: 'Se’n crea l’espai i es convida el seu administrador per correu.',
          SUBTITLE_REQUEST: 'Amb les dades de la sol·licitud: tria qui la gestiona al partner.',
          CLOSE: 'Tancar',
          SECTION_COMPANY: 'Empresa',
          SECTION_ADMIN: 'Administrador',
          SECTION_PARTNER: 'Partner',
          LEGAL_NAME: 'Raó social',
          TAX_ID: 'CIF',
          CITY: 'Ciutat',
          EMPLOYEES: 'Nre. d’empleats',
          ADMIN_NAME: 'Nom i cognoms',
          ADMIN_EMAIL: 'Correu de l’administrador',
          ADMIN_EMAIL_PLACEHOLDER: 'nom@empresa.com',
          ADMIN_EMAIL_HINT: 'Li arribarà una invitació per entrar al dashboard de l’empresa.',
          PARTNER: 'Partner',
          PARTNER_WAIIS: 'WAIIS (per defecte)',
          PARTNER_NOTE: 'Si tries un partner, l’empresa apareix al seu panell i n’hereta els preus, els mesos de prova gratis i els permisos.',
          MANAGER: 'Gestor del partner',
          MANAGER_HINT: 'El Partner admin que portarà l’empresa.',
          ERROR_REQUIRED: 'Aquest camp és obligatori.',
          ERROR_EMAIL: 'Escriu un correu vàlid.',
          ERROR_EMPLOYEES: 'Indica almenys 1 empleat.',
          ERROR_MANAGER: 'Tria el gestor de l’empresa.',
          ERROR_SAVE: 'No s’ha pogut crear l’empresa.',
          CANCEL: 'Cancel·lar',
          SUBMIT: 'Crear empresa',
          CREATING: 'Creant…',
          DONE_INVITED: 'Empresa creada. Invitació enviada a {{email}}',
          DONE_LINKED: 'Empresa creada. {{email}} ja pot entrar com a administrador',
          DONE_OK: 'D’acord',
        },
        ONBOARDING: {
          GRAN_DAY: 'Dia',
          GRAN_WEEK: 'Setmana',
          GRAN_MONTH: 'Mes',
          HINT_DAY: 'Últims 30 dies',
          HINT_WEEK: 'Últimes 12 setmanes',
          HINT_MONTH: 'Últims 12 mesos',
          IN_PERIOD_DAY: 'els últims 30 dies',
          IN_PERIOD_WEEK: 'les últimes 12 setmanes',
          IN_PERIOD_MONTH: 'els últims 12 mesos',
          INSIGHT_ALL_DONE: 'totes han completat l\'onboarding',
          INSIGHT_ONE_PENDING: '1 continua pendent d\'activar',
          INSIGHT_N_PENDING: '{{n}} continuen pendents d\'activar',
          INSIGHT_ONE: '{{n}} alta en {{period}}; {{pending}}.',
          INSIGHT_OTHER: '{{n}} altes en {{period}}; {{pending}}.',
          TILE_UNSEEN: 'Noves sense revisar',
          TILE_UNSEEN_SUB: 'últims 90 dies',
          TILE_UNSEEN_HINT: 'Encara no has obert la seva fitxa',
          TILE_ALL_REVIEWED: 'Tot revisat',
          TILE_TODAY: 'Altes avui',
          TILE_TODAY_HINT: '{{n}} en els últims 30 dies',
          TILE_WEEK: 'Altes aquesta setmana',
          TILE_WEEK_HINT: 'Des de dilluns',
          TILE_MONTH: 'Altes aquest mes',
          TILE_MONTH_HINT: '{{n}} pendents d\'activar (90 dies)',
          TITLE: 'Altes en onboarding',
          SUBTITLE: 'Empreses que han començat l\'alta a WAIIS. Les noves sense revisar es destaquen en blau al llistat.',
          GRANULARITY: 'Granularitat',
          LOADING: 'Carregant altes…',
          KPIS_LABEL: 'Indicadors d\'altes',
          VIEW_IN_TABLE: 'Mostra a la taula',
          BY_DAY: 'Altes per dia',
          BY_WEEK: 'Altes per setmana',
          BY_MONTH: 'Altes per mes',
          CHART_Q: '{{period}} · {{n}} altes',
          LEGEND_DONE: 'Onboarding completat',
          LEGEND_PENDING: 'Pendent d\'activar',
          EMPTY: 'No hi ha altes en aquest període.',
          TIP_DONE: 'Completat:',
          TIP_PENDING: 'Pendent:',
          TIP_TOTAL: 'Total:',
          VIEW_DATA: 'Mostra les dades',
          COL_PERIOD: 'Període',
          COL_DONE: 'Completat',
          COL_PENDING: 'Pendent',
        },
        INCENTIVES_TAB: {
          READ_ONLY: 'Vista només de lectura. Les campanyes es configuren i s\'envien des del dashboard de l\'empresa.',
          MANAGE: 'Gestiona els incentius',
          LOADING: 'Carregant incentius…',
          LOCKED: 'El mòdul d\'incentius no està inclòs en el pla actual d\'aquesta empresa.',
          VIEW_PLAN: 'Mostra el pla de l\'empresa',
          SEGMENTS_LABEL: 'Empleats per segment a incentivar',
          CAMPAIGNS_TITLE: 'Campanyes d\'incentius',
          NO_CAMPAIGNS: 'Encara no s\'ha enviat cap campanya.',
          LAST_CAMPAIGNS: 'Últimes {{shown}} de {{total}} campanyes.',
          COL_RECIPIENTS: 'Destinataris',
          COL_COMMITTED: 'Compromès',
          COL_THRESHOLD: 'Llindar d\'inactivitat',
          COL_DETAIL: 'Detall',
          DAYS: '{{n}} dies',
          ONE_OFFICE: 'Només una seu',
          ERROR_LOAD: 'No s\'ha pogut carregar la informació d\'incentius.',
          SEG_NOT_REGISTERED: 'Sense registrar',
          SEG_NOT_REGISTERED_HINT: 'Empleats en plantilla que encara no s\'han donat d\'alta a l\'app',
          SEG_DNI: 'DNI pendent',
          SEG_DNI_HINT: 'Registrats sense verificar la identitat',
          SEG_NO_TRIPS: 'Sense viatges',
          SEG_NO_TRIPS_HINT: 'Registrats que encara no han compartit cap viatge',
          SEG_INACTIVE: 'Inactius',
          SEG_INACTIVE_HINT: 'Sense viatges en els últims {{n}} dies',
          ST_IN_PROGRESS: 'En curs',
          ST_COMPLETED: 'Completada',
          ST_CANCELLED: 'Cancel·lada',
          ST_SCHEDULED: 'Programada',
          ST_SENT: 'Enviada',
          ST_FAILED: 'Fallida',
        },
        TRAVELS_TAB: {
          LAST_DAYS: 'Últims {{n}} dies',
          OFFICE_ALL: 'Seu: totes',
          SEARCH_PLACEHOLDER: 'Cerca per conductor, passatger o adreça…',
          SEARCH_LABEL: 'Cerca viatge',
          RANGE: 'Interval',
          REPORT: 'Informe de viatges',
          COL_ROUTE: 'Ruta',
          COL_DRIVER: 'Conductor',
          COL_PASSENGERS: 'Passatgers',
          COL_AMOUNT: 'Import',
          LOADING: 'Carregant viatges…',
          EMPTY: 'No hi ha viatges d\'empleats d\'aquesta empresa en l\'interval seleccionat.',
          ERROR_LOAD: 'No s\'han pogut carregar els viatges.',
          FOOT: 'Es mostren <b>{{shown}}</b> de <b>{{total}}</b> viatges',
        },
        PMST_TAB: {
          TITLE: 'Pla de Mobilitat Sostenible a la Feina',
          SUBTITLE: 'Obligatori per a empreses de més de 200 empleats. El qüestionari s\'emplena per empresa i per seu.',
          OPEN: 'Obre el PMST al dashboard',
          ENABLED: 'PMST activat per l\'empresa',
          DISABLED: 'PMST desactivat per l\'empresa',
          OFFICES_DONE: '{{done}} de {{total}} amb el qüestionari complet',
          NO_OFFICES: 'Sense seus donades d\'alta.',
          INACTIVE: '· inactiva',
          DOCS_TITLE: 'Documents i informes',
          DOCS_SUB: 'Fitxers PMST pujats per l\'empresa o per WAIIS.',
          LOADING_DOCS: 'Carregant documents…',
          COL_DOCUMENT: 'Document',
          COL_UPLOADED: 'Pujat',
          EMPTY: 'No hi ha documents PMST per a aquesta empresa.',
          DOWNLOAD: 'Baixa',
          DOWNLOAD_DOC: 'Baixa el document',
          ERROR_LOAD: 'No s\'han pogut carregar els documents PMST.',
          ERROR_DOWNLOAD: 'No s\'ha pogut baixar el document.',
          QUESTIONNAIRE_DONE: 'Qüestionari complet',
          QUESTIONNAIRE_PENDING: 'Qüestionari pendent',
        },
        OFFICES_TAB: {
          COUNT_ONE: 'seu donada d\'alta',
          COUNT_OTHER: 'seus donades d\'alta',
          DECLARED: '· {{n}} declarades a l\'alta',
          MANAGE: 'Gestiona les seus al dashboard',
          EMPTY: 'Aquesta empresa no té seus donades d\'alta.',
          NOT_APPLICABLE: 'No s\'hi aplica',
          VIEW_EMPLOYEES: 'Mostra els empleats de la seu',
          VIEW_OFFICE: 'Mostra la seu',
        },
        EMPLOYEES_TAB: {
          SEARCH_PLACEHOLDER: 'Cerca empleat, correu, DNI o departament…',
          SEARCH_LABEL: 'Cerca empleat',
          OFFICE_ALL: 'Seu: totes',
          STATUS_ALL: 'Estat: tots',
          FILTER_REGISTERED: 'Registrats',
          FILTER_PENDING: 'Pendents de registre',
          FILTER_INACTIVE: 'Inactius',
          MANAGE: 'Gestiona al dashboard',
          COL_DEPARTMENT: 'Departament',
          COL_APP: 'App',
          LOADING: 'Carregant empleats…',
          ERROR_LOAD: 'No s\'han pogut carregar els empleats.',
          EMPTY_FILTERED: 'Cap empleat no coincideix amb els filtres.',
          EMPTY: 'Aquesta empresa encara no té empleats donats d\'alta.',
          VIEW_EMPLOYEE: 'Mostra l\'empleat',
          FOOT: 'Es mostren <b>{{shown}}</b> de <b>{{total}}</b> empleats',
          ST_INACTIVE: 'Inactiu',
          ST_REGISTERED: 'Registrat',
          ST_PENDING: 'Pendent',
          ST_PENDING_HINT: 'Encara no s\'ha registrat a l\'app',
          LINKED: 'Vinculat',
          LINKED_HINT: 'Compte de l\'app vinculat',
          NOT_LINKED: 'Sense vincular',
          STATUS_CODE: {
            activo: 'Actiu',
            con_rutina: 'Amb rutina',
            vinculado: 'Vinculat',
            inactivo: 'Inactiu',
            pendiente: 'Pendent',
            rechazado: 'Rebutjat',
          },
        },
        DATA_TAB: {
          TITLE: 'Dades de l\'empresa',
          SUBTITLE: 'Identitat fiscal, persona de contacte i adreça. Els canvis es desen al moment.',
          SEC_IDENTITY: 'Identitat',
          TRADE_NAME: 'Nom comercial',
          LEGAL_NAME: 'Raó social',
          TAX_ID: 'CIF / NIF',
          SECTOR: 'Sector',
          OPTIONAL: 'Opcional',
          SEC_CONTACT: 'Persona de contacte',
          NAME: 'Nom',
          SEC_FISCAL: 'Adreça fiscal',
          CITY: 'Ciutat',
          POSTAL_CODE: 'Codi postal',
          SEC_STATUS: 'Estat',
          ACTIVE: 'Empresa activa',
          PMST_ENABLED: 'PMST activat',
          STATUS_HELP: 'Una empresa inactiva deixa d\'aparèixer a l\'app per als seus empleats. Desactivar el PMST amaga la secció de Pla de Mobilitat al seu dashboard.',
          DISCARD: 'Descarta',
          SAVING: 'Desant…',
          SAVE: 'Desa els canvis',
          INVITE_TITLE: 'Codi d\'invitació',
          INVITE_SUB: 'Amb aquest codi els empleats vinculen el seu compte de l\'app a l\'empresa.',
          CODE_COPIED: 'Codi copiat',
          COPY_CODE: 'Copia el codi',
          NO_CODE: 'Sense codi generat.',
          INVITE_LINK: 'Enllaç de vinculació',
          PLAN: 'Pla',
          PLAN_BILLING: 'Pla i facturació',
          PLAN_MANAGED_BY_WAIIS: 'El pla el gestiona WAIIS. Per canviar-lo, escriu-nos.',
          PARTNER: 'Partner',
          PARTNER_READ_ONLY: 'Només el canvia WAIIS',
          SETTINGS_LINK: 'Logotip, administradors i contracte',
          FIX_FIELDS: 'Revisa els camps marcats abans de desar.',
          NO_CHANGES: 'No hi ha canvis per desar.',
          SAVED: 'Dades desades.',
          SAVE_ERROR: 'No s\'han pogut desar les dades.',
          NO_PLAN_ASSIGNED: 'Sense pla assignat',
          PLAN_ACTIVE: 'actiu',
          PLAN_EXPIRED: 'caducat',
          PLAN_CANCELLED: 'cancel·lat',
          PLAN_UNTIL: ' · fins al {{date}}',
          ERR_REQUIRED: 'Obligatori',
          ERR_EMAIL: 'Correu electrònic no vàlid',
          ERR_PATTERN: 'Format no vàlid',
          ERR_TOO_LONG: 'Massa llarg',
          ERR_CIF: 'CIF/NIF no vàlid',
          ERR_INVALID: 'Valor no vàlid',
        },
        DETAIL: {
          TAB_EMPLOYEES: 'Empleats',
          TAB_OFFICES: 'Seus',
          TAB_TRIPS: 'Viatges',
          TAB_INCENTIVES: 'Incentius',
          TAB_PMST: 'PMST / informes',
          TAB_DATA: 'Dades',
          ERROR_NOT_FOUND: 'No s\'ha trobat l\'empresa.',
          ERROR_FORBIDDEN: 'No tens permís per veure aquesta empresa.',
          ERROR_LOAD: 'No s\'ha pogut carregar l\'empresa.',
          KPI_REGISTERED: 'Empleats registrats',
          KPI_REGISTERED_HINT: '{{total}} en plantilla · {{active}} actius',
          KPI_CARPOOLING: 'En carpooling (mes)',
          KPI_SHARED_TRIPS: 'Viatges compartits (mes)',
          KPI_CO2: 'CO₂e evitat (mes)',
          META_TAX_ID: 'CIF {{value}}',
          TRIAL_ENDS: 'Prova · acaba el {{date}}',
          TRIAL_END_CHANGE: 'Canviar la fi de la prova',
          TAB_SUMMARY: 'Resum',
          TAB_CONTRACT: 'Contracte i preu',
          TAB_WALLET: 'Cartera',
          TAB_FOLLOWUP: 'Seguiment',
          PARTNER_KPI_REGISTERED_HINT: '{{percent}} % de {{total}} en plantilla',
          PARTNER_KPI_TRIPS_CHANGE: '{{percent}} % respecte al mes anterior',
          PARTNER_KPI_CO2_TOTAL: 'CO₂e evitat des de l’alta',
          PARTNER_TRIAL_NOTE: 'La prova acaba el {{date}} · queden {{days}} dies.',
          PARTNER_TRIAL_NOTE_MISSING: 'La prova acaba el {{date}} · queden {{days}} dies. Falta {{items}}.',
          PARTNER_RESENT: 'Invitació reenviada a {{email}}',
          PARTNER_CALL: 'Trucar',
          PARTNER_WRITE: 'Escriure',
          PARTNER_RESEND: 'Reenviar la invitació',
          PARTNER_DASHBOARD: 'Veure el seu dashboard',
          PARTNER_GO_CONTRACT: 'Anar al contracte',
          PARTNER_KPI_TONS: '{{value}} t',
          TRIAL_END_LABEL: 'Últim dia de la prova',
          TRIAL_END_HINT: 'Ha de ser posterior a avui. Si l’empresa estava bloquejada, torna a la prova.',
          TRIAL_END_SAVE: 'Desar',
          TRIAL_END_SAVING: 'Desant…',
          TRIAL_END_ERROR: 'No s’ha pogut canviar la data de fi de la prova.',
          TOPUP_LIMIT: 'Límit de la bossa mensual',
          TOPUP_LIMIT_GENERAL: 'General: {{max}} €',
          TOPUP_LIMIT_CUSTOM: 'Propi d’aquesta empresa: {{max}} €',
          TOPUP_LIMIT_LABEL: 'Límit nou, en euros al mes',
          TOPUP_LIMIT_HINT: 'Pot ser més gran o més petit que el general. L’import que l’empresa ja ha desat no canvia.',
          TOPUP_LIMIT_SAVE: 'Desa',
          TOPUP_LIMIT_SAVING: 'Desant…',
          TOPUP_LIMIT_RESET: 'Torna al general',
          TOPUP_LIMIT_LOADING: 'Carregant el límit…',
          TOPUP_LIMIT_LOAD_ERROR: 'No s’ha pogut llegir el límit de la bossa.',
          TOPUP_LIMIT_ERROR: 'No s’ha pogut desar el límit de la bossa.',
          META_PLAN: 'Pla {{value}}',
          BACK: 'Torna a empreses',
          BREADCRUMB: 'Ruta de navegació',
          COMPANIES: 'Empreses',
          LOADING: 'Carregant l\'empresa…',
          BACK_TO_LIST: 'Torna al llistat',
          EDIT: 'Edita',
          ENTER_DASHBOARD: 'Entra al dashboard',
          ENTER_DASHBOARD_TOOLTIP: 'Mostra el dashboard tal com el veu l\'empresa',
          CONTACT_PERSON: 'Persona de contacte',
          KPIS_LABEL: 'Indicadors del mes en curs',
          TABS_LABEL: 'Secció de l\'empresa',
        },
        COMMON: {
          RETRY: 'Torna-ho a provar',
          PREVIOUS: 'Anterior',
          NEXT: 'Següent',
          PREV_PAGE: 'Pàgina anterior',
          NEXT_PAGE: 'Pàgina següent',
          CLEAR_FILTERS: 'Neteja els filtres',
          LOADING: 'Carregant…',
          ACTIONS: 'Accions',
          STATUS: 'Estat',
          PER_PAGE: '{{n}} per pàgina',
          SHOWING: 'Es mostren {{shown}} de {{total}}',
          VS_PREV_MONTH: '{{trend}} vs mes anterior',
          EMPLOYEE: 'Empleat',
          OFFICE: 'Seu',
          OFFICES: 'Seus',
          EMPLOYEES: 'Empleats',
          PLAN: 'Pla',
          DATE: 'Data',
          EMAIL: 'Correu electrònic',
          PHONE: 'Telèfon',
          ADDRESS: 'Adreça',
          CONTACT: 'Contacte',
          TOTAL: 'Total',
        },
        FORMAT: {
          STATUS_PRE_LAUNCH: 'Abans de començar',
          STATUS_TRIAL: 'En prova',
          STATUS_TRIAL_DAYS: 'En prova · {{n}} dies',
          STATUS_LOCKED: 'Bloquejada',
          STATUS_ACTIVE: 'Activa',
          MISSING: 'falta {{items}}',
          MISSING_NONE: 'llesta',
          MISSING_BILLING: 'dades de facturació',
          MISSING_PAYMENT_METHOD: 'mètode de pagament',
          MISSING_CONTRACT: 'contracte',
          MISSING_ANNUAL_PLAN: 'pla anual',
          MISSING_PAYMENT: 'pagament',
          MISSING_INVOICE: 'pagament de la factura',
          PLAN_FREEMIUM: 'Freemium',
          PLAN_INCENTIVES: 'Incentius',
          NO_PLAN: 'Sense pla',
          NOT_AVAILABLE: 'Dada no disponible',
          SUB_ACTIVE: 'Subscripció activa',
          PLAN_EXPIRED: '{{plan}} · caducat',
          SUB_EXPIRED: 'Subscripció caducada',
          PLAN_CANCELLED: '{{plan}} · cancel·lat',
          SUB_CANCELLED: 'Subscripció cancel·lada',
          PMST_NOT_REQUESTED: 'No sol·licitat',
          PMST_NOT_REQUESTED_HINT: 'L\'empresa no ha activat el PMST',
          COMPLETED: 'Completat',
          PMST_COMPLETED_HINT: 'Qüestionari PMST complet a l\'empresa i les seus',
          PENDING: 'Pendent',
          PMST_PENDING_HINT: 'Qüestionari PMST sense completar',
          ACTIVE: 'Activa',
          INACTIVE: 'Inactiva',
        },
        LIST: {
          NEW_COMPANY: 'Nova empresa',
          ENDING_TITLE: '{{n}} proves acaben aviat amb dades pendents',
          ENDING_TITLE_ONE: 'Una prova acaba aviat amb dades pendents',
          ENDING_DAYS_LEFT: 'queden {{n}} dies',
          ENDING_DAYS_LEFT_ONE: 'queda 1 dia',
          SHOULD_BE_PARTNER: 'Hauria de ser de {{partner}}? +{{threshold}} empleats',
          SHOULD_BE_PARTNER_SHORT: 'Hauria de ser de {{partner}}?',
          DEGRADED_NOTE: 'El backend d\'aquest entorn encara no exposa el llistat amb agregats ({{endpoint}}): seus, empleats, viatges i pla apareixen buits i el filtre per pla està desactivat.',
          VIEW: 'Vista',
          TAB_COMPANIES: 'Empreses',
          TAB_DATA: 'Dades',
          SEARCH_PLACEHOLDER: 'Cerca empresa, CIF, contacte o ciutat…',
          SEARCH_LABEL: 'Cerca empresa',
          NEW_UNSEEN: 'Noves sense revisar',
          NEW_UNSEEN_TOOLTIP: 'Empreses donades d\'alta en els últims 90 dies que encara no has obert',
          COL_SIGNUP: 'Alta',
          COL_COMPANY: 'Empresa',
          COL_TRIPS_MONTH: 'Viatges (mes)',
          LOADING_COMPANIES: 'Carregant empreses',
          EMPTY_NEW: 'No hi ha empreses noves sense revisar. Tot al dia!',
          EMPTY_FILTERED: 'Cap empresa no coincideix amb els filtres.',
          EMPTY: 'Encara no hi ha empreses registrades.',
          NEW_PILL: 'Nova',
          NEW_PILL_TOOLTIP: 'Alta recent que encara no has obert',
          ENTER_DASHBOARD: 'Entra al dashboard de l\'empresa',
          EDIT_DATA: 'Edita les dades',
          VIEW_DETAIL: 'Mostra la fitxa',
          PER_PAGE_LABEL: 'Empreses per pàgina',
          FOOT: 'Es mostren {{shown}} de {{total}} empreses',
          FILTER_STATUS_ALL: 'Estat: tots',
          FILTER_PMST_ALL: 'PMST: totes',
          FILTER_PLAN_ALL: 'Pla: tots',
          COL_PARTNER: 'Partner',
          FILTER_PARTNER_ALL: 'Partner: tots',
          CHANGE_PARTNER: 'Canviar partner',
          CHANGE_PARTNER_CONSEQUENCES: 'Els permisos i el que veu l’empresa canvien al moment. El pla, la bossa, el contracte i la prova es tanquen a mà: l’empresa queda pendent de completar el seu compte amb {{partner}}.',
          PARTNER_TITLE: 'Empreses de {{name}}',
          PARTNER_SUBTITLE: "Les empreses que has donat d'alta amb WAIIS. Fes clic en una fila per veure'n la fitxa, o fes servir l'ull per entrar al seu dashboard tal com el veu l'empresa.",
          PARTNER_VIEW_NOTE: 'Estàs veient només les empreses de <strong>{{name}}</strong>.',
          ERROR_FORBIDDEN: 'No tens permís per veure el llistat d\'empreses.',
          ERROR_LOAD: 'No s\'ha pogut carregar el llistat d\'empreses.',
          TITLE_NEW: 'Empreses noves sense revisar',
          TITLE_ACTIVE: 'Empreses actives',
          TITLE_PRE_LAUNCH: 'Empreses abans de començar',
          TITLE_TRIAL: 'Empreses en prova',
          TITLE_LOCKED: 'Empreses bloquejades',
          TITLE_ALL: 'Totes les empreses',
          SUB_NEW: 'Altes dels últims 90 dies que encara no has obert.',
          SUB_PMST: 'PMST {{value}}',
          SUB_NO_PLAN: 'sense pla',
          SUB_PLAN: 'pla {{value}}',
          SUB_SEARCH: 'cerca «{{value}}»',
          SUB_FILTERED: 'Filtrat per {{filters}}.',
          SUB_DEFAULT: 'Empreses clients amb les seves seus, empleats, viatges del mes i pla.',
          AGO_TODAY: 'avui',
          AGO_YESTERDAY: 'ahir',
          AGO_DAYS: 'fa {{n}} dies',
          AGO_WEEKS: 'fa {{n}} setmanes',
          AGO_MONTHS: 'fa {{n}} mesos',
          AGO_ONE_YEAR: 'fa 1 any',
          AGO_YEARS: 'fa {{n}} anys',
        },
      },
      MATCH_LIST: {
        ALL: 'Tots',
        ITEMS: 'matchs',
        COL_DRIVER: 'Conductor',
        COL_ROUTINE: 'Rutina',
        COL_ROUTE_DATE: 'Data de la ruta',
        COL_PASSENGERS: 'Passatgers',
        COL_CREATED: 'Creat',
        FILTER_STATUS: 'Estat',
        FILTER_DRIVER: 'Conductor',
        FILTER_DATE_FROM: 'Data des de',
        FILTER_DATE_TO: 'Data fins a',
        REMOVE_FILTER: 'Treure {{label}}',
        OPEN_CALENDAR: 'Obrir el calendari',
        CLEAR: 'Netejar',
        STATUS: {
          INITIAL: 'Inicial',
          CONFIRMED: 'Confirmat',
          ONGOING: 'En curs',
          PENDING: 'Pendent',
          ACCEPTED: 'Acceptat',
          REJECTED: 'Rebutjat',
          CANCELLED: 'Cancel·lat',
          EXPIRED: 'Caducat',
        },
      },
      MATCH: {
        TITLE: 'Detall del match',
        SUBTITLE: 'Conductor, passatgers i trajecte del match, amb els seus mapes.',
        BACK: 'Tornar',
        LOADING: 'Carregant el match...',
        LOAD_ERROR: 'No s\'ha pogut carregar el match.',
        BACK_TO_LIST: 'Tornar al llistat',
        RETRY: 'Tornar-ho a provar',
        DRIVER: 'Conductor',
        PASSENGERS_ONE: '{{count}} passatger',
        PASSENGERS_OTHER: '{{count}} passatgers',
        CREATED: 'Creat',
        UPDATED: 'Actualitzat',
        DRIVER_ROUTE: 'Ruta del conductor',
        ROUTINE: 'Rutina',
        SCHEDULES: 'Horaris',
        COL_TYPE: 'Tipus',
        COL_ORIGINAL_ROUTE: 'Ruta original',
        COL_MATCH: 'Match',
        DEPARTURE: 'Sortida',
        ARRIVAL: 'Arribada',
        POINTS: 'Punts',
        ORIGIN: 'Origen',
        DESTINATION: 'Destinació',
        PICKUP: 'Pickup',
        DROPOFF: 'Dropoff',
        DROPOFF_X: 'Dropoff (X)',
        COPY_COORDINATES: 'Copiar les coordenades',
        COORDINATES_COPIED: 'Coordenades copiades',
        COPY_ORIGIN_ARIA: 'Copiar les coordenades d\'origen',
        COPY_DESTINATION_ARIA: 'Copiar les coordenades de destinació',
        VIEW_ORIGIN: 'Veure l\'origen al mapa',
        VIEW_DESTINATION: 'Veure la destinació al mapa',
        VIEW_DRIVER_ORIGIN_ARIA: 'Veure l\'origen del conductor al mapa',
        VIEW_DRIVER_DESTINATION_ARIA: 'Veure la destinació del conductor al mapa',
        DRIVER_MAP_CAPTION: 'Mapa de la ruta original del conductor amb origen i destinació.',
        PASSENGERS_TITLE: 'Passatgers associats',
        PASSENGERS_LINKED_ONE: '{{count}} passatger vinculat al match.',
        PASSENGERS_LINKED_OTHER: '{{count}} passatgers vinculats al match.',
        NO_PASSENGERS: 'Aquest match no té passatgers vinculats.',
        REFRAME_PASSENGER: 'Reenquadrar l\'origen i la destinació',
        REFRAME_PASSENGER_ARIA: 'Reenquadrar l\'origen i la destinació del passatger al mapa',
        ORDER: 'Ordre {{order}}',
        COPY_PAX_ORIGIN_ARIA: 'Copiar les coordenades d\'origen del passatger',
        FOCUS_PAX_ORIGIN_ARIA: 'Enfocar l\'origen del passatger al mapa',
        COPY_PAX_DESTINATION_ARIA: 'Copiar les coordenades de destinació del passatger',
        FOCUS_PAX_DESTINATION_ARIA: 'Enfocar la destinació del passatger al mapa',
        COPY_PAX_PICKUP_ARIA: 'Copiar les coordenades de pickup del passatger',
        VIEW_PICKUP: 'Veure el pickup al mapa',
        FOCUS_PAX_PICKUP_ARIA: 'Enfocar el pickup del passatger al mapa',
        EDIT_PICKUP: 'Editar el pickup al mapa',
        EDIT_PICKUP_ARIA: 'Editar el pickup del passatger',
        COPY_PAX_DROPOFF_ARIA: 'Copiar les coordenades de dropoff del passatger',
        VIEW_DROPOFF: 'Veure el dropoff al mapa',
        FOCUS_PAX_DROPOFF_ARIA: 'Enfocar el dropoff del passatger al mapa',
        EDIT_DROPOFF: 'Editar el dropoff al mapa',
        EDIT_DROPOFF_ARIA: 'Editar el dropoff del passatger',
        PASSENGER_MAP_CAPTION: 'Mapa del trajecte del passatger amb origen, destinació, pickup i dropoff quan existeixin.',
        CLICK_MAP_PICKUP: 'Fes clic al mapa per seleccionar el punt de pickup.',
        CLICK_MAP_DROPOFF: 'Fes clic al mapa per seleccionar el punt de dropoff.',
        WAYPOINTS: 'Waypoints',
        WAYPOINTS_COUNT_ONE: '{{count}} punt al trajecte.',
        WAYPOINTS_COUNT_OTHER: '{{count}} punts al trajecte.',
        REFRAME_ALL: 'Reenquadrar tots els punts',
        REFRAME_ALL_ARIA: 'Reenquadrar tots els waypoints al mapa',
        REFRAME: 'Reenquadrar',
        COL_TIME: 'Hora',
        COL_POINT: 'Punt',
        COL_ACTIONS: 'Accions',
        FOCUS_WAYPOINT_ARIA: 'Enfocar el waypoint {{n}} al mapa',
        VIEW_THIS_POINT: 'Veure aquest punt al mapa',
        NO_ADDRESS: 'Sense adreça',
        COORDINATES: 'Coordenades',
        DISTANCE_FROM_PREVIOUS: 'Distància des del punt anterior',
        COPY_WAYPOINT_ARIA: 'Copiar les coordenades del waypoint',
        VIEW_POINT: 'Veure el punt al mapa',
        VIEW_WAYPOINT_ARIA: 'Veure el waypoint al mapa',
        WAYPOINTS_MAP_CAPTION: 'Mapa interactiu del trajecte amb zoom i desplaçament.',
        MAP_LOAD_ERROR: 'No s\'ha pogut carregar el mapa.',
        MAP_LOADING: 'Carregant el mapa…',
        DRIVER_ORIGIN: 'Origen del conductor',
        DRIVER_DESTINATION: 'Destinació del conductor',
        MARKER_WAYPOINT: 'Waypoint {{n}}',
        SAVE_POINT_TITLE: 'Desar {{point}}',
        SAVE_POINT_QUESTION: 'Vols desar aquest punt de {{point}} per a aquesta ruta?',
        POINT_PICKUP: 'pickup',
        POINT_DROPOFF: 'dropoff',
        SAVE: 'Desar',
        SAVING: 'Desant…',
        SAVED: 'Desat',
        SAVE_ERROR_TITLE: 'No s\'ha pogut desar el punt',
        SAVE_ERROR_TEXT: 'El backend no ha acceptat l\'actualització.',
        STATUS: {
          PENDING_DRIVER: 'Pendent del conductor',
          CONFIRMED_DRIVER: 'Confirmat pel conductor',
          PENDING_PASSENGER: 'Pendent del passatger',
          PASSENGER_CONFIRMED: 'Confirmat pel passatger',
          INITIAL: 'Inicial',
          CONFIRMED: 'Confirmat',
          ONGOING: 'En curs',
          CANCELLED: 'Cancel·lat',
          REJECTED: 'Rebutjat',
        },
        WAYPOINT_ACTIONS: {
          START: 'Inici',
          END: 'Final',
          PICKUP: 'Recollida',
          DROPOFF: 'Baixada',
        },
      },
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Verificació facial',
          PAGE: {
            NOTE_TITLE: 'Quan es demana la verificació facial',
            NOTE_TEXT: 'La verificació facial només la demana l\'avaluació de frau a mig viatge, en acabar el trajecte. Amb l\'interruptor general desactivat no es demana a ningú. Els llindars de Rekognition fixen quan es dona per superada i la referència, contra quina foto es compara. Tot es desa amb el botó del final.',
            GENERAL_SUB: 'Activa o desactiva la verificació facial per a tots els usuaris',
            THRESHOLDS_SUB: 'Confiança mínima de liveness i de similitud per donar la verificació per superada',
            REFERENCE_SUB: 'Amb quina foto es compara la cara de l\'usuari a cada verificació',
            LOADING: 'Carregant els ajustos',
          },
          GENERAL_TITLE: 'Interruptor general',
          KILL_SWITCH_WARNING: 'Interruptor d\'emergència: en desactivar-lo, ningú estarà obligat a passar la verificació facial.',
          ENABLED_LABEL: 'Verificació facial activada',
          THRESHOLDS_TITLE: 'Llindars de Rekognition',
          LIVENESS_THRESHOLD_LABEL: 'Llindar de confiança de liveness',
          LIVENESS_THRESHOLD_HINT: 'Nombre entre 0 i 100 (s\'admeten decimals)',
          SIMILARITY_THRESHOLD_LABEL: 'Llindar de similitud',
          SIMILARITY_THRESHOLD_HINT: 'Nombre entre 0 i 100 (s\'admeten decimals)',
          REFERENCE_TITLE: 'Referència de la comparació',
          REFERENCE_TECALIS_LABEL: 'Selfie de Tecalis',
          REFERENCE_TECALIS_HINT: 'Sempre amb la selfie que Tecalis va verificar amb el document',
          REFERENCE_ENROLLMENT_LABEL: 'Captura després de fallades properes',
          REFERENCE_ENROLLMENT_HINT: 'Primer amb la selfie de Tecalis; en sumar diverses fallades properes es desa la imatge de la prova de vida i des d\'aleshores es compara amb aquesta',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Similitud mínima d\'una fallada propera',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Nombre entre 0 i 100 (s\'admeten decimals). Una selfie de Tecalis sense cara detectable també compta',
          ENROLLMENT_ATTEMPTS_LABEL: 'Fallades properes per desar la captura',
          ENROLLMENT_ATTEMPTS_HINT: 'Nombre enter entre 1 i 10, comptant tots els viatges de l\'usuari',
          UPDATED_AT_LABEL: 'Última modificació',
          DISABLE_CONFIRM_TITLE: 'Desactivar la verificació facial?',
          DISABLE_CONFIRM_TEXT: 'Ningú estarà obligat a passar la verificació facial fins que es torni a activar.',
          CONFIRM: 'Confirmar',
          CANCEL: 'Cancel·lar',
          SAVE: 'Desar',
          SAVING: 'Desant…',
          SAVED: 'Ajustos desats',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'No s\'han pogut carregar els ajustos',
          ERROR_SAVE: 'No s\'han pogut desar els canvis',
          ERROR_FORBIDDEN: 'No tens permís per realitzar aquesta acció',
          ACCEPT: 'Acceptar',
          VALIDATION: {
            REQUIRED: 'Aquest camp és obligatori',
            INTEGER: 'El valor ha de ser un nombre enter',
            RANGE: 'El valor ha d\'estar entre 0 i 100',
            ATTEMPTS_RANGE: 'El valor ha d\'estar entre 1 i 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          PAGE: {
            NOTE_TITLE: 'VTC es desa en confirmar-ho; la resta, amb «Desar»',
            NOTE_TEXT: 'L\'interruptor de VTC demana confirmació i s\'aplica tan bon punt confirmes. Catàleg de productes, comissió, penalització i ajustos es desen junts amb el botó del final.',
            VTC_TITLE: 'Disponibilitat de VTC',
            VTC_SUB: 'Mostra o amaga el botó de demanar ride a l\'app per a tots els usuaris',
            ESTIMATES_TITLE: 'Presentació d\'opcions',
            ESTIMATES_SUB: 'Com mostra l\'app les opcions de VTC i taxi en estimar un ride',
            PRODUCTS_TITLE: 'Catàleg de productes',
            PRODUCTS_SUB: 'Quins productes veu el rider en estimar un ride',
            FEES_TITLE: 'Comissió i cancel·lació',
            FEES_SUB: 'Comissió que es cobra a cada ride i penalització si es cancel·la',
            ADJUSTMENTS_TITLE: 'Ajustos amb l\'import real',
            ADJUSTMENTS_SUB: 'Corregeixen la penalització o el cobrament amb el que factura el proveïdor',
            LOADING: 'Carregant els ajustos',
          },
          TITLE: 'Ajustos de rides',
          VTC_LABEL: 'VTC habilitat',
          VTC_HINT: 'Controla la disponibilitat global de rides VTC a l\'app',
          VTC_CONFIRM_TITLE: 'N\'estàs segur?',
          VTC_DISABLE_TEXT: 'En deshabilitar VTC s\'amagarà el botó de demanar ride a l\'app per a tots els usuaris',
          VTC_ENABLE_TEXT: 'En habilitar VTC el botó de demanar ride es tornarà a mostrar a l\'app',
          VTC_SAVED: 'VTC actualitzat',
          ESTIMATES_LABEL: 'Mode de presentació',
          ESTIMATES_HINT: 'Totes mostra cada opció disponible. Millors opcions només mostra la més econòmica i la més ràpida.',
          ESTIMATES_ALL: 'Totes les opcions',
          ESTIMATES_BEST_OPTIONS: 'Només la més econòmica i la més ràpida',
          ESTIMATES_SAVED: 'Presentació actualitzada',
          ERROR_FORBIDDEN: 'No tens permís per canviar la presentació d\'opcions',
          CONFIRM: 'Confirmar',
          CANCEL: 'Cancel·lar',
          RIDE_PRODUCTS_ENABLED_LABEL: 'Productes WAIIS en estimacions',
          RIDE_PRODUCTS_ENABLED_HINT: 'Encès: es mostren els productes WAIIS i, per a cadascun, el proveïdor més barat. Apagat: es mostra el llistat real de productes de cada proveïdor visible (p. ex. per a certificacions).',
          COMMISSION_ENABLED_LABEL: 'Cobrar comissió',
          COMMISSION_PERCENT_LABEL: '% comissió',
          COMMISSION_PERCENT_HINT: 'Percentatge entre 0 i 100 (dos decimals)',
          CANCELLATION_PENALTY_LABEL: '% penalització per cancel·lació',
          CANCELLATION_PENALTY_HINT: 'Percentatge entre 0 i 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Ajust per tarifa real',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalcular la penalització amb la quota real del proveïdor',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'S\'aplica a viatges creats des de',
          RECEIPT_ADJUSTMENT_LABEL: 'Ajust per rebut en viatges completats',
          RECEIPT_ADJUSTMENT_HINT: 'Conciliar la diferència amb l\'import cobrat quan arribi el rebut del proveïdor',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'S\'aplica a viatges creats des de',
          ADJUSTMENT_NEVER_ENABLED: 'Mai activat',
          SAVE: 'Desar',
          SAVING: 'Desant…',
          SAVED: 'Ajustos desats',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'No s\'han pogut carregar els ajustos',
          ERROR_SAVE: 'No s\'han pogut desar els canvis',
          ACCEPT: 'Acceptar',
          VALIDATION: {
            REQUIRED: 'Aquest camp és obligatori',
            RANGE: 'El valor ha d\'estar entre 0 i 100',
          },
        },
        GUEST_PHONES: {
          PAGE: {
            SUBTITLE: 'Números del pool de convidats. Pots activar-los, editar-los o esborrar-los.',
            FOOTER: 'Mostrant {{shown}} de {{total}} telèfons',
            LOADING: 'Carregant telèfons',
            ACTIVE_ON: 'Actiu',
            ACTIVE_OFF: 'Inactiu',
            SAVING: 'Desant…',
            RETRY: 'Reintentar',
            MODAL_SECTION: 'Número del convidat',
            DELETING: 'Esborrant…',
            DELETED: 'Esborrat',
            ERROR_LOAD: 'No s\'han pogut carregar els telèfons',
            ERROR_TOGGLE: 'No s\'ha pogut canviar l\'estat del telèfon',
            ERROR_DELETE: 'No s\'ha pogut esborrar el telèfon',
          },
          TITLE: 'Telèfons de convidats',
          EMPTY: 'No hi ha telèfons configurats',
          TABLE: {
            PHONE_NUMBER: 'Telèfon',
            ACTIVE: 'Actiu',
            ACTIONS: 'Accions',
          },
          ACTIONS: {
            ADD: 'Afegir',
            EDIT: 'Editar',
            DELETE: 'Esborrar',
            CANCEL: 'Cancel·lar',
            SAVE: 'Desar',
            ACCEPT: 'Acceptar',
          },
          MODAL: {
            CREATE_TITLE: 'Nou telèfon convidat',
            EDIT_TITLE: 'Editar telèfon convidat',
          },
          FORM: {
            PHONE_NUMBER: 'Telèfon',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'Format E.164: prefix internacional amb + (p. ex. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'El telèfon és obligatori',
            PHONE_FORMAT: 'Format invàlid: fes servir E.164 (+ i 7–15 dígits)',
          },
          DELETE: {
            TITLE: 'Esborrar telèfon?',
            TEXT: 'S\'eliminarà {{phone}} del pool de convidats',
            CONFIRM: 'Sí, esborrar',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDER_ROUTING: {
          TITLE: 'Enrutament per etiqueta',
          PAGE: {
            SUBTITLE: 'Cada regla indica el proveïdor que veu un usuari amb aquesta etiqueta.',
            FOOTER: 'Mostrant {{shown}} de {{total}} regles',
            LOADING: 'Carregant regles',
            RETRY: 'Reintentar',
            SAVING: 'Desant…',
            DELETING: 'Esborrant…',
            DELETED: 'Esborrat',
            ERROR_LOAD: 'No s\'han pogut carregar les regles',
            ERROR_SWITCH: 'No s\'ha pogut canviar l\'interruptor',
            ERROR_DELETE: 'No s\'ha pogut esborrar la regla',
            MODAL_SECTION: 'Regla',
          },
          SWITCH: {
            TITLE: 'Enrutament actiu',
            LABEL: 'Enrutar per etiqueta',
            HINT: 'Amb l\'interruptor encès, un usuari etiquetat només veu a estimates el proveïdor de la seva regla.',
            SAVED_ON: 'Enrutament activat',
            SAVED_OFF: 'Enrutament desactivat',
          },
          EMPTY: 'No hi ha regles configurades',
          TABLE: {
            TAG: 'Etiqueta',
            PROVIDER: 'Proveïdor',
            USERS: 'Usuaris',
            ACTIONS: 'Accions',
          },
          ACTIONS: {
            ADD: 'Afegir regla',
            EDIT: 'Editar',
            DELETE: 'Esborrar',
            CANCEL: 'Cancel·lar',
            SAVE: 'Desar',
            ACCEPT: 'Acceptar',
            CLOSE: 'Tancar',
          },
          USERS: {
            TITLE: 'Usuaris de la regla',
            OPEN: "Veure els usuaris de l'etiqueta {{tag}}",
            SEARCH_PLACEHOLDER: 'Cerca per nom o email',
            LOADING: 'Carregant usuaris',
            NAME: 'Nom',
            EMAIL: 'Email',
            ERROR_LOAD: "No s'han pogut carregar els usuaris",
            EMPTY: 'Cap usuari té aquesta etiqueta',
            EMPTY_SEARCH: 'Cap usuari coincideix amb la cerca',
            FOOTER: 'Mostrant {{shown}} de {{total}} usuaris',
            PREVIOUS: 'Anterior',
            NEXT: 'Següent',
          },
          MODAL: {
            CREATE_TITLE: 'Nova regla',
            EDIT_TITLE: 'Editar regla',
          },
          FORM: {
            TAG: 'Etiqueta',
            TAG_PLACEHOLDER: 'uber',
            TAG_HINT: 'Lletres, números, punt, guió i guió baix. No es pot canviar després.',
            PROVIDER: 'Proveïdor',
          },
          VALIDATION: {
            TAG_REQUIRED: 'L\'etiqueta és obligatòria',
            TAG_FORMAT: 'Només lletres, números, «.», «_» i «-»',
            PROVIDER_REQUIRED: 'Tria un proveïdor',
          },
          DELETE: {
            TITLE: 'Esborrar regla?',
            TEXT: 'S\'eliminarà la regla de l\'etiqueta {{tag}}',
            CONFIRM: 'Sí, esborrar',
          },
        },
        PROVIDERS: {
          TITLE: 'Proveïdors i mapatge de productes',
          RIDE_PRODUCTS: {
            TITLE: 'Productes WAIIS',
            HELP: 'Són els productes que veu el rider. Cada proveïdor mapeja un dels seus productes reals a cada producte WAIIS; l\'estimació mostra el proveïdor més barat dels mapejats.',
            ADD: 'Afegeix producte WAIIS',
            MOVE_UP: 'Puja',
            MOVE_DOWN: 'Baixa',
            TABLE: {
              ORDER: 'Ordre',
              PRODUCT: 'Producte',
              VISIBLE: 'Visible',
              ACTIONS: 'Accions',
            },
            MODAL: {
              NEW_TITLE: 'Nou producte WAIIS',
              EDIT_TITLE: 'Edita producte WAIIS',
              SECTION_DATA: 'Dades del producte',
              KEY: 'Clau',
              KEY_HELP: 'Identificador intern en minúscules, xifres i guions (p. ex. go, premium-xl). No es pot canviar després.',
              DISPLAY_NAME: 'Nom',
              IMAGE: 'Imatge',
              IMAGE_HELP: 'URL de la icona que veu el rider',
              DESCRIPTION: 'Descripció',
              DESCRIPTION_HELP: 'Opcional, per idioma. Només es desen els idiomes amb text.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'La clau és obligatòria',
              KEY_FORMAT: 'Només minúscules, xifres i guions (màxim 50 caràcters)',
              DISPLAY_NAME_REQUIRED: 'El nom és obligatori',
            },
            CONFIRM: {
              DELETE_TITLE: 'Eliminar producte WAIIS?',
              DELETE_TEXT: 'S\'eliminarà "{{product}}" definitivament',
            },
            ERROR: {
              IN_USE: 'No es pot eliminar: encara hi ha fitxes que el mapegen a {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Ruta de mostra per descobrir productes',
            HELP: 'Els proveïdors només revelen els seus productes en estimar un trajecte, i el catàleg canvia segons la ciutat. Tria origen i destinació a la ciutat que vulguis consultar: la ruta es desa per a tot l\'equip.',
            PICKUP: 'Origen',
            DROPOFF: 'Destinació',
          },
          DISCOVER: {
            BUTTON: 'Descobreix els productes del proveïdor',
            ADD_TAG: 'Usa aquesta clau: ',
            PLACEHOLDER: 'Escriu la clau o descobreix els productes del proveïdor',
            EMPTY: 'Encara no hi ha productes descoberts',
            CAPACITY: '{{capacity}} places',
            MAPPED_TO: 'Ja mapejat a {{product}}',
            MAPPED_HIDDEN: 'Mapejat i ocult',
            REFRESH: 'Tornar a consultar el proveïdor',
            ROUTE_USED: 'Ruta de mostra: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Configura la ruta de mostra a la pàgina de proveïdors per descobrir productes',
            ERROR: {
              DISABLED: 'El proveïdor està deshabilitat al servidor',
              UNAVAILABLE: 'El proveïdor no està disponible ara mateix',
              GENERIC: 'No s\'han pogut descobrir els productes del proveïdor',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Afegeix producte',
            SAVE: 'Desa',
            CANCEL: 'Cancel·la',
            ACCEPT: 'D\'acord',
            EDIT: 'Edita',
            DELETE: 'Elimina',
            SAVING: 'Desant…',
            DELETING: 'Eliminant…',
            DELETED: 'Eliminat',
            RETRY: 'Tornar-ho a provar',
          },
          FORM: {
            DISPLAY_NAME: 'Nom personalitzat',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'Aquest proveïdor encara no té productes mapejats',
            RIDE_PRODUCTS: 'No hi ha productes WAIIS configurats',
          },
          FOOT: {
            RIDE_PRODUCTS: 'Mostrant {{count}} de {{total}} productes WAIIS',
            PRODUCTS: 'Mostrant {{count}} de {{total}} productes',
          },
          TABLE: {
            PRODUCT_KEY: 'Producte del proveïdor',
            RIDE_PRODUCT: 'Producte WAIIS',
            VISIBLE: 'Visible',
            ACTIONS: 'Accions',
          },
          MODAL: {
            NEW_PRODUCT: 'Nou producte',
            EDIT_PRODUCT: 'Edita producte',
            PRODUCT_KEY: 'Producte del proveïdor',
            PRODUCT_KEY_HELP: 'Nom exacte del producte al proveïdor (p. ex. UberX, Standard)',
            RIDE_PRODUCT: 'Producte WAIIS',
            RIDE_PRODUCT_PLACEHOLDER: 'Selecciona un producte WAIIS',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'El producte del proveïdor és obligatori',
            RIDE_PRODUCT_REQUIRED: 'El producte WAIIS és obligatori',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: 'Eliminar producte?',
            DELETE_PRODUCT_TEXT: 'S\'eliminarà "{{product}}" definitivament',
          },
          ERROR: {
            TITLE: 'Error',
            LOAD: "No s'han pogut carregar els proveïdors",
            REORDER: "No s'ha pogut canviar l'ordre",
            VISIBILITY: "No s'ha pogut canviar la visibilitat",
            DELETE: "No s'ha pogut eliminar",
            SAVE_PROVIDER: "No s'ha pogut desar el proveïdor",
            LOAD_ROUTE: "No s'ha pogut carregar la ruta de mostra",
            SAVE_ROUTE: "No s'ha pogut desar la ruta de mostra",
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Proveïdor desat',
          },
        },
      },
      POIS: {
        TITLE: 'POIs',
        SUBTITLE: 'Punts de recollida / deixada',
        REVIEW_TAB: 'Revisar',
        UPLOAD_TAB: 'Pujar',
        TOTAL: 'POIs totals',
        BY_CATEGORY: 'Per categoria',
        BUS_STOP: 'Parades de bus',
        TRAIN_STATION: 'Estacions de tren',
        METRO_STATION: 'Estacions de metro',
        ZEBRA_CROSSING: 'Passos de zebra',
        STREET_CORNER: 'Cantonades',
        LOCAL_BUSINESS: 'Negocis locals',
        LOAD_IN_VIEW: 'Carregar POIs d\'aquesta vista',
        LOADING: 'Carregant…',
        SHOWING: 'Mostrant {{count}} POIs',
        TRUNCATED:
          'Mostrant els primers {{limit}} POIs — fes zoom per veure\'ls tots.',
        NO_POIS: 'No hi ha POIs en aquesta vista.',
        FILTERS: 'Categories',
        UPLOAD_TITLE: 'Pujar POIs',
        UPLOAD_HELP:
          'Array JSON de {osm_id, category, name, lat, lng}. La pujada reemplaça tot el conjunt per diff.',
        SELECT_FILE: 'Seleccionar fitxer JSON',
        UPLOAD_BTN: 'Pujar',
        UPLOADING: 'Pujant…',
        IMPORT_RUNNING: 'Ja hi ha una pujada en curs.',
        IMPORT_QUEUED: 'Pujada posada a la cua.',
        UPLOAD_ERROR: 'La pujada ha fallat.',
        PROGRESS_TITLE: 'Progrés de la pujada',
        STATUS: 'Estat',
        PROCESSED: 'Processats',
        STAGED: 'Inserits',
        DELETED: 'Esborrats',
        FAILED: 'Fallits',
        STATUS_IDLE: 'Inactiu',
        STATUS_QUEUED: 'A la cua',
        STATUS_PARSING: 'Analitzant fitxer',
        STATUS_RESYNCING: 'Recalculant relacions',
        STATUS_COMPLETED: 'Completat',
        STATUS_FAILED: 'Fallit',
      },
      TRIP_MAP: {
        SHOW_HEXAGONS: 'Mostrar Hexàgons',
        H3_RESOLUTION: 'Resolució H3:',
        POINT_DETAILS: 'Detalls del punt',
        SELECT_TRIP: 'Selecciona un viatge per veure el mapa',
        LOADING: 'Carregant mapa',
        POINT: 'Punt',
        MOBILITY: 'Mobilitat',
        NOT_CLASSIFIED: 'Sense classificar',
        CLASSIFIED_AS: 'Classificat com:',
        CLASSIFY_GROUP: 'Classificar grup de punts',
        RESET: 'Restablir',
        START: 'Inici',
        END: 'Fi',
        ACTIVITY: 'Activitat',
        MISCELLANEOUS: 'Miscel·lània',
        CONFIRM: 'Confirmar',
        TAGS: {
          VEHICLE: 'Vehicle',
          BICYCLE: 'Bicicleta',
          WALKING: 'Caminant',
          BUS: 'Autobús',
          SUBWAY: 'Metro',
          MOTORCYCLE: 'Moto',
          OTHER: 'Altre',
        },
        MISC: {
          HOME: 'Casa',
          WORK: 'Feina',
          JAM: 'Embús',
          STOPOVER: 'Parada',
          OTHER: 'Altre',
        },
        SAVING: 'Desant',
        SAVED: 'Canvis desats amb èxit',
        ERROR_ASSIGNING_TAG:
          "Error en assignar l'etiqueta. Si us plau, torna-ho a intentar.",
        ERROR_LOADING_DATA:
          'Error en carregar les dades del viatge. Si us plau, torna-ho a intentar.',
        REVISION_STATUS: 'Estat de la revisió',
        PENDING: 'Pendent',
        MULTISELECT_INSTRUCTION:
          'Mantén premuda la tecla Shift + Click per seleccionar múltiples punts',
        SELECT_ALL: 'Seleccionar tot',
        ALL_POINTS: 'Tots els punts',
        DATE: 'Data',
        MOVING: 'En moviment',
        MOVING_YES: 'Sí',
        MOVING_NO: 'No',
        SPEED: 'Velocitat',
        ODOMETER: 'Odòmetre',
        START_TIME: "Hora d'Inici",
        END_TIME: 'Hora de Fi',
        SELECTION_OPTIONS: 'Opcions de Selecció',
        SELECT_BY_RANGE: "Seleccionar per Rang d'Horari",
        ENTER_START_TIME: "Hora d'inici (HH:mm)",
        ENTER_END_TIME: 'Hora de fi (HH:mm)',
        SELECT: 'Seleccionar',
        CANCEL: 'Cancel·lar',
        NO_POINTS_IN_RANGE:
          "No s'han trobat punts en el rang seleccionat.",
        FILTER_POINTS: 'Filtrar punts',
        ALL: 'Tots',
        NONE: 'Cap',
        SHOW_VISIBLE_MAP_H3: 'Mostrar H3 del mapa visible',
        AVAILABLE_RANGE: 'Rang disponible: {{start}} - {{end}}',
        START_BEFORE_END: "L'hora d'inici ha de ser anterior a la de fi",
        RANGE_BETWEEN: 'El rang ha de ser entre {{start}} i {{end}}',
        HEX_POINTS: '{{count}} punts',
        LONG_ADDRESS: 'Adreça completa',
        COORDINATES: 'Coordenades',
        RAW_POINT_DATA: 'Dades en brut del punt',
        TIME: 'Hora',
        EVENT: 'Esdeveniment',
        CONFIDENCE: 'Confiança',
        ACCURACY: 'Precisió',
        ALTITUDE: 'Altitud',
        HEADING: 'Rumb',
        ORDER: 'Ordre',
        NOT_AVAILABLE: 'N/D',
      },
      TRIP_REVIEW: {
        SELECTED_DATE: 'Data seleccionada',
        NO_TRIPS_FOR_DAY: 'No hi ha viatges per a aquest dia',
        NO_DATA_FOR_USER: 'No hi ha dades per a aquest usuari',
        VERIFY_USER_EXISTS: "Verifica que l'usuari existeixi o selecciona'n un altre.",
        LOADING: 'Carregant',
        STATUS_REVIEWED: 'Revisat',
        STATUS_NOT_REVIEWED: 'No revisat',
        ROUTINE_TRIP: 'Viatge rutinari',
        REVIEW_STATUS_PENDING: 'Pendent',
        REVIEW_STATUS_REVIEWED: 'Revisat',
        REVIEW_STATUS_FRAUDULENT: 'Fraudulent',
        REVIEW_STATUS_ERRONEOUS: 'Erroni',
        CLASSIFICATION_SAVE_SUCCESS: 'Classificació desada correctament',
        CLASSIFICATION_SAVE_ERROR:
          'Error en desar la classificació. Torna-ho a intentar.',
        BACK: 'Tornar',
        SEARCH_USER_PLACEHOLDER: 'Cerca un usuari…',
        SEARCH_USER_ARIA: 'Cerca un usuari per nom o correu',
        SEARCH_SHOWING: 'Es mostren {{shown}} de {{total}} coincidències. Afina la cerca per veure la resta.',
        SEARCHING: 'Cercant…',
        NO_RESULTS: 'Sense resultats',
        SEARCH_ERROR: "No s'ha pogut cercar. Torna-ho a provar.",
        LOAD_USER_ERROR: "No s'ha pogut carregar la fitxa d'aquest usuari. Torna-ho a provar més tard.",
        LOAD_CALENDAR_ERROR: "No s'ha pogut carregar el calendari d'aquest usuari. Torna-ho a provar més tard.",
        COPY_ID: "Copia l'ID",
        ID_COPIED: 'ID copiat',
        COPY_ID_ERROR: "No s'ha pogut copiar l'ID",
        SHOW_MORE_TRIPS: 'Veure més viatges',
        UNKNOWN: 'Desconegut',
        NOT_LINKED: 'Sense vincular',
        EDIT_LINKED_SEGMENTS: 'Editar segments vinculats',
        EDIT_SEGMENTS: 'Editar segments',
        PREVIOUS_SEGMENT: 'Segment anterior',
        NEXT_SEGMENT: 'Segment següent',
        UNSAVED_CHANGES: 'Hi ha canvis sense desar.',
        SAVING: 'Desant…',
        SAVE: 'Desar',
        SAVE_SEGMENTS_ERROR: "No s'han pogut desar els segments vinculats.",
      },
      MATCH_REVIEW: {
        DRIVER: 'Conductor',
        RIDERS: 'Passatgers',
        PASSENGER: 'Passatger',
        VERIFY: 'Verificar',
        SELECT_DRIVER: 'Selecciona un conductor',
        SELECT_PASSENGER: 'Selecciona un passatger',
        DRIVER_DATA: 'Dades del Conductor',
        PASSENGER_DATA: 'Dades del Passatger',
        ROUTE_MAP: 'Mapa de Ruta',
        NO_DATA: 'Sense dades disponibles',
        ENTER_ROUTINE_IDS:
          'Introdueix els IDs de rutina del conductor i passatger per veure les rutes al mapa',
        LOADED: 'Carregat',
        USER: 'Usuari',
        DISTANCE: 'Distància',
        DURATION: 'Durada',
        PRICE: 'Preu',
        LOADING: 'Carregant',
        SHOW_HEXAGONS: 'Mostrar Hexàgons',
        SHOW_MAP_HEXAGONS: 'Veure tots els hexàgons del mapa',
        SHOW_POLYLINE: 'Veure Polilínia',
        ADD_DRIVER: 'Afegir conductor',
        ADD_RIDER: 'Afegir passatger',
        SELECT_ROUTINE: 'Fes clic aquí per afegir una rutina',
        ROUTE_SELECTOR: 'Selector de ruta',
        NAME: 'Nom',
        LOCATIONS: 'Ubicacions',
        ERROR_LOADING_ROUTE: 'Error carregant ruta',
        SELECT_ROUTE_DETAILS: 'Selecciona una ruta per veure els detalls',
        COPY_PHP_PAYLOAD: 'Copiar payload PHP',
        COPY_PHP_PAYLOAD_HINT: 'Copia les dades de la rutina com a array PHP',
        COPIED: 'Copiat',
        CENTER: 'Centrar',
        H3_RESOLUTION: 'Resolució H3',
        HEXAGON_POINTS: 'Punts per a Hexàgons',
        SIGNIFICANT_POINTS: 'Punts Significatius',
        ALL_POINTS: 'Tots els Punts',
        ERROR: 'Error',
        MAPS_LOAD_ERROR: 'Error en carregar Google Maps',
        ENTER_DRIVER_ID: "Si us plau introdueix un ID de rutina del conductor",
        ENTER_PASSENGER_ID: 'Si us plau introdueix un ID de rutina del passatger',
        ERROR_VERIFYING: 'Error en verificar la rutina del {{type}}',
        PICKUP: 'Recollida {{type}}',
        ORIGIN: 'Origen {{type}}',
        DROPOFF: 'Deixada {{type}}',
        DESTINATION: 'Destí {{type}}',
        DRIVER_TEXT: 'conductor',
        PASSENGER_TEXT: 'passatger',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'Índex H3 (Res {{res}})',
        LOADING_ROUTINE: 'Carregant rutina...',
        UNKNOWN_ERROR: 'Error desconegut',
        INFO: 'Informació',
        SEARCH_RADIUS: 'Radi de Cerca',
        RADIUS_PLACEHOLDER: 'Radi en metres',
        FOUND: "S'han trobat",
        INTEREST_POINTS: "punts d'interès",
        NO_POINTS_FOUND:
          "No s'han trobat punts d'interès al radi especificat",
        ERROR_FETCHING_POINTS: "Error en obtenir els punts d'interès",
        SEARCH_INTEREST_POINTS: "Cercar punts d'interès",
        CANCEL_SEARCH: 'Cancel·lar cerca',
        CLEAN_INTEREST_POINTS: "Netejar punts d'interès",
        LOAD_FROM_FILE: "Carregar des d'arxiu",
        PROCESS_COMPLETE: 'Procés completat',
        CONFIRM: 'Confirmar',
        MAP_SUB: 'Polilínies, punts i hexàgons H3 de les rutines triades a les taules de sota.',
        H3_ROUTINE: 'H3 rutina',
        H3_ALL: 'Tots els H3',
        POI_CLICK_HINT: 'Fes clic al mapa per cercar al voltant d\'aquest punt.',
        LEGEND: 'Llegenda',
        SHARED_H3: 'Hexàgon groc amb vora verda: H3 compartit entre rutines',
        POI_LEGEND: 'Etiqueta groga: estació de bus o tren (es veu amb zoom 13 o més)',
        DRIVERS: 'Conductors',
        DRIVERS_SUB: 'Rutines de conductor que es dibuixen al mapa. Prem una fila per veure\'n el detall.',
        RIDERS_SUB: 'Rutines de passatger que es dibuixen al mapa, amb la recollida i la deixada. Prem una fila per veure\'n el detall.',
        LOAD_FROM_FILE_HINT: 'Carregar rutines des d\'un fitxer',
        ROUTINE: 'Rutina',
        POLYLINE: 'Polilínia',
        ORIGIN_DESTINATION: 'Origen / Destí',
        PICKUP_DROPOFF: 'Pickup / Dropoff',
        TOGGLE_POLYLINE: 'Mostrar o amagar la polilínia al mapa',
        TOGGLE_PINS: 'Mostrar o amagar origen i destí al mapa',
        TOGGLE_SPECIAL: 'Mostrar o amagar recollida i deixada al mapa',
        CENTER_ON_ROUTE: 'Centrar el mapa en aquesta ruta',
        REMOVE_DRIVER: 'Eliminar conductor',
        REMOVE_RIDER: 'Eliminar passatger',
        EXPAND: 'Veure o amagar el detall',
        DAY: 'Dia',
        DEPARTURE: 'Sortida',
        ARRIVAL: 'Arribada',
        SCHEDULE: 'Horari',
        COPY_ADDRESS: 'Copiar adreça',
        COPY_COORDS: 'Copiar coordenades',
        ROUTINE_LOAD_FAILED: 'No s\'ha pogut carregar la rutina',
        FILE_NOT_TXT: 'Selecciona un fitxer .txt',
        FILE_NO_IDS: 'El fitxer no conté routineIds vàlids',
        FILE_PROCESS_ERROR: 'No s\'ha pogut processar el fitxer',
        FILE_READ_ERROR: 'No s\'ha pogut llegir el fitxer',
        LOAD_DRIVERS_TITLE: 'Carregar {{count}} conductors',
        LOAD_RIDERS_TITLE: 'Carregar {{count}} passatgers',
        LOAD_ROUTINES_TEXT: 'Es verificarà cada rutina i s\'afegirà a la taula i al mapa.',
        PROCESSED_OK: 'S\'han processat {{count}} rutines correctament.',
        ERRORS_FOUND: 'Errors trobats ({{count}}):',
        DAY_N: 'Dia {{n}}',
        OUTBOUND: 'Anada',
        RETURN: 'Tornada',
        UNKNOWN_DAY: 'Desconegut',
        ROUTE_POINT: 'Punt de la ruta',
        FILE_EMPTY: 'El fitxer és buit',
        POI_TYPE_BUS_STATION: 'Estació de bus',
        POI_TYPE_TRAIN_STATION: 'Estació de tren',
      },
      SUPPORT_CHAT: {
        TRIP_CHAT_FALLBACK: 'Xat de trajecte',
        NAMES_AND: '{{names}} i {{last}}',
        TITLE: 'Xat de suport',
        LIST_TITLE: 'Chats de Suport',
        NO_CHATS: "No s'han trobat converses de suport.",
        SEND: 'Enviar',
        SELECT_CHAT: 'Selecciona un xat',
        SELECT_CHAT_DESC:
          'Selecciona una conversa del llistat per veure els missatges',
        LOADING_MORE: 'Carregant missatges anteriors...',
        YOU_SUPPORT: 'Tu (Suport)',
        NO_MESSAGES: 'Sense missatges',
        IMAGE_MSG: '[Imatge]',
        TODAY: 'Avui',
        YESTERDAY: 'Ahir',
        SEARCH_PLACEHOLDER: 'Cerca per nom, ID o missatge...',
        CLEAR_SEARCH: 'Neteja la cerca',
        NO_RESULTS: 'Cap conversa coincideix amb la cerca.',
        LOAD_ERROR: 'No s\'han pogut carregar les dades.',
        RETRY: 'Tornar-ho a provar',
        LOADING_MORE_CHATS: 'Carregant més converses...',
        LOAD_MORE: 'Carrega\'n més',
        ALL_LOADED: 'No hi ha més converses',
        CONVERSATION_START: 'Inici de la conversa',
        CLOSE_TAB: 'Tanca la pestanya',
        CLOSE_ALL: 'Tanca-les totes',
        VIEW_PROFILE: "Veure l'usuari",
        MARK_AS_UNREAD: 'Marcar com a no llegit',
        MARK_AS_READ: 'Marcar com a llegit',
        PENDING_REPLY_HINT: 'Pendent de respondre',
        PENDING_REPLY_ERROR: "No s'ha pogut actualitzar l'avís de pendent de respondre",
        SEND_HINT: 'Enter per enviar · Shift+Enter per fer salt de línia',
        TABS_HINT: 'Cada xat s\'obre en una pestanya, així pots tornar a qualsevol conversa anterior.',
        IMAGE_UNAVAILABLE: 'Imatge no disponible',
        SEARCH_INDEXING: 'Indexant totes les converses...',
        SEARCH_SCOPE_ALL: 'Cercant a totes les converses',
        ATTACH_IMAGE: 'Adjunta una imatge',
        DROP_IMAGE: "Deixa anar la imatge per enviar-la",
        IMAGE_SENDING: 'Enviant la imatge...',
        IMAGE_TOO_LARGE: 'La imatge és massa gran. El màxim són 4 MB.',
        IMAGE_INVALID_TYPE: 'Aquest fitxer no és una imatge.',
        IMAGE_UPLOAD_ERROR: "No s'ha pogut enviar la imatge. Torna-ho a provar.",
        CLOSE_IMAGE: 'Tanca la imatge',
        LOCATION_SHARED: 'Ubicació compartida',
        EDIT: 'Edita',
        DELETE: 'Esborra',
        SAVE: 'Desa',
        CANCEL: 'Cancel·la',
        EDITED: '(editat)',
        EDIT_HINT: 'Enter per desar · Esc per cancel·lar',
        DELETE_CONFIRM: "Vols esborrar aquest missatge? No es pot desfer.",
        EDIT_ERROR: "No s'ha pogut editar el missatge. Torna-ho a provar.",
        DELETE_ERROR: "No s'ha pogut esborrar el missatge. Torna-ho a provar.",
        TRIP_CARD_MSG: 'Trajecte no verificat',
        CAPTURE_ATTEMPT_MSG: 'Intent de captura',
        CAPTURE_ATTEMPT_ROW_SCREENSHOT: 'Ha intentat fer una captura',
        CAPTURE_ATTEMPT_ROW_RECORDING: 'Ha intentat gravar la pantalla',
        CAPTURE_ATTEMPT_SCREENSHOT: '{{name}} ha intentat fer una captura de pantalla al xat «{{chat}}»',
        CAPTURE_ATTEMPT_RECORDING: '{{name}} ha intentat gravar la pantalla al xat «{{chat}}»',
        CAPTURE_ATTEMPT_UNKNOWN_CHAT: 'desconegut',
        TRIP_CHAT_LABEL: 'Xat grupal de trajecte',
        COMPANY_TAG: 'Empresa - {{name}}',
        TRIP_CHAT_TITLE_PREFIX: 'Xat grupal',
        VIEW_PARTICIPANTS: 'Veure participants',
        GO_TO_TRIP: 'Anar al detall del viatge',
        TRIP_DATE: 'Data',
        TRIP_TYPE: 'Tipus de viatge',
        TRIP_TYPE_routine: 'Rutinari',
        TRIP_TYPE_punctual: 'Puntual',
        TRIP_DRIVER: 'Conductor',
        CLOSE_INCIDENT: 'Tanca la incidència',
        CLOSE_INCIDENT_CONFIRM: 'El xat desapareixerà de l\'app per als participants. El podràs continuar veient aquí i reobrir-la quan calgui.',
        CLOSE_INCIDENT_ERROR: 'No s\'ha pogut tancar la incidència. Torna-ho a provar.',
        CLOSE_INCIDENT_DONE: 'Incidència tancada i arxivada',
        INCIDENT_CLOSED: 'Incidència tancada',
        INCIDENT_CLOSED_HINT: 'Aquesta incidència està tancada. Ja no es poden enviar missatges.',
        REOPEN_INCIDENT: 'Reobre la incidència',
        REOPEN_INCIDENT_CONFIRM: 'El xat tornarà a estar disponible a l\'app i es podran tornar a enviar missatges.',
        REOPEN_INCIDENT_ERROR: 'No s\'ha pogut reobrir la incidència. Torna-ho a provar.',
        NEW_MESSAGES_BELOW: '{{count}} missatges nous',
        BACK_TO_LIST: 'Torna al llistat',
        MORE_ACTIONS: 'Més accions',
        INBOX: {
          TAB_UNREAD: 'No llegits',
          TAB_ALL: 'Tots',
          TAB_GROUPS: 'Grups',
          FILTER: 'Ordena',
          ORDER: 'Ordre',
          COMPANY: 'Empresa',
          COMPANY_ALL: 'Totes',
          COMPANY_CLEAR: "Treu el filtre d'empresa",
          COMPANY_FILTER: 'Filtra per empresa',
          COMPANY_FILTER_EMPTY: "Cap conversa d'empresa en aquesta pestanya",
          COMPANY_SEARCH: 'Cerca empresa…',
          COMPANY_NONE: 'Cap empresa coincideix',
          ORDER_OLDEST: 'Més antic primer',
          ORDER_NEWEST: 'Més recent primer',
          WAITING_FOR: 'Esperant resposta des de fa {{time}}',
          YOU_PREFIX: 'Tu:',
          CHIP_CLOSED: 'Tancada',
          CHIP_RESOLVED: 'Finalitzada',
          DONE_SECTION: 'Finalitzades',
          EMPTY_unread: 'No hi ha res per llegir.',
          EMPTY_all: 'No hi ha converses.',
          EMPTY_groups: 'No hi ha xats de trajecte.',
          EMPTY_TAG: 'No hi ha converses amb aquest tema.',
        },
        PEEK: {
          SHOW: 'Llegir sense obrir',
          HIDE: 'Amaga i marca com a llegit',
          HINT: 'En amagar-ho queda marcat com a llegit',
          MARK_READ: 'Marca com a llegit',
          REPLY: 'Respon',
          EMPTY: "No hi ha missatges de l'usuari per mostrar.",
          ERROR: "No s'ha pogut carregar la previsualització.",
          READ_ERROR: "No s'ha pogut marcar com a llegit. Torna-ho a provar.",
        },
        TAGS: {
          trip: 'Trajecte',
          payments: 'Pagaments',
          payouts: 'Retirades',
          cae: 'CAE',
          price: 'Preu',
          referrals: 'Referits',
          app: 'App',
          account: 'Compte',
        },
        TAG_FILTER: 'Filtra per tema',
        TAG_FILTER_ALL: 'Tots els temes',
        TAG_FILTER_SHOW: 'Mostra els temes',
        TAG_FILTER_HIDE: 'Amaga els temes',
        TAG_FILTER_CLEAR: 'Treu el filtre de tema',
        TAG_FILTER_EMPTY: 'Cap conversa d\'aquesta pestanya té tema',
        TAG_SCROLL_PREV: 'Temes anteriors',
        TAG_SCROLL_NEXT: 'Més temes',
        TAG_ADD: 'Tema',
        TAG_MENU_TITLE: 'Tema de la conversa',
        TAG_ACCEPT: 'Confirma',
        TAG_REMOVE: 'Treu el tema',
        TAG_SUGGESTED_HINT: "Tema suggerit a partir de l'últim missatge. Confirma'l per desar-lo.",
        TAG_AUTO_HINT: 'Automàtic: és un xat de trajecte',
        TAGS_ERROR: "No s'ha pogut desar el tema. Torna-ho a provar.",
        RESOLVE: {
          FINISH: 'Finalitza',
          REOPEN: 'Reobre',
          UNDO: 'Desfés',
          DONE_ONE: 'Conversa finalitzada',
          DONE_MANY: '{{count}} converses finalitzades',
          REOPENED: 'Conversa reoberta',
          ERROR: "No s'ha pogut finalitzar. Revisa la connexió o els permisos i torna-ho a provar.",
          REOPEN_ERROR: "No s'ha pogut reobrir. Revisa la connexió o els permisos i torna-ho a provar.",
          STALE_BANNER: '{{count}} converses sense activitat en +30 dies.',
          STALE_BANNER_ONE: '1 conversa sense activitat en +30 dies.',
          STALE_DISMISS: 'Amaga l\'avís',
          STALE_ACTION: 'Finalitza-les',
          BULK_TITLE: 'Vols finalitzar {{count}} converses?',
          BULK_CONFIRM: "Passaran a «Finalitzades». Si l'usuari torna a escriure, tornaran soles a «No llegits». L'app no canvia per a l'usuari.",
          BULK_ACTION: 'Finalitza',
        },
        COMPOSER: {
          PLACEHOLDER: 'Escriu un missatge…',
          HINT: 'Enter per enviar · Shift+Enter per fer salt de línia · «/» amb el missatge buit per a respostes ràpides',
          QUICK_REPLIES: 'Respostes ràpides',
          DISMISS: "Tanca l'avís",
        },
        QUICK_REPLIES: {
          TITLE: 'Respostes ràpides',
          SEARCH: 'Cerca per títol, categoria o text...',
          LANGUAGE: 'Idioma de la resposta',
          LOCAL_FALLBACK: "No s'han pogut carregar les respostes: es mostren les de reserva.",
          NO_CA: "Sense versió en català: s'inserirà en castellà",
          EMPTY: 'Cap resposta coincideix amb la cerca.',
          KEYS_HINT: '↑↓ moure · Enter inserir · Esc tancar',
          MANAGE: 'Gestiona les respostes',
        },
        CONTEXT: {
          TITLE: 'Usuari',
          TOGGLE: "Mostra o amaga les dades de l'usuari",
          CLOSE: 'Tanca el panell',
          OPEN_PROFILE: 'Obre la fitxa',
          GROUP_HINT: 'Prem un participant per veure les seves dades de pagament.',
          NO_PARTICIPANTS: 'Sense participants.',
          UPDATED_AT: 'Actualitzat a les {{time}}',
          LOADING: 'Carregant...',
          REFRESH: 'Actualitzar',
          USER_ERROR: "No s'han pogut carregar les dades de pagament.",
          USER_NOT_FOUND: 'Aquest usuari no existeix en aquest entorn.',
          PAYMENTS: 'Pagaments',
          PAYMENT_STATUS: {
            OK: 'Al dia',
            WARNING: 'Avís',
            BLOCKED: 'Bloquejat',
            CANCELLED: 'Cancel·lat',
            UNKNOWN: 'Sense dades',
          },
          REASON: 'Motiu',
          CARD_EXPIRED: 'Caducada',
          CARD_EXPIRES_SOON: 'Caduca aviat',
          OTHER_CARDS: '+{{n}} targetes',
          NO_CARDS: 'Sense targetes desades',
          NO_CUSTOMER: 'Mai no ha afegit cap targeta',
          STRIPE_UNAVAILABLE: 'Stripe no respon: dades incompletes.',
          PAYOUTS: 'Cobraments',
          BANK_ACCOUNT: 'Compte bancari',
          PAYOUT_LOCAL_ONLY: 'Stripe no respon: es mostren les dades desades.',
          BALANCE: 'Saldo',
          WALLET: 'Moneder',
          CREDITS: 'Crèdits',
        },
      },
      SUPPORT_TOOLS: {
        PAYMENTS: {
          TAB: 'Pagaments',
          TITLE: 'Pagaments',
          SUBTITLE: 'Targetes amb què paga com a passatger i compte on cobra com a conductor. Es consulta Stripe en viu.',
          REFRESH: 'Actualitzar',
          RETRY: 'Tornar-ho a provar',
          LOAD_ERROR: 'No s\'ha pogut carregar la informació de pagaments.',
          CARDS_TITLE: 'Com a passatger · targetes',
          PAYOUT_TITLE: 'Com a conductor · cobraments',
          PAYMENT_STATUS: 'Estat de pagament',
          STATUS: {
            ok: 'Al dia',
            warning: 'Avís',
            blocked: 'Bloquejat',
            cancelled: 'Cancel·lat',
            unknown: 'Sense dades',
          },
          REASONS: {
            card_expiring: 'Targeta a punt de caducar',
            card_expired: 'Targeta caducada',
            method_removed: 'Ha tret el mètode de pagament',
            charge_failed: 'Cobrament fallit',
            hold_failed: 'Caució rebutjada',
            debt_paid: 'Deute pagat',
            method_added: 'Ha afegit un mètode de pagament',
            wallet_topup: 'Recàrrega de saldo',
            retry_succeeded: 'Reintent de cobrament correcte',
            grace_period_exceeded: 'Període de gràcia esgotat',
            manual_override: 'Canvi manual',
          },
          FUNDING: {
            credit: 'Crèdit',
            debit: 'Dèbit',
            prepaid: 'Prepagada',
            unknown: 'Tipus desconegut',
          },
          EXPIRES: 'Caduca {{date}}',
          DEFAULT: 'Predeterminada',
          EXPIRES_SOON: 'Caduca aviat',
          EXPIRED: 'Caducada',
          GRACE_PERIOD: 'En període de gràcia',
          GRACE_PERIOD_UNTIL: 'En període de gràcia fins al {{date}}',
          NO_CARDS: 'Sense targetes',
          NO_CUSTOMER: 'Sense client de Stripe',
          STRIPE_UNAVAILABLE_CARDS: 'Stripe no ha respost: ara mateix no es poden mostrar les targetes. Prova d\'actualitzar d\'aquí a un moment.',
          LOCAL_SOURCE_NOTE: 'Stripe no ha respost: aquestes dades surten de la nostra base de dades i poden no estar al dia.',
          UNKNOWN: 'Desconegut',
          BANK_ACCOUNTS: 'Comptes bancaris',
          NO_BANK_ACCOUNTS: 'Sense comptes bancaris',
          BANK_UNKNOWN: 'Banc desconegut',
          REASON_OTHER: 'Un altre motiu',
          PAYOUT_OK: 'Pot cobrar',
          PAYOUT_BLOCKED: 'No pot cobrar',
          PAYOUT_NOT_STARTED: 'Encara no ha donat d\'alta els cobraments',
          PAYOUT_UNVERIFIED: 'Sense comprovar a Stripe',
          PAYOUT_RECEIVES_IN: 'Rep les seves retirades a {{bank}} •••• {{last4}}.',
          PAYOUT_NO_BANK: 'Encara no té cap compte bancari registrat.',
          PAYOUT_NOT_STARTED_TEXT: 'No ha començat l\'alta de cobraments a l\'app, així que encara no pot retirar el que guanya com a conductor.',
          PAYOUT_COMPLETE_ONBOARDING: 'Ha de completar l\'alta de cobraments a l\'app.',
          PAYOUT_WAIT_VERIFICATION: 'Stripe està revisant les seves dades: de moment no ha de fer res.',
          PAYOUT_STRIPE_ASKS: 'Stripe li demana:',
          PAYOUT_STRIPE_WILL_ASK: 'Stripe li demanarà aviat:',
          REQ_GROUPS: {
            personal: 'Dades personals (nom, data de naixement, adreça, telèfon…)',
            document: 'Document d\'identitat',
            bank: 'Compte bancari',
            tos: 'Acceptar les condicions de Stripe',
            business: 'Dades de l\'activitat',
            other: 'Altres dades',
          },
          DISABLED_REASONS: {
            past_due: 'Stripe va demanar dades i el termini ha vençut',
            pending_verification: 'Stripe està verificant les dades',
            rejected: 'Stripe ha rebutjat el compte',
            under_review: 'En revisió per Stripe',
            other: 'Bloquejat per Stripe',
          },
          BANK_STATUS: {
            new: 'Nou',
            validated: 'Validat',
            verified: 'Verificat',
            verification_failed: 'Verificació fallida',
            errored: 'Amb errors',
          },
        },
        SOLUTIONS: {
          TITLE: 'Com solucionar-ho',
          COPY: 'Copiar el missatge per a l\'usuari',
          INSERT: 'Inserir al xat',
          COPIED: 'Copiat',
          COPY_ERROR: 'No s\'ha pogut copiar: el text queda seleccionat per copiar-lo a mà.',
          ACCOUNT_ID: 'Id del compte',
          COPY_ID: 'Copiar l\'id',
          OPEN_CHAT: 'Obrir el xat amb el missatge',
          NO_CHAT_HINT: 'Aquest usuari encara no té xat de suport: copia el missatge i envia-l\'hi per una altra via.',
          CHECKING_CHAT: 'Comprovant si té xat de suport…',
          OPEN_CHAT_ERROR: 'No s\'ha pogut obrir el xat de suport. Torna-ho a provar.',
          STEPS: {
            ASK_ADD_BANK: 'Demana-li que afegeixi el seu compte bancari des de l\'app: La meva cartera → Mètodes de pagament i cobrament → Cobrament → Afegir mètode de cobrament.',
            SEND_MESSAGE: 'Li pots enviar el missatge de sota.',
            LEGACY_REPLACEABLE: 'El seu compte de cobrament és del sistema antic i està incomplet. En afegir un compte bancari des de l\'app, se substitueix sol.',
            LEGACY_HAS_BALANCE: 'El seu compte antic té saldo a Stripe i no es pot substituir sol.',
            NOTIFY_DEV_WITH_ID: 'Avisa l\'equip de desenvolupament i passa-li l\'id del compte.',
            REVIEW_PERSONAL: 'Demana-li que revisi les seves dades personals a Perfil i que torni a afegir el compte bancari.',
            IF_PERSISTS_DEV: 'Si continua igual, avisa l\'equip de desenvolupament.',
            NOTHING_TO_DO: 'No cal fer res: Stripe està revisant les seves dades.',
            RE_ADD_BANK: 'Demana-li que torni a afegir el compte bancari des de l\'app.',
            ASK_NEW_CARD: 'Demana-li que afegeixi una targeta nova: La meva cartera → Mètodes de pagament i cobrament → Pagament → Afegir mètode de pagament.',
            WARN_EXPIRING: 'Avisa l\'usuari que la seva targeta caduca aviat i que en pot afegir una de nova abans.',
            DEBT: 'Té un cobrament pendent i el compte bloquejat: demana-li que premi «Actualitzar mètode de pagament» a l\'avís de l\'app i afegeixi una targeta vàlida. El deute es cobra sol.',
          },
        },
        SNIPPETS_CONFIG: {
          MENU: 'Respostes del suport',
          BREADCRUMB: 'Configuració',
          BREADCRUMB_ARIA: 'Ruta de navegació',
          TITLE: 'Respostes i recordatoris del suport',
          DESCRIPTION: 'Textos que l\'equip de suport insereix des del xat. Arrossega les files per canviar l\'ordre en què apareixen.',
          NEW: 'Nou text',
          TAB_REPLIES: 'Respostes ràpides',
          TAB_REMINDERS: 'Recordatoris',
          SEARCH_PLACEHOLDER: 'Cerca per títol, text o categoria...',
          REORDER_DISABLED: 'Esborra la cerca per poder reordenar',
          LOADING: 'Carregant...',
          LOAD_ERROR: 'No s\'han pogut carregar els textos.',
          RETRY: 'Tornar-ho a provar',
          EMPTY_REPLIES: 'Encara no hi ha respostes ràpides.',
          EMPTY_REMINDERS: 'Encara no hi ha recordatoris.',
          NO_RESULTS: 'Cap text coincideix amb la cerca.',
          COL_ORDER: 'Ordre',
          COL_LABEL: 'Títol',
          COL_BODY: 'Text',
          COL_CATEGORY: 'Categoria',
          COL_USES: 'Usos',
          COL_ACTIVE: 'Actiu',
          COL_ACTIONS: 'Accions',
          DRAG: 'Arrossega per reordenar',
          EDIT: 'Editar',
          DELETE: 'Esborrar',
          NEW_TITLE: 'Nou text',
          EDIT_TITLE: 'Editar text',
          KIND_REPLY: 'Resposta ràpida',
          KIND_REMINDER: 'Recordatori',
          FIELD_LABEL: 'Títol',
          FIELD_CATEGORY: 'Categoria',
          CATEGORY_PLACEHOLDER: 'Ex.: Pagaments, CAE...',
          CATEGORY_NONE: 'Sense categoria',
          CATEGORY_NEW: '+ Nova categoria…',
          CATEGORY_NEW_PLACEHOLDER: 'Nom de la nova categoria',
          CATEGORY_BACK: 'Triar de la llista',
          FIELD_BODY: 'Text',
          FIELD_BODY_ES: 'Text en castellà',
          FIELD_BODY_CA: 'Text en català (opcional)',
          FIELD_ACTIVE: 'Actiu',
          PLACEHOLDER_HINT: 'En inserir la resposta, <code>{nombre}</code> (castellà) i <code>{nom}</code> (català) se substitueixen pel nom de pila de l\'usuari.',
          REQUIRED: 'Camp obligatori',
          PREVIEW: 'Previsualització',
          PREVIEW_EMPTY: 'Escriu el text per veure com quedarà.',
          SAVE: 'Desar',
          CANCEL: 'Cancel·lar',
          CREATED: 'Text creat',
          SAVED: 'Canvis desats',
          DELETED: 'Text esborrat',
          DELETE_TITLE: 'Esborrar text',
          DELETE_TEXT: '«{{label}}» deixarà d\'aparèixer al xat de suport.',
          DELETE_CONFIRM: 'Sí, esborrar',
          ERROR_SAVE: 'No s\'han pogut desar els canvis. S\'ha desfet el canvi.',
          ERROR_DELETE: 'No s\'ha pogut esborrar. S\'ha restaurat el text.',
          ERROR_REORDER: 'No s\'ha pogut desar l\'ordre. S\'ha restaurat l\'anterior.',
          SAVING: 'Desant…',
          ACCEPT: 'D\'acord',
          SECTION_CONTENT: 'Contingut',
        },
      },
      ECONOMIC_DASHBOARD: {
        DETAIL_ROUTE: 'ruta {{id}}',
        HOLD: {
          REASON: {
            reinforced_verification: 'Reforçada',
            cash_delay: 'Caixa',
          },
          DAYS: 'dia {{day}}/{{total}}',
          UNTIL: 'fins al {{date}}',
          DUE_TRANSFER: 'dia {{day}}/{{total}} · s\'abona en uns minuts',
          DUE_PAYOUT: 'dia {{day}}/{{total}} · pendent de revisió',
          TITLE: 'Retingut fins al {{date}}',
        },
        TITLE: 'Tauler econòmic',
        SUBTITLE: 'Retirades dels conductors, saldo a Stripe i el que queda per pagar. Tots els imports, en euros.',
        EXPORT_CSV: 'Exportar moviments (CSV)',
        EXPORTING: 'Exportant…',
        EXPORT_ERROR: 'No s\'ha pogut exportar el CSV',
        FORBIDDEN: 'No tens permís per a això: falta l\'operació {{operation}}',
        HELP: {
          trip_charge: 'El que es cobra al passatger per un viatge.',
          user_charge: 'Càrrec a l\'usuari: una recàrrega de cartera o un altre càrrec (avui no es poden distingir).',
          negative_balance_charge: 'Cobrament per deixar a zero el saldo negatiu d\'un usuari.',
          trip_transfer: 'Pagament del viatge al conductor, des de la cartera del passatger.',
          trip_commission: 'El que es queda WAIIS de cada viatge.',
          driver_payout: 'El conductor passa diners de la seva cartera al seu compte bancari.',
          instant_payout: 'Retirada instantània: el conductor rep els diners en minuts, amb comissió.',
          instant_payout_fee: 'Comissió que cobra WAIIS per una retirada instantània.',
          instant_payout_refund: 'Devolució a la cartera d\'una retirada instantània que va fallar (import i comissió).',
          cae_discount: 'Bonificació per Certificats d\'Estalvi Energètic (CAE) d\'un viatge ja fet.',
          manual_adjustment: 'Correcció feta a mà per un administrador (abonament o retirada).',
          referral_bonus: 'Bonus per convidar algú que fa el seu primer viatge.',
          corporate_ride_reclaim: 'Cobrament a l’empleat d’un viatge d’empresa rebutjat: passa de la seva cartera a la de l’empresa.',
          corporate_ride_reclaim_topup: 'Recàrrega amb la targeta de l’empleat per cobrir un viatge d’empresa rebutjat.',
          PAYOUT_PAID: 'Stripe va confirmar el pagament al banc del conductor.',
          PAYOUT_PENDING: 'Enviada a Stripe sense confirmar, o en revisió manual.',
          PAYOUT_FAILED: 'Stripe no la va poder pagar, o es va rebutjar a la revisió.',
          PAYOUT_REFUNDED: 'Va fallar i els diners van tornar a la cartera del conductor.',
          CHARGE_COMPLETED: 'El cobrament al passatger s\'ha fet bé.',
          CHARGE_PENDING: 'El cobrament encara no està confirmat.',
          CHARGE_FAILED: 'El cobrament al passatger ha fallat: són diners que no han entrat.',
          CHARGE_REFUNDED: 'Es va cobrar i després es va retornar al passatger.',
        },
        STATS: {
          FOLD_HIDE: 'Amagar detall',
          FOLD_SHOW: 'Veure detall',
          INSIGHT_FLOWS_NEG: 'En {{range}}, els passatgers van pagar {{in}} amb targeta i els conductors van retirar {{out}} al seu banc: van sortir {{net}} més dels que van entrar.',
          INSIGHT_FLOWS_POS: 'En {{range}}, els passatgers van pagar {{in}} amb targeta i els conductors van retirar {{out}} al seu banc: van entrar {{net}} més dels que van sortir.',
          FLOWS_TIP_OUT: 'Retirat per conductors',
          FLOWS_TIP_IN: 'Pagat per passatgers',
          FLOWS_TOTAL: 'Total',
          FLOWS: 'Diners que entren i surten de WAIIS',
          FLOWS_Q_hour: 'Entra: el que paguen els passatgers amb targeta (viatges i recàrregues de cartera), que arriba al compte de Stripe de WAIIS. Surt: el que els conductors retiren de la seva cartera al seu banc. Per hora, sense fallits ni reemborsats.',
          FLOWS_Q_day: 'Entra: el que paguen els passatgers amb targeta (viatges i recàrregues de cartera), que arriba al compte de Stripe de WAIIS. Surt: el que els conductors retiren de la seva cartera al seu banc. Per dia, sense fallits ni reemborsats.',
          FLOWS_Q_week: 'Entra: el que paguen els passatgers amb targeta (viatges i recàrregues de cartera), que arriba al compte de Stripe de WAIIS. Surt: el que els conductors retiren de la seva cartera al seu banc. Per setmana, sense fallits ni reemborsats.',
          FLOWS_IN: 'Entra · pagaments de passatgers',
          FLOWS_OUT: 'Surt · retirades de conductors',
          FLOWS_NET: 'Diferència',
          FLOWS_PERIOD: 'Període',
          FLOWS_TABLE: 'Veure les dades',
          FLOWS_WEEK_OF: 'setmana del {{date}}',
          FLOWS_TRUNCATED: 'Dades parcials: hi ha més de 1.000 moviments en aquest rang i només se sumen els més recents. Tria un rang més curt.',
          INSIGHT_PAYOUTS: 'Es van pagar {{paid}} de {{total}} retirades ({{pct}}).',
          INSIGHT_PAYOUTS_FAILED: '{{n}} van fallar o es van rebutjar: revisa la taula filtrant per {{concept}}.',
          INSIGHT_CHARGES_FAILED: '1 de cada {{n}} cobraments de viatge no es va cobrar ({{pct}}): són diners que no han entrat.',
          INSIGHT_CHARGES_OK: 'Tots els cobraments de viatge s\'han cobrat o encara estan en curs.',
          INSIGHT_CONCEPT: 'El més freqüent és {{label}}: {{pct}} dels moviments.',
          INSIGHT_MANUAL: '{{n}} ajustos manuals ({{pct}}): moltes correccions fetes a mà.',
          INSIGHT_NO_REFERRALS: 'Cap bonus per referit en aquest període.',
          SHOW_IN_TABLE: 'Veure a la taula',
          HELP: 'Què vol dir',
          SHOW: 'Veure estadístiques',
          HIDE: 'Amagar estadístiques',
          TITLE: 'Estadístiques de moviments',
          SUBTITLE: 'Dades del rang de la taula: {{range}}',
          PAYOUTS: 'Retirades per estat',
          PAYOUTS_Q: 'S\'està pagant als conductors?',
          PAYOUTS_TOTAL: '{{count}} retirades · {{valid}} sense fallides ni rebutjades',
          PAYOUT_PAID: 'Pagades',
          PAYOUT_PENDING: 'Pendents',
          PAYOUT_FAILED: 'Fallides o rebutjades',
          PAYOUT_REFUNDED: 'Retornades a la cartera',
          INSTANT_PAYOUTS: 'Retirades instantànies per estat',
          INSTANT_PAYOUTS_Q: 'Arriben les retirades instantànies als conductors?',
          INSTANT_PAYOUTS_TOTAL: '{{count}} retirades instantànies · {{valid}} sense fallides ni rebutjades',
          CHARGES: 'Cobraments de viatge per estat',
          CHARGES_Q: 'S\'estan cobrant els viatges als passatgers?',
          CHARGES_TOTAL: '{{count}} cobraments',
          CHARGE_COMPLETED: 'Cobrats',
          CHARGE_PENDING: 'Pendents',
          CHARGE_FAILED: 'Impagats',
          CHARGE_REFUNDED: 'Reemborsats',
          BY_CONCEPT: 'Quins moviments hi ha',
          BY_CONCEPT_Q: 'Quants moviments de cada concepte, de més a menys',
          TOTAL: '{{count}} moviments',
          EMPTY: 'Sense moviments en aquest rang',
          LOADING: 'Calculant estadístiques…',
          ERROR: 'No s\'han pogut carregar les estadístiques',
        },
        KPI: {
          PAYOUTS_24H: 'Retirades · darreres 24 h',
          PAYOUTS_24H_HINT: 'Retirades de conductors',
          PAYOUTS_24H_DETAIL: '{{count}} retirades',
          PAYOUTS_24H_UNCONFIRMED: '{{count}} sense confirmar',
          PAYOUTS_MONTH: 'Retirades · darrer mes',
          PAYOUTS_MONTH_HINT: 'Darrers 30 dies',
          PAYOUTS_MONTH_DETAIL: '{{count}} retirades',
          VS_PREVIOUS: '{{pct}} vs mes anterior',
          STRIPE: 'Saldo disponible a Stripe',
          STRIPE_HINT: 'Pendent: {{pending}}',
          UPDATED_JUST_NOW: 'Actualitzat ara',
          UPDATED_MINUTES: 'Actualitzat fa {{n}} min',
          UPDATED_HOURS: 'Actualitzat fa {{n}} h',
          UPDATED_ON: 'Actualitzat el {{date}}, {{time}}',
          NO_STRIPE_MOVEMENTS: 'Sense moviments',
          PENDING: 'Pendent de pagar',
          PENDING_HINT: 'Saldo retirable a wallets + retirades creades',
          COVERED: 'Cobert: Stripe = {{ratio}}× el pendent',
          NOT_COVERED: 'No cobert: falten {{missing}}',
          STRIPE_UNAVAILABLE: 'No disponible',
          ERROR: 'No s\'han pogut carregar els indicadors',
        },
        MOVEMENTS: {
          SEARCH: 'Cercar concepte, usuari o referència…',
          NO_MATCH: 'Cap moviment d\'aquesta pàgina coincideix amb «{{q}}»',
          CLEAR_SEARCH: 'Esborrar cerca',
          SEARCH_SERVER: 'Cercant a tots els moviments per {{filters}}',
          TITLE: 'Moviments recents',
          SUBTITLE: 'Cada viatge genera dos moviments interns: el pagament del passatger al conductor i la comissió de WAIIS. Els cobraments amb Stripe i les retirades són entrades i sortides reals de diners.',
          CLEAR: 'Netejar filtres',
          SHOWING: 'Mostrant {{count}} de {{total}} moviments',
          PREV: 'Anterior',
          NEXT: 'Següent',
          LOADING: 'Carregant moviments…',
          EMPTY: 'No hi ha moviments amb aquests filtres',
          ERROR: 'No s\'han pogut carregar els moviments',
          RETRY: 'Tornar-ho a provar',
          DELETED_USER: 'Usuari eliminat',
        },
        COLUMNS: {
          DATE: 'Data',
          MOVEMENT: 'Moviment',
          USER: 'Usuari',
          COUNTERPARTY: 'Contrapart',
          TYPE: 'Tipus',
          MEDIUM: 'Mitjà',
          AMOUNT: 'Import',
          STATUS: 'Estat',
        },
        FILTERS: {
          TYPE_ALL: 'Tipus: tots',
          CONCEPT_ALL: 'Concepte: tots',
          MEDIUM_ALL: 'Mitjà: tots',
          STATUS_ALL: 'Estat: tots',
          RANGE: 'Rang: {{range}}',
        },
        TYPE: {
          inbound: 'Entrada',
          outbound: 'Sortida',
          internal: 'Intern',
        },
        MEDIUM: {
          stripe: 'Stripe',
          balance: 'Saldo',
          manual: 'Manual',
        },
        STATUS: {
          completed: 'Completat',
          paid: 'Pagat',
          pending: 'Pendent',
          failed: 'Impagat',
          refunded: 'Reemborsat',
          held: 'Retingut',
        },
        RANGE: {
          '24h': '24 hores',
          '7d': '7 dies',
          '30d': '30 dies',
          '90d': '90 dies',
        },
        CONCEPT: {
          trip_charge: 'Cobrament del viatge',
          user_charge: 'Càrrec a l\'usuari',
          negative_balance_charge: 'Cobrament per saldo negatiu',
          trip_transfer: 'Pagament al conductor',
          trip_commission: 'Comissió WAIIS',
          driver_payout: 'Retirada a conductor',
          instant_payout: 'Retirada instantània',
          instant_payout_fee: 'Comissió de retirada instantània',
          instant_payout_refund: 'Devolució de retirada instantània',
          cae_discount: 'Bonificació CAE',
          manual_adjustment: 'Ajust manual',
          referral_bonus: 'Bonus per referit',
          corporate_ride_reclaim: 'Viatge d’empresa rebutjat',
          corporate_ride_reclaim_topup: 'Recàrrega per viatge d’empresa rebutjat',
        },
      },
      RECLAMATIONS: {
        PANEL: {
          ALL_TITLE: 'Totes les reclamacions',
          ALL_SUBTITLE: "Pendents i processades. Prem-ne una per veure'n el detall.",
          PENDING_TITLE: 'Reclamacions pendents',
          PENDING_SUBTITLE: 'Encara sense processar. Prem-ne una per revisar-la.',
          PROCESSED_TITLE: 'Reclamacions processades',
          PROCESSED_SUBTITLE: "Ja revisades per l'equip. Prem-ne una per veure'n el detall.",
        },
        SHOWING: 'Mostrant {{shown}} de {{total}} reclamacions',
        DETAIL: {
          BREADCRUMB_ARIA: 'Ruta de navegació',
          DETAIL: 'Detall',
          BACK: 'Tornar a reclamacions',
          LOADING: 'Carregant reclamació…',
          RETRY: 'Tornar-ho a provar',
          PROCESSED: 'Processada',
          PENDING: 'Pendent',
          REOPEN: 'Reobrir',
          MARK_PROCESSED: 'Marcar com a processada',
          RECEIVED: 'Rebuda',
          UPDATED: 'actualitzada {{date}}',
          PERSON: 'Persona',
          VIEW_PROFILE: 'Veure fitxa',
          NO_PERSON: 'Sense dades de la persona.',
          MANAGER: 'Gestor assignat',
          UNASSIGNED: 'Sense assignar',
          MANAGER_HINT: "El gestor s'assigna o es treu des del llistat de reclamacions.",
          CONTENT_TITLE: 'Què explica la persona',
          ENRICHED_TITLE: "Context enriquit de l'agent",
          NEEDS_REVIEW: 'Requereix revisió · {{value}}',
          DIAGNOSIS: 'Diagnòstic',
          PROBABLE_CAUSE: 'Causa probable',
          PROPOSED_RESOLUTION: 'Resolució proposada',
          CONVERSATION_SUMMARY: 'Resum de la conversa',
          SENTIMENT: 'Sentiment reportat',
          NO_ENRICHED_TITLE: 'Sense context enriquit',
          NO_ENRICHED_TEXT: "Aquest tiquet no té context enriquit: o no el va crear l'agent de suport, o el backend encara no exposa aquests camps al backoffice (vegeu <code>specs/reclamation-detail-backend-brief.md</code>).",
          RELATED: 'Elements relacionats',
          TRIP: 'Trajecte',
          OPEN: 'Obrir',
          ASSIGNMENT: 'Assignació',
          PAYMENT: 'Pagament',
          LOAD_ERROR: "No s'ha pogut carregar la reclamació.",
          UPDATE_ERROR: "No s'ha pogut actualitzar l'estat.",
          DOMAIN: {
            VALIDATION: 'Validació',
            CAE: 'CAE',
            CANCELLATION: 'Cancel·lació',
            PAYMENT: 'Pagament',
            CREDITS: 'Crèdits',
            ACCOUNT: 'Compte',
          },
          OUTCOME: {
            RESOLVED: "Resolt per l'agent",
            RESOLVED_WITH_REPORT: 'Resolt amb informe · requereix confirmació',
            ESCALATED_WRITE_REQUIRED: 'Escalat · requereix una acció manual',
            ESCALATED_DATA_MISMATCH: 'Escalat · les dades no coincideixen',
            ESCALATED_PRIORITY: 'Escalat · prioritat alta',
            ESCALATED_RECURRENCE: 'Escalat · incidència recurrent',
            ESCALATED_NO_DATA: 'Escalat · sense prou dades',
          },
          PRIORITY: {
            P0: 'P0 · crítica',
            P1: 'P1 · alta',
            P2: 'P2 · mitjana',
            P3: 'P3 · baixa',
          },
        },
        TITLE: 'Reclamacions',
        SEARCH_PLACEHOLDER: 'Cercar reclamacions...',
        TABS: {
          ALL: 'Totes',
          PENDING: 'Pendents',
          PROCESSED: 'Processades',
        },
        STATE: {
          LOADING: 'Carregant reclamacions',
          LOADING_HINT: 'Sol·licitant el llistat amb els filtres seleccionats.',
          ERROR: 'No s\'ha pogut carregar el llistat de reclamacions.',
          EMPTY: 'Sense resultats',
          EMPTY_HINT: 'No hi ha reclamacions que coincideixin amb els filtres.',
        },
        PAGINATION: {
          PREVIOUS: 'Anterior',
          NEXT: 'Següent',
          OF: 'de',
        },
        COLUMNS: {
          TITLE: 'Títol',
          CATEGORY: 'Categoria',
          SUBCATEGORY: 'Subcategoria',
          STATUS: 'Estat',
          USER: 'Usuari',
          DATE: 'Data',
        },
        STATUS: {
          PENDING: 'Pendent',
          PROCESSED: 'Processada',
        },
        FILTERS: {
          CATEGORY_ALL: 'Categoria: totes',
          SUBCATEGORY_ALL: 'Subcategoria: totes',
          CLEAR_ALL: 'Netejar filtres',
          TITLE: 'Filtres',
          APPLY: 'Aplicar filtres',
          CLEAR: 'Netejar',
          ALL: 'Tots',
          USER_ID: 'ID Usuari',
        },
        MODAL: {
          CLASSIFICATION: 'Classificació',
          TITLE: 'Detall de reclamació',
          CONTENT: 'Contingut',
          USER_SECTION: 'Usuari',
          USER_NAME: 'Nom',
          USER_EMAIL: 'Correu',
          USER_PHONE: 'Telèfon',
          USER_ROLE: 'Rol',
          VIEW_USER: "Veure fitxa d'usuari",
          NO_USER: "Dades d'usuari no disponibles",
          METADATA: 'Metadades',
          CREATED_AT: 'Creada',
          UPDATED_AT: 'Actualitzada',
        },
        ACTIONS: {
          RETRY: 'Tornar-ho a provar',
          OPEN: 'Obrir',
          SAVE: 'Desar',
          SAVING: 'Desant...',
          CANCEL: 'Cancel·lar',
          ACCEPT: 'Acceptar',
          MARK_PROCESSED: 'Marcar processada',
          REOPEN: 'Reobrir',
          VIEW_DETAIL: 'Veure detall complet',
        },
        SUCCESS: {
          TITLE: 'Correcte',
          UPDATED: "La reclamació s'ha actualitzat correctament",
        },
        ERROR: {
          TITLE: 'Error',
        },
        VALIDATION: {
          TITLE_REQUIRED: 'El títol és obligatori',
          CONTENT_REQUIRED: 'El contingut és obligatori',
          SUBCATEGORY_REQUIRES_CATEGORY:
            'La subcategoria requereix una categoria seleccionada',
        },
        INACTIVE_CODE: 'Inactiu',
      },
      RECLAMATION_TAXONOMY: {
        BREADCRUMB_ARIA: 'Ruta de navegació',
        LOADING_SUBCATEGORIES: 'Carregant subcategories',
        TITLE: 'Taxonomia de reclamacions',
        FORM: {
          UNCHANGED: 'Canvia el codi per poder desar',
          CODE: 'Codi (identificador)',
          CODE_PLACEHOLDER: 'ex. no_show',
          CODE_HINT: 'Només minúscules, números i guions baixos (snake_case).',
          PREVIEW: 'Vista prèvia',
        },
        DETAIL: {
          EDIT_CATEGORY: 'Editar categoria',
          SUBCATEGORIES: 'Subcategories',
        },
        MODAL: {
          NEW_CATEGORY: 'Nova categoria',
          NEW_SUBCATEGORY: 'Nova subcategoria',
        },
        ACTIONS: {
          RETRY: 'Tornar-ho a provar',
          BACK: 'Tornar al llistat',
          NEW_CATEGORY: 'Nova categoria',
          NEW_SUBCATEGORY: 'Afegir subcategoria',
          SAVE: 'Desar',
          SAVING: 'Desant...',
          CANCEL: 'Cancel·lar',
          ACCEPT: 'Acceptar',
          DELETE: 'Eliminar',
          DELETING: 'Eliminant...',
          DELETED: 'Eliminada',
          DELETE_CATEGORY: 'Eliminar categoria',
        },
        EMPTY: {
          CATEGORIES: 'No hi ha categories configurades.',
          CREATE_FIRST: 'Crear primera categoria',
          SUBCATEGORIES: 'Aquesta categoria no té subcategories.',
        },
        SUCCESS: {
          CATEGORY_CREATED: 'Categoria creada correctament',
          CATEGORY_UPDATED: 'Categoria actualitzada correctament',
          CATEGORY_DELETED: 'Categoria eliminada correctament',
          SUBCATEGORY_CREATED: 'Subcategoria creada correctament',
          SUBCATEGORY_DELETED: 'Subcategoria eliminada correctament',
        },
        ERROR: {
          LOAD_CATEGORIES: "No s'han pogut carregar les categories.",
          LOAD_SUBCATEGORIES: "No s'han pogut carregar les subcategories.",
          LOAD_CATEGORY: "No s'ha pogut carregar la categoria.",
          TITLE: 'Error',
          NOT_FOUND: 'Categoria no trobada',
        },
        VALIDATION: {
          CODE_REQUIRED: 'El codi és obligatori',
          CODE_FORMAT: 'Format no vàlid. Utilitza snake_case (ex. no_show)',
          CODE_MAX_LENGTH: 'El codi no pot superar 255 caràcters',
        },
        CONFIRM: {
          DELETE_SUBCATEGORY_TITLE: 'Eliminar subcategoria?',
          DELETE_SUBCATEGORY_TEXT:
            "S'eliminarà «{{label}}» (<code>{{code}}</code>). Les reclamacions existents conserven la seva classificació, però no es podrà utilitzar en reclamacions noves.",
          DELETE_CATEGORY_TITLE: 'Eliminar categoria?',
          DELETE_CATEGORY_TEXT:
            "S'eliminaran «{{label}}» (<code>{{code}}</code>) i <strong>totes les seves subcategories</strong>. No es pot desfer des del tauler; les reclamacions existents conserven la seva classificació.",
        },
      },
      TAGS: {
        SAVE: 'Desar',
        SAVING: 'Desant…',
        DISABLED: 'Desactivada',
        PICK_COLOR: 'Triar color',
        CLEAR_COLOR: 'Treure color',
        SAVE_ERROR: "No s'ha pogut desar l'etiqueta",
        DELETE_ERROR: "No s'ha pogut eliminar l'etiqueta",
        TITLE: 'Etiquetes',
        ADD: 'Afegir Etiqueta',
        EDIT: 'Editar Etiqueta',
        NAME: 'Nom',
        TSOFT_NAME: 'Nom TSoft',
        CATEGORY: 'Categoria',
        COLOR: 'Color',
        SUCCESS_CREATE: 'Etiqueta creada correctament',
        SUCCESS_UPDATE: 'Etiqueta actualitzada correctament',
        SUCCESS_DELETE: 'Etiqueta eliminada correctament',
        CONFIRM_DELETE: 'Estàs segur que vols eliminar aquesta etiqueta?',
        SEARCH: 'Cercar etiqueta',
        ACTIONS: 'Accions',
        WAIT: 'Espera..',
        ENABLED: 'Activada',
        ENABLE_TAG: 'Activar etiqueta',
        CATEGORIES: {
          ACTIVITY: 'Activitat',
          GENERAL: 'Generals',
          MISC: 'Miscel·lània',
        },
        SUCCESS: 'Èxit!',
        ERROR: 'Error',
        CONFIRM: 'Acceptar',
        CANCEL: 'Cancel·lar',
        ITEMS: 'etiquetes',
      },
      ROLES: {
        TITLE: 'Rols',
        ADD: 'Afegir Rol',
        EDIT: 'Editar Rol',
        NAME: 'Nom',
        CREATED_AT: 'Data Creació',
        UPDATED_AT: 'Data Edició',
        SUCCESS_CREATE: 'Rol creat correctament',
        SUCCESS_UPDATE: 'Rol actualitzat correctament',
        SUCCESS_DELETE: 'Rol eliminat correctament',
        CONFIRM_DELETE: 'Estàs segur que vols eliminar aquest rol?',
        SEARCH: 'Cercar rol',
        ACTIONS: 'Accions',
        WAIT: 'Espera..',
        SUCCESS: 'Èxit!',
        ERROR: 'Error',
        CONFIRM: 'Acceptar',
        CANCEL: 'Cancel·lar',
        ITEMS: 'rols',
      },
      AUTHORIZATION: {
        TITLE: 'Autorització',
        BACK_TO_ROLES: 'Torna a Rols',
        ROLES: {
          TITLE: 'Rols',
          ADD: 'Afegir Rol',
          EDIT: 'Editar Rol',
          NAME: 'Nom',
          CREATED_AT: 'Data Creació',
          UPDATED_AT: 'Data Edició',
          SUCCESS_CREATE: 'Rol creat correctament',
          SUCCESS_UPDATE: 'Rol actualitzat correctament',
          SUCCESS_DELETE: 'Rol eliminat correctament',
          CONFIRM_DELETE: 'Estàs segur que vols eliminar aquest rol?',
          SEARCH: 'Cercar rol',
          PANEL_SUB:
            "Rols que poden tenir els usuaris del backoffice. Edita'ls o obre les seves accions, permisos i pàgines.",
          MODAL_SUB: 'El nom amb què apareix el rol en assignar-lo.',
          ACTIONS: 'Accions',
          VIEW_ACTIONS: 'Veure Accions',
          VIEW_PERMISSIONS: 'Veure Permisos',
          VIEW_PAGES: 'Veure Pàgines',
          WAIT: 'Espera..',
          SUCCESS: 'Èxit!',
          ERROR: 'Error',
          CONFIRM: 'Acceptar',
          CANCEL: 'Cancel·lar',
        },
        ACTIONS: {
          ITEMS: 'accions',
          TITLE: 'Accions',
          ADD: 'Afegir Acció',
          EDIT: 'Editar Acció',
          ACTION: 'Acció',
          CREATED_AT: 'Data Creació',
          UPDATED_AT: 'Data Edició',
          SUCCESS_CREATE: 'Acció creada correctament',
          SUCCESS_UPDATE: 'Acció actualitzada correctament',
          SUCCESS_DELETE: 'Acció eliminada correctament',
          CONFIRM_DELETE: 'Estàs segur que vols eliminar aquesta acció?',
          SEARCH: 'Cercar acció',
          WAIT: 'Espera..',
          SUCCESS: 'Èxit!',
          ERROR: 'Error',
          CONFIRM: 'Acceptar',
          CANCEL: 'Cancel·lar',
        },
        ROLES_PERMISSIONS: {
          ITEMS: 'permisos',
          TITLE: 'Permisos',
          ADD: 'Afegir Permís',
          EDIT: 'Editar Permís',
          OPERATION_ID: 'Operació',
          DESCRIPTION: 'Descripció',
          SELECT_OPERATION: 'Selecciona una operació...',
          CREATE_MODAL_TITLE: 'Crear Permís',
          EDIT_MODAL_TITLE: 'Editar Permís',
          CREATED_AT: 'Data Creació',
          UPDATED_AT: 'Data Edició',
          SUCCESS_CREATE: 'Permís creat correctament',
          SUCCESS_UPDATE: 'Permís actualitzat correctament',
          SUCCESS_DELETE: 'Permís eliminat correctament',
          CONFIRM_DELETE: 'Estàs segur que vols eliminar aquest permís?',
          SEARCH: 'Cercar permís',
          WAIT: 'Espera..',
          SUCCESS: 'Èxit!',
          ERROR: 'Error',
          CONFIRM: 'Acceptar',
          CANCEL: 'Cancel·lar',
        },
        ROLES_PAGES: {
          ITEMS: 'pàgines',
          TITLE: 'Pàgines',
          ADD: 'Afegir Pàgina',
          EDIT: 'Editar Pàgina',
          PAGE_TAG: 'Pàgina',
          CREATED_AT: 'Data Creació',
          UPDATED_AT: 'Data Edició',
          SUCCESS_CREATE: 'Pàgina creada correctament',
          SUCCESS_UPDATE: 'Pàgina actualitzada correctament',
          SUCCESS_DELETE: 'Pàgina eliminada correctament',
          CONFIRM_DELETE: 'Estàs segur que vols eliminar aquesta pàgina?',
          SEARCH: 'Cercar pàgina',
          WAIT: 'Espera..',
          SUCCESS: 'Èxit!',
          ERROR: 'Error',
          CONFIRM: 'Acceptar',
          CANCEL: 'Cancel·lar',
        },
        USER_ROLE_CORPORATIONS: {
          TITLE: 'Assignacions de Rols a Usuaris',
          ADD: 'Nou',
          SEARCH: 'Cercar assignació',
          USER: 'Usuari',
          ROLE: 'Rol',
          TYPE: "Tipus d'Assignació",
          CORPORATION: 'Empresa',
          OFFICE: 'Oficina',
          OFFICE_LABEL: "Oficina d'Empresa",
          TYPE_AUTO_HINT:
            "El Tipus d'Assignació s'estableix automàticament segons el rol seleccionat.",
          PANEL_SUB:
            "Cada fila és un usuari amb un rol, i l'empresa o seu on el té.",
          MODAL_SUB:
            "Tria l'usuari i el seu rol; l'empresa o seu, si el rol la necessita.",
          LOADING: 'Carregant...',
          COL_USER: 'Usuari',
          COL_EMAIL: 'Correu',
          COL_ROLE: 'Rol',
          COL_TYPE: 'Tipus',
          COL_CORP_OFFICE: 'Empresa/Oficina',
          DELETE_CONFIRM_BTN: 'Eliminar',
          DELETE_CANCEL_BTN: 'Cancel·lar',
          CREATED_AT: 'Data Creació',
          UPDATED_AT: 'Data Edició',
          REQUIRED_TEXT: "Tria l'usuari i el rol.",
          DUPLICATE_TITLE: 'Assignació repetida',
          DUPLICATE_TEXT: 'Aquest usuari ja té aquesta assignació.',
          CREATE_ERROR: "No s'ha pogut crear l'assignació.",
          DELETE_ERROR: "No s'ha pogut eliminar l'assignació.",
          LOAD_ERROR: "No s'han pogut carregar les dades.",
          SUCCESS_CREATE: 'Assignació creada correctament',
          SUCCESS_DELETE: 'Assignació eliminada correctament',
          DELETE_CONFIRM:
            'Estàs segur que vols eliminar aquesta assignació?',
          WAIT: 'Espera..',
          SUCCESS: 'Èxit!',
          ERROR: 'Error',
          CONFIRM: 'Acceptar',
          CANCEL: 'Cancel·lar',
          ITEMS: 'assignacions de rols',
        },
      },
      CRUD: {
        PROCESSING: 'Carregant...',
        EMPTY_TABLE: 'No hi ha dades disponibles a la taula',
        INFO: 'Mostrant _START_ a _END_ de _TOTAL_ registres',
        INFO_EMPTY: 'Mostrant 0 a 0 de 0 registres',
        INFO_FILTERED: '(filtrat de _MAX_ registres totals)',
        LENGTH_MENU: 'Mostrar _MENU_ registres',
        LOADING_RECORDS: 'Carregant...',
        ZERO_RECORDS: "No s'han trobat registres coincidents",
        SEARCH: 'Cercar:',
        ACTIONS: 'Accions',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        SHOWING: 'Mostrant {{count}} de {{total}} {{items}}',
        ITEMS: 'registres',
        DELETE: 'Eliminar',
        DELETING: 'Eliminant…',
        DELETED: 'Eliminat',
        DELETE_ERROR: "No s'ha pogut eliminar",
        CONFIRM_DELETE_TITLE: 'Estàs segur?',
        CONFIRM_DELETE_TEXT: 'Aquesta acció desactiva el recurs seleccionat',
        ROW_VIEW: 'Veure',
        ROW_EDIT: 'Editar',
        ROW_DELETE: 'Esborrar',
        ROW_LINK: 'Vincular',
      },
      TERMS_CONDITIONS: {
        TITLE: 'Termes i Condicions d\'Ús',
        TAB_DASHBOARD: 'Dashboard',
        TAB_APP: 'App',
        CURRENT_VERSION: 'Versió vigent actualitzada el',
        NO_VERSION: 'Sense versió vigent — crea la primera versió',
        SAVING: 'Desant…',
        SAVE: 'Desar canvis',
        LOADING: 'Carregant contingut…',
        PLACEHOLDER: 'Escriu aquí els termes i condicions...',
        SUCCESS_SAVE: 'Canvis desats correctament',
        ERROR_ACTIVATE: 'Error en activar la versió',
        ERROR_SAVE: 'Error en desar els canvis',
        NOTE_TITLE: 'Desar és publicar',
        NOTE_TEXT: 'Cada desament crea una versió nova i passa a ser la vigent. El panell i l\'app tenen cadascun el seu text: tria la pestanya abans d\'editar.',
        EMPTY_HINT: 'Escriu el text per poder desar',
      },
      CONTRACT_TEMPLATES: {
        TITLE: 'Plantilla de contracte',
        CURRENT_VERSION: 'Versió vigent actualitzada el',
        HASH: 'Hash:',
        NO_VERSION: 'Sense versió vigent — crea la primera versió',
        SAVING: 'Desant…',
        SAVE: 'Desar canvis',
        LOADING: 'Carregant contingut…',
        PLACEHOLDER: 'Escriu aquí la plantilla de contracte...',
        SUCCESS_SAVE: 'Canvis desats correctament',
        ERROR_ACTIVATE: 'Error en activar la versió',
        ERROR_SAVE: 'Error en desar els canvis',
        NOTE_TITLE: 'Desar és publicar',
        NOTE_TEXT: 'Cada desament crea una versió nova i passa a ser la vigent: amb ella es genera el contracte de cada empresa. El que va entre claudàtors, com [Razón social del Cliente], ho omple el sistema amb les dades de l\'empresa: no ho canviïs.',
        EDITOR_TITLE: 'Text de la plantilla',
        EMPTY_HINT: 'Escriu el text per poder desar',
      },
      DATA_PROCESSING_AGREEMENT: {
        TITLE: "Contracte d'encàrrec de tractament (DPA)",
        CURRENT_VERSION: 'Versió vigent actualitzada el',
        NO_VERSION: 'Sense versió vigent — crea la primera versió',
        PUBLISH_HINT: "En desar es crea una versió nova i es publica: substitueix la vigent per a totes les altes d'empresa posteriors.",
        SOFT_BREAK_HINT: 'Dins una cel·la, Enter crea una altra cel·la: fes servir Maj+Enter per saltar de línia. Tabulant a l\'última cel·la s\'afegeix una fila.',
        SAVING: 'Desant…',
        SAVE: 'Desar i publicar',
        LOADING: 'Carregant contingut…',
        PLACEHOLDER: "Escriu aquí el contracte d'encàrrec de tractament...",
        SUCCESS_SAVE: "Contracte d'encàrrec desat i publicat correctament",
        ERROR_LOAD: "Error en carregar el contracte d'encàrrec",
        ERROR_ACTIVATE: 'La versió es va crear però no es va poder publicar',
        ERROR_SAVE: 'Error en desar els canvis',
        NOTE_TITLE: 'Desar és publicar',
        EDITOR_TITLE: 'Text del contracte',
        EMPTY_HINT: 'Escriu el text per poder desar',
        INSERT_TABLE: 'Inserir taula',
        TABLE_COLUMNS: '{{count}} columnes',
        CELL_BACKGROUND: 'Fons de cel·la',
        CELL_BG_PEACH: 'Préssec (etiquetes)',
        CELL_BG_LIGHT_BLUE: 'Blau clar',
        CELL_BG_NAVY: 'Blau marí (capçalera)',
        CELL_BG_GREY: 'Gris',
        CELL_BG_NONE: 'Sense fons',
        TABLE_COLUMN: '{{count}} columna',
      },
      LABELS: {
        SAVE: 'Desar',
        SEARCH: 'Cercar etiqueta',
        ADD: 'Afegir etiqueta',
        EDIT: 'Editar etiqueta',
        NAME: 'Nom',
        NAME_PLACEHOLDER: 'Ex. VIP',
        NAME_MAX_LENGTH: 'El nom no pot superar els 255 caràcters',
        CODE: 'Codi',
        CODE_PLACEHOLDER: 'Ex. vip',
        CODE_HINT:
          "Identificador estable de l'etiqueta: minúscules sense accents, números i guions baixos. Es proposa a partir del nom i pots canviar-lo.",
        CODE_INVALID:
          'Només minúscules sense accents, números i guions baixos, començant per una lletra',
        CODE_MAX_LENGTH: 'El codi no pot superar els 100 caràcters',
        APPLIES_TO: "S'aplica a",
        APPLIES_TO_OPTIONS: {
          ALL: 'Usuaris i rutes',
          USER: 'Usuaris',
          POOLING_ROUTE: 'Rutes de pooling',
        },
        APPLIES_TO_HINT:
          'Decideix en quines fitxes es pot assignar l\'etiqueta. "Usuaris i rutes" la deixa disponible a totes dues.',
        CANCEL: 'Cancel·lar',
        CONFIRM: "D'acord",
        WAIT: 'Desant…',
        SUCCESS: 'Correcte',
        SUCCESS_CREATE: "S'ha creat correctament l'etiqueta",
        SUCCESS_UPDATE: "S'ha actualitzat correctament l'etiqueta",
        SUCCESS_DELETE: "S'ha eliminat correctament l'etiqueta",
        ERROR: 'Error',
        SAVE_ERROR: "No s'ha pogut desar l'etiqueta",
        DELETE_ERROR: "No s'ha pogut eliminar l'etiqueta",
        NOT_FOUND: "L'etiqueta ja no existeix. Actualitza el llistat.",
        LOAD_ERROR: 'No s\'han pogut carregar les etiquetes',
        UNKNOWN_ERROR:
          "No s'ha pogut completar l'operació. Torna-ho a provar.",
        ITEMS: 'etiquetes',
      },
      VALORATION_LABELS: {
        SEARCH: 'Cercar etiqueta',
        ADD: 'Afegir etiqueta',
        EDIT: 'Editar etiqueta',
        NAME: 'Nom',
        NAME_MAX_LENGTH: 'El nom no pot superar els 255 caràcters',
        ROLE: 'Rol',
        ROLES: {
          BOTH: 'Ambdós',
          DRIVER: 'Conductor',
          RIDER: 'Passatger',
        },
        POSITIVE_NAME: 'Etiqueta positiva',
        POSITIVE_NAME_PLACEHOLDER: 'Ex. Cotxe net',
        NEGATIVE_NAME: 'Etiqueta negativa',
        NEGATIVE_NAME_PLACEHOLDER: 'Ex. Cotxe brut',
        PAIR_HINT:
          'Les etiquetes van sempre en parella: els vots en contra de la positiva són les vegades que es rep la negativa. Es creen totes dues alhora i la parella no es pot canviar després.',
        CANCEL: 'Cancel·lar',
        CONFIRM: 'Acceptar',
        WAIT: 'Desant…',
        SUCCESS: 'Correcte',
        SUCCESS_CREATE: 'S\'ha creat correctament l\'etiqueta de valoració',
        SUCCESS_UPDATE:
          'S\'ha actualitzat correctament l\'etiqueta de valoració',
        SUCCESS_DELETE:
          'S\'ha eliminat correctament l\'etiqueta de valoració',
        ERROR: 'Error',
        ITEMS: 'etiquetes de valoració',
        SAVE: 'Desar',
        SAVE_ERROR: 'No s\'ha pogut desar l\'etiqueta',
        DELETE_ERROR: 'No s\'ha pogut eliminar l\'etiqueta',
        NOT_FOUND: 'L\'etiqueta ja no existeix. Actualitza el llistat.',
        LOAD_ERROR: 'No s\'han pogut carregar les dades de l\'etiqueta',
        UNKNOWN_ERROR:
          'No s\'ha pogut completar l\'operació. Torna-ho a provar.',
      },
      FRAUD_RULES: {
        NOTE_TITLE: 'Aquests avisos ajuden a prioritzar, no prenen la decisió final',
        NOTE_TEXT: 'El sistema reuneix indicis i explica què ha detectat. Una persona ha de revisar el context abans de bloquejar un compte o retenir un pagament.',
        LOADING: 'Carregant les regles',
        LOAD_ERROR: 'No s\'han pogut carregar les regles del model.',
        SAVE_ERROR: 'No s\'han pogut desar les regles.',
        RETRY: 'Tornar-ho a provar',
        RULES_TITLE: 'Com es generen els avisos',
        RULES_SUB: 'Comportaments que fan que un viatge necessiti revisió',
        RULES_UNUSED: "Ara mateix no es fan servir: el model de l'equip de dades no els llegeix i no canvien cap avís. Es desen només com a referència.",
        MAX_SPEED: 'Velocitat màxima plausible (km/h)',
        MAX_GPS_JUMP: 'Salt GPS màxim entre punts (m)',
        MAX_TRIPS_DEVICE: 'Màx. trajectes/dia per dispositiu',
        NO_SHOWS: 'No-shows per marcar risc',
        NON_ELIGIBLE: 'Llindar de transport no elegible',
        COLLISION: 'Llindar de col·lusió / baixa independència',
        SPOOFING: 'Llindar de location spoofing',
        MANUAL_REVIEW: 'Llindar per a revisió manual',
        MIN_ZERO: 'Ha de ser 0 o més.',
        RANGE_ERROR: 'Ha d\'estar entre 0 i 1.',
        RANGE_HINT: 'Entre 0 i 1.',
        NOTICE_TITLE: 'Avís de verificació reforçada',
        NOTICE_SUB_1: 'Text que veu el conductor al detall del trajecte mentre el seu compte està en verificació reforçada.',
        NOTICE_SUB_2: 'se substitueix pels dies de termini configurats.',
        REQUIRED: 'El text és obligatori.',
        REINFORCED_TITLE: "Verificació reforçada",
        REINFORCED_SUB: "Quan entra un compte en verificació reforçada i què li passa mentre hi és.",
        AUTO_ENABLED: "Posar en verificació reforçada automàticament per score",
        AUTO_HINT: "S'aplica cada cop que l'equip de dades carrega una score nova. La llista blanca mai no hi entra.",
        AUTO_MIN_SCORE: "Score mínima",
        SCORE_RANGE: "Entre 0 i 100.",
        TRIP_DELAY: "Dies fins a abonar el viatge al conductor",
        WITHDRAWAL_DELAY: "Dies que espera una retirada",
        DAYS_RANGE: "Entre 0 i 90 dies.",
        MIN_PAYOUT: "Mínim per retirar (€)",
        FREE_INVITE: "En verificació reforçada pot continuar convidant a cost 0",
        FREE_INVITE_HINT: "Desmarcat, ningú en reforçada pot donar ni bescanviar viatges a cost 0. «Reforçada + sense cost 0» ho bloqueja sempre.",
        SWITCH_ON: "Activada",
        SWITCH_OFF: "Desactivada",
        SWITCH_TURN_ON: "Activar",
        SWITCH_TURN_OFF: "Desactivar",
        CANCEL: "Cancel·lar",
        CONFIRM_WORD: "CONFIRMAR",
        CONFIRM_TYPE: "Per continuar, escriu {{word}}.",
        AUTO_OFF_CONFIRM_TITLE: "Desactivar la reforçada automàtica?",
        AUTO_OFF_CONFIRM_TEXT: "Les scores noves deixaran de posar ningú en verificació reforçada. Qui ja hi és continua igual. Es desa al moment.",
        AUTO_ON_CONFIRM_TITLE: "Activar la reforçada automàtica?",
        AUTO_ON_CONFIRM_TEXT: "Cada score nova igual o més gran que {{score}} posarà aquell compte en verificació reforçada (excepte la llista blanca). Es desa al moment.",
        FREE_INVITE_OFF_CONFIRM_TITLE: "Bloquejar el cost 0 en reforçada?",
        FREE_INVITE_OFF_CONFIRM_TEXT: "Ningú en verificació reforçada podrà donar ni bescanviar viatges a cost 0, des d'ara. L'app ho llegeix del mateix valor. Es desa al moment.",
        FREE_INVITE_ON_CONFIRM_TITLE: "Permetre el cost 0 en reforçada?",
        FREE_INVITE_ON_CONFIRM_TEXT: "Qui sigui en verificació reforçada podrà tornar a convidar a cost 0 (excepte «Reforçada + sense cost 0»). Es desa al moment.",
        BACK: "Tornar a Frau",
        LAST_CHANGE: "Últim canvi: {{by}} · {{when}}",
        SOMEONE: "Automàtic",
        SAVE_CARD: "Desar",
        NEVER_CHANGED: "Últim canvi: encara no s'ha canviat mai des del backoffice (valors per defecte).",
        REVIEW_DAYS: "Avisar de revisar la score cada (dies)",
        REVIEW_DAYS_HINT: "Passats aquests dies sense desar la score, Frau ho avisa en vermell.",
        SAVED: 'Desat',
        FIX_FIELDS: 'Revisa els camps marcats per poder desar',
        SAVING: 'Desant…',
        SAVE: 'Desar les regles',
      },
      APP_ANNOUNCEMENT: {
        GO_VARIABLES: "Veure variables",
        NOTE_TITLE: "Cada persona veu el comunicat una vegada",
        NOTE_TEXT: "L'app mostra el comunicat fins que es prem el botó i en recorda l'identificador. <b>Desar canvis</b> manté l'identificador (per corregir errates): qui ja l'ha acceptat no el torna a veure. <b>Publicar com a comunicat nou</b> crea un altre identificador i el torna a veure tothom.",
        LOADING: "Carregant el comunicat…",
        LOAD_ERROR: "No s'ha pogut carregar el comunicat.",
        RETRY: "Tornar-ho a provar",
        VISIBILITY_TITLE: "Visibilitat",
        VISIBILITY_SUB: "Interruptor de la variable APP_ANNOUNCEMENT_ENABLED. Es desa a l'instant.",
        SHOW: "Mostrar comunicat",
        CURRENT_ID: "Comunicat publicat:",
        NO_ID: "Encara no s'ha publicat cap comunicat.",
        STATE_ON: "Visible a l'app",
        STATE_OFF: "Ocult",
        ENABLE: "Activar",
        DISABLE: "Desactivar",
        CONTENT_TITLE: "Textos",
        CONTENT_SUB: "El castellà és obligatori. En català i anglès, si no hi ha títol, l'app mostra la versió en castellà.",
        NO_ANNOUNCEMENT: "Encara no hi ha cap comunicat desat.",
        INVALID_STORED: "El valor desat d'APP_ANNOUNCEMENT no és un comunicat vàlid. En desar se substituirà per aquests textos.",
        LANGUAGE: "Idioma",
        LANG_ES: "Castellà",
        LANG_CA: "Català",
        LANG_EN: "Anglès",
        LANG_HAS_ERRORS: "Hi ha camps per corregir en aquest idioma",
        FALLBACK_HINT: "Sense text en aquest idioma: l'app mostrarà la versió en castellà.",
        FIELD_TITLE: "Títol",
        TITLE_REQUIRED: "Escriu un títol o un text en castellà.",
        FIELD_BODY: "Text",
        BODY_PLACEHOLDER: "Escriu el text del comunicat…",
        BODY_HELP: "Títols, negreta, cursiva, subratllat, llistes i <b>color destacat</b> (negreta en lila). Les imatges, els enllaços i els estils enganxats es treuen.",
        BODY_HELP_HTML: "HTML del cos. Només es desen <code>p</code>, <code>br</code>, <code>strong</code>, <code>em</code>, <code>u</code>, <code>h2</code>, <code>h3</code>, <code>ul</code>, <code>ol</code>, <code>li</code> i <code>&lt;span class=\"ql-color-accent\"&gt;</code>; la resta d'etiquetes i atributs es treuen en desar.",
        VIEW_HTML: "Veure HTML",
        VIEW_EDITOR: "Veure editor",
        ACCENT_COLOR: "Color destacat",
        FIELD_CTA: "Text del botó",
        PREVIEW_TITLE: "Previsualització",
        PREVIEW_SUB: "Així es veurà a l'app.",
        PREVIEW_THEME: "Tema de la previsualització",
        PREVIEW_LIGHT: "Clar",
        PREVIEW_DARK: "Fosc",
        COPY_HINT: "El que escriguis en castellà es copia sol al català i a l'anglès. Si vols una versió pròpia en un altre idioma, entra a la seva pestanya i canvia-la.",
        LINKED_HINT: "Copiat del castellà: s'actualitza sol. Si el canvies aquí, passa a ser una versió pròpia d'aquest idioma.",
        OWN_HINT: "Versió pròpia d'aquest idioma: ja no es copia del castellà.",
        RELINK: "Tornar a copiar del castellà",
        UNSAVED: "Hi ha canvis sense desar",
        NOT_PUBLISHED: "Comunicat sense publicar",
        FIX_FIELDS: "Revisa els camps marcats per poder desar",
        PUBLISH_NEW: "Publicar com a comunicat nou",
        SAVE_HINT: "Manté el comunicat actual: qui ja l'ha acceptat no el torna a veure.",
        SAVE: "Desar canvis",
        SAVING: "Desant…",
        SAVED: "Comunicat desat",
        ERROR_SAVE: "No s'ha pogut desar el comunicat",
        ERROR_TOGGLE: "No s'ha pogut canviar la visibilitat del comunicat",
        PUBLISH_NEW_TITLE: "Publicar com a comunicat nou",
        PUBLISH_NEW_TEXT_ON: "Es crea un comunicat nou i el tornaran a veure tots els usuaris en obrir l'app, també els que ja havien acceptat l'anterior.",
        PUBLISH_NEW_TEXT_OFF: "Es crea un comunicat nou. Quan l'activis, el veuran tots els usuaris, també els que ja havien acceptat l'anterior.",
        PUBLISH_NEW_CONFIRM: "Publicar",
        PUBLISHED_DONE: "Publicat",
        CANCEL: "Cancel·lar",
        ACCEPT: "Acceptar",
        ENABLE_NEEDS_SAVE: "Desa el comunicat abans d'activar-lo",
        ENABLE_TITLE: "Mostrar el comunicat",
        ENABLE_TEXT: "El veuran en obrir l'app els usuaris que encara no l'hagin acceptat.",
        ENABLE_TEXT_DIRTY: "El veuran en obrir l'app els usuaris que encara no l'hagin acceptat, amb els textos desats: els canvis sense desar no es mostren.",
        DISABLE_TITLE: "Amagar el comunicat",
        DISABLE_TEXT: "Ningú no el veurà en obrir l'app fins que el tornis a activar.",
        ENABLED_DONE: "Activat",
        DISABLED_DONE: "Desactivat",
      },
      CONFIG_VARIABLES: {
        MODAL_CREATE: 'Afegir variable de configuració',
        MODAL_EDIT: 'Editar variable de configuració',
        SECTION_VARIABLE: 'Variable',
        FIELD_NAME: 'Nom de la variable',
        NAME_PLACEHOLDER: 'p. ex.: app_version',
        NAME_REQUIRED: 'El nom és obligatori (mínim 3 caràcters; només lletres, números, guions i guions baixos)',
        FIELD_VALUE: 'Valor',
        VALUE_PLACEHOLDER: 'p. ex.: 1.0.0',
        VALUE_REQUIRED: 'El valor és obligatori',
        FIELD_DESCRIPTION: 'Descripció',
        DESCRIPTION_PLACEHOLDER: 'Descripció de la variable',
        FREE_TRIPS: {
          TITLE: 'Empreses amb coste 0',
          HINT: 'Els treballadors vinculats a l\'empresa viatgen com a passatgers a coste 0 en qualsevol trajecte d\'aquests dies (dates incloses).',
          SELECT_COMPANY: 'Selecciona una empresa',
          COMPANY: 'Empresa',
          FROM: 'Des de',
          TO: 'Fins a',
          ADD: 'Afegir empresa',
          REMOVE: 'Treure',
          EMPTY: 'Cap empresa amb coste 0.',
          INCOMPLETE: 'Tria l\'empresa i les dues dates (la final no pot ser abans de l\'inicial): si no, no s\'aplica.',
          INVALID: 'El valor guardat no es pot llegir; en desar se substituirà pel d\'aquí.',
        },
        SECTION_CLASSIFICATION: 'Classificació',
        FIELD_CATEGORY: 'Categoria',
        SELECT_CATEGORY: 'Seleccionar categoria',
        CATEGORY_REQUIRED: 'La categoria és obligatòria',
        FIELD_STATUS: 'Estat',
        ACTIVE: 'Activa',
        CREATE: 'Crear',
        SAVE: 'Desar',
        SAVING: 'Desant…',
        ACTIVATE_LOGS: 'Activar logs',
        ADD_TOOLTIP: 'Afegir nova variable',
        ADD: 'Afegir variable',
        PANEL_TITLE: 'Variables de configuració',
        PANEL_SUB: 'Cada fila és una variable amb el seu valor, la seva categoria i si està activa. Prem el llapis per editar-la.',
        LOADING: 'Carregant…',
        COL_NAME: 'Nom',
        COL_VALUE: 'Valor',
        COL_DESCRIPTION: 'Descripció',
        COL_CATEGORY: 'Categoria',
        COL_ACTIVE: 'Activa',
        COL_ACTIONS: 'Accions',
        LOAD_ERROR: 'No s\'han pogut carregar les variables de configuració.',
        RELOAD_ERROR: 'No s\'han pogut recarregar les variables de configuració.',
        RETRY: 'Tornar-ho a provar',
        YES: 'Sí',
        NO: 'No',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        SHOW: 'Mostrar',
        PER_PAGE: 'Registres per pàgina',
        RECORDS: 'registres',
        TTL_LABEL: 'Temps de vida (segons)',
        TTL_PLACEHOLDER: 'p. ex.: 3600',
        TTL_HINT: 'Indica quants segons estaran actius els logs',
        ACTIVATE: 'Activar',
        ACTIVATING: 'Activant…',
        DT_SEARCH: 'Cercar:',
        DT_LENGTH_MENU: 'Mostrar _MENU_ registres',
        DT_ZERO_RECORDS: 'No s\'han trobat registres',
        DT_INFO_EMPTY: 'Mostrant 0 de 0 variables',
        DT_INFO_FILTERED: '(filtrat de _MAX_ variables en total)',
        DT_FIRST: 'Primer',
        DT_LAST: 'Últim',
        DT_NEXT: 'Següent',
        DT_PREVIOUS: 'Anterior',
        DT_INFO: 'Mostrant {{shown}} de {{total}} variables',
        DELETE_TITLE: 'Eliminar variable de configuració',
        DELETE_TEXT: 'S\'eliminarà la variable «{{name}}».',
        DELETE_CONFIRM: 'Sí, eliminar',
        DELETING: 'Eliminant…',
        DELETED: 'Eliminada',
        DELETE_ERROR: 'No s\'ha pogut eliminar la variable',
        CREATED: 'Variable de configuració creada correctament',
        CREATE_ERROR: 'No s\'ha pogut crear la variable',
        UPDATED: 'Variable de configuració actualitzada correctament',
        UPDATE_ERROR: 'No s\'ha pogut actualitzar la variable',
        GENERIC_ERROR: 'S\'ha produït un error. Torna-ho a provar.',
        TTL_INVALID_TITLE: 'Valor no vàlid',
        TTL_INVALID_TEXT: 'Introdueix un valor més gran que 0',
        LOGS_ACTIVATED: 'Logs activats durant {{seconds}} segons',
        LOGS_ERROR: 'No s\'han pogut activar els logs',
      },
      COUPONS: {
        SHARED: {
          CLEAR: 'Netejar',
          REMOVE_FILTER: 'Treure {{label}}',
          SAVING: 'Desant…',
        },
        GIFT_CARDS: {
          ADD: 'Afegir cupó',
          SEARCH_PLACEHOLDER: 'Cercar cupó',
          SEARCH_LABEL: 'Cercar cupó',
          ITEMS: 'cupons',
          PROVIDER: 'Proveïdor',
          PROVIDER_REQUIRED: 'El proveïdor és obligatori',
          NAME: 'Nom del cupó',
          NAME_REQUIRED: 'El nom és obligatori',
          IMAGE: 'Imatge del cupó',
          IMAGE_REQUIRED: 'La imatge és obligatòria en crear un cupó',
          PREVIEW: 'Previsualització',
          DESCRIPTION: 'Descripció',
          DESCRIPTION_REQUIRED: 'La descripció és obligatòria',
          EXPIRATION: 'Caducitat',
          EXPIRATION_REQUIRED: 'La data de caducitat és obligatòria',
          CREDIT_VALUE: 'Valor en crèdits',
          CREDIT_VALUE_REQUIRED: 'El valor en crèdits és obligatori',
          EURO_VALUE: 'Valor en €',
          EURO_VALUE_REQUIRED: 'El valor en euros és obligatori',
          STATUS: 'Estat',
          STATUS_REQUIRED: 'L\'estat és obligatori',
          ACTIVE: 'Actiu',
          INACTIVE: 'Inactiu',
          COL_COUPON: 'Cupó',
          COL_PROVIDER: 'Proveïdor',
          COL_EXPIRATION: 'Caducitat',
          COL_CREDIT_VALUE: 'Valor en crèdits',
          COL_EURO_VALUE: 'Valor en €',
          COL_STATUS: 'Estat',
          COL_INSTRUCTIONS: 'Enllaç d\'instruccions',
          OPEN: 'Obrir',
          EDIT_TITLE: 'Editar cupó',
          CREATE_TITLE: 'Crear cupó',
          UPDATED: 'Targeta regal modificada correctament',
          CREATED: 'Targeta regal creada correctament',
          SAVE_ERROR: 'No s\'ha pogut desar la targeta regal',
        },
        CODES: {
          ADD: 'Afegir codi',
          SEARCH_PLACEHOLDER: 'Cercar codi',
          SEARCH_LABEL: 'Cercar codi',
          ITEMS: 'codis',
          COUPON: 'Cupó',
          COUPON_REQUIRED: 'El cupó és obligatori',
          CODE: 'Codi',
          CODE_REQUIRED: 'El codi és obligatori',
          INSTRUCTIONS: 'Instruccions',
          URL_INVALID: 'Introdueix una URL vàlida',
          ASSIGN_TO: 'Assignar a',
          IMPORT_TITLE: 'Importar CSV per cupó',
          IMPORT_SELECT_COUPON: 'Selecciona un cupó',
          IMPORT_SELECT_FILE: 'Selecciona un fitxer',
          IMPORT_FILE_REQUIRED: 'El fitxer és obligatori',
          IMPORT: 'Importar',
          STATUS_ALL: 'Tots',
          STATUS_AVAILABLE: 'Disponible',
          STATUS_EXPIRED: 'Caducat',
          STATUS_USED: 'Usat',
          COL_CODE: 'Codi',
          COL_INSTRUCTIONS: 'Instruccions',
          COL_PROVIDER: 'Proveïdor',
          COL_COUPON: 'Cupó',
          COL_EXPIRATION: 'Caducitat',
          COL_ASSIGNMENT: 'Data d\'assignació',
          COL_USER: 'Usuari',
          EDIT_TITLE: 'Editar codi',
          VIEW_TITLE: 'Detalls del codi',
          CREATE_TITLE: 'Crear codi',
          UPDATED: 'Codi modificat correctament',
          CREATED: 'Codi creat correctament',
          SAVE_ERROR: 'No s\'ha pogut desar el codi',
          IMPORTED: 'Codis importats correctament',
          IMPORT_ERROR: 'No s\'han pogut importar els codis',
          IMPORT_ERROR_TEXT: 'S\'ha produït un error en la importació de codis',
        },
        PROVIDERS: {
          ADD: 'Afegir proveïdor',
          SEARCH_PLACEHOLDER: 'Cercar',
          SEARCH_LABEL: 'Cercar proveïdor',
          ITEMS: 'proveïdors',
          LOGO: 'Logotip',
          NAME: 'Proveïdor',
          NAME_REQUIRED: 'El nom és obligatori',
          NAME_MIN: 'El nom ha de tenir com a mínim 4 lletres',
          CONTACT: 'Contacte',
          EMAIL_REQUIRED: 'El correu electrònic és obligatori',
          EMAIL_INVALID: 'El correu electrònic no és vàlid',
          LOADING: 'Carregant...',
          COL_PROVIDER: 'Proveïdor',
          COL_TOTAL_COUPONS: 'Total de cupons',
          COL_CONTACT: 'Contacte',
          EDIT_TITLE: 'Editar proveïdor',
          CREATE_TITLE: 'Crear proveïdor',
          UPDATED: 'Proveïdor modificat correctament',
          CREATED: 'Proveïdor creat correctament',
          SAVE_ERROR: 'No s\'ha pogut desar el proveïdor',
        },
        PROMO_CODES: {
          ITEMS: 'codis promocionals',
          KIND_APP: 'Promoció a l\'app',
          KIND_CAMPAIGN: 'Codi de campanya',
          LOADING_DETAIL: 'Carregant el codi promocional…',
          LOAD_DETAIL_ERROR: 'No s\'ha pogut carregar el codi promocional. Tanca el formulari i torna-ho a provar; no s\'ha desat res.',
          GUIDE_TITLE: 'Quin tipus de promoció configuraràs?',
          GUIDE_SUB: 'Guia: promoció a l\'app o codi de campanya, amb un exemple de cadascuna.',
          GUIDE_SHOW: 'Veure la guia',
          GUIDE_HIDE: 'Amagar la guia',
          GUIDE_APP_TEXT: 'L\'usuari la veu a «Promocions» i l\'activa amb el botó «Aplicar», sense escriure cap codi.',
          GUIDE_APP_EXAMPLE: 'Exemple: 5€ en el primer viatge Taxi/VTC',
          GUIDE_APP_1: 'Tipus <b>Absolut</b>, valor <b>5</b>',
          GUIDE_APP_2: 'S\'aplica a <b>només Taxi / VTC</b> (sense Carpooling)',
          GUIDE_APP_3: 'Nre. de viatges <b>1</b>: un viatge amb descompte',
          GUIDE_APP_4: 'Màx. viatges completats <b>0</b>: només usuaris que encara no han fet cap viatge de Taxi/VTC',
          GUIDE_APP_5: 'Viatges que compten: <b>Només els tipus als quals s\'aplica</b> (els viatges de carpooling no compten)',
          GUIDE_APP_6: '<b>Visible a l\'app</b> activat · zona si cal',
          GUIDE_APP_7: 'Textos en es/en/ca (el títol en castellà és obligatori)',
          GUIDE_APP_HINT: 'En triar <b>Visible a l\'app</b>, els camps buits s\'omplen amb aquesta configuració. Els pots canviar.',
          GUIDE_CAMPAIGN_TEXT: 'Només funciona si l\'usuari escriu el codi a «Tinc un codi promocional». No apareix a la targeta «Aplicar».',
          GUIDE_CAMPAIGN_EXAMPLE: 'Exemple: VERANO10, 10% en 3 viatges',
          GUIDE_CAMPAIGN_1: 'Tria <b>Només amb codi</b>',
          GUIDE_CAMPAIGN_2: 'Codi: el que es reparteix (<b>VERANO10</b>)',
          GUIDE_CAMPAIGN_3: 'Dates de la campanya',
          GUIDE_CAMPAIGN_4: 'Tipus i valor (<b>Percentatge 10</b>) i descompte màx./ús',
          GUIDE_CAMPAIGN_5: 'Nre. de viatges (<b>3</b>): obligatori en percentatge',
          GUIDE_CAMPAIGN_6: 'S\'aplica a <b>Carpooling</b> (els codis de campanya no poden ser de Taxi/VTC)',
          GUIDE_CAMPAIGN_HINT: 'Les altres condicions i els textos són de les promocions visibles a l\'app. A l\'app es mostra amb el codi com a títol.',
          GUIDE_NOTE: 'La diferència és a <b>«Com l\'aconsegueix l\'usuari?»</b>: visible a l\'app = s\'activa amb un botó; només amb codi = cal escriure\'l.',
          HOW_TITLE: 'Com l\'aconsegueix l\'usuari?',
          SECTIONS: 'Seccions del codi promocional',
          TAB_DISCOUNT: 'Descompte',
          CODE: 'Codi',
          CODE_HINT_APP: 'L\'app no el mostra, però continua funcionant si algú l\'escriu a «Tinc un codi promocional» (amb les mateixes regles). El títol visible va a «A l\'app».',
          CODE_HINT_CAMPAIGN: 'És el que escriu l\'usuari per bescanviar-lo.',
          START_DATE: 'Data d\'inici',
          START_DATE_REQUIRED: 'La data d\'inici és obligatòria',
          END_DATE: 'Data de fi',
          END_DATE_HINT: 'Buit = no caduca',
          DATES_HINT: 'Comença a les 00:00 del dia d\'inici i caduca a les 00:00 del dia de fi: l\'últim dia amb descompte és l\'anterior a la data de fi.',
          TYPE: 'Tipus',
          TYPE_REQUIRED: 'El tipus és obligatori',
          VALUE: 'Valor',
          VALUE_REQUIRED: 'El valor és obligatori',
          VALUE_MIN: 'El valor mínim permès és 0',
          VALUE_MAX: 'El valor màxim permès és {{max}}',
          FREE_TRIPS: 'Nre. de trajectes gratuïts',
          FREE_TRIPS_REQUIRED: 'El nombre de trajectes és obligatori',
          MAX_PER_USE: 'Descompte màx./ús',
          MAX_PER_USE_REQUIRED: 'El descompte màx./ús és obligatori',
          MAX_PER_USE_MIN: 'No pot ser negatiu',
          MAX_PER_USE_MAX: 'No pot superar el valor del cupó ({{limit}} €)',
          MAX_PER_USE_HINT: 'Topall que es descompta a cada viatge. 0 = sense límit.',
          NUM_ROUTES: 'Nre. de viatges',
          NUM_ROUTES_TIP: 'Quants viatges amb descompte té cada usuari. En percentatge és obligatori: sense això el cupó es bescanvia però no descompta mai.',
          NUM_ROUTES_PLACEHOLDER: 'P. ex. 3',
          NO_LIMIT: 'Sense límit',
          NUM_ROUTES_REQUIRED: 'En percentatge cal indicar en quants viatges descompta',
          NUM_ROUTES_MIN: 'Mínim 1 viatge',
          NUM_ROUTES_MAX_ONE: 'Amb «Màx. viatges completats» = {{completed}} només es pot fer servir en {{count}} viatge',
          NUM_ROUTES_MAX: 'Amb «Màx. viatges completats» = {{completed}} només es pot fer servir en {{count}} viatges',
          NUM_ROUTES_HINT: 'És el número que veu l\'usuari a «Et queden N viatges amb descompte».',
          NUM_ROUTES_FIRST_TRIP: 'Primer viatge: un sol viatge amb descompte (la regla es comprova a cada viatge).',
          APPLIES_TO: 'S\'aplica a',
          CAMPAIGN_ONLY_CARPOOLING: 'Els codis de campanya només poden ser de Carpooling.',
          REMOVED_VTC: 'Aquest codi tenia Taxi / VTC, que ja no es permet en codis de campanya. Revisa «S\'aplica a» abans de desar.',
          APPLIES_TO_REQUIRED: 'Selecciona com a mínim un tipus de viatge',
          APP_PROMO_NEEDS_VTC: 'Una promoció visible a l\'app ha d\'incloure Taxi / VTC: l\'app només les mostra en viatges sota demanda.',
          TAB_CONDITIONS: 'Condicions',
          FIRST_TRIP_RULES_ONLY_VTC: '«Màx. viatges completats» i «Viatges que compten» (regles de primer viatge) només estan disponibles quan «S\'aplica a» és només Taxi / VTC.',
          MAX_COMPLETED: 'Màx. viatges completats',
          MAX_COMPLETED_TIP: 'Només la poden fer servir usuaris amb com a màxim aquest nombre de viatges fets. 0 = primer viatge. Buit = qualsevol.',
          NO_RESTRICTION: 'Sense restricció',
          MAX_COMPLETED_HINT: 'Requisit per poder-la fer servir: quants viatges pot haver fet l\'usuari com a màxim. P. ex.: 0 = només qui encara no ha fet cap viatge. Aquest número no apareix a l\'app.',
          TRIPS_COUNTED: 'Viatges que compten',
          TRIPS_COUNTED_TIP: 'Quins viatges es compten per a «Màx. viatges completats». Amb «Només els tipus als quals s\'aplica», el carpooling no compta per a una promo de Taxi/VTC.',
          TRIPS_COUNTED_ALL: 'Tots els viatges',
          TRIPS_COUNTED_APPLICABLE: 'Només els tipus als quals s\'aplica',
          ZONE: 'Zona',
          ZONE_TIP: 'Només descompta si l\'origen del viatge és a dins. A l\'app es mostra com a «Vàlid a».',
          ANYWHERE: 'Qualsevol lloc',
          LEGACY_ZONE: 'Aquesta zona ja no és una zona de promoció. Es conserva si no la canvies; si en tries una altra, ja no hi podràs tornar.',
          ZONE_NO_PERMISSION: 'No tens permís per canviar la zona.',
          ZONE_ONLY_VTC: 'La zona només està disponible quan «S\'aplica a» és només Taxi / VTC.',
          TAB_APP: 'A l\'app',
          APP_TEXTS_HINT: 'Es mostren a la targeta «Aplicar», al detall i a «Aplicat».',
          TEXTS_LANGUAGE: 'Idioma dels textos',
          TITLE_LANG: 'Títol ({{lang}})',
          TITLE_PLACEHOLDER: '5€ de descompte en el teu primer viatge amb Taxi/VTC',
          DETAILS: 'Detalls',
          APPLIES_TO_TEXT: 'S\'aplica a (text)',
          EMPTY_TEXT_DELETES: 'Deixar un text buit l\'esborra.',
          STATUS_ALL: 'Tots',
          ACTIVE: 'Actiu',
          INACTIVE: 'Inactiu',
          TYPE_ABSOLUTE: 'Absolut',
          TYPE_PERCENTAGE: 'Percentatge',
          TYPE_BALANCE: 'Saldo',
          TYPE_FREE_TRIPS: 'Trajectes gratuïts',
          SELECT_ALL: 'Seleccionar-ho tot',
          TRIP_VTC_ALL: 'Taxi / VTC (tots els proveïdors)',
          TRIP_VTC: 'Taxi / VTC',
          TRIP_CARPOOLING: 'Carpooling',
          CODE_ONLY: 'Només amb codi',
          CODE_ONLY_HINT: 'L\'escriu a «Tinc un codi promocional»',
          SHOW_IN_APP: 'Visible a l\'app',
          SHOW_IN_APP_HINT: 'L\'activa amb «Aplicar», sense escriure el codi',
          COL_CODE: 'Codi',
          COL_START_DATE: 'Data d\'inici',
          COL_END_DATE: 'Data de fi',
          COL_VALUE: 'Valor',
          COL_FREE_TRIPS: 'Nombre de trajectes gratuïts',
          COL_MAX_PER_USE: 'Descompte màx./ús',
          COL_TYPE: 'Tipus de cupó',
          COL_STATUS: 'Estat',
          DELETE_ERROR_TITLE: 'No es pot eliminar',
          DELETE_IN_USE: 'Aquest codi ja l\'han aplicat o fet servir usuaris, així que no es pot eliminar. Perquè deixi de fer-se servir, edita\'l i posa com a data de fi la d\'avui.',
          DELETE_ERROR: 'No s\'ha pogut eliminar el codi promocional. Torna-ho a provar.',
          EDIT_TITLE: 'Editar codi promocional',
          CREATE_TITLE: 'Crear codi promocional',
          TITLE_ES_REQUIRED: 'Per mostrar-la a l\'app cal el títol en castellà',
          TITLE_EQUALS_CODE: 'El títol no pot ser igual al codi: l\'app no mostraria la promoció',
          UPDATED: 'Codi promocional modificat correctament',
          CREATED: 'Codi promocional creat correctament',
          SAVE_ERROR: 'No s\'ha pogut desar el codi promocional',
          VALUE_HELP_ABSOLUTE: 'Import total del cupó. Es gasta viatge a viatge fins que s\'esgota.',
          VALUE_HELP_BALANCE: 'Saldo que es carrega a l\'usuari.',
          VALUE_HELP_PERCENTAGE: 'Percentatge que es descompta de cada viatge.',
        },
      },
      ADMIN_HOME_MAP: {
        ROUTINES_24H: 'Rutines en les últimes 24 h',
        LOAD_ERROR: 'No s\'han pogut carregar els viatges recents',
        ZOOM_IN: 'Apropar',
        ZOOM_OUT: 'Allunyar',
      },
      ADMIN_FUNNEL: {
        DATE_RANGE_ERROR: 'La data d\'inici no pot ser posterior a la data de fi',
        LOAD_ERROR: 'Error en carregar les dades',
        PDF_CATEGORY: 'Categoria',
        PDF_VALUE: 'Valor',
      },
    },
    COMPANY: {
      PARKINGS: {
        COMMON: {
          BACK: 'Torna',
          BACK_TO_LIST: 'Torna al llistat',
          RETRY: 'Torna-ho a provar',
          LOADING: 'Carregant...',
          BREADCRUMB: 'Ruta de navegació',
          CANCEL: 'Cancel·la',
          SAVE: 'Desa',
          SAVE_CHANGES: 'Desa els canvis',
          SAVING: 'Desant…',
          ACCEPT: 'D\'acord',
          ACTIVE: 'Actiu',
          ACTIVE_F: 'Activa',
          INACTIVE_F: 'Inactiva',
          YES: 'Sí',
          NO: 'No',
          ALL_F: 'Totes',
          ALL_M: 'Tots',
          REMOVE_FILTER: 'Treu {{label}}',
          OPEN_CALENDAR: 'Obre el calendari',
          SELECT_DATE_TIME: 'Selecciona data i hora',
          PREFERENCES: 'Preferències',
          IMPORT_UNAVAILABLE: 'Importació no disponible',
          IMPORT_UNAVAILABLE_TEXT: 'La importació massiva per CSV encara no està disponible. No s\'ha desat cap dada.',
          NOT_ASSIGNED: 'No assignat',
          TOTAL: 'Total',
          TOTAL_COLON: 'Total:',
          VIEW_DATA: 'Mostra les dades',
        },
        FIELDS: {
          SPACE: 'Plaça',
          TYPE: 'Tipus',
          LOCATION: 'Ubicació',
          OFFICE: 'Seu',
          USER: 'Usuari',
          ROLE: 'Rol',
          PLATE: 'Matrícula',
          SHIFT: 'Torn',
          SHIFT_N: 'Torn {{n}}',
          DAYS: 'Dies',
          RESERVED_DAYS: 'Dies reservats',
          ASSIGNED_DAYS: 'Dies assignats',
          SHARING: 'Compartint',
          CREDIT: 'Crèdit',
          EXPIRY: 'Caducitat',
          START_DATE: 'Data d\'inici',
          END_DATE: 'Data de fi',
          STATUS: 'Estat',
          REASON: 'Raó',
          RESERVATION: 'Reserva',
          DAY: 'Dia',
        },
        ERRORS: {
          OFFICE_REQUIRED: 'La seu és obligatòria',
          USER_REQUIRED: 'L\'usuari és obligatori',
          PLATE_REQUIRED: 'La matrícula és obligatòria',
          SHIFT_REQUIRED: 'El torn és obligatori',
          DAYS_REQUIRED: 'Els dies són obligatoris',
          SPACE_NAME_REQUIRED: 'El nom de la plaça és obligatori',
          TYPE_REQUIRED: 'El tipus de plaça és obligatori',
          LOCATION_REQUIRED: 'La ubicació és obligatòria',
          REASON_REQUIRED: 'El motiu és obligatori',
          SPACE_REQUIRED: 'La plaça d\'aparcament és obligatòria',
          COUPON_REQUIRED: 'El valor del cupó és obligatori',
        },
        DAYS: {
          MON: 'Dilluns',
          TUE: 'Dimarts',
          WED: 'Dimecres',
          THU: 'Dijous',
          FRI: 'Divendres',
          SAT: 'Dissabte',
          SUN: 'Diumenge',
        },
        SHIFT_STATUS: {
          BUSY: 'Ocupat',
          FREE: 'Lliure',
        },
        ROLES: {
          DRIVER: 'Conductor',
          PASSENGER: 'Passatger',
        },
        SPACE_TYPES: {
          GENERAL: 'General',
          ELECTRIC: 'Cotxe elèctric',
          MOTORBIKE: 'Moto',
          TRUCK: 'Camió',
          VIP: 'VIP',
          ZONE: 'Zona {{n}}',
        },
        SPACES: {
          CREATE: 'Crea una plaça d\'aparcament',
          SEARCH: 'Cerca plaça d\'aparcament',
          ITEMS: 'places d\'aparcament',
          EDIT_TITLE: 'Edita la plaça d\'aparcament',
          CREATE_TITLE: 'Crea una plaça d\'aparcament',
          CREATE_SUBTITLE: 'Dona d\'alta una plaça d\'aparcament en una seu.',
          SPACE_LABEL: 'Plaça {{name}}',
          DETAIL: 'Detall',
          SAVED_EDIT: 'Plaça d\'aparcament modificada correctament',
          SAVED_CREATE: 'Plaça d\'aparcament creada correctament',
          SAVE_ERROR: 'No s\'ha pogut desar la plaça d\'aparcament',
          LOADING: 'Carregant la plaça d\'aparcament',
          DATA_TITLE: 'Dades de la plaça',
          DATA_SUB: 'Seu a què pertany, nom, tipus i on és.',
          PREFS_SUB: 'Només es poden reservar les places actives.',
          CREATE_BTN: 'Crea la plaça',
          NOT_FOUND: 'No s\'ha trobat la plaça d\'aparcament.',
          LOAD_ERROR: 'No s\'ha pogut carregar la plaça d\'aparcament.',
          RESERVATIONS: 'Reserves',
          RESERVATIONS_SUB: 'Qui té reservada aquesta plaça, en quin torn, quins dies i entre quines dates.',
          RESERVATIONS_ERROR: 'No s\'han pogut carregar les reserves.',
          NO_RESERVATIONS: 'Aquesta plaça no té reserves.',
          RESERVATIONS_FOOT: 'Es mostren {{shown}} de {{total}} reserves',
        },
        RESERVATIONS: {
          CREATE: 'Reserva una plaça d\'aparcament',
          SEARCH: 'Cerca plaça d\'aparcament',
          ITEMS: 'reserves d\'aparcament',
          EDIT_TITLE: 'Edita la reserva',
          CREATE_TITLE: 'Crea una reserva',
          FORM_SUBTITLE: 'Qui reserva, en quines dates i quina plaça ocupa.',
          SAVED_EDIT: 'Reserva modificada correctament',
          SAVED_CREATE: 'Reserva creada correctament',
          SAVE_ERROR: 'No s\'ha pogut desar la reserva',
          MISSING_FIELDS: 'Falten camps obligatoris',
          MISSING_FIELDS_TEXT: 'Emplena tots els camps obligatoris abans de continuar.',
          WHO_TITLE: 'Qui reserva',
          WHO_SUB: 'Tipus d\'usuari, seu i dades de la persona.',
          USER_TYPE: 'Tipus d\'usuari',
          EMPLOYEE: 'Empleat',
          EMPLOYEE_HINT: 'Persona d\'una seu: tries la seu i l\'empleat; la matrícula surt de la seva fitxa.',
          GUEST: 'Usuari convidat',
          GUEST_SHORT: 'Convidat',
          GUEST_HINT: 'Persona externa: escrius el seu nom i la seva matrícula.',
          DATES_TITLE: 'Dates i motiu',
          DATES_SUB: 'Des de quan i fins a quan es reserva la plaça, i per què.',
          REASON: 'Motiu de la reserva',
          REASON_PLACEHOLDER: 'Escriu el motiu aquí...',
          SPACE_TITLE: 'Plaça',
          SPACE_SUB: 'Assignació automàtica o elecció manual de la plaça.',
          SPACE_SELECTION: 'Selecció de plaça',
          AUTOMATIC: 'Automàtic',
          MANUAL: 'Manual',
          LOADING_SPACES: 'Carregant places…',
          LOAD_SPACES: 'Carrega les places disponibles',
          SPACES_COUNT: 'Places: {{n}}',
          SELECT_SPACE: 'Selecciona una plaça',
          PICK_SPACE_TO_SAVE: 'Tria una plaça per poder desar',
          DETAIL_TITLE: 'Detalls de la reserva',
          DETAIL_SUB: 'Qui té la plaça, quina és i en quines dates.',
          NOT_FOUND: 'No s\'ha trobat la reserva.',
          LOAD_ERROR: 'No s\'ha pogut carregar la reserva.',
          OCCUPANCY_INDEX: 'Índex d\'ocupació',
          PERIOD: 'Període',
          START: 'Inici',
          END: 'Fi',
          REASON_TITLE: 'Motiu',
        },
        CREDITS: {
          CREATE: 'Assigna un cupó de crèdit d\'aparcament',
          SEARCH: 'Cerca usuari',
          ITEMS: 'crèdits d\'aparcament',
          EDIT_TITLE: 'Edita el crèdit d\'aparcament',
          CREATE_TITLE: 'Aparcament públic - Assigna crèdit',
          CREATE_SUBTITLE: 'Tria la persona, la seu, els dies i el cupó de crèdit.',
          SAVED_EDIT: 'Crèdit d\'aparcament modificat correctament',
          SAVED_CREATE: 'Crèdit d\'aparcament assignat correctament',
          SAVE_ERROR: 'No s\'ha pogut desar el crèdit d\'aparcament',
          PERSON_TITLE: 'Persona',
          PERSON_SUB: 'A qui s\'assigna el crèdit, amb quin rol i quin vehicle.',
          PARKING_TITLE: 'Aparcament',
          PARKING_SUB: 'Seu, torn i dies en què pot fer servir l\'aparcament.',
          CREDIT_TITLE: 'Crèdit',
          CREDIT_SUB: 'Valor del cupó i període en què és vàlid.',
          COUPON_VALUE: 'Valor del cupó',
          CREDITS_WORD: 'crèdits',
          PREFS_SUB: 'Si el crèdit està actiu.',
          NOT_FOUND: 'No s\'ha trobat el crèdit d\'aparcament.',
          LOAD_ERROR: 'No s\'ha pogut carregar el crèdit d\'aparcament.',
          GENERAL_INFO: 'Informació general',
          OCCUPANCY_TITLE: 'Ocupació de l\'aparcament',
          OCCUPANCY_SUB: 'Dies i torn en què fa servir l\'aparcament.',
          OCCUPANCY: 'Ocupació',
          ENTRY: 'Entrada',
          EXIT: 'Sortida',
          USAGE_TITLE: 'Ús/assistència del crèdit',
          PAID_PARKING: 'Aparcament de pagament',
          USED: 'Utilitzat',
          NOT_USED: 'No utilitzat',
          UNKNOWN: 'Desconegut',
          USED_COLON: 'Utilitzat:',
          NOT_USED_COLON: 'No utilitzat:',
          NO_USAGE: 'No hi ha dades d\'ús.',
          CREDITS_COL: 'Crèdits',
          USAGE_INSIGHT: 'S\'ha fet servir el {{pct}} % dels crèdits d\'aquests {{days}} dies.',
          USAGE_LIST_TITLE: 'Ús de crèdits d\'aparcament',
          USAGE_LIST_SUB: 'Cada dia amb el seu crèdit i si es va fer servir.',
          USAGE_ITEMS: 'dies',
        },
      },
      INCENTIVE_STEPS: {
        OBJECTIVES: {
          PROFILE: 'Completar perfil',
          ROUTINE: 'Crear primera rutina',
          REQUEST: 'Enviar petició',
          MATCH: 'Fer match',
          TRAVEL: 'Realitzar primer viatge',
        },
        CREDIT_TYPES: {
          CREDITS: 'Crèdits WAIIS',
          TRAVEL: 'Viatges gratis',
          DISCOUNT: 'Descomptes en trajectes',
          BONUS: 'Bonificació mensual acumulable',
          EMPLOYEE: 'Bonificació per referir companys',
          SHARED: 'Bonificació cotxe compartit amb companys',
        },
      },
      INCENTIVES_LIST: {
        SEARCH: 'Cercar',
        CREATE: 'Crear incentiu',
        EDIT: 'Editar incentiu',
        COL_TYPE: 'Tipus',
        COL_FUNNEL_OBJECTIVE: 'Objectiu del funnel',
        COL_USERS_REACHED: 'Usuaris assolits',
        COL_START_END_DATE: 'Data inici / fi',
        COL_INCENTIVE_TYPE: "Tipus d'incentiu",
        COL_CONVERSIONS: 'Conversions',
        COL_STATUS: 'Estat',
        BONUS_PERCENTAGE_PER_TRIP: 'Percentatge per trajecte',
        BONUS_FIXED_PER_TRIP: 'Import fix per trajecte',
        BONUS_TOTAL: 'Bonificació total',
      },
      INCENTIVES_ADOPTION: {
        ERROR_TITLE: 'No s\'ha pogut desar la campanya',
        WHAT_TITLE: 'Què són els incentius?',
        WHAT_TEXT: 'Són recompenses i recordatoris que la teva empresa pot activar per motivar la plantilla a utilitzar WAIIS: des d\'un avís per email fins a saldo de benvinguda a l\'app. Tria la millor acció per a cada fase d\'adopció dels teus empleats.',
        CAMPAIGN_TITLE: 'Configura la campanya d\'incentius',
        ACTIVE: 'Activada',
        INACTIVE: 'Desactivada',
        EMPLOYEES: 'empleats',
        EMPLOYEE: 'empleat',
        WHAT_TO_SEND: 'Què envies a aquest grup?',
        SEND_EMAIL: 'Enviar correu',
        SEND_CREDIT: 'Enviar crèdit a l\'app',
        NO_COST: 'Sense cost',
        CUSTOM_AMOUNT: 'Import personalitzat per empleat',
        STAGE_COST: 'Cost d\'aquesta etapa',
        PER_EMPLOYEE_X: 'per empleat',
        EMAIL_SEND: 'Enviament per correu',
        STAGE_DISABLED: 'Etapa desactivada · no s\'envia',
        TOTAL_CAMPAIGN_COST: 'Cost total estimat de la campanya',
        SEND_CAMPAIGN: 'Enviar campanya',
        DAYS: 'dies',
        INACTIVITY_THRESHOLD: 'Llindar d\'inactivitat',
        INACTIVITY_SAVE_ERROR: 'No s\'ha pogut desar el llindar d\'inactivitat.',
        SENT_TITLE: 'Campanya enviada!',
        SENT_TEXT_COST: '{{count}} incentius encuats. S\'han carregat {{cost}} € a la cartera corporativa.',
        SENT_TEXT_FREE: '{{count}} incentius encuats. Sense cost.',
        INSUFFICIENT_BALANCE_TITLE: 'Saldo insuficient',
        INSUFFICIENT_BALANCE_TEXT: 'L\'empresa no té saldo suficient per cobrir el cost de la campanya. Recarrega la cartera abans de tornar-ho a intentar.',
        GO_TO_WALLET: 'Anar a la cartera',
        SEND_ERROR: 'No s\'ha pogut enviar la campanya. Revisa les dades i torna-ho a intentar.',
        NOT_REGISTERED: 'No s\'han registrat',
        NOT_REGISTERED_DESC: 'Empleats que encara no tenen un compte WAIIS vinculat. Envia\'ls un recordatori per correu perquè es donin d\'alta.',
        PENDING_DNI: 'No s\'han verificat el DNI',
        PENDING_DNI_DESC: 'Empleats amb compte creat però amb la verificació d\'identitat pendent. Pots enviar-los un avís per correu o crèdit de benvinguda.',
        NO_TRIPS: 'No han realitzat viatges',
        NO_TRIPS_DESC: 'Empleats registrats i verificats que encara no han fet cap trajecte. Motiva\'ls amb un correu o crèdit a l\'app.',
        SEG_INACTIVE: 'Inactius',
        SEG_INACTIVE_DESC: 'Empleats que van usar WAIIS però porten més del llindar configurat sense activitat. Reactiva\'ls amb un recordatori o un incentiu.',
        PAGE_NAME: 'Incentius',
        ALL_OFFICES: 'Tots els centres',
        HISTORY_TITLE: 'Historial de campanyes',
        HISTORY_EMPTY: 'Encara no s\'han enviat campanyes.',
        HISTORY_STATUS_SENT: 'Enviada',
        HISTORY_STATUS_IN_PROGRESS: 'En curs',
        HISTORY_STATUS_COMPLETED: 'Completada',
        HISTORY_STATUS_CANCELLED: 'Cancel·lada',
        SEND_CONFIRM_TITLE: 'Segur que vols enviar la campanya?',
        SEND_CONFIRM_TEXT: 'Es llançaran {{segments}} campanya(es) per a {{recipients}} empleats, amb {{cost}} € compromesos de la cartera.',
        SEND_CONFIRM_OK: 'Enviar',
        SENT_SEGMENT_OK: '{{count}} empleats · {{amount}} € compromesos',
        EMPTY_SEGMENT_ERROR: 'No hi ha empleats a qui enviar: el segment és buit o ja són en una altra campanya activa.',
        FEATURE_LOCKED: 'El pla de l\'empresa no inclou incentius.',
        CAMPAIGN_NOT_CANCELLABLE: 'La campanya ja és tancada i no es pot cancel·lar.',
        RECIPIENT_NOT_CANCELLABLE: 'L\'empleat ja no és pendent i no es pot cancel·lar.',
        DETAIL_COMMITTED: 'Compromès',
        DETAIL_PAID: 'Abonat',
        RECIPIENTS_TITLE: 'Empleats de la campanya',
        GROUP_CAMPAIGNS: 'Campanyes del grup',
        SEND_SCOPE_ALL: 'S\'enviarà als empleats de totes les seus',
        SEND_SCOPE_OFFICE: 'S\'enviarà només als empleats de {{office}}',
        SEGMENT_UNKNOWN: 'Diversos segments',
        DETAIL_COMPLETED: 'Completats',
        CANCEL_GROUP: 'Cancel·lar grup',
        GROUP_NOT_CANCELLABLE: 'El grup no té cap campanya viva per cancel·lar.',
        CANCEL_GROUP_CONFIRM_TITLE: 'Vols cancel·lar tot el grup?',
        CANCEL_GROUP_CONFIRM_TEXT: 'Es cancel·laran les {{count}} campanyes que segueixen vives i s\'alliberarà el seu import compromès. El que ja s\'ha cobrat no es veu afectat.',
        CANCEL_GROUP_CONFIRM_OK: 'Cancel·lar grup',
        CANCEL_GROUP_OK_TITLE: 'Grup cancel·lat',
        CANCEL_GROUP_OK_TEXT: '{{count}} campanyes cancel·lades · {{amount}} € alliberats.',
        CANCEL_CHILD_CONFIRM_TEXT: 'Es cancel·larà la campanya de «{{segment}}» i els seus {{count}} empleats pendents.',
        OFFICE: 'Seu',
        SEGMENT_IN_PROGRESS: '{{count}} ja en una altra campanya activa',
        RECIPIENTS_EMPTY: 'Encara no hi ha empleats en aquesta campanya.',
        RECIPIENT_EMPLOYEE: 'Empleat',
        RECIPIENT_PAID_AT: 'Abonat el',
        RECIPIENT_STATUS_PENDING: 'Pendent',
        RECIPIENT_STATUS_COMPLETED: 'Completat',
        RECIPIENT_STATUS_CANCELLED: 'Cancel·lat',
        CANCEL_REASON_MANUAL: 'Cancel·lat manualment',
        CANCEL_REASON_CAMPAIGN: 'Campanya cancel·lada',
        CANCEL_REASON_UNLINKED: 'Empleat donat de baixa',
        CANCEL_CAMPAIGN: 'Cancel·lar campanya',
        CANCEL_RECIPIENT: 'Cancel·lar',
        CANCEL_CONFIRM_BACK: 'Tornar',
        CANCEL_CAMPAIGN_CONFIRM_TITLE: 'Vols cancel·lar tota la campanya?',
        CANCEL_CAMPAIGN_CONFIRM_TEXT: 'Es cancel·laran els {{count}} empleats que segueixen pendents i s\'alliberarà el seu import compromès. Els que ja han cobrat no es veuen afectats.',
        CANCEL_CAMPAIGN_CONFIRM_OK: 'Cancel·lar campanya',
        CANCEL_CAMPAIGN_OK_TITLE: 'Campanya cancel·lada',
        CANCEL_CAMPAIGN_OK_TEXT: 'S\'han alliberat {{amount}} € compromesos.',
        CANCEL_RECIPIENT_CONFIRM_TITLE: 'Vols cancel·lar aquest empleat?',
        CANCEL_RECIPIENT_CONFIRM_TEXT: 'Es cancel·larà l\'incentiu de {{email}} i s\'alliberarà el seu import.',
        CANCEL_RECIPIENT_CONFIRM_OK: 'Cancel·lar empleat',
        CLOSE: 'Tancar',
        HISTORY_STATUS_SCHEDULED: 'Programada',
        HISTORY_STATUS_FAILED: 'Fallida',
        HISTORY_DETAIL_TITLE: 'Detall de campanya',
        HISTORY_DATE: 'Data de creació',
        HISTORY_STATUS: 'Estat',
        HISTORY_SENT_AT: 'Data d\'enviament',
        HISTORY_SEND_AT: 'Data programada',
        HISTORY_RECIPIENTS: 'Destinataris',
        HISTORY_COST: 'Cost total',
        HISTORY_FAILURE_REASON: 'Motiu del error',
        HISTORY_SCHEDULED_INFO: 'Campanya programada — encara no s\'ha processat.',
        HISTORY_SEGMENT: 'Segment',
        HISTORY_CHANNEL: 'Canal',
        HISTORY_AMOUNT: 'Import / empleat',
      },
      INCENTIVE_FORM: {
        SELECTION: 'Selecció',
        PREVIOUS: 'Anterior',
        CONTINUE: 'Continuar',
        SAVE: 'Desar',
        SUCCESS_TITLE: 'Correcte!',
        UPDATED_SUCCESS: "L'incentiu s'ha actualitzat correctament",
        CREATED_SUCCESS: "L'incentiu s'ha creat correctament",
        ERROR_TITLE: 'Error',
        EDIT_TITLE: 'Editar incentiu',
        CREATE_TITLE: 'Crear incentiu',
        TABS: {
          OBJECTIVES: 'Objectius',
          TYPES: 'Tipus',
          ACTIVATION: 'Activació',
          DURATION: 'Durada',
          COMMUNICATION: 'Comunicació',
          BONUSES: 'Bonificacions',
        },
      },
      INCENTIVE_DETAILS: {
        BACK: 'Tornar',
        TITLE: "Detalls de l'incentiu",
        TYPE: 'Tipus',
        OBJECTIVE: 'Objectiu',
        INCENTIVE_TYPE: "Tipus d'incentiu",
        ACTIVATION: 'Activació',
        START_END_DATE: 'Data inici / fi',
        COMMUNICATION: 'Comunicació',
        BASIC_INFO: 'Informació bàsica',
        BONUS_TYPE: 'Tipus de bonificació',
        AMOUNT: 'Import',
      },
      SUSTAINABILITY: {
        REPORT_TITLE: 'Informe de sostenibilitat',
        REPORT_DETAILS: 'Detalls de l\'informe',
        REPORT_SUB: 'Dades reals d\'ús, actualitzades cada mes.',
        PERIOD: 'Període:',
        CO2_AVOIDED_IN: 'CO₂e evitat durant {{period}}',
        CO2_AVOIDED_DESC: 'CO₂e evitades pel carpooling dels teus empleats durant {{period}}.',
        ACCUMULATED: 'Acumulat {{year}} · {{range}}',
        ACCUMULATED_SUB: 'CO₂e evitades en el que va d\'any',
        ACCUMULATED_FOOT: 'Total de l\'any, independentment del mes seleccionat.',
        IMPACT_EQUIVALENCES: 'Equivalències d\'impacte',
        TREES_YEAR: '{{n}} arbres/any',
        TREES_DESC: 'Equivalent al que absorbirien en un any.',
        KM: '{{n}} km',
        KM_DESC: 'Trajectes en solitari que s\'han evitat.',
        OCCUPANTS: '{{n}} ocupants',
        OCCUPANTS_DESC: 'Mitjana de persones per vehicle compartit.',
        TITLE: 'Sostenibilitat',
        ALL_OFFICES: 'Tots els centres',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock Actiu',
        SELECT_MONTH_YEAR: 'Seleccionar mes i any',
        TOTAL_CARBON_FOOTPRINT: 'Petjada de Carboni Total',
        COMPANY_WORKERS: "Treballadors de l'Empresa",
        SUM_EMISSIONS_GENERATED: 'Suma de les emissions generades',
        SUSTAINABLE_MOBILITY_SAVINGS: 'Estalvi de Mobilitat Sostenible',
        THIS_MONTH_SAVED: 'Aquest mes has estalviat',
        EQUIVALENT_TREES: '<strong>{{count}} arbres</strong> plantats',
        EQUIVALENT_FLIGHTS:
          '<strong>{{count}} vols</strong> Madrid-Barcelona evitats',
        EQUIVALENT_LED_HOURS:
          '<strong>{{hours}} hores</strong> de bombeta LED encesa',
        EQUIVALENT_MOBILE_CHARGES:
          '<strong>{{charges}} càrregues</strong> de mòbil completes',
        FOOTPRINT_BY_OFFICE: 'Petjada per Oficina',
        EMISSIONS_BY_WORK_CENTER: 'Emissions per centre de treball',
        FOOTPRINT_BY_DEPARTMENT: 'Petjada per Departament',
        EMISSIONS_BY_DEPARTMENT: 'Emissions per departament',
        NO_DATA: 'No hi ha dades disponibles per a aquest període',
        MONTHLY_ECONOMIC_COST: 'Cost Econòmic Mensual',
        ESTIMATED_TRIPS: 'Estimat dels trajectes',
        TRAVEL_ALONE: 'Viatgen sols',
        CARPOOL: 'Comparteixen cotxe',
        PEOPLE_COUNT: '<strong>{{count}} persones</strong>',
        TOTAL_COST: 'Cost total: <strong>{{cost}} €</strong>',
        AVERAGE_COST_MONTH:
          'Cost mitjà: <strong class="text-warning">{{cost}} €/mes</strong>',
        CARBON_FOOTPRINT: 'Petjada de Carboni',
        MONTHLY_ESTIMATED: 'Estimada mensualment',
        TOTAL_EMISSIONS_MONTHLY:
          'Emissions totals: <strong>{{emissions}} kg CO₂/mes</strong>',
        EMISSIONS_PER_PERSON:
          'Emissions per persona: <strong class="text-info">{{emissions}} kg/persona</strong>',
        FOOTPRINT_BY_WORKER: 'Petjada per Treballador',
        INDIVIDUAL_EMISSIONS_LINKED:
          'Emissions individuals vinculades a trajectes realitzats',
        SEARCH_BY_WORKER: 'Cercar per treballador',
        WORKER: 'Treballador',
        DISTANCE_TRAVELED: 'Distància recorreguda',
        TRANSPORT_MODE: 'Mode de transport utilitzat',
        EMISSION_FACTOR: "Factor d'emissió aplicat",
        EMISSION_SAVINGS: "Estalvi d'emissions",
      },
      TRAVEL: {
        ALL: 'Tots',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock Actiu',
        SELECT_MONTH_YEAR: 'Selecciona mes i any',
        TRAVELS: 'Viatges',
        DISTANCE_DURATION_BY_USER: 'Distància i durada per usuari',
        ROUTINES_CREATED: 'Rutines creades',
        TRAVEL_HOURS: 'Viatges Hora',
        TRAVEL_DAYS: 'Viatges dia',
        KM_WITH_PASSENGER: 'Km recorreguts amb ≥1 passatger',
        AVG_PASSENGERS_PER_CAR: 'Mitjana de passatgers per cotxe',
        USER_ADDRESSES: 'Adreces dels usuaris',
        NO_DATA: 'No hi ha dades disponibles',
        LOADING: 'Carregant...',
        // Descripciones de estadísticas
        DRIVERS: 'Conductors',
        PASSENGERS: 'Passatgers',
        // Columnas de tabla de viajes
        DATE: 'Data',
        DRIVER: 'Conductor',
        PASSENGER: 'Passatger',
        PRICE: 'Preu',
        DESTINATION: 'Destí',
        // Columnas de tabla de distancia y duración
        NAME: 'Nom',
        AVERAGE_DISTANCE: 'Distància Mitjana',
        AVERAGE_DURATION: 'Durada Mitjana',
        TRIPS: 'Viatges',
        // Columnas de tabla de rutinas
        ORIGIN: 'Origen',
        ROUTINES: 'Rutines',
        USERS: 'Usuaris',
        // Etiquetas de gráficas
        HOURS: 'Hores',
        DAY: 'Dia',
        // Mensajes de DataTables
        INFO: 'Mostrant _START_ a _END_ de _TOTAL_ registres',
        INFO_EMPTY: 'Mostrant 0 a 0 de 0 registres',
        INFO_FILTERED: '(filtrat de _MAX_ registres totals)',
        // Dies de la setmana
        MONDAY: 'Dilluns',
        TUESDAY: 'Dimarts',
        WEDNESDAY: 'Dimecres',
        THURSDAY: 'Dijous',
        FRIDAY: 'Divendres',
        SATURDAY: 'Dissabte',
        SUNDAY: 'Diumenge',
      },
      FUNNEL: {
        ERROR_DATE_RANGE: 'La data d\'inici no pot ser posterior a la data de fi',
        ERROR_LOAD: 'Error en carregar les dades',
        PDF_CATEGORY: 'Categoria',
        PDF_VALUE: 'Valor',
        TITLE: 'Funnel',
        COMPANY_FALLBACK: 'Empresa',
        MOCK: 'Dades de prova',
        MOCK_ACTIVE: 'Dades de prova (actiu)',
        OFFICE: 'Seu:',
        ALL_OFFICES: 'Tots els centres',
        START_DATE: "Data d'inici:",
        END_DATE: 'Data de fi:',
        LOAD: 'Carregar',
        LOADING: 'Carregant...',
        COMPARATIVE: 'Comparativa',
        LEGEND_GLOBAL: 'Global',
        LEGEND_COMMERCIAL: 'Comercial',
        LEGEND_COMPANY: 'Empresa',
        FILTER_GLOBAL: 'Global',
        FILTER_COMMERCIAL: 'Comercial',
        FILTER_COMPANY: 'Empresa',
        PRESETS: {
          LAST_7_DAYS: 'Últims 7 dies',
          LAST_30_DAYS: 'Últims 30 dies',
          LAST_90_DAYS: 'Últims 90 dies',
          THIS_YEAR: 'Aquest any',
          CUSTOM: 'Rang personalitzat',
        },
        STAGES: {
          REGISTERED: 'Registrats',
          LINKED: 'Vinculats',
          WITH_ROUTINE: 'Amb rutina',
          REQUEST_SENT_OR_RECEIVED: 'Petició enviada o rebuda',
          SHARING: 'Compartint',
          TRIP_COMPLETED: 'Viatge realitzat',
          SHARED_TRIP: 'Viatge compartit',
          RECURRENT: 'Recurrents',
          TOTAL_USERS: 'Total usuaris',
          TOTAL_USERS_WITH_ROUTINE: 'Total usuaris amb rutina',
          TOTAL_USERS_ROUTINE_COMPLETED: 'Total usuaris amb rutina completada',
          TOTAL_USERS_ROUTINE_SHARED_COMPLETED:
            'Total usuaris amb rutina compartida completada',
        },
        STAGE_HINTS: {
          '0': "Treballadors donats d'alta",
          '1': 'Han creat una ruta recurrent',
          '2': 'Han completat almenys un viatge (sols o compartit)',
          '3': 'Han compartit almenys un viatge',
          '4': '3 o més viatges compartits',
        },
        BASE: 'base 100%',
        VS_PREVIOUS_MONTH: 'vs període ant.',
        DROP: 'caiguda',
        EMPLOYEES: 'treballadors',
        BIGGEST_LOSS: 'major pèrdua',
        COMING_SOON: 'Properament',
        NO_DATA: 'No hi ha dades de funnel per al període seleccionat.',
        MANAGE_INCENTIVES: 'Gestionar incentius',
        SEND_COMMUNICATION: 'Enviar comunicació a aquest grup',
        INSIGHT: {
          TITLE: 'El major abandonament està entre «{{from}}» i «{{to}}» (−{{percentage}}%).',
          DESCRIPTION:
            "És el punt exacte on convé activar incentius: només {{converted}} dels {{base}} treballadors que ja han passat per aquesta etapa arriben a {{toStage}}. Convertir aquest grup és la palanca més rendible per pujar l'adopció d'ús.",
        },
      },
      COMMON: {
        GENERATING_PDF: "S'està generant el PDF, espera si us plau...",
        LOADING: 'Carregant...',
        ACCEPT: 'Acceptar',
        CANCEL: 'Cancel·lar',
        SAVE: 'Desar',
        FILTERS: 'Filtres',
        CLOSE: 'Tancar',
        SELECT_DATE: 'Selecciona una data',
        APPLY_FILTERS: 'Aplicar filtres',
        CLEAR: 'Netejar',
        EXPORT_CSV: 'Exportar CSV',
        IMPORT_CSV: 'Importar CSV',
        ACTIVE: 'Actiu',
        WAIT: 'Espera..',
        BASIC_INFO: 'Informació bàsica',
        FISCAL_ADDRESS: 'Adreça Fiscal',
        ADDRESS: 'Adreça',
        CITY: 'Ciutat',
        POSTAL_CODE: 'Codi postal',
        OFFICE_NAME: 'Nom de la seu',
        OFFICE_NAME_REQUIRED: 'El nom fiscal és requerit',
        CONTACT_PERSON: 'Persona de contacte',
        CONTACT_PERSON_REQUIRED: 'La persona de contacte és requerida',
        CONTACT_PHONE: 'Telèfon de contacte',
        CONTACT_PHONE_REQUIRED: 'El telèfon és requerit',
        CONTACT_EMAIL: 'Email de contacte',
        CONTACT_EMAIL_REQUIRED: "L'email és requerit",
        ADDRESS_REQUIRED: "L'adreça és requerida",
        CITY_REQUIRED: 'La ciutat és requerida',
        POSTAL_CODE_REQUIRED: 'El codi postal és requerit',
        USER: 'Usuari',
        USER_REQUIRED: "L'usuari és requerit",
        LICENSE_PLATE: 'Matrícula',
        LICENSE_PLATE_REQUIRED: 'La matrícula és requerida',
        OFFICE: 'Seu',
        OFFICE_REQUIRED: 'La seu és requerida',
        SHIFT: 'Torn',
        SHIFT_REQUIRED: 'El torn és requerit',
        RESERVED_DAYS: 'Dies Reservats',
        RESERVED_DAYS_REQUIRED: 'Els dies són requerits',
        START_DATE: 'Data Inici',
        END_DATE: 'Data Fi',
        DATETIME_PLACEHOLDER: 'Selecciona data i hora',
        CORRECT: 'Correcte',
        ERROR_BANG: 'Error!',
      },
      PARKING_REPORT: {
        WEEK_N: 'Setmana {{n}}',
        TOTAL_PARKING_SPACES: 'Total places pàrquing',
        AVAILABLE_SPACES: 'Places disponibles',
        OCCUPIED_SPACES: 'Places ocupades',
        SELECT_MONTH_YEAR: 'Selecciona mes i any',
        OWN_COMPANY_PARKING: "Pàrquing propi de l'empresa",
        OCCUPATION: 'Ocupació',
        DAY: 'Dia',
        WEEK: 'Setmana',
        MONTH: 'Mes',
        PAID_PARKING: 'Pàrquing de pagament',
        CREDIT_USE_AND_COST: 'Ús i cost de crèdit',
        PARKING_SPACES_USAGE: 'Ús de les places de pàrquing',
        TOTAL_PARKING_SPACES_LABEL: 'Total places de pàrquing',
        PARKING_SPACES_ALLOCATION: 'Assignació de places de pàrquing',
        TOTAL_USERS: "Total d'usuaris",
        MORNING_SHIFT: 'Torn de matí',
        AFTERNOON_SHIFT: 'Torn de tarda',
        PARKING_CREDIT: 'Crèdit Pàrquing',
        SHARED: 'Compartit',
        INDIVIDUAL: 'Individual',
        USERS_WITH_ALLOCATED_SPACES: 'Usuaris amb places assignades',
        USERS_WITHOUT_ALLOCATED_SPACES: 'Usuaris sense places assignades',
      },
      USAGE_REPORT: {
        USAGE: 'Ús',
        ALL_CENTERS: 'Tots els centres',
        LAST_7_DAYS: 'Últims 7 dies',
        LAST_30_DAYS: 'Últims 30 dies',
        LAST_90_DAYS: 'Últims 90 dies',
        LAST_YEAR: 'Últim any',
        TOP_CARPOOLERS: 'Top carpoolers del període',
        TOP_CARPOOLERS_SUBTITLE:
          "El #1 és qui més km ha conduït amb passatgers, detectat automàticament per l'app.",
        EMPLOYEE: 'TREBALLADOR',
        OFFICE: 'SEU',
        KM_WITH_PASSENGERS: 'KM AMB PASSATGERS',
        KM_DRIVEN_TOTAL: 'KM CONDUÏTS (TOTAL)',
        TRIPS: 'TRAJECTES',
        KM: 'km',
        RGPD_NOTE: 'Noms anonimitzats segons la normativa RGPD. Només inicials.',
        LOADING: 'Carregant estadístiques...',
        LOAD_ERROR_TEXT: "No s'han pogut carregar les estadístiques",
        LOAD_ERROR_MESSAGE: "Error en carregar les estadístiques d'ús",
        ACTIVE_USERS_BREAKDOWN: "Desglossament d'usuaris actius",
        DAU: 'Usuaris actius avui (DAU)',
        WAU: 'Actius aquesta setmana (WAU)',
        MAU: 'Actius aquest mes (MAU)',
        SHARED_TRIPS_MONTH: 'Trajectes compartits aquest mes',
        ACTIVE_USERS_PERIOD: 'Actius en el període',
        SHARED_TRIPS_PERIOD: 'Trajectes compartits en el període',
        ACTIVE_USERS: 'Usuaris actius',
        DRIVERS: 'Conductors',
        PASSENGERS: 'Passatgers',
        COMPLETED_TRIPS: 'Trajectes realitzats',
      },
      CONVERSION_REPORT: {
        ROUTE_OUTBOUND: 'Anada',
        ROUTE_RETURN: 'Tornada',
        ROUTE_ROUND_TRIP: 'Anada i tornada',
        SELECT_MONTH_YEAR: 'Selecciona mes i any',
        INDICATORS: 'Indicadors',
        INDICATOR: 'INDICADOR',
        INTERPRETATION: 'INTERPRETACIÓ',
        NUMBER_OF_USERS: "NOMBRE D'USUARIS",
        SMART_SURVEY: 'Enquesta intel·ligent',
        RESPONSES_BY_INDICATOR: 'Respostes segons indicador',
        MOST_COMMON_REASONS: 'Motius més comuns per no compartir vehicle',
        STATS: {
          ACTIVE_USERS: 'Usuaris actius',
          CONVERSION_RATE_CARPOOLING: 'Taxa de conversió a carpooling',
          AVG_DAYS_FIRST_MATCH: 'Mitjana de dies fins al primer match',
          REJECTED_MATCHES: 'Matches rebutjats',
        },
        INDICATORS_LIST: {
          REJECTS_ALL_MATCHES: 'Rebutja tots els matches',
          NEVER_CREATES_TRIPS: 'Mai crea trajectes',
          LIVES_IN_AREA_WITHOUT_USERS: 'Viu en zona sense altres usuaris a prop',
          USERS_WITH_WORST_RATINGS: 'Usuaris amb pitjors valoracions',
          USERS_WITH_COMPLAINTS: 'Usuaris amb queixes',
          USERS_WITH_LOW_ROUTINE_LOYALTY: 'Usuaris amb baixa fidelitat en rutina',
          USERS_WITHOUT_PERMISSIONS: 'Usuaris sense permisos activats',
          USERS_WITH_HIGH_CANCELLATION: "Usuaris amb alta taxa de cancel·lació",
        },
        INTERPRETATIONS: {
          DISTRUST_LACK_OF_INTEREST: "Desconfiança / manca d'interès",
          DOES_NOT_UNDERSTAND_UTILITY: "No entén la utilitat o interfície poc clara",
        },
        RESPONSES: {
          SCHEDULE_CHANGES: 'Els meus horaris canvien molt',
          NOBODY_NEARBY: 'Ningú a prop de la meva zona',
          PREFER_ALONE: 'Prefereixo anar sol',
          DID_NOT_KNOW: 'No sabia que podia fer-ho',
          OTHER_REASON: 'Altre motiu',
        },
        REASONS: {
          VERY_SHY: 'Sóc molt tímid@',
          NOT_CONVENIENT: 'No em va bé',
          CHILDREN_TO_SCHOOL: "He de portar els meus fills a l'escola",
          UNCOMFORTABLE_WITH_STRANGER: "Em fa vergonya no conèixer l'acompanyant",
          OTHER_REASONS: 'Altres motius',
        },
        USERS_LABEL: 'usuaris',
      },
      USER_LIST: {
        EMPLOYEES: 'Treballadors',
        STAFF: 'Plantilla',
        GROUPS: 'Grups',
        COMING_SOON: 'Properament',
        ALL_CENTERS: 'Tots els centres',
        LAST_7_DAYS: 'Últims 7 dies',
        LAST_30_DAYS: 'Últims 30 dies',
        LAST_90_DAYS: 'Últims 90 dies',
        LAST_YEAR: 'Últim any',
        DECLARED_STAFF: 'Plantilla declarada',
        REGISTERED_IN_WAIIS: 'Vinculats a WAIIS',
        REGISTRATION_OF_STAFF: 'Registre (de la plantilla)',
        ACTIVE_IN_USE_CARPOOLING: 'Actius en ús (carpooling)',
        SEARCH_NAME_OR_EMAIL: 'Cerca nom o correu',
        UPLOAD_CSV: 'Pujar CSV',
        ADD_MANUAL: 'Afegir manualment',
        LINK_USERS: 'Vincular usuaris',
        ADD_INVITE_EMPLOYEES: 'Afegir empleats',
        PARTNER_MANAGED_CHIP: 'Altes gestionades per {{partner}}',
        PARTNER_EMPTY_TITLE: 'La teva plantilla apareixerà aquí',
        PARTNER_EMPTY_TEXT: '{{partner}} dona d\'alta els teus empleats. Aquí veuràs qui es registra i qui fa servir l\'app.',
        ADD_INVITE_EMPLOYEES_MODAL_TITLE: 'Afegir o convidar empleats',
        CREATE_USER: 'Crear usuari',
        ALL: 'Tots',
        ACTIVE: 'Actiu',
        REGISTERED: 'Registrat',
        UNREGISTERED: 'Sense registrar',
        STATUS_WITH_ROUTINE: 'Amb rutina',
        STATUS_LINKED: 'Vinculat',
        STATUS_INACTIVE_FILTER: 'Inactiu',
        STATUS_PENDING: 'Pendent d\'acceptar',
        STATUS_REJECTED: 'Rebutjat',
        EMPLOYEE_GROUPS: "Grups de treballadors",
        EMPLOYEE_GROUPS_SUBTITLE:
          'Organitza treballadors i assigna polítiques de ride-hailing per col·lectiu.',
        CREATE_GROUP: 'Crear grup',
        GROUP_NAME: 'Nom del grup',
        LINKED_POLICIES: 'Polítiques vinculades',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        ACTIVE_LABEL: 'Actiu',
        NAME: 'Nom',
        SURNAME: 'Cognoms',
        EMAIL: 'Email',
        DEPARTMENT: 'Departament',
        OFFICE: 'Seu',
        SHIFT: 'Torn',
        FIELD_REQUIRED: 'Aquest camp és obligatori',
        EMAIL_FORMAT_ERROR: 'Introdueix un correu vàlid, p. ex. nom@empresa.com',
        DNI: 'DNI',
        PERSONAL_EMAIL: 'Correu personal',
        PHONE: 'Telèfon',
        PHONE_FORMAT_ERROR: 'Inclou el prefix del país, p. ex. +34600000000',
        COMPANY_PHONE: 'Tel. empresa',
        PARKING_PLACE: 'Plaça pàrquing',
        LOADING: 'Carregant...',
        CANCEL: 'Cancel·lar',
        ACCEPT: 'Acceptar',
        WAIT: 'Espera..',
        IMPORT_CSV_BY_OFFICE: 'Importar CSV per seu',
        LINK_USERS_BY_OFFICE: 'Vincular usuaris per seu',
        CSV_FILE: 'Fitxer CSV',
        DOWNLOAD_TEMPLATE: 'Descarregar plantilla d\'exemple',
        DOWNLOADING_TEMPLATE: 'Descarregant plantilla...',
        IMPORT: 'Importar',
        LINK: 'Vincular',
        EDIT_USER: 'Editar Usuari',
        CREATE_USER_TITLE: 'Crear Usuari',
        COLUMN_EMPLOYEE: 'Treballador',
        COLUMN_OFFICE_AREA: 'Seu · Àrea',
        COLUMN_STATUS: 'Estat',
        STATUS_ACTIVE: 'Actiu',
        STATUS_INACTIVE: 'Inactiu',
        SELECT_OFFICE_ALERT: 'Has de seleccionar una seu',
        SEARCH_EMPLOYEE: 'Cerca empleat',
        CLEAR_SEARCH: 'Esborra la cerca',
        NO_OFFICES: 'No hi ha seus disponibles',
        OFFICES_LOAD_ERROR: 'No s\'han pogut carregar les seus',
        RETRY: 'Reintentar',
        SUCCESS_TITLE: 'Correcte!',
        USER_UPDATED: "Usuari actualitzat correctament!",
        USER_CREATED: 'Usuari creat correctament!',
        ERROR_TITLE: 'Error!',
        CONFIRM_BUTTON: 'Acceptar',
        LINK_SUCCESS: "La vinculació d'usuaris s'ha realitzat correctament",
        DELETE_SUCCESS: "L'empleat s'ha eliminat correctament",
        IMPORT_SUCCESS: "La importació d'usuaris s'ha realitzat correctament",
        LINK_ERROR: "S'ha produït un error en la vinculació d'usuaris",
        IMPORT_ERROR: "S'ha produït un error en la importació d'usuaris",
        CSV_INVALID_EXTENSION: 'El fitxer ha de ser un CSV (.csv)',
        CSV_INVALID_HEADERS: 'El fitxer no coincideix amb la plantilla. Torna a descarregar-la i no canviïs el nom ni l\'ordre de les columnes.',
        CSV_MODAL_TITLE: 'Pujar CSV',
        CSV_MODAL_SUB: "Amb la plantilla: una fila per empleat. Abans d'importar veus quantes files són vàlides.",
        CSV_DROP: 'Arrossega aquí el teu CSV',
        CSV_DROP_HINT: "o fes clic per triar-lo. Columnes de la plantilla: name, surname, dni, email, phone, department.",
        CSV_DROP_CHANGE: "Arrossega'n un altre o fes clic per canviar-lo.",
        CSV_VALID_ROW: '1 fila vàlida',
        CSV_VALID_ROWS: '{{count}} files vàlides',
        CSV_INVALID_ROW: "1 fila amb errors no s'importarà (línia {{lines}}). Necessita nom, cognoms, departament i DNI, correu o telèfon.",
        CSV_INVALID_ROWS: "{{count}} files amb errors no s'importaran (línies {{lines}}). Necessiten nom, cognoms, departament i DNI, correu o telèfon.",
        CSV_PREVIEW_NAME: 'Nom',
        CSV_PREVIEW_EMAIL: 'Correu',
        CSV_MORE_ROWS: '+ {{count}} més',
        CSV_EMPTY: 'El fitxer està buit',
        ITEMS_USERS: 'usuaris',
        ITEMS_EMPLOYEES: 'empleats',
        EMAIL_PLACEHOLDER: 'nom@empresa.com',
        MOCK_GROUPS: {
          EXECUTIVES: 'Executius',
          EXECUTIVES_DESC: 'Alta direcció i C-level',
          MANAGERS: 'Managers',
          MANAGERS_DESC: "Responsables d'àrea i project managers",
          OPERATIONS: 'Operacions',
          OPERATIONS_DESC: "Equip d'operacions i torn de nit",
          GENERAL: 'General',
          GENERAL_DESC: 'Empleats sense cap grup específic assignat',
          POLICY_BUSINESS: 'Viatges de negoci',
          POLICY_NIGHT: 'Torn de nit',
          POLICY_COMMUTE: 'Commute diari',
        },
      },
      USER_DETAILS: {
        LOADING: 'Carregant...',
        BACK: 'Tornar',
        EMPLOYEES: 'Treballadors',
        EMPLOYEE_INFO: "Informació del treballador",
        PAYMENTS: 'Pagaments',
        TRIPS: 'Viatges',
        SUCCESS_RATE: "Percentatge d'èxit",
        COMPLETE_PROFILE: 'Completar perfil',
        PROFILE_DETAILS: 'Detalls del perfil',
        ID: 'ID',
        NAME_AND_SURNAME: 'Nom i Cognoms',
        DNI: 'DNI',
        EMAIL: 'Email',
        PHONE: 'Telèfon',
        CONTACT_PHONE: 'Telèfon de contacte',
        CONTACT_PHONE_TOOLTIP: "Número associat a l'usuari",
        OFFICE: 'Seu',
        DEPARTMENT: 'Departament',
        DEPARTMENT_TOOLTIP: "Departament de l'empresa",
        SHIFT: 'Torn',
        ROLE: 'Rol',
        ORIGIN: 'Origen',
        DESTINATION: 'Destinació',
        PARKING: 'Pàrquing',
        LINKED: 'Vinculació',
        ROUTINE_STATUS: 'Estat rutina',
        VERIFIED: 'Verificat',
        UNKNOWN: 'Desconegut',
      },
    },
    USER: {
      INNER: {
        SIGN_OUT: 'Tancar sessió',
        DASHBOARD_COMPANY: 'Tauler Empresa',
        DASHBOARD_ADMIN: 'Tauler Administrador',
        LANGUAGE: 'Idioma',
      },
      TRIPS_COLUMNS: {
        BUTTON: 'Columnes',
        TITLE: 'Columnes visibles',
        ROUTE: 'Trajecte',
        ROLE: 'Rol',
        ROUTINE: 'Rutina',
        STATUS: 'Estat',
        FOOTPRINT: 'Empremta',
        FRAUD: 'Frau',
        HIDDEN_ONE: '1 oculta',
        HIDDEN_MANY: '{{count}} ocultes',
        RESET: 'Restablir',
      },
    },
    SUPPORT_MESSAGE: {
      SHOW_MESSAGE: 'Veure missatge',
      HIDE_MESSAGE: 'Amagar missatge',
      LANG_LABEL: 'Idioma del missatge',
      SHOW_ALL: 'Veure-ho tot',
      SHOW_LESS: 'Veure\'n menys',
    },
    PRICING_EXPLAINER: {
      BUTTON: 'Com es calcula?',
      TITLE: 'Com es calcula el preu',
      LOADING: 'Carregant valors…',
      ERROR: 'No s\'han pogut carregar els valors actuals.',
      RETRY: 'Tornar-ho a provar',
      PRICE: 'Preu del viatge: {{perKm}} ct/km fins a 200 km, amb un mínim de {{fixed}} €. A partir de 200 km se sumen {{from200}} ct/km (des de 400 km, {{from400}}; des de 600 km, {{from600}}).',
      CAE: 'Bo CAE: {{perKm}} ct/km (màx. 200 km). En viatges sense cost per al passatger, {{withoutCost}} ct/km. Màxim {{maxTrips}} viatges al dia amb bo.',
      COMMISSION: 'Comissió WAIIS: {{single}} % en viatges puntuals; {{firstMonth}} % el primer mes d\'una rutina i {{longTerm}} % després, + IVA {{tax}} % sobre la comissió.',
      FORMULA: 'Paga el passatger = preu − bo CAE i ajudes + comissió. El conductor rep el preu del viatge. Si el viatge es queda sense CAE (app competidora o verificació facial no superada), rep el que paguen els passatgers menys la comissió.',
      TIMING: 'Es cobra {{chargeHours}} h abans de la sortida del conductor; termini per pagar fins a {{blockHours}} h abans.',
      THIS_TRIP: 'En aquest viatge:',
      TRIP_KM: '{{km}}',
      TRIP_PRICE: 'preu {{amount}}',
      TRIP_CAE: 'bo CAE {{amount}}',
      TRIP_COMMISSION_NO_PERCENT: 'comissió {{amount}}',
    },
    // Detalle de un viaje (/travel/:id): pooling-route-detail y su página.
    TRIP_DETAIL: {
      APP_SHOWS_VERIFYING: "A l'app: «Verificando»",
      APP_VERIFYING_HINT: "El viatge està verificat, però el conductor encara no ha cobrat (pagament ajornat per retard de caixa o per verificació reforçada). Fins que cobri, l'app li mostra «Verificando» al conductor i als passatgers.",
      LOADING: 'Carregant el trajecte…',
      RETRY: 'Torna-ho a provar',
      ERROR_TIMEOUT: 'El servidor no ha respost a temps. Torna-ho a provar.',
      ERROR_LOAD: 'No s\'ha pogut carregar el trajecte.',
      PAGE: {
        BREADCRUMB_ARIA: 'Ruta de navegació',
        PARENT: 'Gestió d\'activitat',
        TRIPS: 'Viatges',
        TRIP: 'Viatge',
        USERS: 'Usuaris',
        USER: "Fitxa de l'usuari",
        BACK: 'Tornar',
      },
      HEAD: {
        ROUTE_OF: 'Ruta de',
        DATE: 'Data',
        DEPARTURE: 'Sortida',
        DISTANCE: 'Distància',
        PARTICIPANTS: 'Participants',
        COPY_ID: 'Copiar l\'ID',
        ID_COPIED: 'ID copiat',
        SHOW_TECH: 'Veure detalls tècnics',
        HIDE_TECH: 'Amagar detalls tècnics',
        ZONES: 'Zones',
        ZONES_TEXT: '0–35 acceptar · 36–55 step-up · 56–74 revisió · 75–100 rebutjar',
        DRIVER_ONE: '1 conductor',
        PASSENGERS_ONE: '1 passatger',
        PASSENGERS_MANY: '{{n}} passatgers',
      },
      STATUS: {
        pending: 'Pendent de verificar',
        in_progress: 'En curs',
        completed: 'Completat',
        cancelled: 'Cancel·lat',
        verified: 'Verificat',
        rejected: 'Rebutjat',
        in_review: 'En revisió',
        enhanced_review: 'En revisió',
        SCHEDULED: 'Programat',
      },
      VERDICT: {
        UPCOMING: 'Viatge programat · encara no s\'ha fet, es verificarà després',
        IN_REVIEW: 'En revisió · els diners estan retinguts',
        NEEDS_REVIEW_ONE: 'Cal revisar-lo · falta verificar 1 persona',
        NEEDS_REVIEW_MANY: 'Cal revisar-lo · falten {{n}} persones per verificar',
        REJECTED_BY_SUPPORT: 'Rebutjat per suport',
        REJECTED_PART_ONE: '1 persona rebutjada automàticament',
        REJECTED_PART_MANY: '{{n}} persones rebutjades automàticament',
        REJECTED_AUTO: 'Rebutjat automàticament',
        ALL_VERIFIED: 'Tot verificat · no cal fer res',
        VERIFIED_PAYOUT_HELD: 'Verificat · el conductor encara no ha cobrat',
        VERIFIED_PAYOUT_HELD_UNTIL: 'Verificat · el conductor cobra el {{date}}',
      },
      KPI: {
        ARIA: 'Indicadors del viatge',
        VERIFICATION: 'Verificació',
        VERIFICATION_HINT: 'Petjada GPS de cada persona del viatge',
        VERIFIED_PEOPLE: 'persones verificades',
        COPRESENCE: 'Copresència',
        COPRESENCE_HINT: 'Solapament de les petjades GPS',
        COPRESENCE_LOW: 'baixa (menys del 70%)',
        COPRESENCE_OK: 'suficient',
        RISK: 'Risc de frau',
        RECOMMENDATION: 'Recomanació: {{action}}',
        ZONE_ACCEPT: 'Acceptar',
        ZONE_STEPUP: 'Step-up',
        ZONE_REVIEW: 'Revisió',
        ZONE_REJECT: 'Rebutjar',
      },
      RISK: {
        LOW: 'Risc baix',
        MODERATE: 'Risc moderat',
        HIGH: 'Risc alt',
        VERY_HIGH: 'Risc molt alt',
        NOT_CALCULATED: 'Risc sense calcular',
        ACTION_ACCEPT: 'Acceptar',
        ACTION_STEPUP: 'Demanar una verificació extra',
        ACTION_REVIEW: 'Revisar a mà',
        ACTION_REJECT: 'Rebutjar',
      },
      MAP: {
        TITLE: 'Mapa del trajecte i petjades GPS',
        COPRESENCE_BADGE: 'Copresència {{value}}',
        COPRESENCE_CAPTION_LOW: 'Copresència {{value}} confirmada (<70% → revisió).',
        COPRESENCE_CAPTION_OK: 'Copresència {{value}} suficient (≥70%).',
        LAYER_TRACE: 'Trajecte real (GPS)',
        LAYER_REFERENCE: 'Ruta teòrica del conductor emparellat',
        LAYER_FOOTPRINT: 'Petjada · {{name}}',
        WINDOW_TITLE: 'Finestra de petjada mostrada',
        WINDOW_HINT: 'Acota, per persona, el tram de la petjada GPS ja carregada (±2h del recorregut teòric) que es dibuixa al mapa.',
        SHOW_DETAIL: 'Veure detall',
        HIDE: 'Amagar',
        DRIVER_WINDOW_START: 'Inici de la finestra del conductor',
        DRIVER_WINDOW_END: 'Final de la finestra del conductor',
        WINDOW_START: 'Inici de la finestra de {{name}}',
        WINDOW_END: 'Final de la finestra de {{name}}',
        RESET_WINDOW: 'Restablir la finestra completa',
        ORIGIN: 'Origen',
        DESTINATION: 'Destinació',
        PICKUP: 'Recollida · {{name}}',
        DROPOFF: 'Baixada · {{name}}',
        PASSENGER_FALLBACK: 'passatger',
        LOADING: 'Carregant el mapa…',
        LOAD_ERROR: 'No s\'ha pogut carregar el mapa.',
      },
      ROLE: {
        DRIVER: 'Conductor',
        PASSENGER: 'Passatger',
      },
      UNVERIFIED: {
        TITLE_ONE: 'Falta verificar 1 persona',
        TITLE_MANY: 'Falta verificar {{n}} persones',
        TITLE_WHY: 'Per què no s\'ha verificat',
        VERIFIED_OK_ONE: '1 persona verificada sense problemes',
        VERIFIED_OK_MANY: '{{n}} persones verificades sense problemes',
        PENDING_ONE: '1 pendent',
        PENDING_MANY: '{{n}} pendents',
        SUPPORT_SAY: 'Si escriu a suport, digues-li:',
        COPY_MESSAGE: 'Copiar el missatge',
        MESSAGE_COPIED: 'Missatge copiat',
        COPY: 'Copiar',
        COPIED: 'Copiat',
        NO_DATA_REASON: 'Encara no hi ha dades: l\'app no ha enviat la ubicació o la verificació no s\'ha executat.',
        OPEN_CHAT: 'Obrir el xat',
        OPEN_CHAT_WITH: 'Obrir el xat de suport amb {{name}}',
        CHAT_ERROR: 'No s\'ha pogut obrir el xat de suport. Torna-ho a provar.',
      },
      FLAG: {
        RESERVATION_OK: 'La reserva i l\'horari coincideixen',
        RESERVATION_BAD: 'La reserva o l\'horari no coincideixen',
        RESERVATION_NONE: 'Reserva i horari sense dades',
        ORIGIN_OK: 'Va arribar a l\'origen previst',
        ORIGIN_BAD: 'No va arribar a l\'origen previst',
        ORIGIN_NONE: 'Origen sense dades d\'ubicació',
        DESTINATION_OK: 'Va arribar a la destinació prevista',
        DESTINATION_BAD: 'No va arribar a la destinació prevista',
        DESTINATION_NONE: 'Destinació sense dades d\'ubicació',
        COVERAGE: 'Cobertura d\'ubicació: {{pct}}%',
        COVERAGE_NONE: 'Cobertura d\'ubicació sense dades',
      },
      // Motivo de rechazo de la huella (`rejection_reason`), en lenguaje de
      // backoffice. Si llega uno nuevo, se pinta el texto del backend.
      REJECTION_REASON: {
        location_data_missing: 'Sense dades d\'ubicació durant el viatge',
        origin_not_confirmed: 'Sortida no confirmada a l\'origen',
        destination_not_confirmed: 'Arribada a la destinació no confirmada',
        location_trace_incomplete: 'Petjada d\'ubicació incompleta',
        route_not_compatible: 'Recorregut no compatible amb un viatge en cotxe',
        copresence_not_confirmed: 'Copresència no confirmada',
        multiple_devices: 'Diversos mòbils alhora',
        mock_location: 'Ubicació simulada',
        network_failed: 'La xarxa no va deixar comprovar la ubicació',
        trip_limit: 'Límit de viatges bonificats assolit',
        pattern_review: 'En revisió per un patró inusual',
        competitor_app: 'App competidora detectada',
        shared_with_riders: 'Viatge amb els passatgers no confirmat',
        shared_with_driver: 'Viatge amb el conductor no confirmat',
        location_permission_missing: 'Sense permís d\'ubicació',
      },
      VERIFICATION: {
        TITLE: 'Verificació de petjada',
        COL_PERSON: 'Persona',
        COL_ROLE: 'Rol',
        COL_METHOD: 'Mètode',
        COL_REASON: 'Motiu',
        COL_COPRESENCE: 'Copresència',
        COL_COMPETITOR: 'App competidora',
        COL_ORIGIN: 'Origen',
        COL_DESTINATION: 'Destinació',
        COL_RESULT: 'Resultat',
        DETECTED: 'Detectada',
        NOT_DETECTED: 'No detectada',
        STATE: {
          pending: 'Sense verificar',
          verified: 'Verificat',
          rejected: 'Rebutjat',
        },
        COMPETITOR_CHECK: {
          unknown: 'Sense comprovar',
          verified_clean: 'Comprovada, sense apps competidores',
          detected: 'Comprovada, app competidora detectada',
        },
      },
      // Fraude a mitad de viaje (EvaluateFraudMidTrip) y verificación facial
      FRAUD_DATA: {
        TITLE: "Senyals de l'equip de dades",
        SIGNAL_TIP: '{{title}}: {{text}} {{direction}}',
        HIGHER_BETTER: 'Més alt = millor.',
        HIGHER_WORSE: 'Més alt = pitjor.',
        COL_SIGNALS: 'Senyals',
        COL_COLLUSION_DRIVER: 'Col·lusió amb el conductor',
      },
      FRAUD_MIDTRIP: {
        TITLE: 'Frau a mig viatge',
        FAILURES: 'Sense superar: {{count}}',
        SUMMARY: {
          requested: 'Verificació facial demanada',
          would_request: 'S\'hauria demanat (ombra)',
          not_sampled: 'S\'hauria demanat, fora del sorteig',
          not_requested: 'Avaluat, sense demanar res',
        },
        HIDDEN_RESULT_HINT: 'El resultat de la verificació facial és el real. L\'app no l\'ensenya a la persona: sempre li diu que l\'ha superada. El viatge queda en verificació fins a la data de «Retingut fins», la superi o no; aleshores no es rebutja: si algú no l\'ha superada, Waiis no finança el CAE del seu tram (si és el conductor, de tot el viatge), com amb l\'app competidora. El passatger no paga res més; el conductor cobra només el que ha pagat el passatger.',
        COL_MODE: 'Mode',
        COL_REASON: 'Motiu',
        COL_RISK: 'Risc',
        COL_SIGNALS: 'Senyals',
        COL_EVALUATIONS: 'Avaluacions',
        COL_RELEASE: 'Retingut fins',
        LAST_EVALUATION: 'darrera: {{date}}',
        WOULD_HAVE_BEEN: 'Sense sorteig: {{reason}}',
        COL_FACE: 'Verificació facial',
        ERRORS: 'Sense dades de: {{sources}}',
        FIRST_TRIP: '1r viatge',
        POSSIBLE_FRAUD: 'Possible frau',
        SIMILARITY: 'Semblança {{value}} %',
        ATTEMPTS: '{{count}} intents',
        MODE: {
          shadow: 'Ombra',
          enforce: 'Exigir',
        },
        REASON: {
          group_already_requested: 'Ja demanada en aquest viatge',
          first_trip: 'Primer viatge amb possible frau',
          high_score: 'Risc alt',
          cooldown: 'Risc alt, però fa poc es va demanar a algú del cotxe',
          low_risk: 'Risc baix',
          not_sampled: 'S\'hauria demanat, però no ha sortit al sorteig',
          whitelisted: 'Algú del cotxe és a la llista blanca: no es demana a ningú',
        },
        FACE: {
          not_requested: 'No demanada',
          pending: 'Pendent',
          passed: 'Superada',
          failed: 'No superada',
          inconclusive: 'No concloent',
          no_show: 'No la va fer',
        },
        FACE_REASON: {
          face_mismatch: 'La cara no coincideix amb la del document',
          liveness_failed: 'Prova de vida no superada',
          reference_face_not_detected: 'Sense cara a la selfie del document',
          liveness_not_completed: 'No va acabar la prova',
          liveness_session_expired: 'La prova va caducar',
          provider_unavailable: 'AWS no va respondre',
        },
        SIGNAL: {
          emulator: 'Emulador',
          same_phone_in_group: 'Mateix mòbil que un altre del cotxe',
          gps_identical_with_participant: 'GPS idèntic a un altre del cotxe',
          clone_environment: 'App clonada',
          wifi_during_trip: 'En wifi durant el viatge',
          prior_face_failure: 'Verificació facial fallida abans',
          shared_ip_with_participant: 'Mateixa IP que un altre del cotxe',
          phone_shared_with_other_account: 'Mòbil compartit amb un altre compte',
          data_team_score: 'Puntuació de l\'equip de dades',
          no_sim: 'Sense SIM',
          no_whatsapp: 'Sense WhatsApp',
          no_whatsapp_no_sim: 'Sense WhatsApp ni SIM',
          many_devices: 'Molts mòbils',
          no_life_outside_trips: 'Sense activitat fora dels viatges',
          rejected_trips: 'Viatges rebutjats',
          driver_concentration: 'Gairebé sempre amb aquest conductor',
          adb_enabled: 'Depuració USB activa',
          collusion_with_participant: 'Col·lusió alta amb un altre del cotxe',
          face_passed_recently: 'Verificació facial superada fa poc (resta)',
          different_ip_from_driver: 'IP diferent de la del conductor (resta)',
        },
      },
      PARTICIPANTS: {
        TITLE: 'Participants',
        MATCH: 'match',
        COL_PERSON: 'Persona',
        COL_TRIP_TYPE: 'Tipus de viatge',
        COL_ROUTE: 'Origen i destinació',
        COL_KM: 'Km',
        COL_COPRESENCE: 'Copresència',
        NO_IDENTITY: 'Sense identitat verificada',
        NO_IDENTITY_TIP: 'Va fer aquest viatge sense la identitat verificada',
        NO_ADDRESS: 'Sense adreça',
        EMPTY: 'Sense passatgers emparellats.',
      },
      KIND: {
        NONE: 'Sense rutina',
        NONE_HINT: 'El trajecte no està associat a cap rutina',
        ROUTINE: 'Rutina',
        ROUTINE_HINT: 'Trajecte habitual que es repeteix els dies de la rutina',
        PUNCTUAL: 'Puntual',
        PUNCTUAL_HINT: 'Viatge d\'un dia concret, no es repeteix',
        LONG_HINT: 'Viatge puntual de llarga distància (més de 200 km) que el passatger va cercar des de l\'app',
        LONG_NOTE: 'Llarga distància',
      },
      MONEY: {
        BALANCED_TIP: 'Paguen passatgers + ajudes − comissió = el que rep el conductor',
        UNBALANCED_TIP: 'El que entra i el que surt no coincideixen',
        PASSENGERS_ONE: '1 passatger',
        DRIVER_IN_BALANCE: 'Al seu saldo',
        DRIVER_TO_PAY: 'Verificat, pendent d\'abonament',
        DRIVER_REJECTED: 'Trajecte no verificat: no cobra',
        DRIVER_HELD_CASH: 'Retard de caixa fins {{when}}',
        DRIVER_HELD_REINFORCED: 'Retingut per reforçada fins {{when}}',
        DRIVER_HELD_IDENTITY: 'Retingut fins que el passatger verifiqui la identitat',
        DRIVER_AFTER_TRIP: 'Cobrarà després del viatge',
        DRIVER_PENDING: 'Falta cobrar {{amount}}',
        BREAKDOWN_SUB: 'Què paga cada passatger, quines ajudes té i quant li arriba al conductor.',
        SUM_ARIA: 'Compte dels diners del viatge',
        PASSENGERS_PAY: 'Paguen passatgers',
        MINUS: '−{{amount}}',
        PASSENGERS_TIMES: '{{n}} × {{amount}}',
        DRIVER_TO_VERIFY: 'Pendent de verificar el trajecte',
        CAE_EXCLUDED: {
          NOTE: 'Sense CAE: {{reason}}',
          REASON: {
            COMPETITOR_APP: 'app competidora',
            COMPETITOR_APP_NAMED: 'app competidora ({{apps}})',
            IDENTITY_NOT_VERIFIED: 'verificació facial no superada',
            OTHER: 'exclòs del CAE',
          },
          TIP: {
            COMPETITOR_APP_DRIVER: 'Al conductor li vam detectar una app competidora en verificar el viatge. El passatger manté el descompte, però Waiis no paga el bo CAE: el conductor cobra el que va pagar el passatger menys la comissió.',
            COMPETITOR_APP_RIDER: 'Al passatger li vam detectar una app competidora en verificar el viatge. Manté el descompte, però Waiis no paga el bo CAE del seu tram: el conductor cobra el que va pagar aquest passatger menys la comissió.',
            IDENTITY_NOT_VERIFIED_DRIVER: 'El conductor no va superar la verificació facial. El passatger manté el descompte, però Waiis no paga el bo CAE: el conductor cobra el que va pagar el passatger menys la comissió.',
            IDENTITY_NOT_VERIFIED_RIDER: 'El passatger no va superar la verificació facial. Manté el descompte, però Waiis no paga el bo CAE del seu tram: el conductor cobra el que va pagar aquest passatger menys la comissió.',
            OTHER: 'Waiis no paga el bo CAE d\'aquest viatge: el conductor cobra el que va pagar el passatger menys la comissió.',
          },
        },
      },
      RESOLUTION: {
        TITLE: 'Decidir sobre el viatge',
        LAST: 'Última:',
        UPCOMING_NOTE: 'Podràs validar o rebutjar aquest viatge quan s\'hagi fet.',
        DECISION: 'Decisió',
        APPLY_TO: 'Aplicar a',
        NOTIFY: 'Avís a l\'usuari',
        NOTIFY_NONE: 'Sense avís a l\'usuari',
        NOTIFY_WITH: 'Avisar: {{channel}}',
        CHANNEL: {
          none: 'No avisar',
          push: 'Push',
          email: 'Correu',
          push_email: 'Push + correu',
        },
        VERDICT: {
          validate: 'Validat',
          reject: 'Rebutjat',
          enhanced_review: 'Posat en revisió',
        },
        VALIDATE_TITLE: 'Validar',
        VALIDATE_WHAT: 'Dones el viatge per bo, igual que si la verificació automàtica l\'hagués aprovat.',
        VALIDATE_MONEY: 'En uns 5 minuts el conductor cobra la part de cada passatger validat.',
        REJECT_TITLE: 'Rebutjar',
        REJECT_WHAT: 'Dones el viatge per no fet: no compta com a compartit.',
        REJECT_MONEY: 'En uns 5 minuts es retorna a la wallet de cada passatger rebutjat el que va pagar, i el conductor no cobra la seva part.',
        CONFIRM_REJECT_ONE: 'Rebutjar 1 participant',
        CONFIRM_REJECT_MANY: 'Rebutjar {{n}} participants',
        CONFIRM_REVIEW_ONE: 'Posar en revisió 1 participant',
        CONFIRM_REVIEW_MANY: 'Posar en revisió {{n}} participants',
        CONFIRM_VERIFY_ONE: 'Verificar 1 participant i pagar',
        CONFIRM_VERIFY_MANY: 'Verificar {{n}} participants i pagar',
        PROCESSING: 'Processant…',
        CHECKING: 'Comprovant…',
        PAID: 'Pagat',
        SELECT_ONE: 'Selecciona almenys un participant.',
        APPLIED: '{{verdict}} · aplicat.',
        APPLIED_MANY: '{{verdict}} · aplicat a {{n}} participants.',
        APPLIED_PARTIAL: '{{verdict}} · aplicat a {{ok}} de {{total}}.',
        FAILED_FOR: 'No s\'ha pogut aplicar a: {{names}}.',
        SAVE_ERROR: 'No s\'ha pogut desar la resolució.',
        VERIFIED_PAID: 'Verificat i pagat: {{names}}.',
        NOT_COMPLETED: 'No s\'ha pogut completar: {{names}}.',
        CANCELLED: 'Cancel·lat: no s\'ha fet res.',
      },
      PAYOUT: {
        CONFIRM_TITLE: 'Verificar i pagar · {{name}}',
        CONFIRM: 'Verificar i pagar',
        CANCEL: 'Cancel·lar',
        OK: 'D\'acord',
        PARTIAL_TITLE: 'Pagament a mitges',
        PARTIAL_TEXT: 'Al passatger ja se li van retirar {{prior}} ({{ref}}), però ara el càlcul dona {{now}}. No s\'ha fet res: revisa els moviments a mà.',
        ERROR_TIMEOUT: 'El servidor no ha respost a temps.',
        ERROR_GENERIC: 'No s\'ha pogut completar l\'operació.',
        ERROR_TITLE: 'Error · {{name}}',
        MISSING_TITLE: 'Falten dades',
        MISSING_TEXT: 'La ruta del passatger no té imports calculats ni distància; no es pot calcular el pagament.',
        OPTION: '{{label}} · conductor {{amount}}',
        OPTION_RIDER: 'passatger −{{amount}}',
        ESTIMATE_NOTE: 'Aquesta ruta no té imports calculats: s\'estima amb la tarifa CAE per km del passatger ({{km}}).',
        RIDER_BALANCE: 'Saldo del passatger:',
        COMPUTED: 'Imports calculats',
        TO_DRIVER: 'Al conductor:',
        RIDER_SHARE: 'passatger {{amount}}',
        DEBIT: 'Es retira al passatger:',
        BALANCE: 'saldo {{balance}}',
        UNCOVERED: 'El passatger no té saldo per a la seva part ({{amount}}; saldo {{balance}}): només es paga la CAE.',
        PRODUCT: {
          pvp: 'PVP',
          coste0: 'Coste 0',
        },
        ROUTINE_KIND: {
          routine: 'Rutina',
          punctual: 'Puntual',
        },
      },
    },
    TRIP_CHARGE: {
      COLUMN: 'Cobrament',
      FILTER_ALL: 'Cobrament: tots',
      FILTER_LABEL: 'Estat del cobrament',
      STATUS: {
        scheduled: 'Programat',
        charged: 'Cobrat',
        paid_to_driver: 'Pagat al conductor',
        refunded_to_wallet: 'Retornat al saldo',
        released: 'Anul·lat',
        failed: 'Rebutjat',
        debt: 'Deute',
        legacy_hold: 'Retenció antiga',
        not_applicable: 'Sense cobrament',
      },
      FAILED_LONG: 'Cobrament rebutjat',
      SCHEDULED_AT: 'Es cobra {{when}}',
      DEADLINE_AT: 'Termini per pagar {{when}}',
      DRIVER_CHARGED: '{{charged}}/{{total}} cobrats',
      DRIVER_FAILED_ONE: '{{n}} rebutjat',
      DRIVER_FAILED_MANY: '{{n}} rebutjats',
      DRIVER_PAID: 'Pagat ({{total}})',
      DRIVER_PAID_HELD: 'Abonat {{credited}}/{{total}}',
      DRIVER_PAID_HELD_SUB: "{{n}} pendent d'abonar",
      PAID_HELD_SUB: "Pendent d'abonar al conductor",
      DRIVER_REFUNDED: 'Retornat',
      WHEN: {
        TODAY: 'avui {{time}}',
        TOMORROW: 'demà {{time}}',
        YESTERDAY: 'ahir {{time}}',
        TODAY_AT: 'avui a les {{time}}',
        TOMORROW_AT: 'demà a les {{time}}',
        DATE_AT: 'el {{date}} a les {{time}}',
      },
      FAILURE: {
        NO_CARD: 'No té cap targeta desada',
        DECLINED: 'La targeta ha estat rebutjada',
        INSUFFICIENT_FUNDS: 'Fons insuficients',
        EXPIRED_CARD: 'Targeta caducada',
        INCORRECT_CVC: 'CVC incorrecte',
        AUTHENTICATION_REQUIRED: 'El banc demana confirmar el pagament (3D Secure)',
        PROCESSING_ERROR: 'Error del banc en processar el pagament',
        OTHER: 'Un altre motiu ({{code}})',
      },
      FRAUD: {
        review: 'En revisió per frau',
        reinforced_review: 'Verificació reforçada',
        blocked: 'Bloquejat',
      },
      ATTEMPT: 'intent {{n}} de {{max}}',
      ATTEMPT_ONLY: 'intent {{n}}',
      CARD_GENERIC: 'targeta',
      ALERT: {
        TITLE: 'No s\'ha pogut cobrar {{amount}} a {{name}}',
        TITLE_DEBT: '{{name}} té pendent el pagament de {{amount}}',
        CARD_ONLY: 'La targeta {{card}} s\'ha rebutjat.',
        DEBT: 'WAIIS ja ha pagat el conductor i el passatger té el compte bloquejat fins que pagui.',
        CHIP_DEBT: 'Deute',
        CHIP_DEADLINE: 'Termini · {{when}}',
        CHIP_DEADLINE_PASSED: 'Termini vençut · {{when}}',
        CHIP_RETRY: 'Reintent · {{when}}',
        DEADLINE_PASSED: 'El termini va vèncer {{when}}: s\'han pausat les seves rutines.',
        NEXT_RETRY: 'Proper reintent del cobrament: {{when}}.',
        NEXT_ATTEMPT: 'Proper intent: {{when}}.',
        DEADLINE: 'Si no està pagat {{when}}, es pausen les seves rutines.',
      },
      OPEN_CHAT: 'Obrir el xat amb el missatge',
      CHAT_ERROR: 'No s\'ha pogut obrir el xat de suport. Torna-ho a provar.',
      AIDS: {
        CAE_BONUS: 'Bo CAE',
        CORPORATION_SUBSIDY: 'Subvenció d\'empresa',
        WAIIS_CONTRIBUTION: 'Aportació WAIIS',
        COUPON: 'Cupó',
        DRIVER_DISCOUNT: 'Descompte del conductor',
      },
      MONEY: {
        TITLE: 'Diners del viatge',
        HINT: 'Passa el ratolí per un pas per veure què vol dir',
        HOW: 'Com es calcula?',
        SUMMARY: {
          PAY: 'Paguen',
          COMMISSION: 'Comissió',
          DRIVER_RECEIVES: 'Rep el conductor',
          BALANCED: 'Quadra',
          UNBALANCED: 'Diferència de {{amount}}',
        },
        COL: {
          PERSON: 'Persona',
          AMOUNT: 'Import',
          STATUS: 'Estat',
          STEPS: 'Passos',
        },
        ROLE: {
          PASSENGER: 'Passatger',
          DRIVER: 'Conductor',
        },
        HOLD_HOURS: '{{n}} h',
        HOLD_DAY: '{{n}} dia',
        HOLD_DAYS: '{{n}} dies',
        HOLD_SHORT: {
          cash_delay: 'Caixa · {{days}}',
          pending_identity: 'Identitat',
        },
        FRAUD_SHORT: {
          review: 'En revisió',
          reinforced_review: 'Reforçada',
          blocked: 'Bloquejat',
        },
        SOURCE: {
          BOTH: 'saldo + targeta',
          WALLET: 'saldo',
          CARD: 'targeta',
        },
        SPLIT_BOTH: '{{wallet}} del seu saldo · {{cardAmount}} de la {{card}}',
        SPLIT_CARD: '{{amount}} de la {{card}}',
        SPLIT_WALLET: '{{amount}} del seu saldo',
        REASON: {
          CHARGED: 'Esperant verificació',
          PAID: 'Pagat el {{day}}',
          PAID_HELD: "Pendent d'abonar al conductor · {{when}}",
          PAID_HELD_NO_DATE: "Pendent d'abonar al conductor",
          REFUNDED: 'Viatge no verificat',
          RELEASED: 'Viatge anul·lat',
          SCHEDULED: 'Es cobra el {{when}}',
          DEBT: 'Deu {{amount}}',
          LEGACY: 'Sistema antic',
          DRIVER_PENDING: 'Quan es verifiqui el viatge',
          DRIVER_IN_BALANCE: 'Al seu saldo des del {{day}}',
          DRIVER_IN_BALANCE_NO_DATE: 'Ja al seu saldo',
          DRIVER_HELD_CASH: 'Retard de caixa · entra al saldo {{when}}',
          DRIVER_HELD_CASH_NO_DATE: 'Retard de caixa',
          DRIVER_HELD_REINFORCED: 'Retingut per reforçada · entra al saldo {{when}}',
          DRIVER_HELD_REINFORCED_NO_DATE: 'Retingut per reforçada',
          DRIVER_HELD_IDENTITY: 'Retingut per identitat · entra al saldo quan el passatger verifiqui la identitat',
          DRIVER_HELD_IDENTITY_NO_DATE: 'Retingut per identitat',
          DRIVER_RELEASE: 'S\'allibera el {{day}}',
        },
        DRIVER_STATUS: {
          HELD: 'Retingut',
          PENDING: 'Per rebre',
          IN_BALANCE: 'Al seu saldo',
        },
        STEP: {
          SCHEDULED: 'Programat',
          CHARGED: 'Retingut',
          FAILED: 'Rebutjat',
          DEADLINE: 'Termini per pagar',
          DEADLINE_PASSED: 'Termini vençut',
          RETRY: 'Reintent',
          VERIFYING: 'Verificant',
          TO_DRIVER: 'Al conductor',
          REFUNDED: 'Retornat al seu saldo',
          RELEASED: 'Anul·lat',
          TRIP_DONE: 'Arribada',
          IN_BALANCE: 'Al seu saldo',
          WITHDRAWABLE: 'Retirable',
          HELD: 'Retingut',
          RELEASE: 'S\'allibera',
          IN_REVIEW: 'revisió',
          IN_PROGRESS: 'en curs',
          VERIFIED: 'verificat',
          NOT_VERIFIED: 'no verificat',
        },
        TIP: {
          SCHEDULED: 'Se li cobra 24 h abans que surti el conductor',
          CHARGED: 'Els diners ja han sortit; WAIIS els guarda fins que es verifiqui el viatge',
          FAILED: 'El banc o Stripe han rebutjat el cobrament',
          DEADLINE: 'Si no paga abans d\'aquesta hora, es pausen les seves rutines',
          DEADLINE_PASSED: 'Ha vençut: les seves rutines estan pausades',
          RETRY: 'Tornarem a intentar el cobrament automàticament',
          VERIFYING: 'Comprovem amb la petjada GPS que el viatge s\'ha fet',
          TO_DRIVER: 'Els diners passen al saldo del conductor',
          REFUNDED: 'El viatge no s\'ha verificat: els diners tornen al seu saldo de WAIIS',
          RELEASED: 'El cobrament s\'ha anul·lat: no se li ha cobrat res',
          TRIP_DONE: 'Hora d\'arribada del viatge',
          IN_BALANCE: 'Els diners entren al seu saldo de l\'app',
          WITHDRAWABLE: 'Els pot passar al seu compte bancari',
          HELD_CASH: 'Revisió del pagament: el viatge està verificat, però els diners no entren al seu saldo fins a la data indicada (com a màxim 2 dies)',
          HELD_REINFORCED: 'Verificació reforçada: els diners no entren al seu saldo fins a la data indicada',
          HELD_IDENTITY: 'Identitat pendent: els diners no entren al seu saldo fins que el passatger verifiqui la identitat',
          RELEASE: 'Un passatger té verificació reforçada: els diners s\'alliberen {{days}} dies després',
        },
        WRITE: 'Escriure-li',
        MORE: 'Veure detall',
        LEGEND: {
          SHOW: 'Què vol dir cada pas',
          COLORS: 'Colors',
          PASSENGER: 'Passatger',
          DRIVER: 'Conductor',
          BOTH: 'Tots dos',
          DOT: {
            done: 'Fet',
            failed: 'Ha fallat',
            next: 'Ara',
            todo: 'Pendent',
          },
          SHORT: {
            SCHEDULED: 'es cobra 24 h abans',
            CHARGED: 'WAIIS guarda els diners',
            FAILED: 'el banc no ha cobrat',
            DEADLINE: 'si no paga, es pausen rutines',
            RETRY: 'es torna a cobrar sol',
            TO_DRIVER: 'ja és del conductor',
            REFUNDED: 'no verificat, li tornen',
            RELEASED: 'no se li cobra res',
            TRIP_DONE: 'hora d\'arribada',
            IN_BALANCE: 'ja té els diners',
            RELEASE: 'espera per verificació reforçada',
            WITHDRAWABLE: 'el pot passar al banc',
            VERIFYING: 'comprovació amb GPS',
            VALIDATED: 'suport el dona per bo',
          },
        },
        MANUAL: {
          VALIDATED: 'Validat per suport',
          VALIDATED_TIP: 'Suport ha donat el viatge per bo: els diners passen al conductor com si s\'hagués verificat sol',
          REASON: 'Validat per suport',
          REASON_BY: 'Validat per {{name}}',
        },
        TABLE_TOGGLE: 'Veure el desglossament en taula',
        DETAIL: {
          BREAKDOWN: 'Preu {{base}}{{aids}} + comissió {{commission}} = paga {{pays}}',
          TODO_LABEL: 'Què ha de fer?',
          FROM_PASSENGER: 'De {{name}}: {{amount}}',
          PAYOUTS: 'Veure Pagaments',
          NO_DATA: 'Aquest entorn encara no envia les dades del cobrament.',
        },
        TODO: {
          NO: 'Res.',
          SCHEDULED: 'Res. Se li cobrarà automàticament {{when}}.',
          SCHEDULED_NO_DATE: 'Res. Se li cobrarà automàticament 24 h abans que surti el conductor.',
          CHARGED: 'Res. WAIIS guarda els diners fins que es verifiqui el viatge.',
          CHARGED_REVIEW: 'Res. WAIIS guarda els diners fins que es resolgui la revisió.',
          REFUNDED: 'Res. L\'import ha tornat al seu saldo de WAIIS.',
          LEGACY: 'Res. És un cobrament del sistema antic (retenció a la targeta).',
          FAILED: 'Afegir una altra targeta. Si no ho fa {{when}}, se li pausen les rutines.',
          FAILED_NO_DEADLINE: 'Afegir una altra targeta perquè se li pugui cobrar.',
          PAY_PENDING: 'Pagar el que queda pendent: el deute es cobra sol en afegir una targeta vàlida.',
          DEBT: 'Afegir una targeta vàlida per pagar el que queda pendent i desbloquejar el compte.',
        },
        PAYMENT_STATUS: 'Estat de pagament',
        PAYMENT_STATUS_VALUES: {
          ok: 'Al dia',
          warning: 'Avís',
          blocked: 'Bloquejat',
          cancelled: 'Cancel·lat',
        },
        VERIFICATION: 'Verificació',
        VERIFICATION_VALUES: {
          NORMAL: 'Normal',
          REVIEW: 'En revisió manual',
          REINFORCED: 'Reforçada: el conductor cobra {{days}} dies després',
          REINFORCED_NO_DAYS: 'Reforçada: el conductor cobra més tard',
          BLOCKED: 'Bloquejat per frau',
        },
        STRIPE: 'Veure a Stripe',
        RECEIPT: 'Veure rebut',
      },
      ECONOMIC: {
        DRIVER_PAYOUT: 'Pagament al conductor',
        COL: {
          PRICE: 'Preu del viatge',
          AIDS: 'Ajudes',
          COMMISSION: 'Comissió WAIIS',
          PAYS: 'Paga el passatger',
          TO_DRIVER: 'Al conductor',
          RECEIPT: 'Rebut',
          PAYMENT: 'Pagament',
          TOTAL: 'Total',
          FREE: 'Sense cost',
          EXPECTED: 'Esperat {{amount}}',
        },
        STATE: {
          PAID: 'Cobrat',
          MISMATCH: 'Diferència',
          EXPECTED: 'Previst',
          TO_CHARGE: 'Per cobrar',
        },
        UPCOMING: 'Imports previstos: al passatger se li cobra 24 h abans que surti el conductor i el conductor cobra quan es verifica el viatge',
      },
      SOURCE: {
        WALLET: 'Saldo',
        CARD: 'Targeta',
        BANK: 'Compte bancari',
        PAID_ON: 'Pagada el {{date}}',
        PAYOUT: {
          paid: 'Pagada',
          pending: 'Pendent',
          in_review: 'En revisió',
          failed: 'Fallida',
        },
      },
    },
    ROLE: {
      TOTAL_USERS: 'Total d\'usuaris amb aquest rol: {{count}}',
      NO_PERMISSIONS: 'Sense permisos assignats...',
      AND_MORE: 'i {{count}} més...',
      VIEW_ROLE: 'Veure rol',
      EDIT_ROLE: 'Editar rol',
      ADD_NEW_ROLE: 'Afegir nou rol',
      DETAILS_TITLE: 'Detalls del rol',
      CLOSE: 'Tancar',
      USER_INFORMATION: 'Informació de l\'usuari',
      ROLE_NAME: 'Nom del rol',
      NAME_REQUIRED: 'El nom del rol és obligatori',
      NAME_MINLENGTH: 'El nom del rol ha de tenir com a mínim 4 caràcters',
      DISCARD: 'Descartar',
      SUBMIT: 'Enviar',
      PLEASE_WAIT: 'Espera si us plau...',
      USERS_ASSIGNED: 'Usuaris assignats',
      COL_NAME: 'Nom',
      COL_ROLE: 'Rol',
      COL_LAST_LOGIN: 'Últim accés',
      COL_JOINED_DATE: 'Data d\'alta',
      SUCCESS: 'Èxit!',
      ERROR: 'Error!',
      CREATED_SUCCESS: 'Rol creat correctament!',
      UPDATED_SUCCESS: 'Rol actualitzat correctament!',
      CONFIRM: 'Entesos!',
    },
    PERMISSION: {
      SEARCH: 'Cercar permisos',
      ADD_PERMISSIONS: 'Afegir permisos',
      DETAILS_TITLE: 'Detalls del permís',
      CLOSE: 'Tancar',
      USER_INFORMATION: 'Informació de l\'usuari',
      NAME: 'Nom',
      NAME_REQUIRED: 'El nom del permís és obligatori',
      NAME_MINLENGTH: 'El nom del permís ha de tenir com a mínim 4 caràcters',
      DISCARD: 'Descartar',
      SUBMIT: 'Enviar',
      PLEASE_WAIT: 'Espera si us plau...',
      COL_NAME: 'Nom',
      COL_ASSIGNED_TO: 'Assignat a',
      COL_CREATED_DATE: 'Data de creació',
      SUCCESS: 'Èxit!',
      ERROR: 'Error!',
      CREATED_SUCCESS: 'Permís creat correctament!',
      UPDATED_SUCCESS: 'Permís actualitzat correctament!',
      CONFIRM: 'Entesos!',
    },
    SHARED: {
      FILTER_SIDEBAR: {
        FILTERS: 'Filtres',
        DATE_PLACEHOLDER: 'Selecciona una data',
        APPLY: 'Aplicar filtres',
        CLEAR: 'Netejar',
        CLOSE: 'Tancar',
      },
      TABLE_EDITABLE: {
        CREATE: 'Crear',
        ACTIONS: 'Accions',
        SAVING: 'Desant...',
        SAVE: 'Desar',
        CANCEL: 'Cancel·lar',
        EDIT: 'Editar',
        NO_DATA: 'No hi ha dades disponibles per mostrar',
        SHOWING: 'Mostrant {{shown}} de {{total}}',
        ITEMS: 'registres',
        HINT: 'Prem el llapis per editar una fila i desa els canvis amb ✓.',
        SAVED: 'Desat',
        SAVE_ERROR: "No s'ha pogut desar",
        CREDITS_TITLE: 'Tots els tipus de crèdit',
        CREDITS_ITEMS: 'tipus de crèdit',
        COMMISSIONS_TITLE: 'Totes les comissions',
        COMMISSIONS_ITEMS: 'comissions',
        COL_ID: 'ID',
        COL_TYPE: 'Tipus',
        COL_DESCRIPTION: 'Descripció',
        COL_VALUE: 'Valor',
      },
      ENTITY_LABELS: {
        TITLE: 'Etiquetes',
        REMOVE_ARIA: 'Treure l’etiqueta {{name}}',
        EMPTY: 'Sense etiquetes',
        ADD: 'Afegir etiqueta',
        SEARCH_PLACEHOLDER: 'Cercar o crear etiqueta…',
        SHARED_SCOPE: 'comuna',
        ALREADY_ASSIGNED: 'Aquesta etiqueta ja està assignada.',
        NONE_AVAILABLE: 'No hi ha més etiquetes disponibles.',
        CREATE: 'Crear «{{name}}»',
        ASSIGN_ERROR: 'No s’ha pogut assignar l’etiqueta.',
        NAME_INVALID: 'El nom ha de contenir alguna lletra o número.',
        CREATE_ERROR: 'No s’ha pogut crear l’etiqueta.',
        REMOVE_ERROR: 'No s’ha pogut treure l’etiqueta.',
        CATALOG_ERROR: 'No s’ha pogut carregar el catàleg d’etiquetes.',
      },
      QUILL: {
        NORMAL: 'Normal',
        HEADING_1: 'Títol 1',
        HEADING_2: 'Títol 2',
        HEADING_3: 'Títol 3',
        VISIT_URL: 'Obrir l\'enllaç:',
        ENTER_LINK: 'Introdueix l\'enllaç:',
        EDIT: 'Editar',
        REMOVE: 'Treure',
        SAVE: 'Desar',
      },
      // Campo de fecha / hora (shared/components/bo-date-input)
      DATE_INPUT: {
        OPEN_CALENDAR: 'Obrir el calendari',
        OPEN_TIME: 'Triar l\'hora',
        CALENDAR: 'Calendari',
        TIME: 'Hora',
        HOURS: 'Hores',
        MINUTES: 'Minuts',
        HOUR_UP: 'Una hora més',
        HOUR_DOWN: 'Una hora menys',
        MINUTE_UP: 'Un minut més',
        MINUTE_DOWN: 'Un minut menys',
        TODAY: 'Avui',
        NOW: 'Ara',
        CLEAR: 'Esborrar',
        DONE: 'Fet',
        FORMAT_DATE: 'dd/mm/aaaa',
        FORMAT_DATETIME: 'dd/mm/aaaa hh:mm',
        FORMAT_TIME: 'hh:mm',
        PREV_MONTH: 'Mes anterior',
        NEXT_MONTH: 'Mes següent',
        MONTH: 'Mes',
        YEAR: 'Any',
      },
    },
    LAYOUT: {
      SHOW_SIDEBAR_MENU: 'Mostrar menú lateral',
      SHOW_HEADER_MENU: 'Mostrar menú de capçalera',
      REFRESH_PROFILE: 'Refrescar perfil',
      HIDE_ENV_BAR: 'Amagar la barra d’entorn',
    },
    ERROR_PAGES: {
      NOT_FOUND_TITLE: 'Vaja!',
      NOT_FOUND_TEXT: 'No trobem aquesta pàgina.',
      SERVER_TITLE: 'Error del sistema',
      SERVER_TEXT: 'Alguna cosa ha anat malament. Torna-ho a provar més tard.',
      HOME: 'Tornar a l’inici',
    },
  },
};
